var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005, _path5006, _path5007, _path5008, _path5009, _path5010, _path5011, _path5012, _path5013, _path5014, _path5015, _path5016, _path5017, _path5018, _path5019, _path5020, _path5021, _path5022, _path5023, _path5024, _path5025, _path5026, _path5027, _path5028, _path5029, _path5030, _path5031, _path5032, _path5033, _path5034, _path5035, _path5036, _path5037, _path5038, _path5039, _path5040, _path5041, _path5042, _path5043, _path5044, _path5045, _path5046, _path5047, _path5048, _path5049, _path5050, _path5051, _path5052, _path5053, _path5054, _path5055, _path5056, _path5057, _path5058, _path5059, _path5060, _path5061, _path5062, _path5063, _path5064, _path5065, _path5066, _path5067, _path5068, _path5069, _path5070, _path5071, _path5072, _path5073, _path5074, _path5075, _path5076, _path5077, _path5078, _path5079, _path5080, _path5081, _path5082, _path5083, _path5084, _path5085, _path5086, _path5087, _path5088, _path5089, _path5090, _path5091, _path5092, _path5093, _path5094, _path5095, _path5096, _path5097, _path5098, _path5099, _path5100, _path5101, _path5102, _path5103, _path5104, _path5105, _path5106, _path5107, _path5108, _path5109, _path5110, _path5111, _path5112, _path5113, _path5114, _path5115, _path5116, _path5117, _path5118, _path5119, _path5120, _path5121, _path5122, _path5123, _path5124, _path5125, _path5126, _path5127, _path5128, _path5129, _path5130, _path5131, _path5132, _path5133, _path5134, _path5135, _path5136, _path5137, _path5138, _path5139, _path5140, _path5141, _path5142, _path5143, _path5144, _path5145, _path5146, _path5147, _path5148, _path5149, _path5150, _path5151, _path5152, _path5153, _path5154, _path5155, _path5156, _path5157, _path5158, _path5159, _path5160, _path5161, _path5162, _path5163, _path5164, _path5165, _path5166, _path5167, _path5168, _path5169, _path5170, _path5171, _path5172, _path5173, _path5174, _path5175, _path5176, _path5177, _path5178, _path5179, _path5180, _path5181, _path5182, _path5183, _path5184, _path5185, _path5186, _path5187, _path5188, _path5189, _path5190, _path5191, _path5192, _path5193, _path5194, _path5195, _path5196, _path5197, _path5198, _path5199, _path5200, _path5201, _path5202, _path5203, _path5204, _path5205, _path5206, _path5207, _path5208, _path5209, _path5210, _path5211, _path5212, _path5213, _path5214, _path5215, _path5216, _path5217, _path5218, _path5219, _path5220, _path5221, _path5222, _path5223, _path5224, _path5225, _path5226, _path5227, _path5228, _path5229, _path5230, _path5231, _path5232, _path5233, _path5234, _path5235, _path5236, _path5237, _path5238, _path5239, _path5240, _path5241, _path5242, _path5243, _path5244, _path5245, _path5246, _path5247, _path5248, _path5249, _path5250, _path5251, _path5252, _path5253, _path5254, _path5255, _path5256, _path5257, _path5258, _path5259, _path5260, _path5261, _path5262, _path5263, _path5264, _path5265, _path5266, _path5267, _path5268, _path5269, _path5270, _path5271, _path5272, _path5273, _path5274, _path5275, _path5276, _path5277, _path5278, _path5279, _path5280, _path5281, _path5282, _path5283, _path5284, _path5285, _path5286, _path5287, _path5288, _path5289, _path5290, _path5291, _path5292, _path5293, _path5294, _path5295, _path5296, _path5297, _path5298, _path5299, _path5300, _path5301, _path5302, _path5303, _path5304, _path5305, _path5306, _path5307, _path5308, _path5309, _path5310, _path5311, _path5312, _path5313, _path5314, _path5315, _path5316, _path5317, _path5318, _path5319, _path5320, _path5321, _path5322, _path5323, _path5324, _path5325, _path5326, _path5327, _path5328, _path5329, _path5330, _path5331, _path5332, _path5333, _path5334, _path5335, _path5336, _path5337, _path5338, _path5339, _path5340, _path5341, _path5342, _path5343, _path5344, _path5345, _path5346, _path5347, _path5348, _path5349, _path5350, _path5351, _path5352, _path5353, _path5354, _path5355, _path5356, _path5357, _path5358, _path5359, _path5360, _path5361, _path5362, _path5363, _path5364, _path5365, _path5366, _path5367, _path5368, _path5369, _path5370, _path5371, _path5372, _path5373, _path5374, _path5375, _path5376, _path5377, _path5378, _path5379, _path5380, _path5381, _path5382, _path5383, _path5384, _path5385, _path5386, _path5387, _path5388, _path5389, _path5390, _path5391, _path5392, _path5393, _path5394, _path5395, _path5396, _path5397, _path5398, _path5399, _path5400, _path5401, _path5402, _path5403, _path5404, _path5405, _path5406, _path5407, _path5408, _path5409, _path5410, _path5411, _path5412, _path5413, _path5414, _path5415, _path5416, _path5417, _path5418, _path5419, _path5420, _path5421, _path5422, _path5423, _path5424, _path5425, _path5426, _path5427, _path5428, _path5429, _path5430, _path5431, _path5432, _path5433, _path5434, _path5435, _path5436, _path5437, _path5438, _path5439, _path5440, _path5441, _path5442, _path5443, _path5444, _path5445, _path5446, _path5447, _path5448, _path5449, _path5450, _path5451, _path5452, _path5453, _path5454, _path5455, _path5456, _path5457, _path5458, _path5459, _path5460, _path5461, _path5462, _path5463, _path5464, _path5465, _path5466, _path5467, _path5468, _path5469, _path5470, _path5471, _path5472, _path5473, _path5474, _path5475, _path5476, _path5477, _path5478, _path5479, _path5480, _path5481, _path5482, _path5483, _path5484, _path5485, _path5486, _path5487, _path5488, _path5489, _path5490, _path5491, _path5492, _path5493, _path5494, _path5495, _path5496, _path5497, _path5498, _path5499, _path5500, _path5501, _path5502, _path5503, _path5504, _path5505, _path5506, _path5507, _path5508, _path5509, _path5510, _path5511, _path5512, _path5513, _path5514, _path5515, _path5516, _path5517, _path5518, _path5519, _path5520, _path5521, _path5522, _path5523, _path5524, _path5525, _path5526, _path5527, _path5528, _path5529, _path5530, _path5531, _path5532, _path5533, _path5534, _path5535, _path5536, _path5537, _path5538, _path5539, _path5540, _path5541, _path5542, _path5543, _path5544, _path5545, _path5546, _path5547, _path5548, _path5549, _path5550, _path5551, _path5552, _path5553, _path5554, _path5555, _path5556, _path5557, _path5558, _path5559, _path5560, _path5561, _path5562, _path5563, _path5564, _path5565, _path5566, _path5567, _path5568, _path5569, _path5570, _path5571, _path5572, _path5573, _path5574, _path5575, _path5576, _path5577, _path5578, _path5579, _path5580, _path5581, _path5582, _path5583, _path5584, _path5585, _path5586, _path5587, _path5588, _path5589, _path5590, _path5591, _path5592, _path5593, _path5594, _path5595, _path5596, _path5597, _path5598, _path5599, _path5600, _path5601, _path5602, _path5603, _path5604, _path5605, _path5606, _path5607, _path5608, _path5609, _path5610, _path5611, _path5612, _path5613, _path5614, _path5615, _path5616, _path5617, _path5618, _path5619, _path5620, _path5621, _path5622, _path5623, _path5624, _path5625, _path5626, _path5627, _path5628, _path5629, _path5630, _path5631, _path5632, _path5633, _path5634, _path5635, _path5636, _path5637, _path5638, _path5639, _path5640, _path5641, _path5642, _path5643, _path5644, _path5645, _path5646, _path5647, _path5648, _path5649, _path5650, _path5651, _path5652, _path5653, _path5654, _path5655, _path5656, _path5657, _path5658, _path5659, _path5660, _path5661, _path5662, _path5663, _path5664, _path5665, _path5666, _path5667, _path5668, _path5669, _path5670, _path5671, _path5672, _path5673, _path5674, _path5675, _path5676, _path5677, _path5678, _path5679, _path5680, _path5681, _path5682, _path5683, _path5684, _path5685, _path5686, _path5687, _path5688, _path5689, _path5690, _path5691, _path5692, _path5693, _path5694, _path5695, _path5696, _path5697, _path5698, _path5699, _path5700, _path5701, _path5702, _path5703, _path5704, _path5705, _path5706, _path5707, _path5708, _path5709, _path5710, _path5711, _path5712, _path5713, _path5714, _path5715, _path5716, _path5717, _path5718, _path5719, _path5720, _path5721, _path5722, _path5723, _path5724, _path5725, _path5726, _path5727, _path5728, _path5729, _path5730, _path5731, _path5732, _path5733, _path5734, _path5735, _path5736, _path5737, _path5738, _path5739, _path5740, _path5741, _path5742, _path5743, _path5744, _path5745, _path5746, _path5747, _path5748, _path5749, _path5750, _path5751, _path5752, _path5753, _path5754, _path5755, _path5756, _path5757, _path5758, _path5759, _path5760, _path5761, _path5762, _path5763, _path5764, _path5765, _path5766, _path5767, _path5768, _path5769, _path5770, _path5771, _path5772, _path5773, _path5774, _path5775, _path5776, _path5777, _path5778, _path5779, _path5780, _path5781, _path5782, _path5783, _path5784, _path5785, _path5786, _path5787, _path5788, _path5789, _path5790, _path5791, _path5792, _path5793, _path5794, _path5795, _path5796, _path5797, _path5798, _path5799, _path5800, _path5801, _path5802, _path5803, _path5804, _path5805, _path5806, _path5807, _path5808, _path5809, _path5810, _path5811, _path5812, _path5813, _path5814, _path5815, _path5816, _path5817, _path5818, _path5819, _path5820, _path5821, _path5822, _path5823, _path5824, _path5825, _path5826, _path5827, _path5828, _path5829, _path5830, _path5831, _path5832, _path5833, _path5834, _path5835, _path5836, _path5837, _path5838, _path5839, _path5840, _path5841, _path5842, _path5843, _path5844, _path5845, _path5846, _path5847, _path5848, _path5849, _path5850, _path5851, _path5852, _path5853, _path5854, _path5855, _path5856, _path5857, _path5858, _path5859, _path5860, _path5861, _path5862, _path5863, _path5864, _path5865, _path5866, _path5867, _path5868, _path5869, _path5870, _path5871, _path5872, _path5873, _path5874, _path5875, _path5876, _path5877, _path5878, _path5879, _path5880, _path5881, _path5882, _path5883, _path5884, _path5885, _path5886, _path5887, _path5888, _path5889, _path5890, _path5891, _path5892, _path5893, _path5894, _path5895, _path5896, _path5897, _path5898, _path5899, _path5900, _path5901, _path5902, _path5903, _path5904, _path5905, _path5906, _path5907, _path5908, _path5909, _path5910, _path5911, _path5912, _path5913, _path5914, _path5915, _path5916, _path5917, _path5918, _path5919, _path5920, _path5921, _path5922, _path5923, _path5924, _path5925, _path5926, _path5927, _path5928, _path5929, _path5930, _path5931, _path5932, _path5933, _path5934, _path5935, _path5936, _path5937, _path5938, _path5939, _path5940, _path5941, _path5942, _path5943, _path5944, _path5945, _path5946, _path5947, _path5948, _path5949, _path5950, _path5951, _path5952, _path5953, _path5954, _path5955, _path5956, _path5957, _path5958, _path5959, _path5960, _path5961, _path5962, _path5963, _path5964, _path5965, _path5966, _path5967, _path5968, _path5969, _path5970, _path5971, _path5972, _path5973, _path5974, _path5975, _path5976, _path5977, _path5978, _path5979, _path5980, _path5981, _path5982, _path5983, _path5984, _path5985, _path5986, _path5987, _path5988, _path5989, _path5990, _path5991, _path5992, _path5993, _path5994, _path5995, _path5996, _path5997, _path5998, _path5999, _path6000, _path6001, _path6002, _path6003, _path6004, _path6005, _path6006, _path6007, _path6008, _path6009, _path6010, _path6011, _path6012, _path6013, _path6014, _path6015, _path6016, _path6017, _path6018, _path6019, _path6020, _path6021, _path6022, _path6023, _path6024, _path6025, _path6026, _path6027, _path6028, _path6029, _path6030, _path6031, _path6032, _path6033, _path6034, _path6035, _path6036, _path6037, _path6038, _path6039, _path6040, _path6041, _path6042, _path6043, _path6044, _path6045, _path6046, _path6047, _path6048, _path6049, _path6050, _path6051, _path6052, _path6053, _path6054, _path6055, _path6056, _path6057, _path6058, _path6059, _path6060, _path6061, _path6062, _path6063, _path6064, _path6065, _path6066, _path6067, _path6068, _path6069, _path6070, _path6071, _path6072, _path6073, _path6074, _path6075, _path6076, _path6077, _path6078, _path6079, _path6080, _path6081, _path6082, _path6083, _path6084, _path6085, _path6086, _path6087, _path6088, _path6089, _path6090, _path6091, _path6092, _path6093, _path6094, _path6095, _path6096, _path6097, _path6098, _path6099, _path6100, _path6101, _path6102, _path6103, _path6104, _path6105, _path6106, _path6107, _path6108, _path6109, _path6110, _path6111, _path6112, _path6113, _path6114, _path6115, _path6116, _path6117, _path6118, _path6119, _path6120, _path6121, _path6122, _path6123, _path6124, _path6125, _path6126, _path6127, _path6128, _path6129, _path6130, _path6131, _path6132, _path6133, _path6134, _path6135, _path6136, _path6137, _path6138, _path6139, _path6140, _path6141, _path6142, _path6143, _path6144, _path6145, _path6146, _path6147, _path6148, _path6149, _path6150, _path6151, _path6152, _path6153, _path6154, _path6155, _path6156, _path6157, _path6158, _path6159, _path6160, _path6161, _path6162, _path6163, _path6164, _path6165, _path6166, _path6167, _path6168, _path6169, _path6170, _path6171, _path6172, _path6173, _path6174, _path6175, _path6176, _path6177, _path6178, _path6179, _path6180, _path6181, _path6182, _path6183, _path6184, _path6185, _path6186, _path6187, _path6188, _path6189, _path6190, _path6191, _path6192, _path6193, _path6194, _path6195, _path6196, _path6197, _path6198, _path6199, _path6200, _path6201, _path6202, _path6203, _path6204, _path6205, _path6206, _path6207, _path6208, _path6209, _path6210, _path6211, _path6212, _path6213, _path6214, _path6215, _path6216, _path6217, _path6218, _path6219, _path6220, _path6221, _path6222, _path6223, _path6224, _path6225, _path6226, _path6227, _path6228, _path6229, _path6230, _path6231, _path6232, _path6233, _path6234, _path6235, _path6236, _path6237, _path6238, _path6239, _path6240, _path6241, _path6242, _path6243, _path6244, _path6245, _path6246, _path6247, _path6248, _path6249, _path6250, _path6251, _path6252, _path6253, _path6254, _path6255, _path6256, _path6257, _path6258, _path6259, _path6260, _path6261, _path6262, _path6263, _path6264, _path6265, _path6266, _path6267, _path6268, _path6269, _path6270, _path6271, _path6272, _path6273, _path6274, _path6275, _path6276, _path6277, _path6278, _path6279, _path6280, _path6281, _path6282, _path6283, _path6284, _path6285, _path6286, _path6287, _path6288, _path6289, _path6290, _path6291, _path6292, _path6293, _path6294, _path6295, _path6296, _path6297, _path6298, _path6299, _path6300, _path6301, _path6302, _path6303, _path6304, _path6305, _path6306, _path6307, _path6308, _path6309, _path6310, _path6311, _path6312, _path6313, _path6314, _path6315, _path6316, _path6317, _path6318, _path6319, _path6320, _path6321, _path6322, _path6323, _path6324, _path6325, _path6326, _path6327, _path6328, _path6329, _path6330, _path6331, _path6332, _path6333, _path6334, _path6335, _path6336, _path6337, _path6338, _path6339, _path6340, _path6341, _path6342, _path6343, _path6344, _path6345, _path6346, _path6347, _path6348, _path6349, _path6350, _path6351, _path6352, _path6353, _path6354, _path6355, _path6356, _path6357, _path6358, _path6359, _path6360, _path6361, _path6362, _path6363, _path6364, _path6365, _path6366, _path6367, _path6368, _path6369, _path6370, _path6371, _path6372, _path6373, _path6374, _path6375, _path6376, _path6377, _path6378, _path6379, _path6380, _path6381, _path6382, _path6383, _path6384, _path6385, _path6386, _path6387, _path6388, _path6389, _path6390, _path6391, _path6392, _path6393, _path6394, _path6395, _path6396, _path6397, _path6398, _path6399, _path6400, _path6401, _path6402, _path6403, _path6404, _path6405, _path6406, _path6407, _path6408, _path6409, _path6410, _path6411, _path6412, _path6413, _path6414, _path6415, _path6416, _path6417, _path6418, _path6419, _path6420, _path6421, _path6422, _path6423, _path6424, _path6425, _path6426, _path6427, _path6428, _path6429, _path6430, _path6431, _path6432, _path6433, _path6434, _path6435, _path6436, _path6437, _path6438, _path6439, _path6440, _path6441, _path6442, _path6443, _path6444, _path6445, _path6446, _path6447, _path6448, _path6449, _path6450, _path6451, _path6452, _path6453, _path6454, _path6455, _path6456, _path6457, _path6458, _path6459, _path6460, _path6461, _path6462, _path6463, _path6464, _path6465, _path6466, _path6467, _path6468, _path6469, _path6470, _path6471, _path6472, _path6473, _path6474, _path6475, _path6476, _path6477, _path6478, _path6479, _path6480, _path6481, _path6482, _path6483, _path6484, _path6485, _path6486, _path6487, _path6488, _path6489, _path6490, _path6491, _path6492, _path6493, _path6494, _path6495, _path6496, _path6497, _path6498, _path6499, _path6500, _path6501, _path6502, _path6503, _path6504, _path6505, _path6506, _path6507, _path6508, _path6509, _path6510, _path6511, _path6512, _path6513, _path6514, _path6515, _path6516, _path6517, _path6518, _path6519, _path6520, _path6521, _path6522, _path6523, _path6524, _path6525, _path6526, _path6527, _path6528, _path6529, _path6530, _path6531, _path6532, _path6533, _path6534, _path6535, _path6536, _path6537, _path6538, _path6539, _path6540, _path6541, _path6542, _path6543, _path6544, _path6545, _path6546, _path6547, _path6548, _path6549, _path6550, _path6551, _path6552, _path6553, _path6554, _path6555, _path6556, _path6557, _path6558, _path6559, _path6560, _path6561, _path6562, _path6563, _path6564, _path6565, _path6566, _path6567, _path6568, _path6569, _path6570, _path6571, _path6572, _path6573, _path6574, _path6575, _path6576, _path6577, _path6578, _path6579, _path6580, _path6581, _path6582, _path6583, _path6584, _path6585, _path6586, _path6587, _path6588, _path6589, _path6590, _path6591, _path6592, _path6593, _path6594, _path6595, _path6596, _path6597, _path6598, _path6599, _path6600, _path6601, _path6602, _path6603, _path6604, _path6605, _path6606, _path6607, _path6608, _path6609, _path6610, _path6611, _path6612, _path6613, _path6614, _path6615, _path6616, _path6617, _path6618, _path6619, _path6620, _path6621, _path6622, _path6623, _path6624, _path6625, _path6626, _path6627, _path6628, _path6629, _path6630, _path6631, _path6632, _path6633, _path6634, _path6635, _path6636, _path6637, _path6638, _path6639, _path6640, _path6641, _path6642, _path6643, _path6644, _path6645, _path6646, _path6647, _path6648, _path6649, _path6650, _path6651, _path6652, _path6653, _path6654, _path6655, _path6656, _path6657, _path6658, _path6659, _path6660, _path6661, _path6662, _path6663, _path6664, _path6665, _path6666, _path6667, _path6668, _path6669, _path6670, _path6671, _path6672, _path6673, _path6674, _path6675, _path6676, _path6677, _path6678, _path6679, _path6680, _path6681, _path6682, _path6683, _path6684, _path6685, _path6686, _path6687, _path6688, _path6689, _path6690, _path6691, _path6692, _path6693, _path6694, _path6695, _path6696, _path6697, _path6698, _path6699, _path6700, _path6701, _path6702, _path6703, _path6704, _path6705, _path6706, _path6707, _path6708, _path6709, _path6710, _path6711, _path6712, _path6713, _path6714, _path6715, _path6716, _path6717, _path6718, _path6719, _path6720, _path6721, _path6722, _path6723, _path6724, _path6725, _path6726, _path6727, _path6728, _path6729, _path6730, _path6731, _path6732, _path6733, _path6734, _path6735, _path6736, _path6737, _path6738, _path6739, _path6740, _path6741, _path6742, _path6743, _path6744, _path6745, _path6746, _path6747, _path6748, _path6749, _path6750, _path6751, _path6752, _path6753, _path6754, _path6755, _path6756, _path6757, _path6758, _path6759, _path6760, _path6761, _path6762, _path6763, _path6764, _path6765, _path6766, _path6767, _path6768, _path6769, _path6770, _path6771, _path6772, _path6773, _path6774, _path6775, _path6776, _path6777, _path6778, _path6779, _path6780, _path6781, _path6782, _path6783, _path6784, _path6785, _path6786, _path6787, _path6788, _path6789, _path6790, _path6791, _path6792, _path6793, _path6794, _path6795, _path6796, _path6797, _path6798, _path6799, _path6800, _path6801, _path6802, _path6803, _path6804, _path6805, _path6806, _path6807, _path6808, _path6809, _path6810, _path6811, _path6812, _path6813, _path6814, _path6815, _path6816, _path6817, _path6818, _path6819, _path6820, _path6821, _path6822, _path6823, _path6824, _path6825, _path6826, _path6827, _path6828, _path6829, _path6830, _path6831, _path6832, _path6833, _path6834, _path6835, _path6836, _path6837, _path6838, _path6839, _path6840, _path6841, _path6842, _path6843, _path6844, _path6845, _path6846, _path6847, _path6848, _path6849, _path6850, _path6851, _path6852, _path6853, _path6854, _path6855, _path6856, _path6857, _path6858, _path6859, _path6860, _path6861, _path6862, _path6863, _path6864, _path6865, _path6866, _path6867, _path6868, _path6869, _path6870, _path6871, _path6872, _path6873, _path6874, _path6875, _path6876, _path6877, _path6878, _path6879, _path6880, _path6881, _path6882, _path6883, _path6884, _path6885, _path6886, _path6887, _path6888, _path6889, _path6890, _path6891, _path6892, _path6893, _path6894, _path6895, _path6896, _path6897, _path6898, _path6899, _path6900, _path6901, _path6902, _path6903, _path6904, _path6905, _path6906, _path6907, _path6908, _path6909, _path6910, _path6911, _path6912, _path6913, _path6914, _path6915, _path6916, _path6917, _path6918, _path6919, _path6920, _path6921, _path6922, _path6923, _path6924, _path6925, _path6926, _path6927, _path6928, _path6929, _path6930, _path6931, _path6932, _path6933, _path6934, _path6935, _path6936, _path6937, _path6938, _path6939, _path6940, _path6941, _path6942, _path6943, _path6944, _path6945, _path6946, _path6947, _path6948, _path6949, _path6950, _path6951, _path6952, _path6953, _path6954, _path6955, _path6956, _path6957, _path6958, _path6959, _path6960, _path6961, _path6962, _path6963, _path6964, _path6965, _path6966, _path6967, _path6968, _path6969, _path6970, _path6971, _path6972, _path6973, _path6974, _path6975, _path6976, _path6977, _path6978, _path6979, _path6980, _path6981, _path6982, _path6983, _path6984, _path6985, _path6986, _path6987, _path6988, _path6989, _path6990, _path6991, _path6992, _path6993, _path6994, _path6995, _path6996, _path6997, _path6998, _path6999, _path7000, _path7001, _path7002, _path7003, _path7004, _path7005, _path7006, _path7007, _path7008, _path7009, _path7010, _path7011, _path7012, _path7013, _path7014, _path7015, _path7016, _path7017, _path7018, _path7019, _path7020, _path7021, _path7022, _path7023, _path7024, _path7025, _path7026, _path7027, _path7028, _path7029, _path7030, _path7031, _path7032, _path7033, _path7034, _path7035, _path7036, _path7037, _path7038, _path7039, _path7040, _path7041, _path7042, _path7043, _path7044, _path7045, _path7046, _path7047, _path7048, _path7049, _path7050, _path7051, _path7052, _path7053, _path7054, _path7055, _path7056, _path7057, _path7058, _path7059, _path7060, _path7061, _path7062, _path7063, _path7064, _path7065, _path7066, _path7067, _path7068, _path7069, _path7070, _path7071, _path7072, _path7073, _path7074, _path7075, _path7076, _path7077, _path7078, _path7079, _path7080, _path7081, _path7082, _path7083, _path7084, _path7085, _path7086, _path7087, _path7088, _path7089, _path7090, _path7091, _path7092, _path7093, _path7094, _path7095, _path7096, _path7097, _path7098, _path7099, _path7100, _path7101, _path7102, _path7103, _path7104, _path7105, _path7106, _path7107, _path7108, _path7109, _path7110, _path7111, _path7112, _path7113, _path7114, _path7115, _path7116, _path7117, _path7118, _path7119, _path7120, _path7121, _path7122, _path7123, _path7124, _path7125, _path7126, _path7127, _path7128, _path7129, _path7130, _path7131, _path7132, _path7133, _path7134, _path7135, _path7136, _path7137, _path7138, _path7139, _path7140, _path7141, _path7142, _path7143, _path7144, _path7145, _path7146, _path7147, _path7148, _path7149, _path7150, _path7151, _path7152, _path7153, _path7154, _path7155, _path7156, _path7157, _path7158, _path7159, _path7160, _path7161, _path7162, _path7163, _path7164, _path7165, _path7166, _path7167, _path7168, _path7169, _path7170, _path7171, _path7172, _path7173, _path7174, _path7175, _path7176, _path7177, _path7178, _path7179, _path7180, _path7181, _path7182, _path7183, _path7184, _path7185, _path7186, _path7187, _path7188, _path7189, _path7190, _path7191, _path7192, _path7193, _path7194, _path7195, _path7196, _path7197, _path7198, _path7199, _path7200, _path7201, _path7202, _path7203, _path7204, _path7205, _path7206, _path7207, _path7208, _path7209, _path7210, _path7211, _path7212, _path7213, _path7214, _path7215, _path7216, _path7217, _path7218, _path7219, _path7220, _path7221, _path7222, _path7223, _path7224, _path7225, _path7226, _path7227, _path7228, _path7229, _path7230, _path7231, _path7232, _path7233, _path7234, _path7235, _path7236, _path7237, _path7238, _path7239, _path7240, _path7241, _path7242, _path7243, _path7244, _path7245, _path7246, _path7247, _path7248, _path7249, _path7250, _path7251, _path7252, _path7253, _path7254, _path7255, _path7256, _path7257, _path7258, _path7259, _path7260, _path7261, _path7262, _path7263, _path7264, _path7265, _path7266, _path7267, _path7268, _path7269, _path7270, _path7271, _path7272, _path7273, _path7274, _path7275, _path7276, _path7277, _path7278, _path7279, _path7280, _path7281, _path7282, _path7283, _path7284, _path7285, _path7286, _path7287, _path7288, _path7289, _path7290, _path7291, _path7292, _path7293, _path7294, _path7295, _path7296, _path7297, _path7298, _path7299, _path7300, _path7301, _path7302, _path7303, _path7304, _path7305, _path7306, _path7307, _path7308, _path7309, _path7310, _path7311, _path7312, _path7313, _path7314, _path7315, _path7316, _path7317, _path7318, _path7319, _path7320, _path7321, _path7322, _path7323, _path7324, _path7325, _path7326, _path7327, _path7328, _path7329, _path7330, _path7331, _path7332, _path7333, _path7334, _path7335, _path7336, _path7337, _path7338, _path7339, _path7340, _path7341, _path7342, _path7343, _path7344, _path7345, _path7346, _path7347, _path7348, _path7349, _path7350, _path7351, _path7352, _path7353, _path7354, _path7355, _path7356, _path7357, _path7358, _path7359, _path7360, _path7361, _path7362, _path7363, _path7364, _path7365, _path7366, _path7367, _path7368, _path7369, _path7370, _path7371, _path7372, _path7373, _path7374, _path7375, _path7376, _path7377, _path7378, _path7379, _path7380, _path7381, _path7382, _path7383, _path7384, _path7385, _path7386, _path7387, _path7388, _path7389, _path7390, _path7391, _path7392, _path7393, _path7394, _path7395, _path7396, _path7397, _path7398, _path7399, _path7400, _path7401, _path7402, _path7403, _path7404, _path7405, _path7406, _path7407, _path7408, _path7409, _path7410, _path7411, _path7412, _path7413, _path7414, _path7415, _path7416, _path7417, _path7418, _path7419, _path7420, _path7421, _path7422, _path7423, _path7424, _path7425, _path7426, _path7427, _path7428, _path7429, _path7430, _path7431, _path7432, _path7433, _path7434, _path7435, _path7436, _path7437, _path7438, _path7439, _path7440, _path7441, _path7442, _path7443, _path7444, _path7445, _path7446, _path7447, _path7448, _path7449, _path7450, _path7451, _path7452, _path7453, _path7454, _path7455, _path7456, _path7457, _path7458, _path7459, _path7460, _path7461, _path7462, _path7463, _path7464, _path7465, _path7466, _path7467, _path7468, _path7469, _path7470, _path7471, _path7472, _path7473, _path7474, _path7475, _path7476, _path7477, _path7478, _path7479, _path7480, _path7481, _path7482, _path7483, _path7484, _path7485, _path7486, _path7487, _path7488, _path7489, _path7490, _path7491, _path7492, _path7493, _path7494, _path7495, _path7496, _path7497, _path7498, _path7499, _path7500, _path7501, _path7502, _path7503, _path7504, _path7505, _path7506, _path7507, _path7508, _path7509, _path7510, _path7511, _path7512, _path7513, _path7514, _path7515, _path7516, _path7517, _path7518, _path7519, _path7520, _path7521, _path7522, _path7523, _path7524, _path7525, _path7526, _path7527, _path7528, _path7529, _path7530, _path7531, _path7532, _path7533, _path7534, _path7535, _path7536, _path7537, _path7538, _path7539, _path7540, _path7541, _path7542, _path7543, _path7544, _path7545, _path7546, _path7547, _path7548, _path7549, _path7550, _path7551, _path7552, _path7553, _path7554, _path7555, _path7556, _path7557, _path7558, _path7559, _path7560, _path7561, _path7562, _path7563, _path7564, _path7565, _path7566, _path7567, _path7568, _path7569, _path7570, _path7571, _path7572, _path7573, _path7574, _path7575, _path7576, _path7577, _path7578, _path7579, _path7580, _path7581, _path7582, _path7583, _path7584, _path7585, _path7586, _path7587, _path7588, _path7589, _path7590, _path7591, _path7592, _path7593, _path7594, _path7595, _path7596, _path7597, _path7598, _path7599, _path7600, _path7601, _path7602, _path7603, _path7604, _path7605, _path7606, _path7607, _path7608, _path7609, _path7610, _path7611, _path7612, _path7613, _path7614, _path7615, _path7616, _path7617, _path7618, _path7619, _path7620, _path7621, _path7622, _path7623, _path7624, _path7625, _path7626, _path7627, _path7628, _path7629, _path7630, _path7631, _path7632, _path7633, _path7634, _path7635, _path7636, _path7637, _path7638, _path7639, _path7640, _path7641, _path7642, _path7643, _path7644, _path7645, _path7646, _path7647, _path7648, _path7649, _path7650, _path7651, _path7652, _path7653, _path7654, _path7655, _path7656, _path7657, _path7658, _path7659, _path7660, _path7661, _path7662, _path7663, _path7664, _path7665, _path7666, _path7667, _path7668, _path7669, _path7670, _path7671, _path7672, _path7673, _path7674, _path7675, _path7676, _path7677, _path7678, _path7679, _path7680, _path7681, _path7682, _path7683, _path7684, _path7685, _path7686, _path7687, _path7688, _path7689, _path7690, _path7691, _path7692, _path7693, _path7694, _path7695, _path7696, _path7697, _path7698, _path7699, _path7700, _path7701, _path7702, _path7703, _path7704, _path7705, _path7706, _path7707, _path7708, _path7709, _path7710, _path7711, _path7712, _path7713, _path7714, _path7715, _path7716, _path7717, _path7718, _path7719, _path7720, _path7721, _path7722, _path7723, _path7724, _path7725, _path7726, _path7727, _path7728, _path7729, _path7730, _path7731, _path7732, _path7733, _path7734, _path7735, _path7736, _path7737, _path7738, _path7739, _path7740, _path7741, _path7742, _path7743, _path7744, _path7745, _path7746, _path7747, _path7748, _path7749, _path7750, _path7751, _path7752, _path7753, _path7754, _path7755, _path7756, _path7757, _path7758, _path7759, _path7760, _path7761, _path7762, _path7763, _path7764, _path7765, _path7766, _path7767, _path7768, _path7769, _path7770, _path7771, _path7772, _path7773, _path7774, _path7775, _path7776, _path7777, _path7778, _path7779, _path7780, _path7781, _path7782, _path7783, _path7784, _path7785, _path7786, _path7787, _path7788, _path7789, _path7790, _path7791, _path7792, _path7793, _path7794, _path7795, _path7796, _path7797, _path7798, _path7799, _path7800, _path7801, _path7802, _path7803, _path7804, _path7805, _path7806, _path7807, _path7808, _path7809, _path7810, _path7811, _path7812, _path7813, _path7814, _path7815, _path7816, _path7817, _path7818, _path7819, _path7820, _path7821, _path7822, _path7823, _path7824, _path7825, _path7826, _path7827, _path7828, _path7829, _path7830, _path7831;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrassAndYardClippings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1zm-4 3v-1h1v1zm7-1h1v1h-1zm9 1v-1h1v1zm-1 1v-1h1v1zm-31 2v1h-1v-1zm51 7h-1v-1h1zm-7 0h1v1h-1zm-60 4v1h-1v-1zm64 1h-1v-1h1zm-4 7v-1h1v1zm-84 1v-1h1v1zm8 2h1v1h-1zm80 0v1h-1v-1zm21 11v-1h1v1zM11 61v-1h1v1zm4 10v1h-1v-1zm98 3v-1h1v1zM26 92h1v1h-1zm9 8v1h-1v-1zm-15 3v1h-1v-1zm-2 2v1h-1v-1zm48 1h1v1h-1zm-33 2h-1v-1h1zm55-1v1h-1v-1zm10 2h1v1h-1zm-60 3v1h-1v-1zm39 0v1h-1v-1zm11 1v-1h1v1zm-27 5v-1h1v1zm-9 2h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14h1v1h-1zm7 3h1v1h-1zm7 10h1v1h-1zm-69 7h1v1h-1zm87 4v1h-1v-1zm-10 11h1v1h-1zm16 0h1v1h-1zm3 2v-1h1v1zM17 54h-1v-1h1zm-4 3h1v1h-1zm102 4h1v1h-1zm-98 3h-1v-1h1zm101 22v1h-1v-1zm-7 10h-1v-1h1zm-82 12h-1v-1h1zm40 1v1h-1v-1zm30 6v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1zm11 4h-1v-1h1zm-22 2v1h-1v-1zm48 21v-1h1v1zm3 24h1v1h-1zm-92 6h-1v-1h1zm93 31h1v1h-1zm-74 2v1h-1v-1zm-1 3v1h-1v-1zm-8 3h1v1h-1zm26 3h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1zm-20 3h1v1h-1zm-9 5v-1h1v1zm58 10v1h-1v-1zm4 30v1h-1v-1zm1 2h-1v-1h1zM9 82v-1h1v1zm96 20h-1v-1h1zm-67 4h-1v-1h1zm70-1h1v1h-1zm-21 4v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11v-1h1v1zm2 1h-1v-1h1zm-8 4h1v1h-1zM8 41h1v1H8zm111 10h1v1h-1zM12 72h-1v-1h1zm19 37v-1h1v1zm-3 0v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1zM25 34h1v1h-1zm89 4v-1h1v1zm-93 8v-1h1v1zm-4 40h-1v-1h1zm93 10v1h-1v-1zm-2 2v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1zm27 59h1v1h-1zm-9 28h1v1h-1zm-36 4v1h-1v-1zm-27 9h1v1h-1z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1zm85 39h1v1h-1zm-7 33h1v1h-1zm-38 6v-1h1v1zm-8 6v-1h1v1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M110 39h1v1h-1zm5 12v-1h1v1zM11 59v-1h1v1zm106 2h-1v-1h1zM13 78h-1v-1h1z",
    fill: "#ffa",
    fillOpacity: 0.012
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1zm25 21h1v1h-1zm14 29h1v1h-1zM21 96h1v1h-1z",
    fill: "#7fff7f",
    fillOpacity: 0.008
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1zM22 87h-1v-1h1zm-3 5h-1v-1h1zm51 21v1h-1v-1z",
    fill: "#cc9",
    fillOpacity: 0.02
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h-1v-1h1zM13 61h-1v-1h1zm-1 9v1h-1v-1zm58 40v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111 62v-1h1v1zM9 67v-1h1v1zm105 6h-1v-1h1zm-11 38h-1v-1h1z",
    fill: "#cfc",
    fillOpacity: 0.02
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29 105h1v1h-1zm32 10h1v1h-1zm33 1h-1v-1h1zm-18 1v1h-1v-1z",
    fill: "#d4d4aa",
    fillOpacity: 0.024
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1zM16 96h1v1h-1zm76 20h-1v-1h1z",
    fill: "#aa5",
    fillOpacity: 0.012
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81 13v1h-1v-1zm7 5h1v1h-1zM15 83h-1v-1h1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15h-1v-1h1zM31 32v1h-1v-1zm55 88v-1h1v1z",
    fill: "#b2cc99",
    fillOpacity: 0.039
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1zm38 34h-1v-1h1zM9 67h1v1H9z",
    fill: "#bfbf9f",
    fillOpacity: 0.031
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1zM19 38v1h-1v-1zm97 26v1h-1v-1z",
    fill: "#b6da91",
    fillOpacity: 0.027
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1zm23 14v-1h1v1zM8 91v1H7v-1z",
    fill: "#bfbf7f",
    fillOpacity: 0.016
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M89 20h-1v-1h1zm24 19v-1h1v1zm6 21h-1v-1h1z",
    fill: "#d4d4bf",
    fillOpacity: 0.047
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1zm76 9h1v1h-1zm-67 81h-1v-1h1z",
    fill: "#b0c49c",
    fillOpacity: 0.051
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1zm58 3h-1v-1h1zm8 40v1h-1v-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.027
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111 45h1v1h-1zm-4 38v-1h1v1zm-69 24v1h-1v-1z",
    fill: "#9c6",
    fillOpacity: 0.02
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16 64h1v1h-1zm2 21h-1v-1h1zm44 32h-1v-1h1z",
    fill: "#deb",
    fillOpacity: 0.059
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9 89h1v1H9zm33 20v-1h1v1zm0 3h-1v-1h1z",
    fill: "#aad47f",
    fillOpacity: 0.024
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10h-1V9h1zm-58 96h-1v-1h1z",
    fill: "#c9d4b4",
    fillOpacity: 0.094
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80 12v1h-1v-1zm-9 3h1v1h-1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78 13v1h-1v-1zM15 68h-1v-1h1z",
    fill: "#bfcca5",
    fillOpacity: 0.078
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1zM12 67h-1v-1h1z",
    fill: "#bfd4aa",
    fillOpacity: 0.047
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1zm28 61h-1v-1h1z",
    fill: "#e7e7e7",
    fillOpacity: 0.043
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1zm-24 7v1h-1v-1z",
    fill: "#9f9f7f",
    fillOpacity: 0.031
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1zm-34 3v-1h1v1z",
    fill: "#b2ccb2",
    fillOpacity: 0.039
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1zM24 93h1v1h-1z",
    fill: "#aad49b",
    fillOpacity: 0.071
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1zm26 42v-1h1v1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1zm20 42h1v1h-1z",
    fill: "#c8dab6",
    fillOpacity: 0.055
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1zm-33 82h-1v-1h1z",
    fill: "#a3c891",
    fillOpacity: 0.055
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1zM48 45v-1h1v1z",
    fill: "#50ab31"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1zm64 38v-1h1v1z",
    fill: "#c6e2c6",
    fillOpacity: 0.035
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1zm0 27h-1v-1h1z",
    fill: "#2aa018"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1zm20 16v1h-1v-1z",
    fill: "#1e860f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1zm13 26v-1h1v1z",
    fill: "#257c16"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1zm0 3v1h-1v-1z",
    fill: "#117d0e"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1zm71 49h1v1h-1z",
    fill: "#0f0",
    fillOpacity: 0.004
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1zm26 82v-1h1v1z",
    fill: "#8faf8f",
    fillOpacity: 0.063
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1zm70 44v1h-1v-1z",
    fill: "#a0c684",
    fillOpacity: 0.106
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1zm45 21v1h-1v-1z",
    fill: "#60ac3f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1zm3 17h1v1h-1z",
    fill: "#188914"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1zm5 13h1v1h-1z",
    fill: "#0b7709"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1zM54 72v-1h1v1z",
    fill: "#056906"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1zm18 2h1v1h-1z",
    fill: "#51ac35"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1zM46 70h1v1h-1z",
    fill: "#066105"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1zm2 34h1v1h-1z",
    fill: "#50aa2b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1zM41 72h-1v-1h1z",
    fill: "#44a424"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1zM65 79h1v1h-1z",
    fill: "#166311"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M112 37v-1h1v1zm-37 77h-1v-1h1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1zm29 34v1h-1v-1z",
    fill: "#227817"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1zm-6 34v1h-1v-1z",
    fill: "#33a124"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1zm12 12v1h-1v-1z",
    fill: "#0c670c"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1zm13 22h1v1h-1z",
    fill: "#004903"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1zM41 57h1v1h-1z",
    fill: "#41a523"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1zM34 67h1v1h-1z",
    fill: "#226c12"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1zM45 97h-1v-1h1z",
    fill: "#2b861d"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1zm2 19v-1h1v1z",
    fill: "#054e03"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1zm-9 38h-1v-1h1z",
    fill: "#409f20"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-1zM41 89h1v1h-1z",
    fill: "#8cc43e"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M114 39v-1h1v1zM10 60v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.039
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1zm31 41h1v1h-1z",
    fill: "#185b13"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1zM50 61v-1h1v1z",
    fill: "#4e8e24"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1zm-4 16v1h-1v-1z",
    fill: "#56af2f"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40v-1h1v1zm7 1v-1h1v1z",
    fill: "#cfdfbf",
    fillOpacity: 0.063
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1zm13 17v-1h1v1z",
    fill: "#49a725"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1zm10 48h1v1h-1z",
    fill: "#1e8215"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1zm8 22h-1v-1h1z",
    fill: "#94be7a",
    fillOpacity: 0.31
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1zm34 3h-1v-1h1z",
    fill: "#309326"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1zm28 47h-1v-1h1z",
    fill: "#066706"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1zm41 76v-1h1v1z",
    fill: "#aad4aa",
    fillOpacity: 0.024
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1zm2 45h-1v-1h1z",
    fill: "#409a22"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1zm8 45v1h-1v-1z",
    fill: "#3f9325"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1zm11 16h-1v-1h1z",
    fill: "#0e5e0c"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1zM79 79h-1v-1h1z",
    fill: "#3b9b23"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1zm53 47h1v1h-1z",
    fill: "#409f29"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1zM24 74h1v1h-1z",
    fill: "#228c12"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1zm-8 5v1h-1v-1z",
    fill: "#2c9d20"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1zM35 92v1h-1v-1z",
    fill: "#7cba2d"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1zm28 35h-1v-1h1z",
    fill: "#055c07"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1zm26 40v-1h1v1z",
    fill: "#14750c"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1zm19 3h-1v-1h1z",
    fill: "#53a732"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1zm24 6h-1v-1h1z",
    fill: "#3b992d"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1zm17 10v1h-1v-1z",
    fill: "#10800c"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1zM47 86h-1v-1h1z",
    fill: "#679b3f"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1zm28 0h1v1h-1z",
    fill: "#045003"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1zM47 79h1v1h-1z",
    fill: "#1b7015"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M108 51h-1v-1h1zM15 98h1v1h-1z",
    fill: "#7fbf7f",
    fillOpacity: 0.016
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M121 51h-1v-1h1zm-7 24v1h-1v-1z",
    fill: "#cddecd",
    fillOpacity: 0.122
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1zm34 4v1h-1v-1z",
    fill: "#3ba718"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1zM19 77v1h-1v-1z",
    fill: "#2c9416"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52h-1v-1h1zm-17 53h-1v-1h1z",
    fill: "#cce5cc",
    fillOpacity: 0.039
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1zm32 4h1v1h-1z",
    fill: "#439931"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1zm38 46h1v1h-1z",
    fill: "#4bad25"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1zM67 93v-1h1v1z",
    fill: "#14800a"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1zm-14 53v-1h1v1z",
    fill: "#78ba42"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v1h-1v-1zm-9 49v1h-1v-1z",
    fill: "#3d9721"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1zm-6 43h-1v-1h1z",
    fill: "#034c05"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1zm54 38h-1v-1h1z",
    fill: "#3a921f"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56h-1v-1h1zm-14 3v-1h1v1z",
    fill: "#1f6914"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55v1h-1v-1zm4 21h1v1h-1z",
    fill: "#002500"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1zm-3 36h1v1h-1z",
    fill: "#36a224"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1zm6 39h-1v-1h1z",
    fill: "#72b747"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1zm29 46v-1h1v1z",
    fill: "#5aac24"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1zm42 0h-1v-1h1z",
    fill: "#045604"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h-1v-1h1zm26 5v-1h1v1z",
    fill: "#1b750f"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1zm-44 3h1v1h-1z",
    fill: "#339e1c"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M62 60h-1v-1h1zm21 19v-1h1v1z",
    fill: "#3a9423"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M118 59v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#ccb",
    fillOpacity: 0.059
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62h-1v-1h1zm25 38v-1h1v1z",
    fill: "#45a11c"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61h1v1h-1zm45 26h1v1h-1z",
    fill: "#57a832"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M42 62v-1h1v1zm50 40v-1h1v1z",
    fill: "#2e921e"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1zm28 36h-1v-1h1z",
    fill: "#127809"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1zm-10 6h1v1h-1z",
    fill: "#0a590a"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M74 61h1v1h-1zm-21 7h-1v-1h1z",
    fill: "#064c07"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M75 63v-1h1v1zm8 10v1h-1v-1z",
    fill: "#0e6c0c"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1zM54 73v1h-1v-1z",
    fill: "#13720c"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v-1h1v1zm3 25h-1v-1h1z",
    fill: "#0b560a"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M70 64h-1v-1h1zM44 82v-1h1v1z",
    fill: "#12860e"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63v1h-1v-1zm-67 53h-1v-1h1z",
    fill: "#afa",
    fillOpacity: 0.012
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65v-1h1v1zM53 79v1h-1v-1z",
    fill: "#066607"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h-1v-1h1zm35 15v-1h1v1z",
    fill: "#58a52f"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1zM27 78v-1h1v1z",
    fill: "#188512"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1zm-44 7h1v1h-1z",
    fill: "#058204"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1zm5 32v-1h1v1z",
    fill: "#29881e"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M109 65h1v1h-1zm7 22v-1h1v1z",
    fill: "#c6e2aa",
    fillOpacity: 0.035
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67h-1v-1h1zm-4 9v1h-1v-1z",
    fill: "#3ea326"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67v-1h1v1zm35-1v1h-1v-1z",
    fill: "#2f9314"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1zM42 94h1v1h-1z",
    fill: "#087f09"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M109 68v-1h1v1zM14 89v1h-1v-1z",
    fill: "#8dc671",
    fillOpacity: 0.035
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M74 69v-1h1v1zM30 80h-1v-1h1z",
    fill: "#52aa32"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1zm1 6h-1v-1h1z",
    fill: "#0d9717"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70v-1h1v1zM50 95v1h-1v-1z",
    fill: "#328216"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71h-1v-1h1zm-5 30v1h-1v-1z",
    fill: "#087a08"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M89 70h1v1h-1zM67 91h1v1h-1z",
    fill: "#39a120"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1zm0 20h1v1h-1z",
    fill: "#21880f"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1zm-34 33v1h-1v-1z",
    fill: "#1e7b0b"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73h-1v-1h1zm2 15v-1h1v1z",
    fill: "#238916"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1zm22 24v1h-1v-1z",
    fill: "#3d9b21"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73h1v1h-1zm20 25h-1v-1h1z",
    fill: "#419f2e"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1zm14 9h1v1h-1z",
    fill: "#055707"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1zm-46 1h1v1h-1z",
    fill: "#45a626"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74v1h-1v-1zm24 22h1v1h-1z",
    fill: "#065607"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76h1v1h-1zm59 14v-1h1v1z",
    fill: "#027a03"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1zm-30 5h1v1h-1z",
    fill: "#5fb136"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm19 23v-1h1v1z",
    fill: "#177710"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h-1v-1h1zm-3 8v-1h1v1z",
    fill: "#077108"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1zm32 2h1v1h-1z",
    fill: "#309521"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1zm22 17v1h-1v-1z",
    fill: "#0b5305"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M50 78v-1h1v1zm14 7v-1h1v1z",
    fill: "#59a634"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1zm27 14h1v1h-1z",
    fill: "#33891f"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1zm7 3h1v1h-1z",
    fill: "#083f09"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1zm44 16h-1v-1h1z",
    fill: "#3d9e20"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M48 83h-1v-1h1zM36 96h1v1h-1z",
    fill: "#4cb02a"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M116 83h-1v-1h1zm-29 34v-1h1v1z",
    fill: "#aac671",
    fillOpacity: 0.035
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1zm9 9h-1v-1h1z",
    fill: "#215e17"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1zm-5 9v1h-1v-1z",
    fill: "#3e8522"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1zm20 2v1h-1v-1z",
    fill: "#0d570e"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1zm65 18h1v1h-1z",
    fill: "#7fbf6a",
    fillOpacity: 0.047
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1zm-5 2v-1h1v1z",
    fill: "#7cbc48"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1zm-10 8h-1v-1h1z",
    fill: "#61b736"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1zm2 4v1h-1v-1z",
    fill: "#18820e"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1zm3 1v1h-1v-1z",
    fill: "#359921"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M107 103v1h-1v-1zm-75 5h1v1h-1z",
    fill: "#e7e7d0",
    fillOpacity: 0.043
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1zm-46 6v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M76 10h-1V9h1z",
    fill: "#ccccb2",
    fillOpacity: 0.039
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10v1h-1v-1z",
    fill: "#bcc6ae",
    fillOpacity: 0.212
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M77 11v-1h1v1z",
    fill: "#cdd5bd",
    fillOpacity: 0.122
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M78 11v1h-1v-1z",
    fill: "#bfcab0",
    fillOpacity: 0.267
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M78 12v-1h1v1z",
    fill: "#cca",
    fillOpacity: 0.059
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h1v1h-1z",
    fill: "#a8c090",
    fillOpacity: 0.208
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M79 13h-1v-1h1z",
    fill: "#a7bf94",
    fillOpacity: 0.412
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#acc592",
    fillOpacity: 0.157
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14h-1v-1h1z",
    fill: "#b6cca3",
    fillOpacity: 0.275
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v-1h1v1z",
    fill: "#a6bb98",
    fillOpacity: 0.282
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#9eb87d",
    fillOpacity: 0.271
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#aac387",
    fillOpacity: 0.2
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1z",
    fill: "#bfd0ad",
    fillOpacity: 0.173
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1z",
    fill: "#a5b390",
    fillOpacity: 0.145
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M81 15h-1v-1h1z",
    fill: "#a4b791",
    fillOpacity: 0.31
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#97b46c",
    fillOpacity: 0.416
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#a0b974",
    fillOpacity: 0.318
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#96b773",
    fillOpacity: 0.365
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h-1v-1h1z",
    fill: "#bfccad",
    fillOpacity: 0.22
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16h-1v-1h1z",
    fill: "#94af84",
    fillOpacity: 0.188
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v-1h1v1z",
    fill: "#9eb58b",
    fillOpacity: 0.259
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#aabf7f",
    fillOpacity: 0.047
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#a6bc79",
    fillOpacity: 0.09
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#96b45a",
    fillOpacity: 0.067
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#a0be5c",
    fillOpacity: 0.573
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#a4c16c",
    fillOpacity: 0.341
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#87a95d",
    fillOpacity: 0.502
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#8eb15c",
    fillOpacity: 0.259
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#99b577",
    fillOpacity: 0.176
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v1h-1v-1z",
    fill: "#94b46f",
    fillOpacity: 0.243
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16v1h-1v-1z",
    fill: "#c1d1b2",
    fillOpacity: 0.196
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h1v1h-1z",
    fill: "#d4d4aa",
    fillOpacity: 0.047
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1z",
    fill: "#8caa76",
    fillOpacity: 0.271
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#84a66b",
    fillOpacity: 0.204
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#e5e5dd",
    fillOpacity: 0.118
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#a5c566",
    fillOpacity: 0.157
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#a2bf5c",
    fillOpacity: 0.412
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#7c9e4b",
    fillOpacity: 0.145
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#92b74f",
    fillOpacity: 0.655
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#a7c75d",
    fillOpacity: 0.608
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#8ead66",
    fillOpacity: 0.098
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#91af5c",
    fillOpacity: 0.467
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#96b668",
    fillOpacity: 0.471
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#8fb860",
    fillOpacity: 0.58
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#86bb50",
    fillOpacity: 0.075
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#bcceb0",
    fillOpacity: 0.165
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1z",
    fill: "#bbd2ac",
    fillOpacity: 0.133
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#7ca562",
    fillOpacity: 0.459
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#7aa65d",
    fillOpacity: 0.204
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1z",
    fill: "#9bb579",
    fillOpacity: 0.231
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1z",
    fill: "#e4e4db",
    fillOpacity: 0.114
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#a6bc58",
    fillOpacity: 0.09
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#9cbd53",
    fillOpacity: 0.549
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#82ab58",
    fillOpacity: 0.361
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#84a854",
    fillOpacity: 0.475
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#b4ce7d",
    fillOpacity: 0.494
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#bacd89",
    fillOpacity: 0.102
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#93ae5d",
    fillOpacity: 0.149
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#87b351",
    fillOpacity: 0.663
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#84b34c",
    fillOpacity: 0.573
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#bacdb0",
    fillOpacity: 0.102
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19v-1h1v1z",
    fill: "#b0cca6",
    fillOpacity: 0.216
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1z",
    fill: "#69a749",
    fillOpacity: 0.71
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1z",
    fill: "#84af58",
    fillOpacity: 0.553
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1z",
    fill: "#90b367",
    fillOpacity: 0.29
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1z",
    fill: "#e4e4d3",
    fillOpacity: 0.114
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#b8c68d",
    fillOpacity: 0.071
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#cce57f",
    fillOpacity: 0.039
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#89b439",
    fillOpacity: 0.788
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#7fab4a",
    fillOpacity: 0.431
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#a8c172",
    fillOpacity: 0.392
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#95b654",
    fillOpacity: 0.69
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#6a9c41",
    fillOpacity: 0.122
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#7dae52",
    fillOpacity: 0.533
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1z",
    fill: "#7eb24e",
    fillOpacity: 0.482
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#adc7a0",
    fillOpacity: 0.306
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#509f3c",
    fillOpacity: 0.545
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#66a736",
    fillOpacity: 0.729
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1z",
    fill: "#81b340",
    fillOpacity: 0.922
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20h-1v-1h1z",
    fill: "#b2dd99",
    fillOpacity: 0.118
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1z",
    fill: "#dbe4ca",
    fillOpacity: 0.114
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#b7ca65",
    fillOpacity: 0.365
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#adc368",
    fillOpacity: 0.753
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#7faa55",
    fillOpacity: 0.047
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#74a839",
    fillOpacity: 0.557
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#80b02b",
    fillOpacity: 0.831
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#e5e5b2",
    fillOpacity: 0.039
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#9cba64",
    fillOpacity: 0.6
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#82ac4f",
    fillOpacity: 0.788
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#519327",
    fillOpacity: 0.906
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#519726",
    fillOpacity: 0.733
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#6ba037",
    fillOpacity: 0.38
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#7fad51",
    fillOpacity: 0.086
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1z",
    fill: "#5c9445",
    fillOpacity: 0.216
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#68aa35",
    fillOpacity: 0.871
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#60a238",
    fillOpacity: 0.651
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#8db384",
    fillOpacity: 0.106
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#a9c495",
    fillOpacity: 0.361
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#9fbf9f",
    fillOpacity: 0.094
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#56aa49",
    fillOpacity: 0.475
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#3b9d28",
    fillOpacity: 0.953
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#8cb648",
    fillOpacity: 0.8
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#83b833",
    fillOpacity: 0.996
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#7eba54",
    fillOpacity: 0.616
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1z",
    fill: "#95a782",
    fillOpacity: 0.161
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1z",
    fill: "#c0ceb3",
    fillOpacity: 0.145
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#accb5f",
    fillOpacity: 0.231
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#a7c440",
    fillOpacity: 0.945
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#b7cc6f",
    fillOpacity: 0.459
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#bfd4bf",
    fillOpacity: 0.047
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#b3c790",
    fillOpacity: 0.145
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#b2c3aa",
    fillOpacity: 0.118
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#adc5a2",
    fillOpacity: 0.086
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#87b45a",
    fillOpacity: 0.133
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#72a53c",
    fillOpacity: 0.592
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#7aa845",
    fillOpacity: 0.302
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#87b335",
    fillOpacity: 0.651
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#87b145",
    fillOpacity: 0.502
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#86a954",
    fillOpacity: 0.714
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#9bb982",
    fillOpacity: 0.2
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#53943c",
    fillOpacity: 0.216
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#4e9523",
    fillOpacity: 0.51
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#6ca136",
    fillOpacity: 0.729
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#7eab4a",
    fillOpacity: 0.71
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#85b04a",
    fillOpacity: 0.525
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#8ab450",
    fillOpacity: 0.31
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#a3bf6d",
    fillOpacity: 0.11
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#6dab47",
    fillOpacity: 0.31
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#53a434",
    fillOpacity: 0.929
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1z",
    fill: "#399027",
    fillOpacity: 0.871
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M79 21h1v1h-1z",
    fill: "#59a539",
    fillOpacity: 0.82
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#60a53b",
    fillOpacity: 0.871
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#48a528",
    fillOpacity: 0.996
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#72b134",
    fillOpacity: 0.902
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#80b22b",
    fillOpacity: 0.969
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22v-1h1v1z",
    fill: "#82b74f",
    fillOpacity: 0.784
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#86ac6a",
    fillOpacity: 0.365
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#b8c1b8",
    fillOpacity: 0.114
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#bfc9b4",
    fillOpacity: 0.094
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#bfcf77",
    fillOpacity: 0.125
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#92ba30",
    fillOpacity: 0.878
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#90bc2d"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#8cb553",
    fillOpacity: 0.8
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#95b76f",
    fillOpacity: 0.557
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#a8c08b",
    fillOpacity: 0.208
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#95af57",
    fillOpacity: 0.227
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#82a839",
    fillOpacity: 0.902
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#85aa45",
    fillOpacity: 0.404
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#8eb75d",
    fillOpacity: 0.267
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#77a940",
    fillOpacity: 0.686
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#7daf4f",
    fillOpacity: 0.302
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#8ab466",
    fillOpacity: 0.282
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#79ad2e",
    fillOpacity: 0.839
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#87b032",
    fillOpacity: 0.894
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#bcbc6e",
    fillOpacity: 0.09
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#7fb691",
    fillOpacity: 0.055
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#66a856",
    fillOpacity: 0.196
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#68ac41",
    fillOpacity: 0.459
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#5daa2e",
    fillOpacity: 0.953
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#59a828",
    fillOpacity: 0.953
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#6dad3d",
    fillOpacity: 0.796
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1z",
    fill: "#74ac42",
    fillOpacity: 0.816
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#539f22",
    fillOpacity: 0.925
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1z",
    fill: "#40a619"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23h-1v-1h1z",
    fill: "#19820a",
    fillOpacity: 0.776
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1z",
    fill: "#55a330",
    fillOpacity: 0.765
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#52ac2b"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#34a41b"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1z",
    fill: "#45a526",
    fillOpacity: 0.902
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#6da44a",
    fillOpacity: 0.31
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#7cae2c",
    fillOpacity: 0.922
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#97c365",
    fillOpacity: 0.6
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#84b467",
    fillOpacity: 0.416
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#bfccb2",
    fillOpacity: 0.078
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#b1c3a0",
    fillOpacity: 0.169
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#80b62e",
    fillOpacity: 0.714
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#7fb817"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#78a92a",
    fillOpacity: 0.898
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#7db442",
    fillOpacity: 0.941
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#80b256",
    fillOpacity: 0.38
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#96b67c",
    fillOpacity: 0.345
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#87ad5c",
    fillOpacity: 0.259
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#b9b973",
    fillOpacity: 0.043
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#82ab2a",
    fillOpacity: 0.561
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#6fad24",
    fillOpacity: 0.984
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#57a21b",
    fillOpacity: 0.976
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#5ca029",
    fillOpacity: 0.678
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#6ba351",
    fillOpacity: 0.502
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#6ba14e",
    fillOpacity: 0.612
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#7bac36",
    fillOpacity: 0.808
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#79ab32",
    fillOpacity: 0.694
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#2f7b2f",
    fillOpacity: 0.275
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#2d7a24",
    fillOpacity: 0.573
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#25801f",
    fillOpacity: 0.741
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#27851f",
    fillOpacity: 0.706
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#308b27",
    fillOpacity: 0.667
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#338722",
    fillOpacity: 0.812
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#318512",
    fillOpacity: 0.961
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#338a0f",
    fillOpacity: 0.796
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#379016",
    fillOpacity: 0.541
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#4d9c2b",
    fillOpacity: 0.557
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#4a9c29",
    fillOpacity: 0.945
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#53a02e",
    fillOpacity: 0.839
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#7ab23b",
    fillOpacity: 0.588
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#76b052",
    fillOpacity: 0.498
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#46a039",
    fillOpacity: 0.667
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#5fb72b"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#4ca923"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#45a329",
    fillOpacity: 0.996
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#3b912c",
    fillOpacity: 0.827
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#6a2",
    fillOpacity: 0.933
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#89b953",
    fillOpacity: 0.62
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#87b664",
    fillOpacity: 0.569
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#8fb478",
    fillOpacity: 0.216
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#a1c086",
    fillOpacity: 0.224
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#7fbf5f",
    fillOpacity: 0.063
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#76a655",
    fillOpacity: 0.6
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#9bb886",
    fillOpacity: 0.141
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#78ae3f",
    fillOpacity: 0.298
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#67a71e",
    fillOpacity: 0.722
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#5fa910"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#75b034",
    fillOpacity: 0.859
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#8cb572",
    fillOpacity: 0.149
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#73ac47",
    fillOpacity: 0.561
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#72a743",
    fillOpacity: 0.447
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#8faf5f",
    fillOpacity: 0.063
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#83a559",
    fillOpacity: 0.412
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#669c41",
    fillOpacity: 0.537
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#55ab37",
    fillOpacity: 0.49
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#409b13",
    fillOpacity: 0.969
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#4ca51d"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#599f19"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#56932d",
    fillOpacity: 0.576
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#468f32",
    fillOpacity: 0.769
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#61a221",
    fillOpacity: 0.988
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#669f2e",
    fillOpacity: 0.992
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#408230",
    fillOpacity: 0.859
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#317f23",
    fillOpacity: 0.541
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#287c21",
    fillOpacity: 0.298
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#2f7a21",
    fillOpacity: 0.212
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#39711b",
    fillOpacity: 0.467
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#3d751b",
    fillOpacity: 0.8
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#36821b",
    fillOpacity: 0.922
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#429133",
    fillOpacity: 0.255
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#288723",
    fillOpacity: 0.392
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#2e8a27",
    fillOpacity: 0.71
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#3c9126",
    fillOpacity: 0.467
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#7aa55b",
    fillOpacity: 0.416
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#85aa91",
    fillOpacity: 0.082
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1z",
    fill: "#299b33",
    fillOpacity: 0.851
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1z",
    fill: "#229c18"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#54ae27"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#439c21",
    fillOpacity: 0.816
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#77b449",
    fillOpacity: 0.761
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#6ab242",
    fillOpacity: 0.8
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#62a91e",
    fillOpacity: 0.922
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#4a9628",
    fillOpacity: 0.894
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#5ea538",
    fillOpacity: 0.878
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#62a447",
    fillOpacity: 0.576
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#89b76f",
    fillOpacity: 0.349
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#78af49",
    fillOpacity: 0.341
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#6aac3d",
    fillOpacity: 0.894
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#9dc291",
    fillOpacity: 0.082
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#94c36a",
    fillOpacity: 0.169
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#9bbf66",
    fillOpacity: 0.412
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#84b244",
    fillOpacity: 0.784
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#70ad1d"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#69af0b"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#6ea12e",
    fillOpacity: 0.714
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#9dc07f",
    fillOpacity: 0.4
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#66a93b",
    fillOpacity: 0.42
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#60a137",
    fillOpacity: 0.612
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#4da83f",
    fillOpacity: 0.22
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#44991c",
    fillOpacity: 0.882
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#349016",
    fillOpacity: 0.894
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#3e9713"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#64a326"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#5c991f"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#358606"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#3b881d"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#6aaa29"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#81ad42",
    fillOpacity: 0.929
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#8fa47f",
    fillOpacity: 0.188
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#a99",
    fillOpacity: 0.059
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#387723",
    fillOpacity: 0.369
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#20750d",
    fillOpacity: 0.8
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#377623",
    fillOpacity: 0.796
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#548c3d",
    fillOpacity: 0.392
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#188a15",
    fillOpacity: 0.933
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#109211",
    fillOpacity: 0.91
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#248d24",
    fillOpacity: 0.741
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1z",
    fill: "#796",
    fillOpacity: 0.059
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#6aa752",
    fillOpacity: 0.592
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#27992f",
    fillOpacity: 0.863
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#26a123"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#30a41a"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1z",
    fill: "#4aaa26",
    fillOpacity: 0.973
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#6aaa58",
    fillOpacity: 0.329
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#7dbb46",
    fillOpacity: 0.651
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#61ac29",
    fillOpacity: 0.953
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#5ea81d",
    fillOpacity: 0.984
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#75ae4e",
    fillOpacity: 0.675
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#63a531",
    fillOpacity: 0.937
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#55a622"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#63ac33",
    fillOpacity: 0.925
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#60aa57",
    fillOpacity: 0.341
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M102 25h1v1h-1z",
    fill: "#a4bd94",
    fillOpacity: 0.122
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M103 26v-1h1v1z",
    fill: "#9db392",
    fillOpacity: 0.184
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#72b03d",
    fillOpacity: 0.663
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#67ab35",
    fillOpacity: 0.635
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#7fac56",
    fillOpacity: 0.29
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#75a64a",
    fillOpacity: 0.588
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#7caa4a",
    fillOpacity: 0.58
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#a7cd75",
    fillOpacity: 0.682
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#9bcb59"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#73ac1d"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#63991d",
    fillOpacity: 0.722
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#91b691",
    fillOpacity: 0.055
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#a3c67a",
    fillOpacity: 0.459
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#b3d085",
    fillOpacity: 0.173
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#5fa743",
    fillOpacity: 0.251
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#4a9825",
    fillOpacity: 0.871
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#409c2e",
    fillOpacity: 0.78
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#298f11",
    fillOpacity: 0.961
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#358b1b",
    fillOpacity: 0.467
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#3f6f4f",
    fillOpacity: 0.063
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#297f1a",
    fillOpacity: 0.533
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#3a8b16",
    fillOpacity: 0.988
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#498e1d"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#489014"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#3f8e14"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#6aab2d"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#85b43e",
    fillOpacity: 0.898
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#458530",
    fillOpacity: 0.561
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#2a6d17",
    fillOpacity: 0.886
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#286f14"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#21811b"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#107b14",
    fillOpacity: 0.98
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#0f7311",
    fillOpacity: 0.933
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#1c8012",
    fillOpacity: 0.867
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#339437",
    fillOpacity: 0.29
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#197d1b",
    fillOpacity: 0.757
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#27792a",
    fillOpacity: 0.451
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#4fa45a",
    fillOpacity: 0.341
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#1a902b",
    fillOpacity: 0.902
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#1d9a26"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#51ac29"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#33a120",
    fillOpacity: 0.969
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#67a84e",
    fillOpacity: 0.659
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#62b02f",
    fillOpacity: 0.941
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#6fb235",
    fillOpacity: 0.886
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#5caa22",
    fillOpacity: 0.949
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#8db755",
    fillOpacity: 0.659
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#7fb071",
    fillOpacity: 0.369
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#68a730",
    fillOpacity: 0.82
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#50a619",
    fillOpacity: 0.969
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#1a8120",
    fillOpacity: 0.788
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#23822e",
    fillOpacity: 0.561
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#4d9b5c",
    fillOpacity: 0.141
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26v1h-1v-1z",
    fill: "#699e4e",
    fillOpacity: 0.435
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M100 27v-1h1v1z",
    fill: "#84b766",
    fillOpacity: 0.098
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26h1v1h-1z",
    fill: "#9fba88",
    fillOpacity: 0.22
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v-1h1v1z",
    fill: "#9cb881",
    fillOpacity: 0.255
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M103 27v-1h1v1z",
    fill: "#94bf94",
    fillOpacity: 0.047
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#6db133",
    fillOpacity: 0.878
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#6cab37",
    fillOpacity: 0.396
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#8daa71",
    fillOpacity: 0.035
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#70a34c",
    fillOpacity: 0.275
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#6fa547",
    fillOpacity: 0.549
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#7aa94b",
    fillOpacity: 0.573
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#85ac5a",
    fillOpacity: 0.231
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#a5b89f",
    fillOpacity: 0.157
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#9bb85e",
    fillOpacity: 0.212
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#97c244"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#9aca46"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#90b55a",
    fillOpacity: 0.353
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#718dc6",
    fillOpacity: 0.035
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#73b341",
    fillOpacity: 0.925
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#63a938",
    fillOpacity: 0.831
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#288820",
    fillOpacity: 0.835
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#1d8d14"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#2a8e23",
    fillOpacity: 0.965
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#2a7e17",
    fillOpacity: 0.38
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#a3b6b6",
    fillOpacity: 0.055
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#67a071",
    fillOpacity: 0.106
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#4b9641",
    fillOpacity: 0.306
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#4b932d",
    fillOpacity: 0.882
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#579b29"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#3e9417"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#4d9817"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#73b036"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#2b8210"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#076a02"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#077104"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#087304"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#046a04"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#047304"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#278f14",
    fillOpacity: 0.957
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#148016",
    fillOpacity: 0.784
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#0b7c0d",
    fillOpacity: 0.957
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#0d8319"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#109529"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#11961b"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#2e9d19"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#4aae25"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#258c14",
    fillOpacity: 0.933
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#309d1b",
    fillOpacity: 0.941
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#59aa3e",
    fillOpacity: 0.627
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#50a724",
    fillOpacity: 0.914
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#85c34f",
    fillOpacity: 0.553
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M85 28h-1v-1h1z",
    fill: "#55a223",
    fillOpacity: 0.922
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1z",
    fill: "#82b54e",
    fillOpacity: 0.749
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1z",
    fill: "#518e47",
    fillOpacity: 0.392
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#82b35c",
    fillOpacity: 0.184
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#6ba731",
    fillOpacity: 0.78
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#5ca24d",
    fillOpacity: 0.129
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#1e7a2b",
    fillOpacity: 0.557
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#1e7d27",
    fillOpacity: 0.827
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#277c34",
    fillOpacity: 0.553
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#528b62",
    fillOpacity: 0.122
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#5d9c44",
    fillOpacity: 0.204
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v-1h1v1z",
    fill: "#529c35",
    fillOpacity: 0.761
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M101 28h-1v-1h1z",
    fill: "#a0bf7f",
    fillOpacity: 0.329
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v1h-1v-1z",
    fill: "#a0b884",
    fillOpacity: 0.212
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#82b64e",
    fillOpacity: 0.192
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#64ac29",
    fillOpacity: 0.941
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#77b643",
    fillOpacity: 0.192
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#5a9652",
    fillOpacity: 0.133
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#609e48",
    fillOpacity: 0.384
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#74a352",
    fillOpacity: 0.533
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#7eab5f",
    fillOpacity: 0.396
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#91bd6d",
    fillOpacity: 0.137
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#9db984",
    fillOpacity: 0.318
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#9dbb8c",
    fillOpacity: 0.235
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#95b482",
    fillOpacity: 0.361
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#96b450",
    fillOpacity: 0.2
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#7ca335",
    fillOpacity: 0.675
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#a0ce61",
    fillOpacity: 0.635
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#99c54f",
    fillOpacity: 0.922
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#5ea330",
    fillOpacity: 0.643
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#3a9025",
    fillOpacity: 0.804
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#63a72c",
    fillOpacity: 0.953
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#339412"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#0c7305"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#3d822c",
    fillOpacity: 0.894
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#64983d",
    fillOpacity: 0.584
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#659d52",
    fillOpacity: 0.482
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#4b9446",
    fillOpacity: 0.82
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#2e9231",
    fillOpacity: 0.647
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#1f9029",
    fillOpacity: 0.29
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#549f32",
    fillOpacity: 0.71
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#4ba429"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#19790e"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#42911f"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#5fa42e"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#2e861c"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#107911"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#0e7912"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#0a730b"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#026c06"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#056e06"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#138414"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#178e16"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#0f871c"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#0b9823"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#0e9021"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#14820d"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#43a01d"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#359c24",
    fillOpacity: 0.992
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#409532",
    fillOpacity: 0.671
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#45a530",
    fillOpacity: 0.847
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#3ea725"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h1v1h-1z",
    fill: "#4ca824",
    fillOpacity: 0.949
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#5eaa34",
    fillOpacity: 0.612
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1z",
    fill: "#5eab28",
    fillOpacity: 0.933
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#66b149",
    fillOpacity: 0.784
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#3d9127",
    fillOpacity: 0.733
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#74ac32",
    fillOpacity: 0.557
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#79ab30",
    fillOpacity: 0.89
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#82b34b",
    fillOpacity: 0.184
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#34893a",
    fillOpacity: 0.153
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#1b7b28",
    fillOpacity: 0.592
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#1a7427",
    fillOpacity: 0.827
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-1v-1h1z",
    fill: "#1a702b",
    fillOpacity: 0.455
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#6b9375",
    fillOpacity: 0.196
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#84a17a",
    fillOpacity: 0.384
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#aabf9f",
    fillOpacity: 0.094
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#5b9e3b",
    fillOpacity: 0.592
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29v-1h1v1z",
    fill: "#63a53e",
    fillOpacity: 0.573
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v-1h1v1z",
    fill: "#aec9a1",
    fillOpacity: 0.075
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M35 30h-1v-1h1z",
    fill: "#6dab31",
    fillOpacity: 0.384
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#52a51b",
    fillOpacity: 0.98
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#4a943c",
    fillOpacity: 0.592
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#4f9042",
    fillOpacity: 0.604
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#63a256",
    fillOpacity: 0.302
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#a5c493",
    fillOpacity: 0.224
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#adc8a3",
    fillOpacity: 0.11
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#9db685",
    fillOpacity: 0.082
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#96af79",
    fillOpacity: 0.239
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#91ba7d",
    fillOpacity: 0.455
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#95b68a",
    fillOpacity: 0.18
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#93b57f",
    fillOpacity: 0.149
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#7ba660",
    fillOpacity: 0.373
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#8fbe50",
    fillOpacity: 0.773
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#86bb37"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#84b252",
    fillOpacity: 0.573
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#6daf3d",
    fillOpacity: 0.792
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#026001"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#3b781f"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#519221"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#398a19",
    fillOpacity: 0.973
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#499722",
    fillOpacity: 0.976
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#50ab2d"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#23991a"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#139310"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#1c9316"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30h-1v-1h1z",
    fill: "#086f0b"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#569f2a"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#256b1a",
    fillOpacity: 0.957
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#0d6113",
    fillOpacity: 0.514
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#196e22",
    fillOpacity: 0.235
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#166916",
    fillOpacity: 0.314
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#1b7019",
    fillOpacity: 0.839
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#197312"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#2c8b21"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#22982c"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#0e9d2a"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#0c971a"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#2d9714"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#198d0e"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#147e0e",
    fillOpacity: 0.996
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#489b28",
    fillOpacity: 0.976
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#3ba21c"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#1e9a13"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#44ad20"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#45aa1a"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#3a9c16"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#4da62a"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#57a51e"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#70b51a"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#6cb01c"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#71a836",
    fillOpacity: 0.529
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#297c39",
    fillOpacity: 0.192
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#1f752d",
    fillOpacity: 0.722
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#116c1c",
    fillOpacity: 0.784
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#60a346",
    fillOpacity: 0.714
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#6eb246",
    fillOpacity: 0.831
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#62b041",
    fillOpacity: 0.82
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v1h-1v-1z",
    fill: "#e0f4b7",
    fillOpacity: 0.098
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30v1h-1v-1z",
    fill: "#87af6f",
    fillOpacity: 0.125
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1z",
    fill: "#79a45a",
    fillOpacity: 0.255
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M34 30h1v1h-1z",
    fill: "#5da531",
    fillOpacity: 0.827
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#419b1e",
    fillOpacity: 0.765
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#4e974e",
    fillOpacity: 0.165
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#7fa64c",
    fillOpacity: 0.431
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#8ab660",
    fillOpacity: 0.541
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#a0b683",
    fillOpacity: 0.137
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#9eb784",
    fillOpacity: 0.196
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#85b271",
    fillOpacity: 0.486
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#84b55b",
    fillOpacity: 0.392
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#82af5a",
    fillOpacity: 0.643
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#78a950",
    fillOpacity: 0.373
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#75974b",
    fillOpacity: 0.145
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#87bb51",
    fillOpacity: 0.788
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#87ba3c",
    fillOpacity: 0.996
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#62a722",
    fillOpacity: 0.992
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#33931b"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#096a08"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#236617"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#3b7519"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#3c8819"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#48991e"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#35981d"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#1e8612",
    fillOpacity: 0.749
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#0e7618",
    fillOpacity: 0.498
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#14861e",
    fillOpacity: 0.49
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#0b7a09",
    fillOpacity: 0.953
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#0b7207"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#3a8d25"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#2a7120",
    fillOpacity: 0.969
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#176017",
    fillOpacity: 0.694
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#196619",
    fillOpacity: 0.427
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#1e6b20",
    fillOpacity: 0.494
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#1c7817",
    fillOpacity: 0.941
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#2b8e1f"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#138d20"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#099c29"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#109c21"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#087c08"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#14810d"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#269510"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#158d0e"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#015f03"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#1b700e"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#178b0c"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#16990f"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#46ae1f",
    fillOpacity: 0.976
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#3e9519",
    fillOpacity: 0.624
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#249617",
    fillOpacity: 0.855
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#3ea419"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#5fa71f",
    fillOpacity: 0.82
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#6ca228",
    fillOpacity: 0.443
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#68aa17",
    fillOpacity: 0.976
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#60a02f",
    fillOpacity: 0.882
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#639b71",
    fillOpacity: 0.071
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#b1c686",
    fillOpacity: 0.141
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#c8d49d",
    fillOpacity: 0.165
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#488d39",
    fillOpacity: 0.416
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#66b340",
    fillOpacity: 0.996
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#329e21"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#2ea118"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31h-1v-1h1z",
    fill: "#6cad39",
    fillOpacity: 0.831
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M101 31h-1v-1h1z",
    fill: "#99bb65",
    fillOpacity: 0.384
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#ccd6c1",
    fillOpacity: 0.098
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#ccd8cc",
    fillOpacity: 0.078
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#acc797",
    fillOpacity: 0.145
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#6aa549",
    fillOpacity: 0.749
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v-1h1v1z",
    fill: "#73b548",
    fillOpacity: 0.988
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#57ad2c"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#3e9725",
    fillOpacity: 0.369
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#9fbf9f",
    fillOpacity: 0.031
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#68a135",
    fillOpacity: 0.835
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#7daf48",
    fillOpacity: 0.263
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#a8c590",
    fillOpacity: 0.173
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#8cb875",
    fillOpacity: 0.298
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#70a557",
    fillOpacity: 0.616
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#72ab40",
    fillOpacity: 0.71
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#8bb568",
    fillOpacity: 0.259
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#93aea1",
    fillOpacity: 0.075
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#579b4b",
    fillOpacity: 0.251
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#469735",
    fillOpacity: 0.765
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#7ab533",
    fillOpacity: 0.949
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#83b637"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#5b9d2a"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#177209"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#32831f"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#4a9723"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#389118"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#318c18"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#3a902c",
    fillOpacity: 0.996
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#2f742c",
    fillOpacity: 0.565
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#3d883d",
    fillOpacity: 0.227
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#206f1f",
    fillOpacity: 0.58
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#0d680e",
    fillOpacity: 0.973
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#268528"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#167a10"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#06680d"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#086210"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#3b832b"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#38831f"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#11780c"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#118f20"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#069822"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#088d17"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#258e2b"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#0b730e"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#128410"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#1b8c13"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#15810c"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#065e02"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#368e1c"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#107f0c"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1z",
    fill: "#259e18"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#4faf27",
    fillOpacity: 0.894
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#7fb95f",
    fillOpacity: 0.188
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#258e1a",
    fillOpacity: 0.835
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1z",
    fill: "#25911d"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#65aa40",
    fillOpacity: 0.494
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#679f57",
    fillOpacity: 0.251
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#4a981a",
    fillOpacity: 0.969
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#359015"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#3b7c27",
    fillOpacity: 0.588
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#a6c968",
    fillOpacity: 0.506
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#9fc861",
    fillOpacity: 0.878
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#abca82",
    fillOpacity: 0.361
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#3f8945",
    fillOpacity: 0.443
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#6ea85a",
    fillOpacity: 0.753
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#73c24b",
    fillOpacity: 0.992
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#29911e",
    fillOpacity: 0.965
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#239024",
    fillOpacity: 0.843
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31v1h-1v-1z",
    fill: "#1d8714"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M100 32v-1h1v1z",
    fill: "#509d29"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31v1h-1v-1z",
    fill: "#77aa47",
    fillOpacity: 0.627
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M102 32v-1h1v1z",
    fill: "#bfcc8c",
    fillOpacity: 0.078
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1z",
    fill: "#c8d1bf",
    fillOpacity: 0.11
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#c3cdb9",
    fillOpacity: 0.2
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#8cac6f",
    fillOpacity: 0.412
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#76b240",
    fillOpacity: 0.447
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#5fb325"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#30a219"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#148613",
    fillOpacity: 0.722
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#55954a",
    fillOpacity: 0.294
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#519633",
    fillOpacity: 0.639
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#529928",
    fillOpacity: 0.839
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#ffbfff",
    fillOpacity: 0.016
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#b4c59f",
    fillOpacity: 0.294
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#7cb161",
    fillOpacity: 0.514
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#65a93c",
    fillOpacity: 0.969
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#66aa40",
    fillOpacity: 0.557
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#91ab8c",
    fillOpacity: 0.227
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#9cbd87",
    fillOpacity: 0.427
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#67af45",
    fillOpacity: 0.839
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#449433",
    fillOpacity: 0.686
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#84b649",
    fillOpacity: 0.776
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#74b53c"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#73ad2d"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#4b8c1c"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#4e9d27"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#5baa28"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#539827"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#3d861d"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#7baf46"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#49922d"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#087b0c",
    fillOpacity: 0.996
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#0c7512"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#146617"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#195e11"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#4a9a32"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#228319"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#04670e"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#2c7d23"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#488c2b"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#0e7a1e"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#119a22"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#189419"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#12710d"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#1f7b1f"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#128909"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#249718"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#075d08"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#378d1c"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#4ba031"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#0b6709"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#2a931a"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#2f9e19",
    fillOpacity: 0.992
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#2c891f",
    fillOpacity: 0.902
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#36a026",
    fillOpacity: 0.996
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#228f16"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#3e992d",
    fillOpacity: 0.925
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#369021",
    fillOpacity: 0.961
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#298a16"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#58a223"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#7bb63c"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#90cb4d"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#46932f",
    fillOpacity: 0.98
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#23791c",
    fillOpacity: 0.784
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1z",
    fill: "#4f9d39",
    fillOpacity: 0.933
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#439238",
    fillOpacity: 0.839
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#5bb23b"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1z",
    fill: "#3f9229",
    fillOpacity: 0.851
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#59a144",
    fillOpacity: 0.537
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33v-1h1v1z",
    fill: "#4e9d36",
    fillOpacity: 0.647
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M101 33h-1v-1h1z",
    fill: "#4b953e",
    fillOpacity: 0.596
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M102 33h-1v-1h1z",
    fill: "#4b942e",
    fillOpacity: 0.918
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32v1h-1v-1z",
    fill: "#5e9d31",
    fillOpacity: 0.871
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32h1v1h-1z",
    fill: "#6fab3f",
    fillOpacity: 0.502
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33h-1v-1h1z",
    fill: "#99bf5f",
    fillOpacity: 0.157
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#d1dac8",
    fillOpacity: 0.11
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#cdd3c7",
    fillOpacity: 0.161
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#7db05c",
    fillOpacity: 0.216
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#6fac4c",
    fillOpacity: 0.663
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#85b846",
    fillOpacity: 0.69
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#61ad13",
    fillOpacity: 0.984
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#3d9d10",
    fillOpacity: 0.898
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#2f942b",
    fillOpacity: 0.741
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#198114",
    fillOpacity: 0.992
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#268f15"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#439823",
    fillOpacity: 0.988
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#74b250",
    fillOpacity: 0.871
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#88b95a",
    fillOpacity: 0.749
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#8cc161",
    fillOpacity: 0.749
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#82b954",
    fillOpacity: 0.863
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#5bab33"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#5da143",
    fillOpacity: 0.533
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#27753a",
    fillOpacity: 0.102
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#82bf6a",
    fillOpacity: 0.773
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#469d2a",
    fillOpacity: 0.941
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#65af2e",
    fillOpacity: 0.973
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#62a92b"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#72b231"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#7bb139"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#5ca928"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#2e880d"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#4d8a26"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#61a635"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#66aa34"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#7abf3f"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#2f8e1c"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#0f670d"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#116111"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#0c5c07"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#3a8c24"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#308c24"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#075c0a"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#0b5c09"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#589b37"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#1d7b22"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#08720c"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#268817"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#3e7e21"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#2a8422"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#259617"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#309627"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#4a9f30"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#4ba12d"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#1d7516"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#066206"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#12840d"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#1c870f"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#187d0f"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1z",
    fill: "#23981a"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#128511"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#0c7910"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#3c8c1c"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#60a925"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#89bf37"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#78bb3f"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#258418"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#107014"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#549a39"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#80b85d"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#4a943c",
    fillOpacity: 0.816
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#6db648",
    fillOpacity: 0.902
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33v1h-1v-1z",
    fill: "#78bd5b",
    fillOpacity: 0.349
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h-1v-1h1z",
    fill: "#6da364",
    fillOpacity: 0.11
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33v1h-1v-1z",
    fill: "#59993c",
    fillOpacity: 0.494
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33h1v1h-1z",
    fill: "#559a29",
    fillOpacity: 0.835
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33v1h-1v-1z",
    fill: "#67a82c",
    fillOpacity: 0.918
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v1h-1v-1z",
    fill: "#83b543",
    fillOpacity: 0.655
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33h1v1h-1z",
    fill: "#a0c65e",
    fillOpacity: 0.106
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34v1h-1v-1z",
    fill: "#8eb469",
    fillOpacity: 0.133
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-1v-1h1z",
    fill: "#7fae5d",
    fillOpacity: 0.149
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#99c572",
    fillOpacity: 0.157
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#a0c18b",
    fillOpacity: 0.243
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#bccfb3",
    fillOpacity: 0.106
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#77b13f",
    fillOpacity: 0.584
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#68b236",
    fillOpacity: 0.831
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#c1d38c",
    fillOpacity: 0.114
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#76b324",
    fillOpacity: 0.635
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#43a210",
    fillOpacity: 0.949
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#5bae40",
    fillOpacity: 0.773
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#2c9222"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#107d09"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#3c9a26",
    fillOpacity: 0.965
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#419e2a",
    fillOpacity: 0.992
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#3da624"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#4bab35"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#4fa72c"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#58b135"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#5ca733",
    fillOpacity: 0.937
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#88b963",
    fillOpacity: 0.702
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#539435",
    fillOpacity: 0.871
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#7ebf56"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#277c1b"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#499b1e"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#6eaf33"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#81b945"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#7cb844"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#54aa2a"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#23780e"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#36792a"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#14640e"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#145e0a"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#3d7b22"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#73b547"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#4b8a2e"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#186313"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#025b02"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#1f7a0f"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#399529"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#0b5206"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#034804"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#408829"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#175e0e"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#055109"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#1b7e13"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#2b7a11"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#2e8520"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#13870e"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#0d7c0d"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#34941c"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#57b335"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#1d7310"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#187511"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#138c16"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#49a62b"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#48a72a"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#38a329"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1z",
    fill: "#21821e"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#1a6e10"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#65a32d"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#81bf2f"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#79bc34"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#2b831f"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1z",
    fill: "#137617"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#197113"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#76ab56"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#8eb67a",
    fillOpacity: 0.718
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#69a561",
    fillOpacity: 0.247
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#66ad49",
    fillOpacity: 0.835
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1z",
    fill: "#b6e69d",
    fillOpacity: 0.082
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35v-1h1v1z",
    fill: "#5c9a32",
    fillOpacity: 0.259
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35h-1v-1h1z",
    fill: "#69a439",
    fillOpacity: 0.663
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35v-1h1v1z",
    fill: "#76a753",
    fillOpacity: 0.608
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M108 34v1h-1v-1z",
    fill: "#8bb079",
    fillOpacity: 0.165
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#84ae5d",
    fillOpacity: 0.408
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#77ac49",
    fillOpacity: 0.773
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#66a841",
    fillOpacity: 0.682
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#38852a",
    fillOpacity: 0.702
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#348836",
    fillOpacity: 0.647
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#348b2c",
    fillOpacity: 0.69
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#2d8b26",
    fillOpacity: 0.725
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#509c3c",
    fillOpacity: 0.733
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#69af3e",
    fillOpacity: 0.655
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#459d29",
    fillOpacity: 0.647
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#59ac26",
    fillOpacity: 0.973
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#35971d",
    fillOpacity: 0.808
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#187723",
    fillOpacity: 0.529
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#44952a",
    fillOpacity: 0.749
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#2b8b12"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#2b9512"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#469e29"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#177a0d"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#157516",
    fillOpacity: 0.98
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#338b27",
    fillOpacity: 0.988
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#4ba124"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#1f8f12"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#0a8a07"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#1e8c14"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#36981f"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#5bad3a"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#7bb948"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#53a624"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#348a1b"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#4c9727"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#60aa2a"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#73ac36"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#75b03a"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#54aa2f"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#6ab041"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#6eaf49"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#1c5218"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#074006"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#003705"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#3d7421"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#74ba46"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#337d22"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#045908"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#0f6c08"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#2c881f"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#156f14"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#004702"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#35741e"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#30811c"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#0e6d0e"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#147110"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#188810"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#1a8610"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#13780b"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#4ca72b"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#4db12c"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#389625"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#086304"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#106e08"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#1c8c1f"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#3aa61e"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#4d9030"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1z",
    fill: "#2a821d"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#4e9f1d"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#67b82a"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#6aba3b"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#4ca421"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#31861c"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#3f8d2c"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#387a16"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#719749",
    fillOpacity: 0.953
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#a1b58e",
    fillOpacity: 0.204
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#18791e",
    fillOpacity: 0.525
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#55aa40",
    fillOpacity: 0.965
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#cae2a8",
    fillOpacity: 0.173
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M106 36v-1h1v1z",
    fill: "#7aa45f",
    fillOpacity: 0.188
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M108 35v1h-1v-1z",
    fill: "#81a666",
    fillOpacity: 0.439
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M108 36v-1h1v1z",
    fill: "#89ac73",
    fillOpacity: 0.4
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36v-1h1v1z",
    fill: "#95ae82",
    fillOpacity: 0.161
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36h1v1h-1z",
    fill: "#a2b98b",
    fillOpacity: 0.043
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37v-1h1v1z",
    fill: "#8fab67",
    fillOpacity: 0.251
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36h1v1h-1z",
    fill: "#90b674",
    fillOpacity: 0.18
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#b1c694",
    fillOpacity: 0.282
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#afca95",
    fillOpacity: 0.114
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#5a5",
    fillOpacity: 0.012
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#388d38",
    fillOpacity: 0.035
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#4c994c",
    fillOpacity: 0.078
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#449037",
    fillOpacity: 0.145
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#3f8d28",
    fillOpacity: 0.22
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#76af4b",
    fillOpacity: 0.541
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#7cc241"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#51ae19"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#57aa23",
    fillOpacity: 0.71
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#349029",
    fillOpacity: 0.769
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#11800e"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#0c7208"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#2c801b"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#137e10"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#2b920e"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#4a9626"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#157110"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#1c7a16"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#58a52d"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#449f2d"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#2d9224"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#348728"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#216c1b"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#469c30"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#4d9e30"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#27891c"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#2f9118"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#54a82d"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#5da632"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#69ae31"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#6dab35"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#61a830"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#3b9d1c"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#5ea236"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#4b8b32"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#539a3e"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#4c9536"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#358229"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#0f480c"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#357c1a"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#44a52c"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#037704"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#046c05"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#0c640a"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#0c6c0a"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#055808"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#277113"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#429621"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#388522"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#449a2f"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#378f17"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#3fa51f"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#1f8910"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#65b132"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#56b02f"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#41a529"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#2f8b24"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#328b1d"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#30931e"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#47a327"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#4f9932"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#1b8210"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#4caa23"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#218919"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#1c7714"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#58a424"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#68b139"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#55a639"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#48971f"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#37871e",
    fillOpacity: 0.949
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M95 36v1h-1v-1z",
    fill: "#418d33",
    fillOpacity: 0.733
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#2f891d",
    fillOpacity: 0.98
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#56af36"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#9ac980",
    fillOpacity: 0.427
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M109 37h-1v-1h1z",
    fill: "#8ead7a",
    fillOpacity: 0.098
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M109 36h1v1h-1z",
    fill: "#96b07b",
    fillOpacity: 0.267
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M110 37v-1h1v1z",
    fill: "#94ae7f",
    fillOpacity: 0.337
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M112 36v1h-1v-1z",
    fill: "#a2b996",
    fillOpacity: 0.173
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38v-1h1v1z",
    fill: "#adc888",
    fillOpacity: 0.11
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#8cb75d",
    fillOpacity: 0.49
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#74a64e",
    fillOpacity: 0.608
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#90b27f",
    fillOpacity: 0.118
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#8fc765",
    fillOpacity: 0.286
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#66b224"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#4ca61b",
    fillOpacity: 0.941
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#51964d",
    fillOpacity: 0.259
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#4e8f47",
    fillOpacity: 0.486
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#5ba548",
    fillOpacity: 0.914
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#519e38"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#238719"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#11840b"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#3d901e"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#5e9934"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#529a38"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#4da02e"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#42ac2f"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#258e1d"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#3f8b2e"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#6db048"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#10650f"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#15690c"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#41a222"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#60b22f"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#429620"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#4ba02b"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#6bb743"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#2c6819"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#2c761a"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#2c7821"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#30812a"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#418d29"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#0c780b"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#025f00"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#034c03"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#054c05"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#045109"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#0d5108"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#3e9423"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#549b2e"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#3e9d23"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#439e1e"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#399e1a"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#269617"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#2d9318"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#369321"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#1c7e11"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#3ea52d"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#288b17"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#16820d"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#4da228"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#307f1e"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#055e07"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#1e7912"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#35941e"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#46952a"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#589d2b"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#74b71f"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#64ae2c"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#287f1e"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#21871a"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#17840c"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#399d1c"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#83c442"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#7ac341"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#95cb75",
    fillOpacity: 0.757
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M111 38v-1h1v1z",
    fill: "#afbf9a",
    fillOpacity: 0.188
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M112 37h1v1h-1z",
    fill: "#b7c4a7",
    fillOpacity: 0.239
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M113 38v-1h1v1z",
    fill: "#c1cab8",
    fillOpacity: 0.114
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1z",
    fill: "#b3c789",
    fillOpacity: 0.145
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M16 39v-1h1v1z",
    fill: "#a8bf7f",
    fillOpacity: 0.314
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h1v1h-1z",
    fill: "#a4bd7f",
    fillOpacity: 0.243
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#7fa561",
    fillOpacity: 0.133
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#83a966",
    fillOpacity: 0.478
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#a0c285",
    fillOpacity: 0.18
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#64a833",
    fillOpacity: 0.565
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#55aa21",
    fillOpacity: 0.871
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#208614",
    fillOpacity: 0.882
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#308333",
    fillOpacity: 0.412
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#3c783c",
    fillOpacity: 0.067
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#69aa51",
    fillOpacity: 0.369
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#60a94e",
    fillOpacity: 0.984
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#6dac47"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#449629"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#368e26"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#51a436"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#7cb650"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#84b951"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#4a9629"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#3d9b2f"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#369d2c"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#1b8a18"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#138314"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#3f9c2d"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#47aa2d"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#217f12"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#17710b"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#1c7b0e"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#1f9513"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#4baa28"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#49a42e"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#3ea631"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#2e931d"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#319721"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#3f8e1e"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#4e8e2b"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#12510e"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#08500b"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#389424"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#61ae3e"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#2d8522"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#2d8a21"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#1b6716"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#083b09"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#08490b"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#073f07"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#418c1d"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#66b22e"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1z",
    fill: "#47a31d"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#1c8a15"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#1a8c10"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#42a12a"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#1b8315"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#0c680c"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#0b6006"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#47ad29"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#2a841c"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#0f7009"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#55b22a"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#247916"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#1b6915"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#42812b"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39v-1h1v1z",
    fill: "#72b23d"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#7abc2c"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#60ab1e"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#45921a"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#267e16"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#349a1c"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#51ae28"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#4ba925",
    fillOpacity: 0.992
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#6bbb3d",
    fillOpacity: 0.98
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#68ba3a",
    fillOpacity: 0.98
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1z",
    fill: "#9fd16b",
    fillOpacity: 0.91
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M98 39v-1h1v1z",
    fill: "#b0d882",
    fillOpacity: 0.627
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M100 39h-1v-1h1z",
    fill: "#bcd99a",
    fillOpacity: 0.239
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M13 40v-1h1v1z",
    fill: "#b6c888",
    fillOpacity: 0.11
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M14 39h1v1h-1z",
    fill: "#adbf7f",
    fillOpacity: 0.329
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40v-1h1v1z",
    fill: "#a5ba7d",
    fillOpacity: 0.278
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40h-1v-1h1z",
    fill: "#a1bb78",
    fillOpacity: 0.075
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#86a15d",
    fillOpacity: 0.075
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#8cad62",
    fillOpacity: 0.455
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#93af6b",
    fillOpacity: 0.176
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#88b44e",
    fillOpacity: 0.294
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#58a41c",
    fillOpacity: 0.988
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#45a01f",
    fillOpacity: 0.902
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#319223",
    fillOpacity: 0.91
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#61a750",
    fillOpacity: 0.286
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#1d7719",
    fillOpacity: 0.235
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#348630",
    fillOpacity: 0.831
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#82c063",
    fillOpacity: 0.902
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#79b84f"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#2d861c"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#1f7e18",
    fillOpacity: 0.863
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#2b8320",
    fillOpacity: 0.929
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#58a330"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#54a02d"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#4fa034"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#5ea844"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#66ac49"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#589c33"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#79b84d"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#42961f"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#479d2a"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#2d9619"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#1e9712"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#0c8e09"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#3da622"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#399a1f"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#179515"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#20931b"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#199322"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#1f8b18"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#539934"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#13380f"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#135110"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#256816"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#55a53b"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#256b19"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#2b8321"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#2b7e1c"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#418331"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#367b2b"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#196115"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#55a61d"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#2e8913"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#23811b"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#2a911a"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#359524"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#1b840f"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#1a8109"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#086008"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#10710c"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#2c851a"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#3c9f21"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#298418"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#53b32a"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#297e19"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#337418"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#61982d"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#69ad2b"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#328a10"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#529924"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#64a938"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#59ad20"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#34a21e"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#53ab26"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#3f8d21",
    fillOpacity: 0.659
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#2f972f",
    fillOpacity: 0.251
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#37992a",
    fillOpacity: 0.851
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h-1v-1h1z",
    fill: "#90c670",
    fillOpacity: 0.518
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M99 39v1h-1v-1z",
    fill: "#a7d272",
    fillOpacity: 0.757
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M100 40h-1v-1h1z",
    fill: "#afd580",
    fillOpacity: 0.957
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40h-1v-1h1z",
    fill: "#bcd89e",
    fillOpacity: 0.467
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M112 40h-1v-1h1z",
    fill: "#dda",
    fillOpacity: 0.059
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40v1h-1v-1z",
    fill: "#b6c87f",
    fillOpacity: 0.055
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40v1h-1v-1z",
    fill: "#8cba57",
    fillOpacity: 0.263
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41v-1h1v1z",
    fill: "#7db450",
    fillOpacity: 0.4
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M14 40v1h-1v-1z",
    fill: "#a5c081",
    fillOpacity: 0.302
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v-1h1v1z",
    fill: "#ffdfdf",
    fillOpacity: 0.031
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#94aa6a",
    fillOpacity: 0.047
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#8cac6a",
    fillOpacity: 0.412
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#90b27b",
    fillOpacity: 0.235
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#9dc26d",
    fillOpacity: 0.082
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#6aa52c",
    fillOpacity: 0.773
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#399b12",
    fillOpacity: 0.875
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#69b448",
    fillOpacity: 0.914
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#509a3c",
    fillOpacity: 0.149
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#2b7e22",
    fillOpacity: 0.435
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#287a2a",
    fillOpacity: 0.737
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#529f49",
    fillOpacity: 0.804
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#63b143"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#76ba4e"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#7ca75b",
    fillOpacity: 0.435
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#1d7623",
    fillOpacity: 0.475
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#258d19"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#076807"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#11640e"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#246c1a"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#549e3a"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#5aab3e"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#5aad3f"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#67af48"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#5ea541"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#449831"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#2a7b23"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#3b9928"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#33a31e"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#10960f"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#179212"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#047b0a"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#138b17"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#52b140"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#65b14a"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#418f31"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#113d0c"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#235a16"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#69be41"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#207014"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#10560c"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#1d7211"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#0f7410"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#217119"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#398d27"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#5ba72e"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#4fa225"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#237d19"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#2c891f"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#429c25"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#197511"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#278613"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#2a7e13"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#0b6404"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#146e0a"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#0f5d0d"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#49a531"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#40a828"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#4eaa29"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#64a72b"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#7cb32e"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#498913"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#69a535"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#609f3b"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#63a833"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#4fa318"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#67b61c"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#4db32b"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#38a027"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#2d8d21"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#5ba94a",
    fillOpacity: 0.549
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#35922f",
    fillOpacity: 0.784
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1z",
    fill: "#6aaf60",
    fillOpacity: 0.478
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h1v1h-1z",
    fill: "#69ae63",
    fillOpacity: 0.322
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M99 40h1v1h-1z",
    fill: "#95bf78",
    fillOpacity: 0.522
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v-1h1v1z",
    fill: "#a0c380",
    fillOpacity: 0.675
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41h-1v-1h1z",
    fill: "#c8dbb2",
    fillOpacity: 0.314
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40v1h-1v-1z",
    fill: "#d6e0a4",
    fillOpacity: 0.396
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M110 40h1v1h-1z",
    fill: "#d0da95",
    fillOpacity: 0.604
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M111 41v-1h1v1z",
    fill: "#ccd599",
    fillOpacity: 0.314
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v-1h1v1z",
    fill: "#cdd7a6",
    fillOpacity: 0.102
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M11 41v1h-1v-1z",
    fill: "#abc378",
    fillOpacity: 0.373
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42h-1v-1h1z",
    fill: "#68a536",
    fillOpacity: 0.784
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41v1h-1v-1z",
    fill: "#328b17",
    fillOpacity: 0.91
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v1h-1v-1z",
    fill: "#3f952b",
    fillOpacity: 0.757
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42h-1v-1h1z",
    fill: "#54a13a",
    fillOpacity: 0.427
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h1v1z",
    fill: "#68a653",
    fillOpacity: 0.192
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h-1v-1h1z",
    fill: "#8cb27f",
    fillOpacity: 0.078
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#94b87f",
    fillOpacity: 0.384
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#72aa54",
    fillOpacity: 0.463
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#63a52b",
    fillOpacity: 0.694
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#68a231",
    fillOpacity: 0.345
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#398c29",
    fillOpacity: 0.576
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#54b52f"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#399622",
    fillOpacity: 0.902
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#3c873c",
    fillOpacity: 0.067
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#227b21",
    fillOpacity: 0.631
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#2a8127",
    fillOpacity: 0.659
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#519d34",
    fillOpacity: 0.953
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#479a1f"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#76bd43"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#88c265",
    fillOpacity: 0.812
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#61ac50",
    fillOpacity: 0.796
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#1d8819"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#1b811b"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#11720f"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#08750b"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#24791e"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#3a852a"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#307b28"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#4ea13c"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#439d2c"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#50a335"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#3f8f2d"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#2e7326"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#3e902a"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#50b234"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#289b1c"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#1c8614"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#016703"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#0e8206"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#12820b"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#53b33c"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#66b64c"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#62ac47"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#6ebe3d"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#388d22"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#1f6f17"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#2a9118"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#004300"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#206a12"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#2b8412"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#26891a"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1z",
    fill: "#4ca230"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#69b33f"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#43872b"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#307b15"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#34871b"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#4f9537"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#54a23c"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#1c5f12"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#063f06"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#1d6c18"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#56b73a"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#5fb132"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#408820"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#166c06"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#22760b"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#6ab034"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#76b93d"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#8bc348"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#87c43f"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#70b535"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#45a82d"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#2c9c2f"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#2f9927"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#5da632",
    fillOpacity: 0.992
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#82be58"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#2a8d1c",
    fillOpacity: 0.925
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#3d9134",
    fillOpacity: 0.604
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#599e30",
    fillOpacity: 0.894
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#71ac3c",
    fillOpacity: 0.89
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42v-1h1v1z",
    fill: "#7eb05f",
    fillOpacity: 0.42
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M107 41v1h-1v-1z",
    fill: "#bfdfdf",
    fillOpacity: 0.031
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M108 42h-1v-1h1z",
    fill: "#cdd69f",
    fillOpacity: 0.345
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42h-1v-1h1z",
    fill: "#cfd99e",
    fillOpacity: 0.635
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v-1h1v1z",
    fill: "#d2dc93",
    fillOpacity: 0.494
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M110 41h1v1h-1z",
    fill: "#cfdf97",
    fillOpacity: 0.125
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v1H8v-1z",
    fill: "#cfcfbf",
    fillOpacity: 0.063
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43H9v-1h1z",
    fill: "#c5ca9c",
    fillOpacity: 0.173
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43v-1h1v1z",
    fill: "#b9d08b",
    fillOpacity: 0.043
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42h1v1h-1z",
    fill: "#557f55",
    fillOpacity: 0.024
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1z",
    fill: "#34832b",
    fillOpacity: 0.114
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43h-1v-1h1z",
    fill: "#439027",
    fillOpacity: 0.325
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43v-1h1v1z",
    fill: "#529c30",
    fillOpacity: 0.596
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43v-1h1v1z",
    fill: "#58a137",
    fillOpacity: 0.761
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#5ba33a",
    fillOpacity: 0.827
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#64a43c",
    fillOpacity: 0.749
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42h1v1h-1z",
    fill: "#66a843",
    fillOpacity: 0.565
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#6cad4e",
    fillOpacity: 0.369
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#77b062",
    fillOpacity: 0.192
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#daecb6",
    fillOpacity: 0.055
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#88bb82",
    fillOpacity: 0.176
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#7fa375",
    fillOpacity: 0.306
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#69aa3c",
    fillOpacity: 0.663
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#5da52b",
    fillOpacity: 0.871
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#87ac87",
    fillOpacity: 0.133
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#94c46a",
    fillOpacity: 0.647
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#87c553",
    fillOpacity: 0.906
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#2a8718",
    fillOpacity: 0.843
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#458b45",
    fillOpacity: 0.086
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#2c851c",
    fillOpacity: 0.804
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#51a22b",
    fillOpacity: 0.973
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#5fa932"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#3e941d"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#3c9e17"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#42a22e"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#68b247"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#47972e"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#176712"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#12780d"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#016f01"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#328121"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#2b801e"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#216c11"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#458628"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#5fad42"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#4ba436"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#54a736"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#4a9827"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#2c8c16"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#44af2a"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#287c16"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#2f6b25"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#468c2a"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#268816"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#118905"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#037002"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#066709"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#1f7e17"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#4ba233"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#70c049"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#71c24c"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#3a8a24"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#075705"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#095208"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#115209"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#2d771a"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#126b08"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#077807"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#258815"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#257719"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#498e2c"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#73b538"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#30711c"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#3e8228"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#5fa939"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#65aa4a"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#4b8635"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#166510"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#4ba535"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#64b840"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#1d790d"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#47a21e"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#64ba26"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#5ab41d"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M88 43h-1v-1h1z",
    fill: "#61b622"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#6dbd27"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#60b134"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#469732"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#4aa334"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#47a037"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#39992c"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#439c23"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#60b43b"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#1a8c15",
    fillOpacity: 0.969
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#53a34d",
    fillOpacity: 0.373
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#afc96e",
    fillOpacity: 0.451
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#9cc65c",
    fillOpacity: 0.976
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M101 42v1h-1v-1z",
    fill: "#75af56",
    fillOpacity: 0.776
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43v-1h1v1z",
    fill: "#85b866",
    fillOpacity: 0.353
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M106 42v1h-1v-1z",
    fill: "#bfcc96",
    fillOpacity: 0.298
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43v-1h1v1z",
    fill: "#c5cc93",
    fillOpacity: 0.659
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M108 43h-1v-1h1z",
    fill: "#c7d28b",
    fillOpacity: 0.467
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M109 42v1h-1v-1z",
    fill: "#c7d285",
    fillOpacity: 0.09
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1z",
    fill: "#8daa55",
    fillOpacity: 0.035
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#66a43e",
    fillOpacity: 0.176
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#60a033",
    fillOpacity: 0.404
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1z",
    fill: "#5ba133",
    fillOpacity: 0.675
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#52a12a",
    fillOpacity: 0.898
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#4aa126",
    fillOpacity: 0.996
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#359822",
    fillOpacity: 0.898
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#1f881a",
    fillOpacity: 0.867
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#60ac3e",
    fillOpacity: 0.498
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#6da739",
    fillOpacity: 0.682
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#8bb973",
    fillOpacity: 0.286
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#8ec16c",
    fillOpacity: 0.765
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#6eb84d",
    fillOpacity: 0.933
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#6ca847",
    fillOpacity: 0.533
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#31811f",
    fillOpacity: 0.608
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#559c3b",
    fillOpacity: 0.435
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#4a9126",
    fillOpacity: 0.631
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#479e26"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#51a331"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#1a8011"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#13810e"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#248a1a"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#5daa35"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#63ac3c"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#569a39"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#288418"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#117806"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#2f8d19"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#429823"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#569d2d"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#6bb33d"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#66b036"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#51a62b"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#3ca01f"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#49a628"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#53af2c"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#7dbb4b"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#86b151"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#447e2a"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#176a0f"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#108607"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#187e0a"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#024201"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#003a00"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#13620d"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#51ae35"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#388827"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#5dac46"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#60ab3f"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#4c8f35"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#30701c"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#338119"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#247c11"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#1c8515"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#046205"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#0e650f"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#3c9215"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#25710f"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#054405"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#2c7518"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#62a533"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#479326"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#5a9f3b"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#6bb744"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#42932a"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#47ab20"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#55b217"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#6cbe22"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#61b917"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#5eba1b"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#57b619"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#5eb829"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#5db341"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#3a8136"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#308d26"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#45a837"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#419e2f"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#51a231"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#44942c"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#138c10"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#299e1c",
    fillOpacity: 0.918
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#469933",
    fillOpacity: 0.851
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#9ecb5d"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#78a948",
    fillOpacity: 0.761
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#82af67",
    fillOpacity: 0.376
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#84b469",
    fillOpacity: 0.4
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M103 44v-1h1v1z",
    fill: "#96b276",
    fillOpacity: 0.286
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M105 44h-1v-1h1z",
    fill: "#acbd7e",
    fillOpacity: 0.714
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M105 43h1v1h-1z",
    fill: "#bcc982",
    fillOpacity: 0.675
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M106 43h1v1h-1z",
    fill: "#bdc87c",
    fillOpacity: 0.184
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#77b757",
    fillOpacity: 0.125
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#58a435",
    fillOpacity: 0.408
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#1e8917",
    fillOpacity: 0.561
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#32921d",
    fillOpacity: 0.886
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#52b41f"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#5daa2a",
    fillOpacity: 0.957
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#67ac30",
    fillOpacity: 0.847
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#54a724"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#1f910c"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#3c9030",
    fillOpacity: 0.706
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#4b9f2e",
    fillOpacity: 0.667
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#4ea227",
    fillOpacity: 0.992
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#469b1f"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#1e8413"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#188818"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#148710"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#177c15"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#186f11"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#4c962a"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#498824"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#6fae43"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#73b844"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#70b73f"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#4ca026"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#1e7c0e"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#308f1b"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#2a9117"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#239114"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#208d11"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#1e9011"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#1a8612"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#90c051"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#6fbb3c"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#57b133"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#327e1b"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#0c5d10"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#0a5507"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#0a6504"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#238e0d"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#0c6204"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#003602"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#13540d"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#4eac30"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#11660a"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#0f700d"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#31961f"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#51af38"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#68b245"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#6bb042"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#5eb03e"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#1d7e14"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1z",
    fill: "#0e700e"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#1c770c"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#2f8c13"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#1c6612"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#266f1a"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#227413"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#7db846"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#7cbc3e"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#318415"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#54a725"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#6ec22c"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#60bd1e"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#66bf27"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#42aa17"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#3ca11e"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#48a42c"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#1f7710"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#4c9e2b"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#54a835"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#165813"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#22781a"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#3a9c26"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#5eaa36"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#3c9530"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#148f0f"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#2fa225"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#108210",
    fillOpacity: 0.992
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#60a53a",
    fillOpacity: 0.984
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#9ec866",
    fillOpacity: 0.851
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M102 45h-1v-1h1z",
    fill: "#52a542",
    fillOpacity: 0.651
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1z",
    fill: "#60a43a",
    fillOpacity: 0.925
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1z",
    fill: "#73ac3b"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v-1h1v1z",
    fill: "#a4bf6b",
    fillOpacity: 0.455
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M111 44v1h-1v-1z",
    fill: "#9cb765",
    fillOpacity: 0.306
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M112 44v1h-1v-1z",
    fill: "#aac671",
    fillOpacity: 0.071
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#ffc",
    fillOpacity: 0.02
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#66a935",
    fillOpacity: 0.725
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#64ab34",
    fillOpacity: 0.765
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#8ac258",
    fillOpacity: 0.773
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#5cb22e"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#21890c"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#2a9811"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#2c9611"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#299612"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#319913"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#389717"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#157e11"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#329226"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#4fa035"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#4e9b35"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#509534"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#64a640"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#578d3e"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#4d8035"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#478d31"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#5ba43d"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#69b343"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#3c8021"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#489823"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#3d9c1c"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#238a16"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#0e6d0d"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#2b6b1e"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#499a33"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#31861a"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#7ab73b"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#63b839"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#2f9f20"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#066506"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#024b04"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#054302"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#054e05"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#167709"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#197e0d"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#126510"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#2f7f22"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#49b22b"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#57b13b"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#3da230"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#198a1a"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#288c1f"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#378827"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#428f2e"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#529b39"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#4ca533"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#227c11"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#0e5e08"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#47992c"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#57ae33"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#7bbb3c"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#75bc36"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#7abe35"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#7bc136"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#50b228"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#49b029"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#51aa37"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#337e20"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#389e1f"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#318923"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#36802a"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#1e7110"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#62b939"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#29821c"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#349922"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#44a525"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#77b644"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#3fa133"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#1a9111"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#45a538",
    fillOpacity: 0.992
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#3d9138",
    fillOpacity: 0.392
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#7da566",
    fillOpacity: 0.224
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#a0cd6a",
    fillOpacity: 0.914
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#53a634",
    fillOpacity: 0.855
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45v1h-1v-1z",
    fill: "#3da028",
    fillOpacity: 0.875
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v1h-1v-1z",
    fill: "#3ea622",
    fillOpacity: 0.992
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45h1v1h-1z",
    fill: "#35a12a",
    fillOpacity: 0.824
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M106 45v1h-1v-1z",
    fill: "#3ca347",
    fillOpacity: 0.349
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M106 46v-1h1v1z",
    fill: "#6abf8a",
    fillOpacity: 0.094
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45v1h-1v-1z",
    fill: "#82af4f",
    fillOpacity: 0.176
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M110 45h1v1h-1z",
    fill: "#88b24e",
    fillOpacity: 0.447
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1z",
    fill: "#98b973",
    fillOpacity: 0.459
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1z",
    fill: "#9abc7f",
    fillOpacity: 0.376
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#c0df8f",
    fillOpacity: 0.322
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#7cb654",
    fillOpacity: 0.749
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#77ae4e",
    fillOpacity: 0.647
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#ab8",
    fillOpacity: 0.176
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#72b448",
    fillOpacity: 0.769
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#38981e"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#268b17"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#3c961b"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#4aa026"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#41a42b"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#2d931b"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#198b12"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#2e9020"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#399c21"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#278220"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#196e15"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#348a24"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#0d5809"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#145512"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#0f520e"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#3d7c32"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#5da93c"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#6cb33e"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#56a91e"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#3ba00c"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#2d9712"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#116d0d"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#033e03"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#528c3b"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#7ac54b"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#63b630"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#53b636"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#2f9c21"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#0f710f"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#044f04"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#094807"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#05610b"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#107611"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#349625"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#46a935"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#48ac37"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#41ad24"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#3f972d"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#115e10"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#084a08"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#095a07"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#105a10"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#2e6923"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#39861e"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#40a528"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#52a33c"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#47912f"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#156c11"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#0e7c08"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#278c15"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#2d851d"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#6eab31"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#5eac2b"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#3e9619"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#75ba33"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#52a924"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#40a924"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#3e9618"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#77bc3b"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#54b126"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#44a322"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#5aae36"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#207c17"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#50ac32"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#4aa52c"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#4cad2f"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#2e9523"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#3ba12a"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#66b346"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#218c1e"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#1b8813"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#53a743"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#529d48",
    fillOpacity: 0.729
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#619d61",
    fillOpacity: 0.216
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#9cc06d",
    fillOpacity: 0.659
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#b1cc83",
    fillOpacity: 0.412
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#557fd4",
    fillOpacity: 0.024
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#3a9c3f",
    fillOpacity: 0.204
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46v1h-1v-1z",
    fill: "#249b28",
    fillOpacity: 0.471
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M105 46h1v1h-1z",
    fill: "#219524",
    fillOpacity: 0.804
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M107 46v1h-1v-1z",
    fill: "#1c9220",
    fillOpacity: 0.91
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47v-1h1v1z",
    fill: "#1d8d21",
    fillOpacity: 0.714
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M108 46h1v1h-1z",
    fill: "#4aa33e",
    fillOpacity: 0.494
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M110 47h-1v-1h1z",
    fill: "#66b03f",
    fillOpacity: 0.627
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M111 46v1h-1v-1z",
    fill: "#d7eb9c",
    fillOpacity: 0.051
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1z",
    fill: "#ffff7f",
    fillOpacity: 0.008
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1z",
    fill: "#bbc986",
    fillOpacity: 0.075
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48v-1h1v1z",
    fill: "#afc777",
    fillOpacity: 0.125
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48v-1h1v1z",
    fill: "#abc376",
    fillOpacity: 0.169
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1z",
    fill: "#afc47a",
    fillOpacity: 0.188
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1z",
    fill: "#adc586",
    fillOpacity: 0.208
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1z",
    fill: "#9bbf74",
    fillOpacity: 0.471
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1z",
    fill: "#84b155",
    fillOpacity: 0.992
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#82bc48"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#67ab2f"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#67a133",
    fillOpacity: 0.961
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#78b04e",
    fillOpacity: 0.753
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#5dad2d",
    fillOpacity: 0.949
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#329619"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#1f8c0e"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#349b1f"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#39a028"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#21911b"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#28901a"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#1c7213"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#247319"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#0a670a"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#0a7707"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#0b7e0d"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#06770a"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#0b790a"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#0d6f0d"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#1c741c"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#1b6416"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#3e8e2f"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#4ba42f"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#66b240"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#5ca435"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#57a62e"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#0b8705"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#107309"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#449125"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#83ce4e"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#449928"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#46aa31"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#0a7209"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#09770e"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#0c730c"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#056c06"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#0e6d12"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#186514"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#196f12"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#0f710c"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#36a625"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#23761a"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#013901"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#032e01"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#083d09"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#22771f"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#1b6610"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#3ab11f"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#0e910d"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#0d820c"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#3fa629"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#64b941"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#5bb637"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#30841b"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#024d06"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#52912f"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#76ba33"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#3d9520"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#48a012"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#5cb52c"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#5eab27"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#69b73b"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#48aa28"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#60b83d"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#4ba928"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#51a439"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#469d2a"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#63b948"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#369730"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#2f9a33"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#399a23"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#4da433"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#1c911d"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#198b15"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#3c9632"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#2f9029"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#328d1e",
    fillOpacity: 0.973
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#4e9a2f",
    fillOpacity: 0.792
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#73ad3d",
    fillOpacity: 0.851
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#579c2b",
    fillOpacity: 0.569
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#529e2e",
    fillOpacity: 0.58
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M104 48v-1h1v1z",
    fill: "#569d2e",
    fillOpacity: 0.565
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M106 47v1h-1v-1z",
    fill: "#5aa135",
    fillOpacity: 0.741
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h-1v-1h1z",
    fill: "#469b26"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M107 47h1v1h-1z",
    fill: "#35a016"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M109 47v1h-1v-1z",
    fill: "#44b719"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M109 48v-1h1v1z",
    fill: "#49ad2b",
    fillOpacity: 0.976
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48v-1h1v1z",
    fill: "#50aa3e",
    fillOpacity: 0.733
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h-1v-1h1z",
    fill: "#68b450",
    fillOpacity: 0.537
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M113 47v1h-1v-1z",
    fill: "#72b556",
    fillOpacity: 0.463
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48h-1v-1h1z",
    fill: "#8bbd56",
    fillOpacity: 0.38
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48h-1v-1h1z",
    fill: "#96bb5c",
    fillOpacity: 0.325
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47v1h-1v-1z",
    fill: "#a2bb6e",
    fillOpacity: 0.325
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M116 47h1v1h-1z",
    fill: "#b1c192",
    fillOpacity: 0.129
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1z",
    fill: "#b0c489",
    fillOpacity: 0.051
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49h-1v-1h1z",
    fill: "#adc074",
    fillOpacity: 0.369
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49h-1v-1h1z",
    fill: "#a8bf6b",
    fillOpacity: 0.439
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49v-1h1v1z",
    fill: "#a7be6c",
    fillOpacity: 0.388
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v-1h1v1z",
    fill: "#a8c073",
    fillOpacity: 0.302
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1z",
    fill: "#abc281",
    fillOpacity: 0.216
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#acc082",
    fillOpacity: 0.145
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#7db446",
    fillOpacity: 0.494
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1z",
    fill: "#59a61f",
    fillOpacity: 0.98
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#5fa420"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#86bb53"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#80ba51",
    fillOpacity: 0.925
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#4f9d26",
    fillOpacity: 0.91
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#0f7e09"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#09870a"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#159511"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#169610"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#1a8a1c"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#27931a"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#227e16"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#307f24"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#0c6b0b"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#10771b"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#21781d"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#024903"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#105b0d"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#136e0d"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#036a03"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#21791b"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#64af46"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#49a32c"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#54a938"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#41922d"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#529d2d"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#61b034"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#339121"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#259212"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#4fac23"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#7bc544"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#47a42c"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#309618"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#309e1b"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#065403"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#044702"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#0c4e0b"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#043802"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#023e03"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#166b0f"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#2fa71d"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#217817"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#034502"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#044d05"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#014000"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#226c18"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#33a820"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#1e9b14"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#138e12"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#097e06"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#097c08"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#167e0a"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#328b26"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#63b349"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#21761c"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#226c15"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#72b534"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#93bd57"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#70b03b"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#57ad1a"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#64b627"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#65b030"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#217115"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#36a124"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#54b23a"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#399b25"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#339225"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#277b1d"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#69b64d"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#3c9634"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#298d24"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#57a325",
    fillOpacity: 0.976
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#6cbb4b",
    fillOpacity: 0.89
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#279824"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#1a8813",
    fillOpacity: 0.882
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#308d23",
    fillOpacity: 0.702
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#3f9a1e",
    fillOpacity: 0.945
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#46a62b",
    fillOpacity: 0.835
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#469a28",
    fillOpacity: 0.835
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#5fa824",
    fillOpacity: 0.925
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#5ea725",
    fillOpacity: 0.776
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#5aa728",
    fillOpacity: 0.718
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M105 48v1h-1v-1z",
    fill: "#60a32c",
    fillOpacity: 0.675
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M105 49v-1h1v1z",
    fill: "#7ab246",
    fillOpacity: 0.325
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48v1h-1v-1z",
    fill: "#96c464",
    fillOpacity: 0.239
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M107 48h1v1h-1z",
    fill: "#6bb534",
    fillOpacity: 0.8
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M109 49h-1v-1h1z",
    fill: "#74bc3a",
    fillOpacity: 0.584
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M110 49h-1v-1h1z",
    fill: "#70b74a",
    fillOpacity: 0.294
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M110 48h1v1h-1z",
    fill: "#4faa3d",
    fillOpacity: 0.341
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48v1h-1v-1z",
    fill: "#5caa38",
    fillOpacity: 0.604
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M112 48h1v1h-1z",
    fill: "#62ab36",
    fillOpacity: 0.839
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M114 48v1h-1v-1z",
    fill: "#72b040",
    fillOpacity: 0.918
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M115 48v1h-1v-1z",
    fill: "#8cba60",
    fillOpacity: 0.478
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49h-1v-1h1z",
    fill: "#a0c174",
    fillOpacity: 0.275
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M117 48v1h-1v-1z",
    fill: "#c5d0a2",
    fillOpacity: 0.086
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#74ae35",
    fillOpacity: 0.761
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#82bd36"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#98c46a",
    fillOpacity: 0.827
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#ccd6ad",
    fillOpacity: 0.098
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#39872a",
    fillOpacity: 0.561
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#198c14"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#0b9210"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#109216"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#168b1a"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#22821f"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#2a8d1b"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#378927"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#1c7411"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#18791a"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#0d650a"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#075408"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#0e510c"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#43842c"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#3d8c27"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#52a23e"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#288019"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#288c13"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#228917"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#419c20"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#62ae35"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#50a52b"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#59ab30"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#98ca4d"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#6dbe3c"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#3a9a0e"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#46a51b"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#1c6f1e"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#085309"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#024204"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#094d0d"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#083c06"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#002600"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#2d681f"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#29a421"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#1c6615"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#033505"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#024a03"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#0c5a0a"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#186d10"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#379d29"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#137d0b"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#147d14"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#0e7b0a"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1z",
    fill: "#108809"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#1b9009"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#0e8c0e"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#188619"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#3b8734"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#238214"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#51a725"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#5c9c28"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#56a320"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#7bbf38"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#3d8723"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#166c11"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#329c24"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#4ba335"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#57a838"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#17770f"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#1c6618"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#42822e"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#348c29"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#006605"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#429923",
    fillOpacity: 0.922
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#74b75b",
    fillOpacity: 0.533
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#40a133"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#3f9930",
    fillOpacity: 0.667
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#87bb6a",
    fillOpacity: 0.384
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#74b346",
    fillOpacity: 0.663
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#afdf8f",
    fillOpacity: 0.063
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#95ba66",
    fillOpacity: 0.557
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#a5c76e",
    fillOpacity: 0.235
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M106 50v-1h1v1z",
    fill: "#67a93b",
    fillOpacity: 0.455
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M108 49v1h-1v-1z",
    fill: "#6da935",
    fillOpacity: 0.502
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M113 49h1v1h-1z",
    fill: "#7cb058",
    fillOpacity: 0.192
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M114 49h1v1h-1z",
    fill: "#7caa5e",
    fillOpacity: 0.392
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M116 49v1h-1v-1z",
    fill: "#75aa5c",
    fillOpacity: 0.4
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M116 50v-1h1v1z",
    fill: "#78aa5c",
    fillOpacity: 0.282
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M118 50h-1v-1h1z",
    fill: "#89b06f",
    fillOpacity: 0.153
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h-1v-1h1z",
    fill: "#afbf9f",
    fillOpacity: 0.063
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1z",
    fill: "#a2bc67",
    fillOpacity: 0.424
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1z",
    fill: "#99be55",
    fillOpacity: 0.749
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#7abe3f",
    fillOpacity: 0.898
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#6dad51",
    fillOpacity: 0.882
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#90b171",
    fillOpacity: 0.58
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#2e6d19",
    fillOpacity: 0.902
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#1b7617"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#289524"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#128516"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1z",
    fill: "#11780e"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#379025"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#25860d"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#31960c"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#288d0a"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#1c8809"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#0d7007"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#086206"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#074907"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#236c16"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#73b645"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#4d912f"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#1d7113"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#4fad2a"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#4baf20"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#329b16"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#288e1b"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#3a9b27"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#37941d"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#429c23"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#6cb939"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#a1cf53"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#73ba40"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#379811"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#2d8e18"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#0f8311"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#23751c"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#407b2f"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#216916"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#034007"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#093106"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#438331"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#12870d"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#063706"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#238a18"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#0f7807"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#3a9621"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1z",
    fill: "#3daa25"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#158b15"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#14890d"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#29a00c"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#34a410"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#27a821"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#097c12"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#095a0c"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#35a620"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#1d6d10"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#297012"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#70b63a"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#69b233"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#196019"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#166c14"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#379c28"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#429a32"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#68b241"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#4e952a"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#347e24"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#1d6113"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#56a23e"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#156c0c"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#278616",
    fillOpacity: 0.996
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#35891f",
    fillOpacity: 0.953
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#4aa82d"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#61b13e",
    fillOpacity: 0.992
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#7fbf4e",
    fillOpacity: 0.855
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#80bb53",
    fillOpacity: 0.506
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#8aae5b",
    fillOpacity: 0.275
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#9cc16f",
    fillOpacity: 0.486
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#a8c585",
    fillOpacity: 0.173
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51v-1h1v1z",
    fill: "#67ab3e",
    fillOpacity: 0.337
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51h-1v-1h1z",
    fill: "#5ea02c",
    fillOpacity: 0.561
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51h-1v-1h1z",
    fill: "#79aa55",
    fillOpacity: 0.082
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M117 51v-1h1v1z",
    fill: "#89b068",
    fillOpacity: 0.153
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50v1h-1v-1z",
    fill: "#9fb98a",
    fillOpacity: 0.231
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M119 50h1v1h-1z",
    fill: "#b6c3aa",
    fillOpacity: 0.235
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M122 50v1h-1v-1z",
    fill: "#ffffdf",
    fillOpacity: 0.031
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52h-1v-1h1z",
    fill: "#abc76c",
    fillOpacity: 0.286
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#a0be5c",
    fillOpacity: 0.635
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51v1h-1v-1z",
    fill: "#a0c37f",
    fillOpacity: 0.455
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#73b354",
    fillOpacity: 0.651
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#358d22",
    fillOpacity: 0.984
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#5e9732"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#22791c"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#2d872e"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#1e7a15"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#158009"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#409535",
    fillOpacity: 0.992
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#419b30"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#3b931d"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#369d1b"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#137b0c"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#22801c"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#035406"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#024101"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#134c11"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#084e0a"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#1d6415"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#48a222"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#57a828"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#379819"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#28981b"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#2f9a1d"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#3eac1d"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#359d19"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h-1v-1h1z",
    fill: "#349a24"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#36931e"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#54ab2b"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#8ec64e"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#8ac14d"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#288d0c"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#157e0a"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#1c8b14"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#15640e"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#5d963b"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#76a94b"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#287819"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#116a0d"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#357f22"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#3c7f28"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#076508"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#0c7715"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#084c0a"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#2a811c"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#065d0b"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#1e6015"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#62b93d"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M70 51h1v1h-1z",
    fill: "#36a229"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1z",
    fill: "#208f0d"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#46af11"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#49b51d"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#1ea11d"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#066c09"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#09590d"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#06720d"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#2ca31a"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#2d8917"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#035b08"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#2a9b17"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#54b32b"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#3c9221"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#197c10"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#28901d"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#368b22"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#58b134"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#69b538"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#63ac3a"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#68b23c"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#72b635"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#70b630"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#69b331"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#67b230"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#5ab333"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#68bb4a",
    fillOpacity: 0.945
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#85be52",
    fillOpacity: 0.631
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#8fb74f",
    fillOpacity: 0.125
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#9abf7f",
    fillOpacity: 0.329
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M103 52v-1h1v1z",
    fill: "#9ab170",
    fillOpacity: 0.169
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M105 52h-1v-1h1z",
    fill: "#6cae42",
    fillOpacity: 0.212
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M105 51h1v1h-1z",
    fill: "#5da229",
    fillOpacity: 0.725
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M107 51v1h-1v-1z",
    fill: "#639b38",
    fillOpacity: 0.071
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M121 52v-1h1v1z",
    fill: "#d0e7d0",
    fillOpacity: 0.043
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M123 51v1h-1v-1z",
    fill: "#ffffe2",
    fillOpacity: 0.035
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#b4d474",
    fillOpacity: 0.094
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1z",
    fill: "#a4c45f",
    fillOpacity: 0.596
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53v-1h1v1z",
    fill: "#98bf74",
    fillOpacity: 0.427
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1z",
    fill: "#9abf83",
    fillOpacity: 0.349
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#8cbf75",
    fillOpacity: 0.298
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#569e30",
    fillOpacity: 0.996
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#318b12"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#167e17"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#267c1d"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#2d891b"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#046b05"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#368f26"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#409827"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#3a9e29"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#3a9a2b"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#378e29"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#358b22"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#348f1e"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#308a21"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#1b630d"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#4d9724"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#48a21b"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#3b9416"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#69b327"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#3c9a1a"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#057802"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#309c1e"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#3caf22"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#23a40f"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52v1h-1v-1z",
    fill: "#319e1e"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#48ac2d"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1z",
    fill: "#1e8710"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1z",
    fill: "#67ab39"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#a8d15d"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52v1h-1v-1z",
    fill: "#339118"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M53 52h1v1h-1z",
    fill: "#329819"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1z",
    fill: "#3c9f20"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#4b902c"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-1v-1h1z",
    fill: "#446929"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#1c3c13"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#398629"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#29841a"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#6bb642"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#5aa63d"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#358521"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#267119"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#389723"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#0f6106"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#023b02"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#042e04"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#549936"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1z",
    fill: "#45ae2f"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1z",
    fill: "#35a514"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1z",
    fill: "#66c018"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#50b321"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#3b9e22"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#1e6316"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#022b03"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#106a14"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1z",
    fill: "#239015"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#37a020"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#076504"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#36a718"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#70c346"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#7ac147"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#4eac2a"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#47ab30"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#7ec751"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#7bc348"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#79c141"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#81be3e"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#8cc541"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#8bc843"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#88c741"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#8cc04a"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#6bad33"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#59a52c"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#79c64f"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#78b957",
    fillOpacity: 0.447
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#99bb6f",
    fillOpacity: 0.431
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M103 53v-1h1v1z",
    fill: "#88bf6a",
    fillOpacity: 0.235
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53h-1v-1h1z",
    fill: "#5ea22d",
    fillOpacity: 0.776
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M106 52v1h-1v-1z",
    fill: "#70a639",
    fillOpacity: 0.259
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1z",
    fill: "#afc36d",
    fillOpacity: 0.467
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1z",
    fill: "#9bc26f",
    fillOpacity: 0.482
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M19 53h1v1h-1z",
    fill: "#88b573",
    fillOpacity: 0.475
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M21 53v1h-1v-1z",
    fill: "#85ab72",
    fillOpacity: 0.263
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#84b05f",
    fillOpacity: 0.482
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#71b73b",
    fillOpacity: 0.988
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#369a17"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#0e6e0c"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#27761a",
    fillOpacity: 0.894
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#418e36",
    fillOpacity: 0.584
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#046705"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#348f21"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#51aa34"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#20891a"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#177d11"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#197b14"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#0c660b"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#389124"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#30871e"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#2b831d"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#389420"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#53ae27"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#57b327"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1z",
    fill: "#51ae20"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#3dab1f"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#138e11"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54h-1v-1h1z",
    fill: "#10710b"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M47 53v1h-1v-1z",
    fill: "#178815"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1z",
    fill: "#0d940d"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M49 54h-1v-1h1z",
    fill: "#43b02b"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M50 53v1h-1v-1z",
    fill: "#238f15"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M51 53v1h-1v-1z",
    fill: "#39891e"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1z",
    fill: "#a9d25a"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h-1v-1h1z",
    fill: "#519f2f"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h1z",
    fill: "#2b8415"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54v-1h1v1z",
    fill: "#56ad26"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1z",
    fill: "#257f11"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53v1h-1v-1z",
    fill: "#084a04"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#023409"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#205416"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#499731"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#287c1a"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#256616"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#488734"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#60a940"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#68b644"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#57a537"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#2c7223"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#1e5d15"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#114810"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1z",
    fill: "#418927"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#3da721"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1z",
    fill: "#40ab18"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1z",
    fill: "#70c122"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#68b62d"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#2e711c"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#092c08"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#0a3508"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#1d7616"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#2b9418"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#4ab324"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#367029"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#44812b"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#6cc040"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#40a52a"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#6db849"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#6bae47"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#91ca5b"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#85bb47"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#82ba35"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#6db53d"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#4f9633"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#3c8c18"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#60ac34"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#71b754",
    fillOpacity: 0.855
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#78b151",
    fillOpacity: 0.541
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#bfffbf",
    fillOpacity: 0.016
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1z",
    fill: "#b6daaa",
    fillOpacity: 0.082
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#84bd52",
    fillOpacity: 0.655
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54h-1v-1h1z",
    fill: "#5da92a",
    fillOpacity: 0.769
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M105 53v1h-1v-1z",
    fill: "#5fa22e",
    fillOpacity: 0.431
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#a2b97f",
    fillOpacity: 0.086
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54h1v1h-1z",
    fill: "#acc871",
    fillOpacity: 0.459
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54v1h-1v-1z",
    fill: "#9cc56a",
    fillOpacity: 0.659
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v1h-1v-1z",
    fill: "#7cb95d",
    fillOpacity: 0.545
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1z",
    fill: "#8cbb77",
    fillOpacity: 0.235
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#53a334",
    fillOpacity: 0.894
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#4f9e25"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#70b642"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#429c1e"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#348a22",
    fillOpacity: 0.957
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#439432",
    fillOpacity: 0.839
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#1e7b12"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#63b13d"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#30931d"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#0c7410"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#167a19"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#178317"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#127e15"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#2d881e"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#30771f"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#206211"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#357d20"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#4ba32f"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#3ba11d"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#2b9b17"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#2da523"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#23a316"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#23ab16"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55v-1h1v1z",
    fill: "#0d9b0f"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#06810d"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M47 55h-1v-1h1z",
    fill: "#046f07"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1z",
    fill: "#159113"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1z",
    fill: "#35b024"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M49 55v-1h1v1z",
    fill: "#56bb37"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54h1v1h-1z",
    fill: "#37971a"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h-1v-1h1z",
    fill: "#84bd47"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#83ba4a"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1z",
    fill: "#187809"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#2f931c"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55v-1h1v1z",
    fill: "#066705"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#003500"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#39892b"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#2d7f23"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#003a03"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#014601"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54h1v1h-1z",
    fill: "#0a6904"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#2f8c1f"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#1e5f16"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1z",
    fill: "#27621f"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1z",
    fill: "#26661c"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M69 55h-1v-1h1z",
    fill: "#287524"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1z",
    fill: "#4bb032"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1z",
    fill: "#57b629"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M73 54v1h-1v-1z",
    fill: "#79c234"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#7ec242"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#64a93f"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#599c43"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#3f8a2b"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#298523"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#107f11"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#2c9f18"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#309c11"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#339d1e"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#1a5818"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#10580c"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#559d3b"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#2c9a20"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#51ac38"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#6aad4a"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#82ba54"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#89bc4a"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#6da726"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#4f9829"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#5cab38"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#499822"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#4b9d22"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#5fa43c",
    fillOpacity: 0.431
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#7db65e",
    fillOpacity: 0.318
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#72af57",
    fillOpacity: 0.227
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55v-1h1v1z",
    fill: "#96c97d",
    fillOpacity: 0.565
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#6abd35"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M104 54v1h-1v-1z",
    fill: "#509b19",
    fillOpacity: 0.475
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M15 55h1v1h-1z",
    fill: "#93bc55",
    fillOpacity: 0.42
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55v1h-1v-1z",
    fill: "#7fb735",
    fillOpacity: 0.933
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M17 55h1v1h-1z",
    fill: "#6bb143",
    fillOpacity: 0.906
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v-1h1v1z",
    fill: "#5ca248",
    fillOpacity: 0.455
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1z",
    fill: "#87b570",
    fillOpacity: 0.561
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h1v1h-1z",
    fill: "#65a645",
    fillOpacity: 0.859
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M21 55h1v1h-1z",
    fill: "#368e16",
    fillOpacity: 0.961
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1z",
    fill: "#468e2b",
    fillOpacity: 0.894
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#6da64f",
    fillOpacity: 0.894
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#78bb38",
    fillOpacity: 0.98
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#39a114"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#37a01a"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#2b8e17"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#2d9119"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#168111"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#237a17"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#45912a"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#52a830"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#3d9d2c"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#4d9f29"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#429f29"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#4ba029"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#45a127"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#3a9c1a"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#238f0b"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#2d991a"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#44a72a"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#2a8c1a"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M44 55h1v1h-1z",
    fill: "#259215"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#0d800a"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#047d06"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1z",
    fill: "#339d1f"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#1d8d18"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M50 56h-1v-1h1z",
    fill: "#3c9d2a"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M51 55v1h-1v-1z",
    fill: "#68ba31"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v-1h1v1z",
    fill: "#70b331"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55v1h-1v-1z",
    fill: "#8dc34f"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1z",
    fill: "#339219"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56h-1v-1h1z",
    fill: "#107d06"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#4aa328"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M56 55h1v1h-1z",
    fill: "#0f700c"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#056208"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1z",
    fill: "#085e08"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#267926"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#0d510b"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#054d03"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#015901"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M64 55v1h-1v-1z",
    fill: "#2d911d"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#002c00"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1z",
    fill: "#002f03"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#015400"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56v-1h1v1z",
    fill: "#17880a"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#37a518"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h-1v-1h1z",
    fill: "#4daa1b"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56v-1h1v1z",
    fill: "#70bd35"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#8fd947"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#79ca3f"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#5cbd35"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#085b0c"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#107310"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#37a814"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#35aa18"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#2a9718"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#3b9837"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#166616"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#327825"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#3ea223"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#77b44d"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#72a63c"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#71aa2d"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#449129"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#358d25"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#59a532"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#60ac40"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#47a126",
    fillOpacity: 0.965
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#9dc979",
    fillOpacity: 0.451
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#a3c888",
    fillOpacity: 0.11
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#66a342",
    fillOpacity: 0.545
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1z",
    fill: "#b0cda6",
    fillOpacity: 0.102
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h1v1h-1z",
    fill: "#70b54c",
    fillOpacity: 0.945
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55v1h-1v-1z",
    fill: "#50a21f",
    fillOpacity: 0.596
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h1v1h-1z",
    fill: "#0ff",
    fillOpacity: 0.004
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56v1h-1v-1z",
    fill: "#dce796",
    fillOpacity: 0.086
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h1v1h-1z",
    fill: "#88be4b",
    fillOpacity: 0.796
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#6cb725"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#6ab332"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M18 57v-1h1v1z",
    fill: "#619f50",
    fillOpacity: 0.824
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#76a45d",
    fillOpacity: 0.608
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57v-1h1v1z",
    fill: "#68aa42",
    fillOpacity: 0.345
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56v1h-1v-1z",
    fill: "#51932b",
    fillOpacity: 0.733
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1z",
    fill: "#5f9646",
    fillOpacity: 0.698
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h-1v-1h1z",
    fill: "#236f17",
    fillOpacity: 0.969
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#7db44a",
    fillOpacity: 0.78
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#66b426"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1z",
    fill: "#6cb72a"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1z",
    fill: "#63b229"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#52ac2c"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#62ae33"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#67b130"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#4aa31a"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#398f1d"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#298013"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#329415"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#19910c"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M38 57h-1v-1h1z",
    fill: "#2d9316"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#56aa2b"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#5daf30"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#43a222"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#52b028"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#218412"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#117e07"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#359919"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M46 56h1v1h-1z",
    fill: "#2d9416"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h1v1h-1z",
    fill: "#3da928"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M49 56v1h-1v-1z",
    fill: "#046504"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57v-1h1v1z",
    fill: "#338325"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M51 56v1h-1v-1z",
    fill: "#72bb42"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M52 57h-1v-1h1z",
    fill: "#6eb932"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h-1v-1h1z",
    fill: "#7cbd3f"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1z",
    fill: "#3a961d"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h-1v-1h1z",
    fill: "#1b8510"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1z",
    fill: "#5fad39"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#226a12"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#035608"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1z",
    fill: "#106e0e"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1z",
    fill: "#1d741e"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57h-1v-1h1z",
    fill: "#064f07"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#18690c"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#004000"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1z",
    fill: "#043304"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#144d0b"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#246712"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#3b9516"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h1v1h-1z",
    fill: "#24940e"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57h-1v-1h1z",
    fill: "#329719"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M71 57v-1h1v1z",
    fill: "#458a2b"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M72 56h1v1h-1z",
    fill: "#2b6317"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#94d64c"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#79cb3a"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#3c9e20"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#38a526"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#0f7711"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#0a5a05"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#35a519"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#60b93d"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#319427"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#33953b"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#1b7a12"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#64b635"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#4da52c"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#72b94e"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#458029"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#65a32a"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#58a338"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#207d1e"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#389326"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#50a642"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#4e9b2b",
    fillOpacity: 0.871
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#53953e",
    fillOpacity: 0.322
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#569a3b",
    fillOpacity: 0.557
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#72ae43",
    fillOpacity: 0.784
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#90bc74",
    fillOpacity: 0.18
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#72bb50",
    fillOpacity: 0.471
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1z",
    fill: "#58a82d",
    fillOpacity: 0.855
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#6aaa55",
    fillOpacity: 0.047
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58h-1v-1h1z",
    fill: "#93bd4e",
    fillOpacity: 0.624
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M16 58h-1v-1h1z",
    fill: "#65ac23"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57h1v1h-1z",
    fill: "#5aa32c",
    fillOpacity: 0.973
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v-1h1v1z",
    fill: "#6aad24",
    fillOpacity: 0.957
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M19 57v1h-1v-1z",
    fill: "#6bae3d",
    fillOpacity: 0.522
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M20 57h1v1h-1z",
    fill: "#5da62d",
    fillOpacity: 0.643
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57h1v1h-1z",
    fill: "#4f9834",
    fillOpacity: 0.518
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M22 57h1v1h-1z",
    fill: "#789e5c",
    fillOpacity: 0.498
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57v1h-1v-1z",
    fill: "#639b46",
    fillOpacity: 0.78
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h1v1h-1z",
    fill: "#90bf71",
    fillOpacity: 0.345
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58h-1v-1h1z",
    fill: "#8fc550",
    fillOpacity: 0.831
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#6fb328"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#50a91d"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#309718"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#46a419"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#47a516"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#3ea010"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#289a0e"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#23980c"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#20950d"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#279815"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#1b9511"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#188509"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#55b02f"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#4ead29"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#3fa520"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1z",
    fill: "#239211"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#1d8111"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#0b7407"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1z",
    fill: "#56ad23"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58h-1v-1h1z",
    fill: "#3ba31b"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v-1h1v1z",
    fill: "#3da326"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1z",
    fill: "#0a6c07"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M49 57h1v1h-1z",
    fill: "#11640d"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1z",
    fill: "#24791b"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h-1v-1h1z",
    fill: "#5fab35"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58v-1h1v1z",
    fill: "#73be36"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#348b17"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1z",
    fill: "#207f10"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1z",
    fill: "#448f2d"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#30701f"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#003702"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#146816"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#0e6510"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h1v1h-1z",
    fill: "#015300"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M62 58h-1v-1h1z",
    fill: "#035703"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58h-1v-1h1z",
    fill: "#449628"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#459524"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#458727"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#5c9834"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#4c912b"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1z",
    fill: "#347b1a"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1z",
    fill: "#318918"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1z",
    fill: "#27870c"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58v-1h1v1z",
    fill: "#66b231"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#245e16"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57h1v1h-1z",
    fill: "#397120"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57v1h-1v-1z",
    fill: "#9ddd4d"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#83d133"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#3da817"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#0b7e09"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#0a7b0b"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#045e05"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#288f13"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#56b32f"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#76cb54"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#258d1b"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#12640d"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#49ac26"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#94d554"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#a2d871"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h-1v-1h1z",
    fill: "#5fb036"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#5ca83a"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#30751e"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#4c9020"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#46962a"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#167b1e"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#0c700b"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#107c0b"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#299014",
    fillOpacity: 0.996
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#4e9936",
    fillOpacity: 0.718
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#77b35b",
    fillOpacity: 0.251
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58h-1v-1h1z",
    fill: "#c3ddaa",
    fillOpacity: 0.118
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#75bf5a",
    fillOpacity: 0.729
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#4eae28",
    fillOpacity: 0.953
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#66b23a",
    fillOpacity: 0.576
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M13 58v1h-1v-1z",
    fill: "#bfdf9f",
    fillOpacity: 0.031
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M13 59v-1h1v1z",
    fill: "#afcb80",
    fillOpacity: 0.427
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M14 58h1v1h-1z",
    fill: "#98be65",
    fillOpacity: 0.702
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58h1v1h-1z",
    fill: "#72ac49",
    fillOpacity: 0.584
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M17 59h-1v-1h1z",
    fill: "#75a94f",
    fillOpacity: 0.733
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59h-1v-1h1z",
    fill: "#7bb83f",
    fillOpacity: 0.835
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M19 58v1h-1v-1z",
    fill: "#68b22d",
    fillOpacity: 0.953
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58v1h-1v-1z",
    fill: "#7db94e",
    fillOpacity: 0.533
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M21 58v1h-1v-1z",
    fill: "#61a726",
    fillOpacity: 0.965
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M22 58v1h-1v-1z",
    fill: "#6fb440",
    fillOpacity: 0.78
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59v-1h1v1z",
    fill: "#76b337",
    fillOpacity: 0.863
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1z",
    fill: "#6eaa36",
    fillOpacity: 0.875
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M25 59h-1v-1h1z",
    fill: "#78af52",
    fillOpacity: 0.4
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M25 58h1v1h-1z",
    fill: "#7bb84f",
    fillOpacity: 0.678
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58v1h-1v-1z",
    fill: "#6cb933"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#55a924"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#409524"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#2e951b"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#1e880e"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#249112"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#13840c"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#10860e"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#22901e"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#1b6b16"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#2c931e"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M38 59v-1h1v1z",
    fill: "#3ba320"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#239c17"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h-1v-1h1z",
    fill: "#178f0f"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1z",
    fill: "#168810"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#006d01"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#046305"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#2d8d15"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#52b415"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M47 58v1h-1v-1z",
    fill: "#4cb320"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1z",
    fill: "#2a9515"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58v1h-1v-1z",
    fill: "#086607"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1z",
    fill: "#055a08"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1z",
    fill: "#0d620e"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M52 58h1v1h-1z",
    fill: "#69b43a"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#2a8d12"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1z",
    fill: "#09790a"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1z",
    fill: "#2f9621"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1z",
    fill: "#498d2d"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#0a4406"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#1d7015"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59v-1h1v1z",
    fill: "#227e19"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M61 58v1h-1v-1z",
    fill: "#3d9522"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v1z",
    fill: "#5eaa37"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#6eb73b"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#5aac2f"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#3b9224"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#1c6811"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#043f04"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59h-1v-1h1z",
    fill: "#08450c"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#125d10"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#3d851c"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v1h-1z",
    fill: "#73c132"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h-1v-1h1z",
    fill: "#247815"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M74 59h-1v-1h1z",
    fill: "#83c836"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#80ce29"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#22a109"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#07840b"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#046206"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#1b870e"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#5ab62c"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#62b73b"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#58b026"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#61bf31"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#55ab34"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#9ac76c"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#97c763"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#5eab34"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#25761b"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#338413"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#52a31c"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#228f13"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#087e0a"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#2b9b0d"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#5cb729"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#50973a",
    fillOpacity: 0.635
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M98 58h1v1h-1z",
    fill: "#8bcf7f",
    fillOpacity: 0.251
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58v1h-1v-1z",
    fill: "#55b234",
    fillOpacity: 0.965
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#63bc33"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#6cb137",
    fillOpacity: 0.322
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M11 59h1v1h-1z",
    fill: "#b7c393",
    fillOpacity: 0.251
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M13 60h-1v-1h1z",
    fill: "#a3be74",
    fillOpacity: 0.404
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M13 59h1v1h-1z",
    fill: "#95bf59",
    fillOpacity: 0.69
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M15 59v1h-1v-1z",
    fill: "#90be57",
    fillOpacity: 0.686
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M16 60h-1v-1h1z",
    fill: "#91bd60",
    fillOpacity: 0.592
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M17 60h-1v-1h1z",
    fill: "#8bba4a",
    fillOpacity: 0.659
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M18 59v1h-1v-1z",
    fill: "#7fbb3c",
    fillOpacity: 0.722
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60h-1v-1h1z",
    fill: "#71b638",
    fillOpacity: 0.827
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60h-1v-1h1z",
    fill: "#58af27"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M20 60v-1h1v1z",
    fill: "#5bac2e",
    fillOpacity: 0.906
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M21 59h1v1h-1z",
    fill: "#6bb138",
    fillOpacity: 0.765
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59h1v1h-1z",
    fill: "#69b42b"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1z",
    fill: "#6cb539"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h1v1h-1z",
    fill: "#63ad2d"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M25 60v-1h1v1z",
    fill: "#5caf27"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M26 59h1v1h-1z",
    fill: "#7bc144"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M27 60v-1h1v1z",
    fill: "#53a324"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59v1h-1v-1z",
    fill: "#63b736"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v-1h1v1z",
    fill: "#45aa26"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1z",
    fill: "#1d900f"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1z",
    fill: "#0f8b0e"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M32 59h1v1h-1z",
    fill: "#0b810c"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v1h-1v-1z",
    fill: "#14870c"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59v1h-1v-1z",
    fill: "#1a880d"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#166b0d"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#227017"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60h-1v-1h1z",
    fill: "#32891f"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#46a622"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M39 59h1v1h-1z",
    fill: "#34a31c"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#349c1f"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#0e810b"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#208115"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60v-1h1v1z",
    fill: "#278713"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#4aa119"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#4ab412"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M46 59h1v1h-1z",
    fill: "#3aa515"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h-1v-1h1z",
    fill: "#0a6309"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-1h1z",
    fill: "#065e08"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60v-1h1v1z",
    fill: "#076905"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M50 59h1v1h-1z",
    fill: "#13700b"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M52 60h-1v-1h1z",
    fill: "#165c13"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#4e8f24"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1z",
    fill: "#48a11e"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#127108"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#409c1b"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#6fae3d"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#66a53e"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#72bc46"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#71b042"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#5a9d38"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#177f0b"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#057707"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#026d04"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#006001"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1z",
    fill: "#085a07"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1z",
    fill: "#126613"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1z",
    fill: "#005403"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#226d0f"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v1z",
    fill: "#5ab728"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M72 59h1v1h-1z",
    fill: "#0c6a11"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M73 59h1v1h-1z",
    fill: "#428b1f"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#69c51d"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#24ac04"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#0e920d"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#207010"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#005002"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#178a0f"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#47b325"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#64c33b"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#5bbe26"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#53b42d"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#17880f"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#1b7b11"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#539135"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1z",
    fill: "#246811"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#479323"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#58a531"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#3d9e22"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#25970d"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#0e820a"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#3ba219"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#65bd31"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#55ab2d"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#45a32f"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#5bab44",
    fillOpacity: 0.631
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v1h-1v-1z",
    fill: "#60b14a",
    fillOpacity: 0.851
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60h-1v-1h1z",
    fill: "#69b83d"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59v1h-1v-1z",
    fill: "#76b939",
    fillOpacity: 0.933
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#8bb964",
    fillOpacity: 0.129
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M17 60h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60v1h-1v-1z",
    fill: "#abcd90",
    fillOpacity: 0.18
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h-1v-1h1z",
    fill: "#5cac2d",
    fillOpacity: 0.973
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1z",
    fill: "#52a930",
    fillOpacity: 0.875
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61v-1h1v1z",
    fill: "#7eb85f",
    fillOpacity: 0.682
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61h-1v-1h1z",
    fill: "#70b051",
    fillOpacity: 0.98
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M23 61v-1h1v1z",
    fill: "#55a038"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-1z",
    fill: "#55a525"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1z",
    fill: "#4ca522"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M26 61v-1h1v1z",
    fill: "#5dad30"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M28 61h-1v-1h1z",
    fill: "#66b739"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60v1h-1v-1z",
    fill: "#41a21c"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h-1v-1h1z",
    fill: "#5bb535"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61v-1h1v1z",
    fill: "#4aa624"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61v-1h1v1z",
    fill: "#2a861a"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M32 61v-1h1v1z",
    fill: "#187711"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#47a128"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61h-1v-1h1z",
    fill: "#2c8912"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#30811a"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#36851d"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#378722"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#52a92a"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61h-1v-1h1z",
    fill: "#36a31e"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M40 61v-1h1v1z",
    fill: "#42ac26"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#19900b"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M43 61h-1v-1h1z",
    fill: "#2c8d1b"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#469b21"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#61b221"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#48b01a"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h1v1h-1z",
    fill: "#45af18"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h1z",
    fill: "#2c8414"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#074807"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#236e16"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61h-1v-1h1z",
    fill: "#268019"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M53 61h-1v-1h1z",
    fill: "#338a17"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1z",
    fill: "#74b837"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#76c349"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#78c247"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#7cc045"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#64b63a"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1z",
    fill: "#2d9a25"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1z",
    fill: "#0c5e09"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1z",
    fill: "#013d03"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M62 61v-1h1v1z",
    fill: "#085706"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#539e32"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#58a12e"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#30811b"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1z",
    fill: "#1e7814"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1z",
    fill: "#0e6307"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#0a6007"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#2b9221"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61h-1v-1h1z",
    fill: "#278e16"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M71 60h1v1h-1z",
    fill: "#0a6b08"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M72 60h1v1h-1z",
    fill: "#0f6609"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M74 60v1h-1v-1z",
    fill: "#0a5307"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M75 61h-1v-1h1z",
    fill: "#329614"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#1eaf06"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#088002"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#328c1e"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#196b0f"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#1b8b13"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#3cab1c"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#55b921"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#5ec22e"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#208f14"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#037909"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#5f9d35"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#55a532"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#4baa31"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#36a41a"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#369e1a"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#4fa027"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#50a22d"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#5db237"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#75bc4e"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#51a73d"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#45a125"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#54ba2c"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#63bd43"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M99 60h1v1h-1z",
    fill: "#6db447"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61h-1v-1h1z",
    fill: "#5eaf36",
    fillOpacity: 0.91
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#add699",
    fillOpacity: 0.098
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v-1h1v1z",
    fill: "#bfceb0",
    fillOpacity: 0.267
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M18 61v1h-1v-1z",
    fill: "#8ab861",
    fillOpacity: 0.369
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M18 62v-1h1v1z",
    fill: "#72ba43",
    fillOpacity: 0.741
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61v1h-1v-1z",
    fill: "#389713",
    fillOpacity: 0.996
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62v-1h1v1z",
    fill: "#4eaf28"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M22 61v1h-1v-1z",
    fill: "#5cb13b"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62v-1h1v1z",
    fill: "#50a52e"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h-1v-1h1z",
    fill: "#3e9923"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M25 62v-1h1v1z",
    fill: "#389c14"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M27 61v1h-1v-1z",
    fill: "#2e9313"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-1h1z",
    fill: "#379d1f"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h-1v-1h1z",
    fill: "#229311"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61h1v1h-1z",
    fill: "#4db126"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62h-1v-1h1z",
    fill: "#3e9e1e"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M32 62v-1h1v1z",
    fill: "#117a0a"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61h1v1h-1z",
    fill: "#0e740b"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1z",
    fill: "#016803"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#05670a"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#0e700b"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#076c0c"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1z",
    fill: "#3d9923"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1z",
    fill: "#42a824"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1z",
    fill: "#38a515"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#3d941b"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#64b525"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#6bb737"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M47 62h-1v-1h1z",
    fill: "#5e9f2e"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#4ca626"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62h-1v-1h1z",
    fill: "#359a19"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M49 62v-1h1v1z",
    fill: "#357f1a"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M50 61h1v1h-1z",
    fill: "#659833"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1z",
    fill: "#2d921f"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61v1h-1v-1z",
    fill: "#5eac3b"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M54 62v-1h1v1z",
    fill: "#34a32d"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h-1v-1h1z",
    fill: "#118816"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#339620"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M57 61h1v1h-1z",
    fill: "#3ba124"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1z",
    fill: "#038306"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1z",
    fill: "#038109"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1z",
    fill: "#076408"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#034e04"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#287518"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1z",
    fill: "#479921"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M65 61h1v1h-1z",
    fill: "#43961c"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#409b1a"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1z",
    fill: "#3f9b1f"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1z",
    fill: "#31a21c"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62h-1v-1h1z",
    fill: "#1d9410"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M71 61v1h-1v-1z",
    fill: "#1e820f"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M71 62v-1h1v1z",
    fill: "#258010"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v1h-1v-1z",
    fill: "#2b8414"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M74 62h-1v-1h1z",
    fill: "#0c5206"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M76 62h-1v-1h1z",
    fill: "#0d940b"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#047505"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#0d6108"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#479c2d"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#3d9f27"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#62bf25"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#61ba27"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#127308"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#0d7709"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#349720"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#56b137"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#6fbb3a"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#59b12d"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#279a17"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#279413"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#50a619"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#52a62a"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#3d8826"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#206b10"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#77a943"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#76ac43"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#4da123"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#3ba522"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#1e8210"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61v1h-1v-1z",
    fill: "#31941a"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61h1v1h-1z",
    fill: "#54b034"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61v1h-1v-1z",
    fill: "#73b257",
    fillOpacity: 0.667
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M103 62h-1v-1h1z",
    fill: "#82b96a",
    fillOpacity: 0.329
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M117 61v1h-1v-1z",
    fill: "#b9c9a4",
    fillOpacity: 0.243
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M118 62h-1v-1h1z",
    fill: "#c4d3b6",
    fillOpacity: 0.137
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63h-1v-1h1z",
    fill: "#81b94b",
    fillOpacity: 0.635
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M19 62v1h-1v-1z",
    fill: "#59b129"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1z",
    fill: "#2d9013"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#46a129"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M22 63h-1v-1h1z",
    fill: "#4dab29"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#40a622"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62v1h-1v-1z",
    fill: "#43a427"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62h1v1h-1z",
    fill: "#3da124"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-1z",
    fill: "#299111"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v-1h1v1z",
    fill: "#3c9a17"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63h-1v-1h1z",
    fill: "#2f8a1c"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62v1h-1v-1z",
    fill: "#6bb948"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h1v1h-1z",
    fill: "#429c26"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#309a1f"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63h-1v-1h1z",
    fill: "#37a41d"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62v1h-1v-1z",
    fill: "#0c7e09"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M33 62h1v1h-1z",
    fill: "#005904"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v1h-1z",
    fill: "#085a0b"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1z",
    fill: "#439b2f"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1z",
    fill: "#3a7f25"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v-1h1v1z",
    fill: "#003c03"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1z",
    fill: "#31781d"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h-1v-1h1z",
    fill: "#45ad24"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#56b42f"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1z",
    fill: "#65ad29"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63v-1h1v1z",
    fill: "#5ba526"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1z",
    fill: "#439f18"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#439d1d"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#5eac36"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M46 62h1v1h-1z",
    fill: "#22630e"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62v1h-1v-1z",
    fill: "#0d4c09"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62h1v1h-1z",
    fill: "#3b9e23"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M49 63v-1h1v1z",
    fill: "#4dae1f"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#3c981c"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M51 62h1v1h-1z",
    fill: "#0a6707"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62v1h-1v-1z",
    fill: "#0f740c"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-1z",
    fill: "#2d8c22"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M55 62v1h-1v-1z",
    fill: "#186215"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M56 63h-1v-1h1z",
    fill: "#08630f"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62h1v1h-1z",
    fill: "#30a120"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-1h1z",
    fill: "#4ab02b"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M58 62h1v1h-1z",
    fill: "#088009"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62v1h-1v-1z",
    fill: "#048c0a"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1z",
    fill: "#058e08"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#058511"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M63 62v1h-1v-1z",
    fill: "#0f7d11"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#036d0b"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1z",
    fill: "#158214"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M65 62h1v1h-1z",
    fill: "#0f610e"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#216b13"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#4eaa26"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M69 63h-1v-1h1z",
    fill: "#289e16"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M70 62v1h-1v-1z",
    fill: "#2f9113"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#318c14"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62v1h-1v-1z",
    fill: "#23840b"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1z",
    fill: "#107305"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1z",
    fill: "#055706"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M75 62v1h-1v-1z",
    fill: "#043f05"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#026302"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#005302"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#35911c"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#79d043"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#87d546"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#4e992f"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#308223"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#57b440"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#4db436"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#30a41f"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#52ac2d"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#559631"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#166919"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#319920"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#59b732"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#4f9e32"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#064607"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#2e6118"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#81a844"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#99c74e"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#96ca58"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1z",
    fill: "#6aad49"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M100 63h-1v-1h1z",
    fill: "#006d00"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M101 62v1h-1v-1z",
    fill: "#32902e",
    fillOpacity: 0.929
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M102 63h-1v-1h1z",
    fill: "#459833",
    fillOpacity: 0.976
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M102 62h1v1h-1z",
    fill: "#66b34a",
    fillOpacity: 0.969
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M104 62v1h-1v-1z",
    fill: "#83b361",
    fillOpacity: 0.729
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h-1v-1h1z",
    fill: "#8eba75",
    fillOpacity: 0.553
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M106 62v1h-1v-1z",
    fill: "#9dc38c",
    fillOpacity: 0.235
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62v1h-1v-1z",
    fill: "#c5dfb8",
    fillOpacity: 0.157
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M110 62h1v1h-1z",
    fill: "#c7dcba",
    fillOpacity: 0.29
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M112 63h-1v-1h1z",
    fill: "#c6d5b7",
    fillOpacity: 0.333
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M113 63h-1v-1h1z",
    fill: "#c6d7b5",
    fillOpacity: 0.176
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M116 62v1h-1v-1z",
    fill: "#b6c491",
    fillOpacity: 0.275
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M117 63h-1v-1h1z",
    fill: "#b9c994",
    fillOpacity: 0.188
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M18 63v1h-1v-1z",
    fill: "#85c44e",
    fillOpacity: 0.765
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M19 64h-1v-1h1z",
    fill: "#2f9513"
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63v1h-1v-1z",
    fill: "#29941a"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v-1h1v1z",
    fill: "#359620"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M22 64h-1v-1h1z",
    fill: "#409f22"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h-1v-1h1z",
    fill: "#3eac22"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64v-1h1v1z",
    fill: "#389b1f"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M25 63v1h-1v-1z",
    fill: "#5aaf35"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M26 63v1h-1v-1z",
    fill: "#45a42e"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M27 63v1h-1v-1z",
    fill: "#53a820"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M28 63v1h-1v-1z",
    fill: "#31910f"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64v-1h1v1z",
    fill: "#33921f"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M30 63v1h-1v-1z",
    fill: "#49a934"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M31 64h-1v-1h1z",
    fill: "#22831d"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M32 63v1h-1v-1z",
    fill: "#35931a"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1z",
    fill: "#0e780a"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64h-1v-1h1z",
    fill: "#055a06"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v1h-1v-1z",
    fill: "#448728"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#7cc048"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63v1h-1v-1z",
    fill: "#44952c"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M37 63h1v1h-1z",
    fill: "#0f640b"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#478d24"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#4eb424"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#59b924"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M41 63h1v1h-1z",
    fill: "#77b236"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M42 63h1v1h-1z",
    fill: "#589f27"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1z",
    fill: "#1f840b"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64v-1h1v1z",
    fill: "#3e9b22"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#33911d"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M47 63v1h-1v-1z",
    fill: "#025a05"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h-1v-1h1z",
    fill: "#0e5208"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M48 63h1v1h-1z",
    fill: "#2f8118"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#4fae26"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#37ab1f"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v-1h1v1z",
    fill: "#12740f"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64h-1v-1h1z",
    fill: "#1d8a1a"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1z",
    fill: "#0f6b0c"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1z",
    fill: "#227217"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#43ad1e"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h1v1h-1z",
    fill: "#63b32e"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M59 63v1h-1v-1z",
    fill: "#1e6e10"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64v-1h1v1z",
    fill: "#086d0a"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1z",
    fill: "#067907"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#1f941e"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64v-1h1v1z",
    fill: "#1e921d"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#138816"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1z",
    fill: "#0c8414"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64h-1v-1h1z",
    fill: "#078218"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v-1h1v1z",
    fill: "#39a126"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1z",
    fill: "#40ab26"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64v-1h1v1z",
    fill: "#098b0e"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#177f0c"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1z",
    fill: "#147f09"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M73 63v1h-1v-1z",
    fill: "#077904"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M73 64v-1h1v1z",
    fill: "#016a01"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63h1v1h-1z",
    fill: "#0c7010"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M76 64h-1v-1h1z",
    fill: "#094c0f"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63h1v1h-1z",
    fill: "#084b05"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-1z",
    fill: "#037007"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v1h-1v-1z",
    fill: "#2ca00b"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#70ca25"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1z",
    fill: "#58ba2f"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#7dcd50"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#74c449"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#42a526"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#2ca215"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#229014"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#1d740f"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#61ac39"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#378423"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#56a938"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#3f8f29"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#359020"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#34831f"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#598f2d"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#5da829"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64v-1h1v1z",
    fill: "#419522"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M97 63v1h-1v-1z",
    fill: "#7fb553"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v-1h1v1z",
    fill: "#83ba59"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M99 63h1v1h-1z",
    fill: "#1a850b"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M100 64v-1h1v1z",
    fill: "#5aaf31",
    fillOpacity: 0.957
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M101 63h1v1h-1z",
    fill: "#7bb558",
    fillOpacity: 0.463
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64v-1h1v1z",
    fill: "#62aa4a",
    fillOpacity: 0.498
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h-1v-1h1z",
    fill: "#61a343",
    fillOpacity: 0.545
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63v1h-1v-1z",
    fill: "#73ad5a",
    fillOpacity: 0.431
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M105 63h1v1h-1z",
    fill: "#89b975",
    fillOpacity: 0.545
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M107 63v1h-1v-1z",
    fill: "#9fca86",
    fillOpacity: 0.365
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64v-1h1v1z",
    fill: "#b6cfa0",
    fillOpacity: 0.275
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M108 63h1v1h-1z",
    fill: "#bbd3a3",
    fillOpacity: 0.251
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63v1h-1v-1z",
    fill: "#bbdaab",
    fillOpacity: 0.192
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M110 63h1v1h-1z",
    fill: "#c5dcad",
    fillOpacity: 0.086
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M115 63v1h-1v-1z",
    fill: "#b2c58b",
    fillOpacity: 0.208
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M116 64h-1v-1h1z",
    fill: "#aec289",
    fillOpacity: 0.298
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M18 65h-1v-1h1z",
    fill: "#82c14f",
    fillOpacity: 0.863
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64h1v1h-1z",
    fill: "#1f8f10"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v1h-1v-1z",
    fill: "#1d8314"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M20 65v-1h1v1z",
    fill: "#409d27"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M22 65h-1v-1h1z",
    fill: "#3f9221"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65h-1v-1h1z",
    fill: "#3ea519"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M23 64h1v1h-1z",
    fill: "#46ab2e"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65h-1v-1h1z",
    fill: "#66b134"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M25 65v-1h1v1z",
    fill: "#63b233"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M26 65v-1h1v1z",
    fill: "#5eb034"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65h-1v-1h1z",
    fill: "#55ab1f"
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M28 64h1v1h-1z",
    fill: "#0d7502"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65v-1h1v1z",
    fill: "#4a9d31"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M30 64h1v1h-1z",
    fill: "#4f962e"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#3e9523"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64h1v1h-1z",
    fill: "#258a15"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M34 64v1h-1v-1z",
    fill: "#479c24"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65v-1h1v1z",
    fill: "#64ac39"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#2a7d18"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M36 64h1v1h-1z",
    fill: "#277d0e"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#5a9e21"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#7db336"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M39 64h1v1h-1z",
    fill: "#52b51f"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#55b81b"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#59a41b"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64v1h-1v-1z",
    fill: "#399516"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1z",
    fill: "#237d0d"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#55ae35"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#0c6d08"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#15720e"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#237818"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#509528"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#4ea324"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h-1v-1h1z",
    fill: "#34a71d"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64h1v1h-1z",
    fill: "#36ae25"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64v1h-1v-1z",
    fill: "#2a961c"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1z",
    fill: "#208113"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-1h1v1z",
    fill: "#198914"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h1v1z",
    fill: "#49a72b"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1z",
    fill: "#49942f"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64v1h-1v-1z",
    fill: "#5ba52e"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M58 64h1v1h-1z",
    fill: "#4a9e25"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1z",
    fill: "#0d6608"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#0c6005"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#4da431"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#278722"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65h-1v-1h1z",
    fill: "#1f701c"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#0e540d"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1z",
    fill: "#207415"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-1h1v1z",
    fill: "#46a02c"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1z",
    fill: "#0f7b14"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h-1v-1h1z",
    fill: "#087414"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v-1h1v1z",
    fill: "#0a6c11"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h-1v-1h1z",
    fill: "#2d8921"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64v1h-1v-1z",
    fill: "#239217"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M72 64h1v1h-1z",
    fill: "#138911"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65h-1v-1h1z",
    fill: "#0d7a0c"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-1h1z",
    fill: "#127d10"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M77 65h-1v-1h1z",
    fill: "#066e0a"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M77 64h1v1h-1z",
    fill: "#096a03"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1z",
    fill: "#61bf28"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1z",
    fill: "#60c92e"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#0f9209"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#38a91e"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#5fb73f"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#75bf46"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v-1h1v1z",
    fill: "#47a221"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#47a423"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#489826"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#49a028"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#71c349"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#93d263"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#8fc55e"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#568f3a"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#226c17"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#419d1a"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M95 65h-1v-1h1z",
    fill: "#6cc22c"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M95 64h1v1h-1z",
    fill: "#66a83e"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64v1h-1v-1z",
    fill: "#579f38"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M97 64h1v1h-1z",
    fill: "#45972a"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M99 64v1h-1v-1z",
    fill: "#3e9a25"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65h-1v-1h1z",
    fill: "#46a027"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65h-1v-1h1z",
    fill: "#3b9f18"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M101 65v-1h1v1z",
    fill: "#4b9d2f",
    fillOpacity: 0.698
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M102 64h1v1h-1z",
    fill: "#81b56c",
    fillOpacity: 0.478
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64v1h-1v-1z",
    fill: "#78b15f",
    fillOpacity: 0.765
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M104 64h1v1h-1z",
    fill: "#7dbb55",
    fillOpacity: 0.78
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M106 64v1h-1v-1z",
    fill: "#89c464",
    fillOpacity: 0.827
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65h-1v-1h1z",
    fill: "#95c57a",
    fillOpacity: 0.416
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64h1v1h-1z",
    fill: "#b9d0a2",
    fillOpacity: 0.043
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M114 65h-1v-1h1z",
    fill: "#adb97f",
    fillOpacity: 0.086
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M114 64h1v1h-1z",
    fill: "#acc079",
    fillOpacity: 0.435
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66v-1h1v1z",
    fill: "#c1db95",
    fillOpacity: 0.114
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h-1v-1h1z",
    fill: "#62ad3c",
    fillOpacity: 0.937
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v-1h1v1z",
    fill: "#1e8816",
    fillOpacity: 0.945
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66h-1v-1h1z",
    fill: "#539d47",
    fillOpacity: 0.573
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M21 65v1h-1v-1z",
    fill: "#63aa44",
    fillOpacity: 0.949
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M23 65v1h-1v-1z",
    fill: "#45a01e"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h-1v-1h1z",
    fill: "#2b9d17"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M24 65h1v1h-1z",
    fill: "#4aaa2a"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66h-1v-1h1z",
    fill: "#6eb329"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h-1v-1h1z",
    fill: "#5aa427"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M27 65h1v1h-1z",
    fill: "#67b93a"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h1v1z",
    fill: "#3e9b20"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M29 65h1v1h-1z",
    fill: "#18730a"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1z",
    fill: "#499c2d"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#24870d"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#37981d"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1z",
    fill: "#3d9822"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M34 65h1v1h-1z",
    fill: "#1b7510"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66v-1h1v1z",
    fill: "#308818"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#489218"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#5d9a1d"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M38 66v-1h1v1z",
    fill: "#63a928"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1z",
    fill: "#54bb24"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1z",
    fill: "#62ba23"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#66ae29"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M42 65h1v1h-1z",
    fill: "#155e0d"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v1h-1v-1z",
    fill: "#246416"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65h1v1h-1z",
    fill: "#459e2c"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#1f7d18"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#095807"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v-1h1v1z",
    fill: "#0b6009"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#629739"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1z",
    fill: "#307b18"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66v-1h1v1z",
    fill: "#218617"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M51 65h1v1h-1z",
    fill: "#2e8e1d"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M53 66h-1v-1h1z",
    fill: "#3eb624"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v1h-1v-1z",
    fill: "#248c1b"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1z",
    fill: "#2d8c20"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M56 66h-1v-1h1z",
    fill: "#60b13d"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65v1h-1v-1z",
    fill: "#13490e"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1z",
    fill: "#1c680f"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v1h-1v-1z",
    fill: "#4aa928"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v1h-1v-1z",
    fill: "#096604"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#30801e"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#5ab538"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65v1h-1v-1z",
    fill: "#10760b"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M64 66v-1h1v1z",
    fill: "#1b7c14"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#389525"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#2b8a1d"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#1d7a16"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#073f04"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M70 65v1h-1v-1z",
    fill: "#023404"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M71 66h-1v-1h1z",
    fill: "#1d6318"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65h1v1h-1z",
    fill: "#29931d"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M72 65h1v1h-1z",
    fill: "#2b9421"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65v1h-1v-1z",
    fill: "#3b9e27"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66h-1v-1h1z",
    fill: "#35a021"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1z",
    fill: "#289817"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h-1v-1h1z",
    fill: "#1c900b"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#39a01c"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66v-1h1v1z",
    fill: "#6acd2f"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#35b316"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#1d910d"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#0f7809"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65h1v1h-1z",
    fill: "#2c971a"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65h1v1h-1z",
    fill: "#329d18"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#3da126"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65h1v1h-1z",
    fill: "#429833"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#1d7e18"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#298a1f"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#4d9a33"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#589c40"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#286319"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#439525"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M94 65h1v1h-1z",
    fill: "#42a42d"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65v1h-1v-1z",
    fill: "#58ad3a"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M96 65h1v1h-1z",
    fill: "#65b33f"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M97 65h1v1h-1z",
    fill: "#56a735"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M98 65h1v1h-1z",
    fill: "#4fa332"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M100 65v1h-1v-1z",
    fill: "#50a739"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v-1h1v1z",
    fill: "#6cb64b"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M102 65v1h-1v-1z",
    fill: "#71c14e"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v-1h1v1z",
    fill: "#67b24d",
    fillOpacity: 0.812
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M104 66h-1v-1h1z",
    fill: "#93c978",
    fillOpacity: 0.298
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M104 65h1v1h-1z",
    fill: "#7db84e",
    fillOpacity: 0.639
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M105 65h1v1h-1z",
    fill: "#88c160",
    fillOpacity: 0.404
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M107 65v1h-1v-1z",
    fill: "#92bc79",
    fillOpacity: 0.314
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M107 66v-1h1v1z",
    fill: "#8bb673",
    fillOpacity: 0.373
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M109 66h-1v-1h1z",
    fill: "#91bb77",
    fillOpacity: 0.192
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66v-1h1v1z",
    fill: "#9aba66",
    fillOpacity: 0.439
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M115 65v1h-1v-1z",
    fill: "#aac47c",
    fillOpacity: 0.153
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M10 66h1v1h-1z",
    fill: "#b9d0a2",
    fillOpacity: 0.086
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67v-1h1v1z",
    fill: "#8ec566",
    fillOpacity: 0.294
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v1h-1v-1z",
    fill: "#359817",
    fillOpacity: 0.996
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#1e8d1b",
    fillOpacity: 0.878
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M20 66v1h-1v-1z",
    fill: "#76af5a",
    fillOpacity: 0.565
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M20 67v-1h1v1z",
    fill: "#64ab3c",
    fillOpacity: 0.992
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M21 66h1v1h-1z",
    fill: "#4e9920",
    fillOpacity: 0.831
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h1v1h-1z",
    fill: "#5fa93b",
    fillOpacity: 0.502
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M24 66h1v1h-1z",
    fill: "#2c9818"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M26 66v1h-1v-1z",
    fill: "#49ad23"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66v1h-1v-1z",
    fill: "#5fac20"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M27 66h1v1h-1z",
    fill: "#3f9d13"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67h-1v-1h1z",
    fill: "#61b62f"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M29 66h1v1h-1z",
    fill: "#57a528"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66h1v1h-1z",
    fill: "#449b22"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M31 66h1v1h-1z",
    fill: "#359e1c"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M32 67v-1h1v1z",
    fill: "#097606"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66v1h-1v-1z",
    fill: "#0c720f"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#25801f"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#166a0c"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#2c7711"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1z",
    fill: "#559819"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v1h-1v-1z",
    fill: "#67a720"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67h-1v-1h1z",
    fill: "#64bd26"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#7bc53d"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#3b7521"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1z",
    fill: "#024002"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M44 66v1h-1v-1z",
    fill: "#47932c"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M45 67h-1v-1h1z",
    fill: "#3a8220"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#47973a"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1z",
    fill: "#288822"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1z",
    fill: "#317a19"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#52842f"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67v-1h1v1z",
    fill: "#075c06"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M50 66h1v1h-1z",
    fill: "#1f8217"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1z",
    fill: "#15770f"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M52 66h1v1h-1z",
    fill: "#308d20"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67v-1h1v1z",
    fill: "#42b02b"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v1h-1v-1z",
    fill: "#39ad24"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M55 67v-1h1v1z",
    fill: "#37a523"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M57 67h-1v-1h1z",
    fill: "#0f8008"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1z",
    fill: "#057105"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h-1v-1z",
    fill: "#258d13"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1z",
    fill: "#66b542"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#388326"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M62 66h1v1h-1z",
    fill: "#0b6f0b"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67h-1v-1h1z",
    fill: "#186817"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#0c4f0b"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M65 67v-1h1v1z",
    fill: "#073a08"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1z",
    fill: "#0d310d"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#216520"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v-1h1v1z",
    fill: "#0b610d"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1z",
    fill: "#056a05"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#056b04"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#0d700d"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v1h-1v-1z",
    fill: "#055405"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M74 67h-1v-1h1z",
    fill: "#126d0a"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#137c0b"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#238113"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#63c03c"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-1z",
    fill: "#6bc833"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#5db629"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#67bb33"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#5db338"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#56af2a"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#42a625"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M84 67h-1v-1h1z",
    fill: "#2a8c14"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M85 66v1h-1v-1z",
    fill: "#218d12"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M86 67h-1v-1h1z",
    fill: "#299914"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1z",
    fill: "#4ca636"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#3c8123"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#1b6e0a"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#0d720b"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#127110"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#136e13"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#439f1e"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M95 66v1h-1v-1z",
    fill: "#288816"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M96 67h-1v-1h1z",
    fill: "#419a29"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M97 66v1h-1v-1z",
    fill: "#479e32"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67h-1v-1h1z",
    fill: "#56a53c"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M99 67h-1v-1h1z",
    fill: "#5daa3f"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M100 66v1h-1v-1z",
    fill: "#68b140"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67h-1v-1h1z",
    fill: "#7bbb48"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M102 66v1h-1v-1z",
    fill: "#3a9a26"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67h-1v-1h1z",
    fill: "#108206",
    fillOpacity: 0.965
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67h-1v-1h1z",
    fill: "#5fb03a",
    fillOpacity: 0.824
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M105 67h-1v-1h1z",
    fill: "#88c053",
    fillOpacity: 0.337
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66v1h-1v-1z",
    fill: "#89c475",
    fillOpacity: 0.051
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M108 66h1v1h-1z",
    fill: "#8cb672",
    fillOpacity: 0.235
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M109 67v-1h1v1z",
    fill: "#92b979",
    fillOpacity: 0.388
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67v-1h1v1z",
    fill: "#9cc082",
    fillOpacity: 0.192
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M112 66h1v1h-1z",
    fill: "#96b85e",
    fillOpacity: 0.412
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M113 66h1v1h-1z",
    fill: "#9fc169",
    fillOpacity: 0.388
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68h-1v-1h1z",
    fill: "#b2c493",
    fillOpacity: 0.224
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68v-1h1v1z",
    fill: "#aabf88",
    fillOpacity: 0.38
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68v-1h1v1z",
    fill: "#acc283",
    fillOpacity: 0.365
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M14 67v1h-1v-1z",
    fill: "#abc285",
    fillOpacity: 0.263
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67h1v1h-1z",
    fill: "#8bb558",
    fillOpacity: 0.259
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67v1h-1v-1z",
    fill: "#71b931",
    fillOpacity: 0.89
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67h1v1h-1z",
    fill: "#26980f"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1z",
    fill: "#158c0f"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v-1h1v1z",
    fill: "#55a732"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M21 68h-1v-1h1z",
    fill: "#5da730",
    fillOpacity: 0.996
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M21 67h1v1h-1z",
    fill: "#4f9521",
    fillOpacity: 0.416
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M22 67h1v1h-1z",
    fill: "#75ab5a",
    fillOpacity: 0.333
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67v1h-1v-1z",
    fill: "#5aaa34"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68h-1v-1h1z",
    fill: "#39a01b"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M26 67v1h-1v-1z",
    fill: "#1e9a15"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#40ac26"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67v1h-1v-1z",
    fill: "#4dac1d"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M29 67v1h-1v-1z",
    fill: "#6ab61e"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67v1h-1v-1z",
    fill: "#89cc35"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M30 67h1v1h-1z",
    fill: "#51ad14"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68h-1v-1h1z",
    fill: "#3a9e12"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M33 67v1h-1v-1z",
    fill: "#268312"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M33 68v-1h1v1z",
    fill: "#0c6208"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1z",
    fill: "#418218"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#5a961c"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#5d9325"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v-1h1v1z",
    fill: "#4d7926"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M39 67h1v1h-1z",
    fill: "#6dbc37"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#48a12a"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M41 67h1v1h-1z",
    fill: "#115008"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67v1h-1v-1z",
    fill: "#387e1d"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M43 67h1v1h-1z",
    fill: "#57a335"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1z",
    fill: "#184e0f"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#1c5b16"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#55ad46"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v1h-1v-1z",
    fill: "#4d922a"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#235c16"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M49 67h1v1h-1z",
    fill: "#0e630d"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v-1h1v1z",
    fill: "#156c0b"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M51 67h1v1h-1z",
    fill: "#1d8216"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1z",
    fill: "#4b942c"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M54 67h1v1h-1z",
    fill: "#50b72b"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M56 67v1h-1v-1z",
    fill: "#25a81d"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M56 68v-1h1v1z",
    fill: "#0d7e0c"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h-1v-1h1z",
    fill: "#055a09"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M58 67h1v1h-1z",
    fill: "#0c6b0a"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M59 67h1v1h-1z",
    fill: "#4fa72b"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67v1h-1v-1z",
    fill: "#5ea53b"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#023d02"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#15640d"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h-1v-1h1z",
    fill: "#123c0e"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#062601"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#032403"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#001700"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1z",
    fill: "#104910"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67h1v1h-1z",
    fill: "#25901f"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-1h1v1z",
    fill: "#048105"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1z",
    fill: "#056a07"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#086f0a"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1z",
    fill: "#006902"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#0b6c08"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M75 68v-1h1v1z",
    fill: "#4fa42e"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M77 67v1h-1v-1z",
    fill: "#71c945"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#4aa325"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#579d2f"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#30831a"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#4dac2d"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#67bc34"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#6cc230"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1z",
    fill: "#6ac42f"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M84 68v-1h1v1z",
    fill: "#52b326"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68h-1v-1h1z",
    fill: "#55b22b"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#6fc042"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68h-1v-1h1z",
    fill: "#7fc649"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#7cc040"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#67b638"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#64b135"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#68b339"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#7fc246"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#84c34d"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68h-1v-1h1z",
    fill: "#7dc34d"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M95 67h1v1h-1z",
    fill: "#6ebc42"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M97 68h-1v-1h1z",
    fill: "#93c95e"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M98 67v1h-1v-1z",
    fill: "#99ca5e"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68v-1h1v1z",
    fill: "#7cbf50"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68h-1v-1h1z",
    fill: "#79ba49"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M101 67v1h-1v-1z",
    fill: "#82bc47"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68h-1v-1h1z",
    fill: "#6bb539"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M103 67v1h-1v-1z",
    fill: "#57ae30",
    fillOpacity: 0.878
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M104 67v1h-1v-1z",
    fill: "#7ebe60",
    fillOpacity: 0.404
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M105 68h-1v-1h1z",
    fill: "#cddcd2",
    fillOpacity: 0.2
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M106 68h-1v-1h1z",
    fill: "#bdd8b9",
    fillOpacity: 0.259
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M106 67h1v1h-1z",
    fill: "#b8d4aa",
    fillOpacity: 0.141
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M110 67h1v1h-1z",
    fill: "#a3bc8b",
    fillOpacity: 0.165
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M111 67h1v1h-1z",
    fill: "#92bb66",
    fillOpacity: 0.294
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v-1h1v1z",
    fill: "#91b856",
    fillOpacity: 0.651
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M114 68h-1v-1h1z",
    fill: "#b6ff91",
    fillOpacity: 0.027
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68h1v1h-1z",
    fill: "#afcf7f",
    fillOpacity: 0.063
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M13 69v-1h1v1z",
    fill: "#b3c892",
    fillOpacity: 0.184
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M14 68h1v1h-1z",
    fill: "#80bd60",
    fillOpacity: 0.592
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M15 69v-1h1v1z",
    fill: "#6eb338",
    fillOpacity: 0.949
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M17 69h-1v-1h1z",
    fill: "#69b626"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68h1v1h-1z",
    fill: "#38a019"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M19 68v1h-1v-1z",
    fill: "#238e12"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M20 68v1h-1v-1z",
    fill: "#3fa120"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69v-1h1v1z",
    fill: "#529f2c",
    fillOpacity: 0.957
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69v-1h1v1z",
    fill: "#76ad51",
    fillOpacity: 0.455
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M23 69h-1v-1h1z",
    fill: "#6ea843",
    fillOpacity: 0.604
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69h-1v-1h1z",
    fill: "#6dac46",
    fillOpacity: 0.482
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M25 68v1h-1v-1z",
    fill: "#56ae35",
    fillOpacity: 0.949
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#209010"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#279b1f"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69v-1h1v1z",
    fill: "#4db12b"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M28 69v-1h1v1z",
    fill: "#71b921"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M30 68v1h-1v-1z",
    fill: "#82c92e"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69v-1h1v1z",
    fill: "#4daa12"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M32 68v1h-1v-1z",
    fill: "#4caa11"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M32 69v-1h1v1z",
    fill: "#58af15"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#50a017"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1z",
    fill: "#59a215"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68h1v1h-1z",
    fill: "#5a9613"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#3a7616"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#156909"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M38 69v-1h1v1z",
    fill: "#3a8327"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1z",
    fill: "#74c244"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#14670c"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#397a22"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#579e37"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M44 68v1h-1v-1z",
    fill: "#2f6a1b"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M44 69v-1h1v1z",
    fill: "#034402"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#1c7816"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M47 68v1h-1v-1z",
    fill: "#388d23"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h-1v-1h1z",
    fill: "#5ba639"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-1v-1z",
    fill: "#5f9038"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M50 68v1h-1v-1z",
    fill: "#669e47"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69v-1h1v1z",
    fill: "#127010"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M52 69h-1v-1h1z",
    fill: "#157c16"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h-1v-1h1z",
    fill: "#4e8535"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M55 69h-1v-1h1z",
    fill: "#73c145"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M56 69h-1v-1h1z",
    fill: "#4fba2b"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M57 68v1h-1v-1z",
    fill: "#21a219"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69h-1v-1h1z",
    fill: "#07810c"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M58 68h1v1h-1z",
    fill: "#16800e"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v-1h1v1z",
    fill: "#4fab32"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M60 68h1v1h-1z",
    fill: "#52ac29"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68v1h-1v-1z",
    fill: "#0d5f06"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#1e6816"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v1h-1v-1z",
    fill: "#082c07"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1z",
    fill: "#022603"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1z",
    fill: "#062c05"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1z",
    fill: "#1f581e"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#145d14"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69v-1h1v1z",
    fill: "#117d10"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69v-1h1v1z",
    fill: "#0a890e"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1z",
    fill: "#047e06"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#027802"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M73 68v1h-1v-1z",
    fill: "#037c03"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#247e14"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M76 69h-1v-1h1z",
    fill: "#3aa81f"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#3eaa20"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M78 68v1h-1v-1z",
    fill: "#4ba02a"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#89c547"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#329220"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#1b9811"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#29a10f"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#3dab10"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M84 69h-1v-1h1z",
    fill: "#2aa30c"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h-1v-1h1z",
    fill: "#2a9d13"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M86 68v1h-1v-1z",
    fill: "#50ae20"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M87 69h-1v-1h1z",
    fill: "#59b410"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68v1h-1v-1z",
    fill: "#6db817"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69v-1h1v1z",
    fill: "#75c023"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69h-1v-1h1z",
    fill: "#73b92a"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#6cb329"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#7cbd28"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#90c34f"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#8cbd63"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M95 68v1h-1v-1z",
    fill: "#77bb48"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M96 69h-1v-1h1z",
    fill: "#63bc37"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M97 69h-1v-1h1z",
    fill: "#7dc24a"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69h-1v-1h1z",
    fill: "#b6e075"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M98 68h1v1h-1z",
    fill: "#b3da72"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M100 68v1h-1v-1z",
    fill: "#a5cf6a"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M100 69v-1h1v1z",
    fill: "#9fce62"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M102 68v1h-1v-1z",
    fill: "#a0ce53"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68v1h-1v-1z",
    fill: "#a8cd61",
    fillOpacity: 0.604
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M103 68h1v1h-1z",
    fill: "#d1daad",
    fillOpacity: 0.11
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68h1v1h-1z",
    fill: "#b8d4a0",
    fillOpacity: 0.212
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69v-1h1v1z",
    fill: "#b8cfac",
    fillOpacity: 0.255
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M107 68v1h-1v-1z",
    fill: "#b7d0a7",
    fillOpacity: 0.322
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M107 69v-1h1v1z",
    fill: "#c4d7ba",
    fillOpacity: 0.102
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M110 68h1v1h-1z",
    fill: "#99b27f",
    fillOpacity: 0.039
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68v1h-1v-1z",
    fill: "#8db855",
    fillOpacity: 0.671
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M112 68h1v1h-1z",
    fill: "#9fc95f",
    fillOpacity: 0.188
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70h-1v-1h1z",
    fill: "#539a36",
    fillOpacity: 0.239
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70v-1h1v1z",
    fill: "#418d2a",
    fillOpacity: 0.769
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69v1h-1v-1z",
    fill: "#6bb239",
    fillOpacity: 0.902
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69h1v1h-1z",
    fill: "#64af1d"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70v-1h1v1z",
    fill: "#55aa3c",
    fillOpacity: 0.831
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v1h-1v-1z",
    fill: "#50a635",
    fillOpacity: 0.871
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M20 70h-1v-1h1z",
    fill: "#40a320"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M20 69h1v1h-1z",
    fill: "#50a933",
    fillOpacity: 0.996
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M21 69h1v1h-1z",
    fill: "#509735",
    fillOpacity: 0.976
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M22 69h1v1h-1z",
    fill: "#36842a",
    fillOpacity: 0.667
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M24 69v1h-1v-1z",
    fill: "#4b983d",
    fillOpacity: 0.506
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70v-1h1v1z",
    fill: "#55a633",
    fillOpacity: 0.953
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70v-1h1v1z",
    fill: "#5db43c"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70v-1h1v1z",
    fill: "#65bc42"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70v-1h1v1z",
    fill: "#35a722"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70h-1v-1h1z",
    fill: "#6ab933"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M29 70v-1h1v1z",
    fill: "#7dbf34"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1z",
    fill: "#41931c"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M31 70v-1h1v1z",
    fill: "#278714"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v1h-1v-1z",
    fill: "#3ea91e"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M34 69v1h-1v-1z",
    fill: "#48ac0c"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h-1v-1h1z",
    fill: "#4cac0d"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M36 69v1h-1v-1z",
    fill: "#4baa0e"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#49a60b"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1z",
    fill: "#2e9409"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M39 70h-1v-1h1z",
    fill: "#5eb030"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1z",
    fill: "#60bc31"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69v1h-1v-1z",
    fill: "#2e8717"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#479423"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69v1h-1v-1z",
    fill: "#307920"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#023a03"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1z",
    fill: "#136b0c"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#288618"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70v-1h1v1z",
    fill: "#1d6d13"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69v1h-1v-1z",
    fill: "#449133"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M48 69h1v1h-1z",
    fill: "#63ad3e"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70h-1v-1h1z",
    fill: "#4a912f"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M50 69h1v1h-1z",
    fill: "#075b07"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h1v1h-1z",
    fill: "#085204"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M53 69v1h-1v-1z",
    fill: "#248020"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v-1h1v1z",
    fill: "#62ad44"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69h1v1h-1z",
    fill: "#359e28"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M55 70v-1h1v1z",
    fill: "#4aaa31"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70h-1v-1h1z",
    fill: "#54ba34"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M58 69v1h-1v-1z",
    fill: "#12a712"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M59 69v1h-1v-1z",
    fill: "#08950c"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70v-1h1v1z",
    fill: "#2b9624"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#339d23"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1z",
    fill: "#3b991c"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1z",
    fill: "#1c6614"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69h1v1h-1z",
    fill: "#022d02"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M64 69h1v1h-1z",
    fill: "#002f01"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v1h-1v-1z",
    fill: "#1a6313"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M67 69v1h-1v-1z",
    fill: "#2a9c1e"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M67 70v-1h1v1z",
    fill: "#2ca728"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1z",
    fill: "#057f0c"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#076c07"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1z",
    fill: "#0e800c"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#2e9015"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#53b130"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70h-1v-1h1z",
    fill: "#2f941d"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#3ea322"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v-1h1v1z",
    fill: "#38a51c"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h1v1h-1z",
    fill: "#49aa32"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#61b22b"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v1h-1v-1z",
    fill: "#419616"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#3cb328"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#11850d"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#41a013"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#128207"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M84 70v-1h1v1z",
    fill: "#0b7c0e"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70h-1v-1h1z",
    fill: "#61ad1f"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M87 70v-1h1v1z",
    fill: "#4e8a1b"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69h1v1h-1z",
    fill: "#51a627"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M90 69v1h-1v-1z",
    fill: "#5cb025"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#70ba1f"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#78bd22"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#73ad20"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#518c1b"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M95 69h1v1h-1z",
    fill: "#3a9525"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M96 70v-1h1v1z",
    fill: "#64bf40"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M98 69v1h-1v-1z",
    fill: "#4da232"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v-1h1v1z",
    fill: "#569d37"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M100 70h-1v-1h1z",
    fill: "#98c85e"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M100 69h1v1h-1z",
    fill: "#a7d260"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M102 70h-1v-1h1z",
    fill: "#a5cf61"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M102 69h1v1h-1z",
    fill: "#a3d569",
    fillOpacity: 0.988
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M103 70v-1h1v1z",
    fill: "#a8ce6e",
    fillOpacity: 0.863
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M104 70v-1h1v1z",
    fill: "#b2cc79",
    fillOpacity: 0.494
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M105 69h1v1h-1z",
    fill: "#a7cb7a",
    fillOpacity: 0.424
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M106 70v-1h1v1z",
    fill: "#a3c977",
    fillOpacity: 0.392
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h-1v-1h1z",
    fill: "#accd8e",
    fillOpacity: 0.365
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70v-1h1v1z",
    fill: "#b8cf9c",
    fillOpacity: 0.255
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M110 69v1h-1v-1z",
    fill: "#b7d796",
    fillOpacity: 0.153
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M110 69h1v1h-1z",
    fill: "#8cb75a",
    fillOpacity: 0.561
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M112 70h-1v-1h1z",
    fill: "#9ec166",
    fillOpacity: 0.392
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70h1v1h-1z",
    fill: "#9fbe8a",
    fillOpacity: 0.231
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70v1h-1v-1z",
    fill: "#669c4d",
    fillOpacity: 0.518
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M14 71v-1h1v1z",
    fill: "#44894e",
    fillOpacity: 0.102
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M16 70v1h-1v-1z",
    fill: "#74b32f",
    fillOpacity: 0.592
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h-1v-1h1z",
    fill: "#4db317"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70h1v1h-1z",
    fill: "#58ac44",
    fillOpacity: 0.451
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M18 70h1v1h-1z",
    fill: "#61b03d",
    fillOpacity: 0.686
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M19 70h1v1h-1z",
    fill: "#46a71f"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71v-1h1v1z",
    fill: "#218c12"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71v-1h1v1z",
    fill: "#1a7f12"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M22 70h1v1h-1z",
    fill: "#0e7307"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M24 71h-1v-1h1z",
    fill: "#47a42d"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M24 70h1v1h-1z",
    fill: "#76bc47",
    fillOpacity: 0.992
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M25 70h1v1h-1z",
    fill: "#77b847",
    fillOpacity: 0.898
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M26 70h1v1h-1z",
    fill: "#2c9217",
    fillOpacity: 0.992
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M28 70v1h-1v-1z",
    fill: "#178813"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v-1h1v1z",
    fill: "#53b026"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h-1v-1h1z",
    fill: "#61b825"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71v-1h1v1z",
    fill: "#60af2b"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h-1v-1h1z",
    fill: "#408e1b"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#258d1f"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#39a72a"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#31a61f"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71v-1h1v1z",
    fill: "#178d0d"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#148508"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1z",
    fill: "#2e920f"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M38 71v-1h1v1z",
    fill: "#65b930"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70v1h-1v-1z",
    fill: "#4eb629"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#36a010"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71h-1v-1h1z",
    fill: "#339d09"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M42 70h1v1h-1z",
    fill: "#32940e"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70h1v1h-1z",
    fill: "#29880a"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#27910b"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1z",
    fill: "#137b09"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h1z",
    fill: "#247818"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M49 71h-1v-1h1z",
    fill: "#61b344"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v1h-1v-1z",
    fill: "#3c8b25"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1z",
    fill: "#2c7322"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M51 71v-1h1v1z",
    fill: "#246819"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M53 70v1h-1v-1z",
    fill: "#4c922f"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-1h1z",
    fill: "#5eaa41"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71v-1h1v1z",
    fill: "#0b750e"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M56 71h-1v-1h1z",
    fill: "#077307"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M57 70v1h-1v-1z",
    fill: "#50a22e"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#59bf31"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M58 70h1v1h-1z",
    fill: "#22a814"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1z",
    fill: "#157e0e"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v-1h1v1z",
    fill: "#0b720e"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70v1h-1v-1z",
    fill: "#2c9522"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#33831f"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M64 70v1h-1v-1z",
    fill: "#024000"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1z",
    fill: "#0e500c"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M66 71h-1v-1h1z",
    fill: "#2c911d"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#2ba31d"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71v-1h1v1z",
    fill: "#24971d"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-1z",
    fill: "#0f730e"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#086107"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#15720f"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h1v1h-1z",
    fill: "#3e9d1e"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#4ba42b"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#0b5606"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70h1v1h-1z",
    fill: "#177d15"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#4a2"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#23920c"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#3f8d36"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#5aa52e"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M79 71v-1h1v1z",
    fill: "#65b82b"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#56c230"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#1e8214"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#3f9f13"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M83 71v-1h1v1z",
    fill: "#439b18"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#037303"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M86 70v1h-1v-1z",
    fill: "#178908"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#5eb51a"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M88 70v1h-1v-1z",
    fill: "#3a861e"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#8bce5f"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#73b354"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v1h-1v-1z",
    fill: "#5ea02e"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#7faf37"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M94 70h1v1h-1z",
    fill: "#67a638"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M95 70h1v1h-1z",
    fill: "#1c6c16"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M97 71h-1v-1h1z",
    fill: "#4aa136"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M98 70v1h-1v-1z",
    fill: "#48aa2f"
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M99 71h-1v-1h1z",
    fill: "#167e11"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M99 70h1v1h-1z",
    fill: "#71b54d"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M101 70v1h-1v-1z",
    fill: "#97d05f"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71h-1v-1h1z",
    fill: "#9bcb5c"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M103 71h-1v-1h1z",
    fill: "#8ec558",
    fillOpacity: 0.949
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71h-1v-1h1z",
    fill: "#84c460",
    fillOpacity: 0.882
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M105 70v1h-1v-1z",
    fill: "#90cb73",
    fillOpacity: 0.604
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71v-1h1v1z",
    fill: "#aad99a",
    fillOpacity: 0.188
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M107 70h1v1h-1z",
    fill: "#b6da91",
    fillOpacity: 0.082
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M108 70h1v1h-1z",
    fill: "#c0d3a1",
    fillOpacity: 0.161
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M110 71h-1v-1h1z",
    fill: "#95c05e",
    fillOpacity: 0.51
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M110 70h1v1h-1z",
    fill: "#89be4d",
    fillOpacity: 0.671
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71v1h-1v-1z",
    fill: "#ab9",
    fillOpacity: 0.059
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M15 71h1v1h-1z",
    fill: "#7cb02f",
    fillOpacity: 0.804
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M16 71h1v1h-1z",
    fill: "#6ab835",
    fillOpacity: 0.98
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h1v1h-1z",
    fill: "#7cba44",
    fillOpacity: 0.584
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M18 72v-1h1v1z",
    fill: "#2e9512",
    fillOpacity: 0.941
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M19 71h1v1h-1z",
    fill: "#3b971a",
    fillOpacity: 0.988
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M20 71h1v1h-1z",
    fill: "#489018",
    fillOpacity: 0.992
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M21 71h1v1h-1z",
    fill: "#4f951f"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h-1v-1h1z",
    fill: "#69b43b"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v-1h1v1z",
    fill: "#61ba38"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M25 72h-1v-1h1z",
    fill: "#50a135",
    fillOpacity: 0.871
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M26 72h-1v-1h1z",
    fill: "#3c9433",
    fillOpacity: 0.565
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M27 71v1h-1v-1z",
    fill: "#1a8f12",
    fillOpacity: 0.98
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71v1h-1v-1z",
    fill: "#188e10"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M28 71h1v1h-1z",
    fill: "#54b22c"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h-1v-1h1z",
    fill: "#3dad21"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M30 71h1v1h-1z",
    fill: "#299c0d"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71v1h-1v-1z",
    fill: "#48a01a"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M32 71h1v1h-1z",
    fill: "#167911"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71h1v1h-1z",
    fill: "#1e861d"
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M35 72h-1v-1h1z",
    fill: "#279921"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M35 71h1v1h-1z",
    fill: "#1a9b18"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#0b890d"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#3b9626"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1z",
    fill: "#87bf4a"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h1v1h-1z",
    fill: "#5bb32d"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#217311"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#238011"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#38a314"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#339b15"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#2e9613"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71v1h-1v-1z",
    fill: "#23900a"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#2b930e"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1z",
    fill: "#3f9b1d"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1z",
    fill: "#5ab13d"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71h1v1h-1z",
    fill: "#2a8121"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1z",
    fill: "#287b1d"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#67b347"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1z",
    fill: "#378c26"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#21931c"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#318f1b"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1z",
    fill: "#358c1e"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h1v1h-1z",
    fill: "#5ebc36"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M60 71v1h-1v-1z",
    fill: "#338b1c"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72v-1h1v1z",
    fill: "#005401"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#097312"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#2a7b16"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#12730f"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#1e8a0f"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M68 72h-1v-1h1z",
    fill: "#2a8716"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72h-1v-1h1z",
    fill: "#378f25"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#1e8a16"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72h-1v-1h1z",
    fill: "#0b7008"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M71 72v-1h1v1z",
    fill: "#4c8f2e"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1z",
    fill: "#3d8a29"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#095012"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1z",
    fill: "#3b7d24"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#42ab1c"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#0b8a09"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#23851e"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#56b130"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#6fcc30"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#2c8914"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#349723"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h-1v-1h1z",
    fill: "#65b532"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72v-1h1v1z",
    fill: "#469b2e"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M85 71h1v1h-1z",
    fill: "#167a07"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71v1h-1v-1z",
    fill: "#53ac0f"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M88 71v1h-1v-1z",
    fill: "#66b72a"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72h-1v-1h1z",
    fill: "#42ab1f"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M89 72v-1h1v1z",
    fill: "#4dad23"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72h-1v-1h1z",
    fill: "#4f9f2e"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#8ecc67"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h-1v-1h1z",
    fill: "#7eb457"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#68983a"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72v-1h1v1z",
    fill: "#478829"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M95 71h1v1h-1z",
    fill: "#1a7515"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v-1h1v1z",
    fill: "#106e0d"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72h-1v-1h1z",
    fill: "#5dba3e"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h-1v-1h1z",
    fill: "#34a123"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72v-1h1v1z",
    fill: "#369422"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M100 71h1v1h-1z",
    fill: "#87c95e"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M102 71v1h-1v-1z",
    fill: "#a0d162"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h-1v-1h1z",
    fill: "#a2c657",
    fillOpacity: 0.953
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M104 71v1h-1v-1z",
    fill: "#98bb60",
    fillOpacity: 0.506
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M105 72h-1v-1h1z",
    fill: "#7fc15f",
    fillOpacity: 0.533
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M105 71h1v1h-1z",
    fill: "#83c263",
    fillOpacity: 0.816
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M107 71v1h-1v-1z",
    fill: "#8abf72",
    fillOpacity: 0.427
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M108 71h1v1h-1z",
    fill: "#759c4e",
    fillOpacity: 0.051
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v-1h1v1z",
    fill: "#88b556",
    fillOpacity: 0.706
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v-1h1v1z",
    fill: "#9fcc72",
    fillOpacity: 0.157
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h-1v-1h1z",
    fill: "#bbc",
    fillOpacity: 0.059
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73h-1v-1h1z",
    fill: "#9cc35e",
    fillOpacity: 0.435
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73v-1h1v1z",
    fill: "#7cb746",
    fillOpacity: 0.682
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73h-1v-1h1z",
    fill: "#8db855",
    fillOpacity: 0.141
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M19 72v1h-1v-1z",
    fill: "#3f971f",
    fillOpacity: 0.902
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M20 73h-1v-1h1z",
    fill: "#3a922a",
    fillOpacity: 0.561
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M21 73h-1v-1h1z",
    fill: "#8aba50",
    fillOpacity: 0.698
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h-1v-1h1z",
    fill: "#82c048",
    fillOpacity: 0.961
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72v1h-1v-1z",
    fill: "#72b950",
    fillOpacity: 0.949
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M23 72h1v1h-1z",
    fill: "#3d931f",
    fillOpacity: 0.863
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M24 73v-1h1v1z",
    fill: "#147f1a",
    fillOpacity: 0.745
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v-1h1v1z",
    fill: "#168a22"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M26 73v-1h1v1z",
    fill: "#31951f"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M27 72h1v1h-1z",
    fill: "#209510"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M29 72v1h-1v-1z",
    fill: "#52af29"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73h-1v-1h1z",
    fill: "#38a626"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M30 72h1v1h-1z",
    fill: "#119816"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M32 73h-1v-1h1z",
    fill: "#2d9f1d"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M34 72v1h-1v-1z",
    fill: "#127e0e"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#1c8119"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#0f9812"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v-1h1v1z",
    fill: "#5ca83b"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M39 72h1v1h-1z",
    fill: "#60b932"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#3b9a25"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#084107"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#2b7020"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#28871a"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#1c7510"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#116007"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#288616"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#1c850a"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#1f8809"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#3fa021"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73h-1v-1h1z",
    fill: "#4daa34"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#419c25"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73h-1v-1h1z",
    fill: "#57b03a"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M54 72v1h-1v-1z",
    fill: "#11760d"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v1h-1v-1z",
    fill: "#1e7214"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#319b20"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h1v1h-1z",
    fill: "#24760d"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v-1h1v1z",
    fill: "#328321"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73h-1v-1h1z",
    fill: "#2a991c"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#569e33"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1z",
    fill: "#3c8825"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#0b7002"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M63 72v1h-1v-1z",
    fill: "#11750a"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#3b951d"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#329918"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1z",
    fill: "#5db132"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M67 73v-1h1v1z",
    fill: "#44a725"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M69 72v1h-1v-1z",
    fill: "#198617"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#07660c"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M71 73h-1v-1h1z",
    fill: "#024d05"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#0c4705"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#54a63d"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#1d5319"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#6c903f"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#7ac549"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#4aac2d"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#18890b"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#52b922"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#50a521"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#1a6310"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#3b9a2d"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#0d6a08"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73h-1v-1h1z",
    fill: "#4fa028"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M84 72h1v1h-1z",
    fill: "#67b346"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#65ac38"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#69b619"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M87 73v-1h1v1z",
    fill: "#6bb129"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M88 73v-1h1v1z",
    fill: "#71ba47"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73v-1h1v1z",
    fill: "#51ad20"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72v1h-1v-1z",
    fill: "#48a816"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#50a629"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72v1h-1v-1z",
    fill: "#8ad166"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#a1cb6f"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h1v1h-1z",
    fill: "#4e8335"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72v1h-1v-1z",
    fill: "#3d8f26"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M96 73v-1h1v1z",
    fill: "#21851a"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M98 72v1h-1v-1z",
    fill: "#26871e"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M98 73v-1h1v1z",
    fill: "#48ae35"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M99 72h1v1h-1z",
    fill: "#229515"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M100 72h1v1h-1z",
    fill: "#5bad36"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M101 72h1v1h-1z",
    fill: "#82c350"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72v1h-1v-1z",
    fill: "#8ec84e"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M103 72h1v1h-1z",
    fill: "#98c84b",
    fillOpacity: 0.969
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M104 72h1v1h-1z",
    fill: "#9fb958",
    fillOpacity: 0.522
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M106 73h-1v-1h1z",
    fill: "#9bc176",
    fillOpacity: 0.212
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M107 73h-1v-1h1z",
    fill: "#84b966",
    fillOpacity: 0.545
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M108 72v1h-1v-1z",
    fill: "#58973b",
    fillOpacity: 0.659
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M109 72v1h-1v-1z",
    fill: "#6eaf46",
    fillOpacity: 0.694
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M110 72v1h-1v-1z",
    fill: "#a6d17d",
    fillOpacity: 0.788
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73v-1h1v1z",
    fill: "#bac79d",
    fillOpacity: 0.541
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M111 73v-1h1v1z",
    fill: "#d9dc9f",
    fillOpacity: 0.878
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M112 72h1v1h-1z",
    fill: "#ebf0a8",
    fillOpacity: 0.604
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74v-1h1v1z",
    fill: "#8dbc67",
    fillOpacity: 0.106
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74h-1v-1h1z",
    fill: "#71a84c",
    fillOpacity: 0.51
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73v1h-1v-1z",
    fill: "#8cb453",
    fillOpacity: 0.227
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M19 74h-1v-1h1z",
    fill: "#79bb4b",
    fillOpacity: 0.831
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M19 73h1v1h-1z",
    fill: "#74bc4a",
    fillOpacity: 0.855
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M20 74v-1h1v1z",
    fill: "#7db753",
    fillOpacity: 0.757
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73v1h-1v-1z",
    fill: "#78b35d",
    fillOpacity: 0.514
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M22 73h1v1h-1z",
    fill: "#83b65e",
    fillOpacity: 0.675
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74h-1v-1h1z",
    fill: "#79a856",
    fillOpacity: 0.255
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M25 73v1h-1v-1z",
    fill: "#138113",
    fillOpacity: 0.667
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74h-1v-1h1z",
    fill: "#0e8917"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h-1v-1h1z",
    fill: "#54ad2f"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h1v1h-1z",
    fill: "#56b128"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M30 73v1h-1v-1z",
    fill: "#31971a"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74v-1h1v1z",
    fill: "#2b8c22"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h-1v-1h1z",
    fill: "#3daa34"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M33 73v1h-1v-1z",
    fill: "#3fab25"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M33 74v-1h1v1z",
    fill: "#44a422"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1z",
    fill: "#64ab35"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1z",
    fill: "#509f31"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#128115"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#038308"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#0b8706"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#5bb833"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#53a325"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#4c9528"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1z",
    fill: "#468a29"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#085b07"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#358124"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#2a7d19"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v1h-1v-1z",
    fill: "#247e1d"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#034f05"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h1v1z",
    fill: "#075804"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M51 73v1h-1v-1z",
    fill: "#348a27"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M51 74v-1h1v1z",
    fill: "#59b63a"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h-1v-1h1z",
    fill: "#2e911e"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74h-1v-1h1z",
    fill: "#4d9e2d"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74h-1v-1h1z",
    fill: "#569b32"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73v1h-1v-1z",
    fill: "#65a03d"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M57 73h1v1h-1z",
    fill: "#3c9725"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M59 74h-1v-1h1z",
    fill: "#11740f"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M60 74h-1v-1h1z",
    fill: "#064705"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74h-1v-1h1z",
    fill: "#2d821f"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#3ca11d"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M63 74h-1v-1h1z",
    fill: "#4ba11a"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#55a72f"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#65b82c"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#4da02d"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#2b9121"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#0f7713"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M68 73h1v1h-1z",
    fill: "#045206"
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#055704"
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#025503"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#063a08"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74h-1v-1h1z",
    fill: "#339326"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M73 74v-1h1v1z",
    fill: "#2e7a1c"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#50972c"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#338923"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#56b43b"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#6cbd3e"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#73c640"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#288620"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#1d8115"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#44932b"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#317021"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#6eb849"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M86 74v-1h1v1z",
    fill: "#7bc333"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h-1v-1h1z",
    fill: "#5ca21d"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74v-1h1v1z",
    fill: "#33861e"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M89 73h1v1h-1z",
    fill: "#57b637"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#47a71b"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#28810f"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M93 74h-1v-1h1z",
    fill: "#248a19"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#7cc362"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M94 73h1v1h-1z",
    fill: "#add780"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M95 74v-1h1v1z",
    fill: "#96c864"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M97 73v1h-1v-1z",
    fill: "#3c862b"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74h-1v-1h1z",
    fill: "#136616"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M99 73v1h-1v-1z",
    fill: "#298922"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M100 73v1h-1v-1z",
    fill: "#147e0b"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74h-1v-1h1z",
    fill: "#42a221"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73v1h-1v-1z",
    fill: "#4aa72e"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M102 73h1v1h-1z",
    fill: "#63b442"
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74h-1v-1h1z",
    fill: "#78b734",
    fillOpacity: 0.937
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74h-1v-1h1z",
    fill: "#9bc14e",
    fillOpacity: 0.925
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M105 74v-1h1v1z",
    fill: "#abc182",
    fillOpacity: 0.49
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74v-1h1v1z",
    fill: "#b4c5a4",
    fillOpacity: 0.122
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M108 74h-1v-1h1z",
    fill: "#65a440",
    fillOpacity: 0.573
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M108 73h1v1h-1z",
    fill: "#88ce55"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M109 73h1v1h-1z",
    fill: "#90be5c"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M110 73h1v1h-1z",
    fill: "#aecc76",
    fillOpacity: 0.957
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73v1h-1v-1z",
    fill: "#ecf59e",
    fillOpacity: 0.718
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M112 73h1v1h-1z",
    fill: "#eeeea3",
    fillOpacity: 0.239
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74h1v1h-1z",
    fill: "#7ab444",
    fillOpacity: 0.294
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74v1h-1v-1z",
    fill: "#74b03f",
    fillOpacity: 0.678
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M17 75v-1h1v1z",
    fill: "#7eb84c",
    fillOpacity: 0.667
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v1h-1z",
    fill: "#72bc41",
    fillOpacity: 0.812
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#50a133",
    fillOpacity: 0.78
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75h-1v-1h1z",
    fill: "#559850",
    fillOpacity: 0.447
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M21 75v-1h1v1z",
    fill: "#72af54",
    fillOpacity: 0.463
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75h-1v-1h1z",
    fill: "#60a839",
    fillOpacity: 0.898
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M24 74v1h-1v-1z",
    fill: "#429a26",
    fillOpacity: 0.882
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M26 74v1h-1v-1z",
    fill: "#3a901c"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M27 75h-1v-1h1z",
    fill: "#6ab342"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M27 74h1v1h-1z",
    fill: "#75c147"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M28 74h1v1h-1z",
    fill: "#61b534"
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h1v1z",
    fill: "#66b536"
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74h1v1h-1z",
    fill: "#83be52"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74v1h-1v-1z",
    fill: "#3f9733"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M32 74h1v1h-1z",
    fill: "#25a126"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74v1h-1v-1z",
    fill: "#3aab22"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#227d18"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#197c14"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#108514"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#098c0a"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#4bad29"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#539d30"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#5aa435"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#7ab444"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#3c8022"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#32791c"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#5da633"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#0c6508"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h1v1h-1z",
    fill: "#085105"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74h1v1h-1z",
    fill: "#085005"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v-1h1v1z",
    fill: "#1f6f12"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h-1v-1h1z",
    fill: "#57b437"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75v-1h1v1z",
    fill: "#3a9c24"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1z",
    fill: "#49a526"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M55 74v1h-1v-1z",
    fill: "#5ca939"
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M56 74v1h-1v-1z",
    fill: "#388027"
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M57 75h-1v-1h1z",
    fill: "#338022"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#1d7c0e"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M58 75v-1h1v1z",
    fill: "#075e03"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h-1v-1h1z",
    fill: "#317d1a"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75v-1h1v1z",
    fill: "#549b2b"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#78c53d"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75h-1v-1h1z",
    fill: "#82c644"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M63 75v-1h1v1z",
    fill: "#52a533"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#1f5d11"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#3d9722"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75h-1v-1h1z",
    fill: "#268d15"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#11650b"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M69 75h-1v-1h1z",
    fill: "#024401"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M70 74v1h-1v-1z",
    fill: "#06640a"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#098406"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#108c14"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#0f9916"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#28a116"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#247e17"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#06650a"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#067506"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#70ba3f"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1z",
    fill: "#76c244"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#8dd461"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#74bd4b"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#4dac2b"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1z",
    fill: "#126a0d"
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1z",
    fill: "#20751c"
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1z",
    fill: "#196010"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#3a7f21"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#82cd47"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#559f25"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#388c28"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#348826"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v1h-1v-1z",
    fill: "#56b132"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75h-1v-1h1z",
    fill: "#50aa27"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1z",
    fill: "#057106"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#2c9a25"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75v-1h1v1z",
    fill: "#7bb961"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M96 74v1h-1v-1z",
    fill: "#b2d687"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v-1h1v1z",
    fill: "#9dbf6a"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M98 74v1h-1v-1z",
    fill: "#1e6415",
    fillOpacity: 0.996
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75v-1h1v1z",
    fill: "#11630e",
    fillOpacity: 0.812
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M100 75h-1v-1h1z",
    fill: "#0e7410",
    fillOpacity: 0.969
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M101 74v1h-1v-1z",
    fill: "#279610"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v-1h1v1z",
    fill: "#50a737"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M103 74v1h-1v-1z",
    fill: "#5faf38"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M104 74v1h-1v-1z",
    fill: "#6cac3d",
    fillOpacity: 0.784
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M105 75h-1v-1h1z",
    fill: "#9dc373",
    fillOpacity: 0.337
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M106 75h-1v-1h1z",
    fill: "#c7dfb7",
    fillOpacity: 0.125
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M106 74h1v1h-1z",
    fill: "#85b05b",
    fillOpacity: 0.659
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75h-1v-1h1z",
    fill: "#8bc25e",
    fillOpacity: 0.965
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M108 75v-1h1v1z",
    fill: "#a5cb6f"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74v1h-1v-1z",
    fill: "#b2cc73",
    fillOpacity: 0.733
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74h1v1h-1z",
    fill: "#a2c766",
    fillOpacity: 0.506
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h-1v-1h1z",
    fill: "#b1ca90",
    fillOpacity: 0.361
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M113 75h-1v-1h1z",
    fill: "#b9c5b9",
    fillOpacity: 0.086
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M16 75v1h-1v-1z",
    fill: "#78b942",
    fillOpacity: 0.529
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M16 75h1v1h-1z",
    fill: "#79b745",
    fillOpacity: 0.616
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76h-1v-1h1z",
    fill: "#7bb241",
    fillOpacity: 0.702
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76v-1h1v1z",
    fill: "#65aa43",
    fillOpacity: 0.698
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75h1v1h-1z",
    fill: "#449c2f",
    fillOpacity: 0.863
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76v-1h1v1z",
    fill: "#72af51",
    fillOpacity: 0.678
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M22 76h-1v-1h1z",
    fill: "#77b445",
    fillOpacity: 0.937
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M23 75v1h-1v-1z",
    fill: "#63b434"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M23 76v-1h1v1z",
    fill: "#5db137"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h-1v-1h1z",
    fill: "#61b239"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M25 75h1v1h-1z",
    fill: "#5db03c"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M26 75h1v1h-1z",
    fill: "#4ea434"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M28 75v1h-1v-1z",
    fill: "#3b9725"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76v-1h1v1z",
    fill: "#1b8d15"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M30 75v1h-1v-1z",
    fill: "#1b7f0e"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M31 76h-1v-1h1z",
    fill: "#48a32a"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M31 75h1v1h-1z",
    fill: "#5ea534"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h-1v-1h1z",
    fill: "#419e29"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-1h1z",
    fill: "#29a820"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M35 75v1h-1v-1z",
    fill: "#28a21e"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#1d8a13"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M36 76v-1h1v1z",
    fill: "#1b9513"
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1z",
    fill: "#128f0d"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h-1v-1h1z",
    fill: "#13870f"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#2a9a19"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#5ab335"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#218510"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#4ca425"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#7cbd3e"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1z",
    fill: "#62a92f"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#7cb741"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#429720"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M48 75v1h-1v-1z",
    fill: "#268e14"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76h-1v-1h1z",
    fill: "#329a16"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#42a019"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#53a92d"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1z",
    fill: "#4fa92a"
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#56b332"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M53 76v-1h1v1z",
    fill: "#36a01b"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M55 76h-1v-1h1z",
    fill: "#107c07"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75v1h-1v-1z",
    fill: "#037101"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M56 75h1v1h-1z",
    fill: "#359b20"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h-1v-1h1z",
    fill: "#379019"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M59 75v1h-1v-1z",
    fill: "#6fb244"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M60 76h-1v-1h1z",
    fill: "#8ecb4a"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#86c64e"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#66a73b"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1z",
    fill: "#4a9b29"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75v1h-1v-1z",
    fill: "#13840d"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#035a04"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#2b8e16"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75v1h-1v-1z",
    fill: "#41a820"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M67 76v-1h1v1z",
    fill: "#10810d"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v-1h1v1z",
    fill: "#0a8a16"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M71 76h-1v-1h1z",
    fill: "#0f931a"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#0e7112"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#13600c"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#68af40"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1z",
    fill: "#237815"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#046409"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#05610c"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#428b27"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#6dbf3b"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#5cbc3a"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#53a834"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#72ba46"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#75ba4c"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#56a135"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#5aa431"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#3b8719"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#56aa28"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#62b543"
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76v-1h1v1z",
    fill: "#46a527"
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M90 75v1h-1v-1z",
    fill: "#298b19"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76h-1v-1h1z",
    fill: "#167012"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#409928"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M93 75v1h-1v-1z",
    fill: "#369425"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#188212"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h1v1h-1z",
    fill: "#286116"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M96 75v1h-1v-1z",
    fill: "#5b8e3e"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76h-1v-1h1z",
    fill: "#95c76c"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M97 76v-1h1v1z",
    fill: "#8eb864",
    fillOpacity: 0.984
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M98 75h1v1h-1z",
    fill: "#79b462",
    fillOpacity: 0.6
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h-1v-1h1z",
    fill: "#57ab43",
    fillOpacity: 0.922
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M101 75v1h-1v-1z",
    fill: "#5cb63d"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M102 76h-1v-1h1z",
    fill: "#85c963"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M103 75v1h-1v-1z",
    fill: "#85c25a"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M103 76v-1h1v1z",
    fill: "#7dc548"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M104 75h1v1h-1z",
    fill: "#7cb951",
    fillOpacity: 0.933
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M105 76v-1h1v1z",
    fill: "#79b64f",
    fillOpacity: 0.804
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M107 75v1h-1v-1z",
    fill: "#76b743",
    fillOpacity: 0.906
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M107 76v-1h1v1z",
    fill: "#9ac65f",
    fillOpacity: 0.925
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76v-1h1v1z",
    fill: "#b0cc6f",
    fillOpacity: 0.91
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M110 76h-1v-1h1z",
    fill: "#dbeba8",
    fillOpacity: 0.314
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M112 75h1v1h-1z",
    fill: "#bfcdb8",
    fillOpacity: 0.141
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M115 75v1h-1v-1z",
    fill: "#daffda",
    fillOpacity: 0.027
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76h1v1h-1z",
    fill: "#82bf49",
    fillOpacity: 0.776
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M17 77h-1v-1h1z",
    fill: "#7abd31",
    fillOpacity: 0.875
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M18 77h-1v-1h1z",
    fill: "#82b442",
    fillOpacity: 0.953
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77h-1v-1h1z",
    fill: "#60a843"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M20 76h1v1h-1z",
    fill: "#43a326"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77v-1h1v1z",
    fill: "#4fa724"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77v-1h1v1z",
    fill: "#3d9c1e"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77v-1h1v1z",
    fill: "#369420"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76v1h-1v-1z",
    fill: "#128908"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M25 76h1v1h-1z",
    fill: "#10900c"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M27 76v1h-1v-1z",
    fill: "#017f03"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M29 76v1h-1v-1z",
    fill: "#0c7c0b"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v-1h1v1z",
    fill: "#037407"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M30 76h1v1h-1z",
    fill: "#108610"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1z",
    fill: "#348d1c"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76v1h-1v-1z",
    fill: "#77bb3e"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#4eae2e"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#26a824"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76h1v1h-1z",
    fill: "#20a01f"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#098e08"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#108708"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#0e780b"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#2f9a26"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#44a22c"
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#31991c"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#107e07"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#489b23"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#508b25"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#699b33"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#6faf36"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1z",
    fill: "#329215"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M49 76v1h-1v-1z",
    fill: "#3d951f"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1z",
    fill: "#4aa023"
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76h1v1h-1z",
    fill: "#4fa124"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M52 76h1v1h-1z",
    fill: "#60b432"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#38a721"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M54 77v-1h1v1z",
    fill: "#057206"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M56 77v-1h1v1z",
    fill: "#2c8619"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76v1h-1v-1z",
    fill: "#5da434"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M58 76h1v1h-1z",
    fill: "#91c558"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M59 77v-1h1v1z",
    fill: "#74ab43"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M61 76v1h-1v-1z",
    fill: "#3d7b28"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1z",
    fill: "#539631"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#319f1f"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76h1v1h-1z",
    fill: "#048706"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v-1h1v1z",
    fill: "#069309"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77h-1v-1h1z",
    fill: "#36aa1f"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1z",
    fill: "#339f1f"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M69 77h-1v-1h1z",
    fill: "#067d0c"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1z",
    fill: "#034006"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#225017"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77h-1v-1h1z",
    fill: "#59953b"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1z",
    fill: "#29931c"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#027507"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#035208"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#185c12"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#69b53f"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#4fb535"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#116612"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#10610c"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v1h-1v-1z",
    fill: "#368f21"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#66b338"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#7ebf4a"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#5ba933"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#398e21"
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#4aa636"
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#5eb737"
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M90 76v1h-1v-1z",
    fill: "#60ad3a"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77h-1v-1h1z",
    fill: "#53a940"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M92 76v1h-1v-1z",
    fill: "#6dbb4a"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77h-1v-1h1z",
    fill: "#7fc452"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#80c85a"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77v-1h1v1z",
    fill: "#7fbe56"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76v1h-1v-1z",
    fill: "#78b855"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h-1v-1h1z",
    fill: "#80c15c"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M98 77h-1v-1h1z",
    fill: "#88c95d"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h-1v-1h1z",
    fill: "#8cd062"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77v-1h1v1z",
    fill: "#70bc49"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M100 76h1v1h-1z",
    fill: "#76be54",
    fillOpacity: 0.957
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M102 77h-1v-1h1z",
    fill: "#75b94c",
    fillOpacity: 0.878
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M103 77h-1v-1h1z",
    fill: "#77b84a",
    fillOpacity: 0.769
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h-1v-1h1z",
    fill: "#7bb256",
    fillOpacity: 0.404
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77v-1h1v1z",
    fill: "#77ad58",
    fillOpacity: 0.42
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M106 77h-1v-1h1z",
    fill: "#79b150",
    fillOpacity: 0.569
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M107 77h-1v-1h1z",
    fill: "#97ca6c",
    fillOpacity: 0.533
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M107 76h1v1h-1z",
    fill: "#d3e3a7",
    fillOpacity: 0.502
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M108 76h1v1h-1z",
    fill: "#b6cc7b",
    fillOpacity: 0.275
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77h-1v-1h1z",
    fill: "#a6c576",
    fillOpacity: 0.506
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M110 77v-1h1v1z",
    fill: "#aacd7f",
    fillOpacity: 0.141
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77v1h-1v-1z",
    fill: "#99b86c",
    fillOpacity: 0.157
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77h1v1h-1z",
    fill: "#96bf6a",
    fillOpacity: 0.49
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h-1v-1h1z",
    fill: "#85c153",
    fillOpacity: 0.8
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M17 77v1h-1v-1z",
    fill: "#7bbd29"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M17 78v-1h1v1z",
    fill: "#62ae2d"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1z",
    fill: "#219310"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M20 77h1v1h-1z",
    fill: "#439b26"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M21 77h1v1h-1z",
    fill: "#349619"
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M22 77h1v1h-1z",
    fill: "#107c0e"
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M24 77v1h-1v-1z",
    fill: "#278116"
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M24 78v-1h1v1z",
    fill: "#34a021"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M26 77v1h-1v-1z",
    fill: "#12760e"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78v-1h1v1z",
    fill: "#0e760c"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M29 77v1h-1v-1z",
    fill: "#0f720a"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78h-1v-1h1z",
    fill: "#0d780a"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#2f9c16"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1z",
    fill: "#64ae31"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v-1h1v1z",
    fill: "#67b541"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M34 77v1h-1v-1z",
    fill: "#228518"
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#178e1f"
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#1aa92b"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#27a222"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#188b10"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#017301"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#2b9923"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#1f8519"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#389120"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#2a8b1b"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#005602"
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#267118"
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#85be51"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#267d14"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v1h-1v-1z",
    fill: "#448c26"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M52 77v1h-1v-1z",
    fill: "#428c22"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M52 78v-1h1v1z",
    fill: "#2d7418"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h1v1h-1z",
    fill: "#328420"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M55 77v1h-1v-1z",
    fill: "#2d9717"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M55 78v-1h1v1z",
    fill: "#318f25"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#156210"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h-1v-1h1z",
    fill: "#3c8627"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h-1v-1h1z",
    fill: "#1b5b13"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78v-1h1v1z",
    fill: "#207619"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78h-1v-1h1z",
    fill: "#218e19"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78h-1v-1h1z",
    fill: "#229315"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M62 78v-1h1v1z",
    fill: "#14810b"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77v1h-1v-1z",
    fill: "#2da520"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78v-1h1v1z",
    fill: "#05850a"
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#0c790f"
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#278918"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M67 78v-1h1v1z",
    fill: "#4bae28"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1z",
    fill: "#288817"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v1z",
    fill: "#136e14"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#11470d"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#134c0f"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1z",
    fill: "#21511c"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M74 77v1h-1v-1z",
    fill: "#266a1c"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#389d2e"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#1d8d1a"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1z",
    fill: "#1a6517"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#0a6107"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#56b439"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#4db335"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#318c29"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#177914"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#1f781a"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#348d1d"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#82ca4d"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#78bc51"
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#7bc552"
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#5db737"
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M89 77v1h-1v-1z",
    fill: "#69c241"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#75bd51"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1z",
    fill: "#5fb246"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#52a73e"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77v1h-1v-1z",
    fill: "#559d36"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#368121"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M95 77v1h-1v-1z",
    fill: "#53ac3a"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M96 77v1h-1v-1z",
    fill: "#5b9d3d"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M96 78v-1h1v1z",
    fill: "#347723"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M97 77h1v1h-1z",
    fill: "#2c8e1d"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78v-1h1v1z",
    fill: "#50a63d"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M99 77h1v1h-1z",
    fill: "#4ba330"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M101 78h-1v-1h1z",
    fill: "#67b34c",
    fillOpacity: 0.91
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M101 77h1v1h-1z",
    fill: "#71ae55",
    fillOpacity: 0.361
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v-1h1v1z",
    fill: "#69b03a",
    fillOpacity: 0.882
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M103 78v-1h1v1z",
    fill: "#6daa43",
    fillOpacity: 0.282
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77h1v1h-1z",
    fill: "#8bb9d0",
    fillOpacity: 0.043
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M106 77v1h-1v-1z",
    fill: "#9fcf73",
    fillOpacity: 0.733
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M107 78h-1v-1h1z",
    fill: "#cddf92",
    fillOpacity: 0.565
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M108 77v1h-1v-1z",
    fill: "#dce1a5",
    fillOpacity: 0.2
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M110 78v-1h1v1z",
    fill: "#9fc57a",
    fillOpacity: 0.557
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M112 78h-1v-1h1z",
    fill: "#a6c781",
    fillOpacity: 0.271
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M13 78v1h-1v-1z",
    fill: "#bcc697",
    fillOpacity: 0.106
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79v-1h1v1z",
    fill: "#97b378",
    fillOpacity: 0.29
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M15 78v1h-1v-1z",
    fill: "#9ac76a",
    fillOpacity: 0.506
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v-1h1v1z",
    fill: "#88c947",
    fillOpacity: 0.745
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h1v1h-1z",
    fill: "#65b91b"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79h-1v-1h1z",
    fill: "#30a10e"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#238819"
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1z",
    fill: "#208610"
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79v-1h1v1z",
    fill: "#47a927"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M22 78v1h-1v-1z",
    fill: "#2e8d1a"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79h-1v-1h1z",
    fill: "#25861e"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v-1h1v1z",
    fill: "#399e25"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M25 78v1h-1v-1z",
    fill: "#238b15"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M25 79v-1h1v1z",
    fill: "#217a1b"
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M26 78h1v1h-1z",
    fill: "#3c912a"
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M28 78v1h-1v-1z",
    fill: "#2c8f18"
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79h-1v-1h1z",
    fill: "#0d7207"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M30 79h-1v-1h1z",
    fill: "#238b1a"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79h-1v-1h1z",
    fill: "#409e21"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78v1h-1v-1z",
    fill: "#78bb38"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M33 78v1h-1v-1z",
    fill: "#479a23"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79v-1h1v1z",
    fill: "#2e9320"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#116c0c"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M35 79v-1h1v1z",
    fill: "#269625"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#32ac32"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#33ac2a"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#289918"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#249d1b"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#168711"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#409c23"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#339d22"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#097d08"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#058908"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#0a8207"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1z",
    fill: "#6aae45"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1z",
    fill: "#0a6e05"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M50 79h-1v-1h1z",
    fill: "#4ea632"
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M51 79h-1v-1h1z",
    fill: "#1e8411"
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M52 79h-1v-1h1z",
    fill: "#056d04"
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M53 79h-1v-1h1z",
    fill: "#035b05"
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M54 78v1h-1v-1z",
    fill: "#055404"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79v-1h1v1z",
    fill: "#369920"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#309e1a"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#096309"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#14810f"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M58 78h1v1h-1z",
    fill: "#128a0e"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#299b15"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M61 78v1h-1v-1z",
    fill: "#339d18"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1z",
    fill: "#17800e"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1z",
    fill: "#137909"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v1h-1z",
    fill: "#2d911a"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M64 78h1v1h-1z",
    fill: "#177811"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#1b6515"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#064a07"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M68 78v1h-1v-1z",
    fill: "#338d28"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v-1h1v1z",
    fill: "#61bf41"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M70 79h-1v-1h1z",
    fill: "#5ab242"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79h-1v-1h1z",
    fill: "#51a442"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M71 79v-1h1v1z",
    fill: "#5ca14d"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79h-1v-1h1z",
    fill: "#63b052"
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h-1v-1h1z",
    fill: "#63bb4e"
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-1v-1z",
    fill: "#64b853"
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#60ba4d"
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#5cb44f"
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#359930"
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#5db83c"
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#57ba48"
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#53a946"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78v1h-1v-1z",
    fill: "#3e9537"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#5db134"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#52a639"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#379a23"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1z",
    fill: "#3fab23"
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1z",
    fill: "#61b840"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M89 79v-1h1v1z",
    fill: "#66ac48"
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1z",
    fill: "#59a040"
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#499f36"
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1z",
    fill: "#55a93f"
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#4ea03a"
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M95 78v1h-1v-1z",
    fill: "#36992f"
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M96 79h-1v-1h1z",
    fill: "#67bb4b"
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h-1v-1h1z",
    fill: "#7ac051"
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79v-1h1v1z",
    fill: "#3d972d"
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M98 78h1v1h-1z",
    fill: "#1f7b1b"
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M99 78h1v1h-1z",
    fill: "#3c9f2b"
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M100 78h1v1h-1z",
    fill: "#6dbe4c"
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M102 78v1h-1v-1z",
    fill: "#73b05c",
    fillOpacity: 0.51
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h-1v-1h1z",
    fill: "#6aaf41",
    fillOpacity: 0.58
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79h-1v-1h1z",
    fill: "#5fac35",
    fillOpacity: 0.808
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M104 79v-1h1v1z",
    fill: "#91c467",
    fillOpacity: 0.627
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M105 78h1v1h-1z",
    fill: "#afd569",
    fillOpacity: 0.953
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M107 78v1h-1v-1z",
    fill: "#c5d17b",
    fillOpacity: 0.243
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79h-1v-1h1z",
    fill: "#96c378",
    fillOpacity: 0.067
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M111 79v-1h1v1z",
    fill: "#9abe71",
    fillOpacity: 0.51
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M112 78h1v1h-1z",
    fill: "#a0c96f",
    fillOpacity: 0.486
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M114 79h-1v-1h1z",
    fill: "#ffffda",
    fillOpacity: 0.027
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79h1v1h-1z",
    fill: "#97c059",
    fillOpacity: 0.29
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v1h-1v-1z",
    fill: "#96cb54",
    fillOpacity: 0.855
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79h1v1h-1z",
    fill: "#7bc32f"
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M17 79v1h-1v-1z",
    fill: "#4aa31b",
    fillOpacity: 0.808
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M17 80v-1h1v1z",
    fill: "#1e8012",
    fillOpacity: 0.553
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1z",
    fill: "#156c1d",
    fillOpacity: 0.376
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#57a238",
    fillOpacity: 0.745
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M20 79h1v1h-1z",
    fill: "#5cab2a",
    fillOpacity: 0.898
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M21 79h1v1h-1z",
    fill: "#53a445",
    fillOpacity: 0.898
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M23 79v1h-1v-1z",
    fill: "#5baf41"
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79v1h-1v-1z",
    fill: "#41a21d"
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M24 79h1v1h-1z",
    fill: "#258812"
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80h-1v-1h1z",
    fill: "#489d23"
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M26 80v-1h1v1z",
    fill: "#3b961c"
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M27 79h1v1h-1z",
    fill: "#288b18"
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M29 79v1h-1v-1z",
    fill: "#4ca334"
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1z",
    fill: "#70b43b"
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80v-1h1v1z",
    fill: "#76be44"
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1z",
    fill: "#68b135"
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M33 79h1v1h-1z",
    fill: "#5db22d"
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#369d22"
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80h-1v-1h1z",
    fill: "#4ba532"
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#2dab2a"
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M37 80v-1h1v1z",
    fill: "#23ae27"
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#37aa23"
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#24a41c"
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#35a920"
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#55b32a"
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#218511"
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#006c06"
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#057706"
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#0e8a0c"
  })), _path5006 || (_path5006 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#2e8e1c"
  })), _path5007 || (_path5007 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#14710d"
  })), _path5008 || (_path5008 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#2f9024"
  })), _path5009 || (_path5009 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h1v1z",
    fill: "#005b00"
  })), _path5010 || (_path5010 = /*#__PURE__*/React.createElement("path", {
    d: "M52 80h-1v-1h1z",
    fill: "#005f03"
  })), _path5011 || (_path5011 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h-1v-1h1z",
    fill: "#0e750d"
  })), _path5012 || (_path5012 = /*#__PURE__*/React.createElement("path", {
    d: "M54 79h1v1h-1z",
    fill: "#1b9017"
  })), _path5013 || (_path5013 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1z",
    fill: "#39b024"
  })), _path5014 || (_path5014 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#1c9412"
  })), _path5015 || (_path5015 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#1f8612"
  })), _path5016 || (_path5016 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#52a229"
  })), _path5017 || (_path5017 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#68a72f"
  })), _path5018 || (_path5018 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#3a831a"
  })), _path5019 || (_path5019 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#0a5c09"
  })), _path5020 || (_path5020 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#136910"
  })), _path5021 || (_path5021 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h1v1z",
    fill: "#238816"
  })), _path5022 || (_path5022 = /*#__PURE__*/React.createElement("path", {
    d: "M64 80v-1h1v1z",
    fill: "#22821e"
  })), _path5023 || (_path5023 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80h-1v-1h1z",
    fill: "#035502"
  })), _path5024 || (_path5024 = /*#__PURE__*/React.createElement("path", {
    d: "M68 79v1h-1v-1z",
    fill: "#116b0d"
  })), _path5025 || (_path5025 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#1b640f"
  })), _path5026 || (_path5026 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h-1v-1h1z",
    fill: "#4b9d23"
  })), _path5027 || (_path5027 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#106f09"
  })), _path5028 || (_path5028 = /*#__PURE__*/React.createElement("path", {
    d: "M72 79v1h-1v-1z",
    fill: "#033e02"
  })), _path5029 || (_path5029 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#2a8b2b"
  })), _path5030 || (_path5030 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79v1h-1v-1z",
    fill: "#3eb030"
  })), _path5031 || (_path5031 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v-1h1v1z",
    fill: "#157610"
  })), _path5032 || (_path5032 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#1a7215"
  })), _path5033 || (_path5033 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#0b520e"
  })), _path5034 || (_path5034 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#11680b"
  })), _path5035 || (_path5035 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#71c044"
  })), _path5036 || (_path5036 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#5dbb42"
  })), _path5037 || (_path5037 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#126711"
  })), _path5038 || (_path5038 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#005a01"
  })), _path5039 || (_path5039 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#388d1f"
  })), _path5040 || (_path5040 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#399c24"
  })), _path5041 || (_path5041 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79v1h-1v-1z",
    fill: "#359420"
  })), _path5042 || (_path5042 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1z",
    fill: "#6aba39"
  })), _path5043 || (_path5043 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h1z",
    fill: "#48ab23"
  })), _path5044 || (_path5044 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h-1v-1h1z",
    fill: "#5fab2d"
  })), _path5045 || (_path5045 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#69a645"
  })), _path5046 || (_path5046 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79h1v1h-1z",
    fill: "#9cd866"
  })), _path5047 || (_path5047 = /*#__PURE__*/React.createElement("path", {
    d: "M92 79v1h-1v-1z",
    fill: "#80c457"
  })), _path5048 || (_path5048 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-1h1v1z",
    fill: "#71a447"
  })), _path5049 || (_path5049 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#60a143"
  })), _path5050 || (_path5050 = /*#__PURE__*/React.createElement("path", {
    d: "M95 80h-1v-1h1z",
    fill: "#21831b"
  })), _path5051 || (_path5051 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80h-1v-1h1z",
    fill: "#289b2e"
  })), _path5052 || (_path5052 = /*#__PURE__*/React.createElement("path", {
    d: "M96 80v-1h1v1z",
    fill: "#33922b"
  })), _path5053 || (_path5053 = /*#__PURE__*/React.createElement("path", {
    d: "M97 79h1v1h-1z",
    fill: "#4da237"
  })), _path5054 || (_path5054 = /*#__PURE__*/React.createElement("path", {
    d: "M99 79v1h-1v-1z",
    fill: "#318d1b"
  })), _path5055 || (_path5055 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80v-1h1v1z",
    fill: "#358927",
    fillOpacity: 0.996
  })), _path5056 || (_path5056 = /*#__PURE__*/React.createElement("path", {
    d: "M101 80h-1v-1h1z",
    fill: "#62b039"
  })), _path5057 || (_path5057 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80h-1v-1h1z",
    fill: "#71b147",
    fillOpacity: 0.89
  })), _path5058 || (_path5058 = /*#__PURE__*/React.createElement("path", {
    d: "M102 79h1v1h-1z",
    fill: "#89b66e",
    fillOpacity: 0.263
  })), _path5059 || (_path5059 = /*#__PURE__*/React.createElement("path", {
    d: "M103 79h1v1h-1z",
    fill: "#5cb13c",
    fillOpacity: 0.875
  })), _path5060 || (_path5060 = /*#__PURE__*/React.createElement("path", {
    d: "M104 80v-1h1v1z",
    fill: "#8cc94d"
  })), _path5061 || (_path5061 = /*#__PURE__*/React.createElement("path", {
    d: "M106 79v1h-1v-1z",
    fill: "#b8ca6a",
    fillOpacity: 0.384
  })), _path5062 || (_path5062 = /*#__PURE__*/React.createElement("path", {
    d: "M113 80h-1v-1h1z",
    fill: "#90be5d",
    fillOpacity: 0.416
  })), _path5063 || (_path5063 = /*#__PURE__*/React.createElement("path", {
    d: "M114 80h-1v-1h1z",
    fill: "#9ec86f",
    fillOpacity: 0.573
  })), _path5064 || (_path5064 = /*#__PURE__*/React.createElement("path", {
    d: "M115 80h-1v-1h1z",
    fill: "#c4eb9c",
    fillOpacity: 0.051
  })), _path5065 || (_path5065 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v-1h1v1z",
    fill: "#a7c157",
    fillOpacity: 0.114
  })), _path5066 || (_path5066 = /*#__PURE__*/React.createElement("path", {
    d: "M12 80h1v1h-1z",
    fill: "#95c73c",
    fillOpacity: 0.608
  })), _path5067 || (_path5067 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80v1h-1v-1z",
    fill: "#93c444",
    fillOpacity: 0.867
  })), _path5068 || (_path5068 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80h1v1h-1z",
    fill: "#9bce60",
    fillOpacity: 0.475
  })), _path5069 || (_path5069 = /*#__PURE__*/React.createElement("path", {
    d: "M16 80v1h-1v-1z",
    fill: "#8ac069",
    fillOpacity: 0.447
  })), _path5070 || (_path5070 = /*#__PURE__*/React.createElement("path", {
    d: "M17 81h-1v-1h1z",
    fill: "#8cb973",
    fillOpacity: 0.2
  })), _path5071 || (_path5071 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1z",
    fill: "#61a844",
    fillOpacity: 0.439
  })), _path5072 || (_path5072 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#6aaf3b",
    fillOpacity: 0.945
  })), _path5073 || (_path5073 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v1h-1z",
    fill: "#75b249",
    fillOpacity: 0.816
  })), _path5074 || (_path5074 = /*#__PURE__*/React.createElement("path", {
    d: "M21 81v-1h1v1z",
    fill: "#67ae41",
    fillOpacity: 0.922
  })), _path5075 || (_path5075 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81h-1v-1h1z",
    fill: "#65b435"
  })), _path5076 || (_path5076 = /*#__PURE__*/React.createElement("path", {
    d: "M23 81v-1h1v1z",
    fill: "#5da32d"
  })), _path5077 || (_path5077 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1z",
    fill: "#70b442"
  })), _path5078 || (_path5078 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80h1v1h-1z",
    fill: "#6cb33a"
  })), _path5079 || (_path5079 = /*#__PURE__*/React.createElement("path", {
    d: "M27 80v1h-1v-1z",
    fill: "#57a737"
  })), _path5080 || (_path5080 = /*#__PURE__*/React.createElement("path", {
    d: "M27 81v-1h1v1z",
    fill: "#5aa641"
  })), _path5081 || (_path5081 = /*#__PURE__*/React.createElement("path", {
    d: "M28 80h1v1h-1z",
    fill: "#5da836"
  })), _path5082 || (_path5082 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80v1h-1v-1z",
    fill: "#73b63c"
  })), _path5083 || (_path5083 = /*#__PURE__*/React.createElement("path", {
    d: "M30 80h1v1h-1z",
    fill: "#67b135"
  })), _path5084 || (_path5084 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80v1h-1v-1z",
    fill: "#47932f",
    fillOpacity: 0.765
  })), _path5085 || (_path5085 = /*#__PURE__*/React.createElement("path", {
    d: "M32 80h1v1h-1z",
    fill: "#1a8715",
    fillOpacity: 0.922
  })), _path5086 || (_path5086 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#268e18"
  })), _path5087 || (_path5087 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#56ae27"
  })), _path5088 || (_path5088 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#42b01a"
  })), _path5089 || (_path5089 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#1e9912"
  })), _path5090 || (_path5090 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#1f9b1d"
  })), _path5091 || (_path5091 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#20ad2a"
  })), _path5092 || (_path5092 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#2aa41e"
  })), _path5093 || (_path5093 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#339c23"
  })), _path5094 || (_path5094 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#2ca21f"
  })), _path5095 || (_path5095 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#22941b"
  })), _path5096 || (_path5096 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#027308"
  })), _path5097 || (_path5097 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#006901"
  })), _path5098 || (_path5098 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#0a770d"
  })), _path5099 || (_path5099 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1z",
    fill: "#1f8f19"
  })), _path5100 || (_path5100 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1z",
    fill: "#1e8e16"
  })), _path5101 || (_path5101 = /*#__PURE__*/React.createElement("path", {
    d: "M49 81h-1v-1h1z",
    fill: "#399325"
  })), _path5102 || (_path5102 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#187b0f"
  })), _path5103 || (_path5103 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#248318"
  })), _path5104 || (_path5104 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#268c16"
  })), _path5105 || (_path5105 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81v-1h1v1z",
    fill: "#32951f"
  })), _path5106 || (_path5106 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#319e20"
  })), _path5107 || (_path5107 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#1a8717"
  })), _path5108 || (_path5108 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#258114"
  })), _path5109 || (_path5109 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#32a419"
  })), _path5110 || (_path5110 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#7da93d"
  })), _path5111 || (_path5111 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#488821"
  })), _path5112 || (_path5112 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#105e06"
  })), _path5113 || (_path5113 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#053b02"
  })), _path5114 || (_path5114 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#145111"
  })), _path5115 || (_path5115 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h1v1h-1z",
    fill: "#27841c"
  })), _path5116 || (_path5116 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81h-1v-1h1z",
    fill: "#137210"
  })), _path5117 || (_path5117 = /*#__PURE__*/React.createElement("path", {
    d: "M65 80h1v1h-1z",
    fill: "#055b03"
  })), _path5118 || (_path5118 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#005200"
  })), _path5119 || (_path5119 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#227116"
  })), _path5120 || (_path5120 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1z",
    fill: "#357922"
  })), _path5121 || (_path5121 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#256b12"
  })), _path5122 || (_path5122 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#4baa22"
  })), _path5123 || (_path5123 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#28881b"
  })), _path5124 || (_path5124 = /*#__PURE__*/React.createElement("path", {
    d: "M72 80h1v1h-1z",
    fill: "#3fa82d"
  })), _path5125 || (_path5125 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#42a532"
  })), _path5126 || (_path5126 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1z",
    fill: "#0b620b"
  })), _path5127 || (_path5127 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#3ba030"
  })), _path5128 || (_path5128 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1z",
    fill: "#238e1e"
  })), _path5129 || (_path5129 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#073c06"
  })), _path5130 || (_path5130 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#024b01"
  })), _path5131 || (_path5131 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#57a936"
  })), _path5132 || (_path5132 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#6dc947"
  })), _path5133 || (_path5133 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#348e25"
  })), _path5134 || (_path5134 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#167513"
  })), _path5135 || (_path5135 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#3fa223"
  })), _path5136 || (_path5136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#2b851a"
  })), _path5137 || (_path5137 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v1h-1v-1z",
    fill: "#027b04"
  })), _path5138 || (_path5138 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#24a014"
  })), _path5139 || (_path5139 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1z",
    fill: "#79cc44"
  })), _path5140 || (_path5140 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1z",
    fill: "#6fab45"
  })), _path5141 || (_path5141 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h1v1h-1z",
    fill: "#388721"
  })), _path5142 || (_path5142 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80v1h-1v-1z",
    fill: "#46882c"
  })), _path5143 || (_path5143 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#73b553"
  })), _path5144 || (_path5144 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80h1v1h-1z",
    fill: "#83bf51"
  })), _path5145 || (_path5145 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#6ca947"
  })), _path5146 || (_path5146 = /*#__PURE__*/React.createElement("path", {
    d: "M94 80h1v1h-1z",
    fill: "#014a01"
  })), _path5147 || (_path5147 = /*#__PURE__*/React.createElement("path", {
    d: "M95 81v-1h1v1z",
    fill: "#077116"
  })), _path5148 || (_path5148 = /*#__PURE__*/React.createElement("path", {
    d: "M97 80v1h-1v-1z",
    fill: "#198a19"
  })), _path5149 || (_path5149 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80v1h-1v-1z",
    fill: "#318706"
  })), _path5150 || (_path5150 = /*#__PURE__*/React.createElement("path", {
    d: "M98 80h1v1h-1z",
    fill: "#6cb223"
  })), _path5151 || (_path5151 = /*#__PURE__*/React.createElement("path", {
    d: "M99 80h1v1h-1z",
    fill: "#89bb47",
    fillOpacity: 0.957
  })), _path5152 || (_path5152 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81v-1h1v1z",
    fill: "#8cc34e",
    fillOpacity: 0.855
  })), _path5153 || (_path5153 = /*#__PURE__*/React.createElement("path", {
    d: "M102 80v1h-1v-1z",
    fill: "#6eb639"
  })), _path5154 || (_path5154 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81v-1h1v1z",
    fill: "#80bc56",
    fillOpacity: 0.882
  })), _path5155 || (_path5155 = /*#__PURE__*/React.createElement("path", {
    d: "M103 80h1v1h-1z",
    fill: "#7bbf53",
    fillOpacity: 0.933
  })), _path5156 || (_path5156 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81h-1v-1h1z",
    fill: "#66b535",
    fillOpacity: 0.945
  })), _path5157 || (_path5157 = /*#__PURE__*/React.createElement("path", {
    d: "M105 81v-1h1v1z",
    fill: "#a4e683",
    fillOpacity: 0.122
  })), _path5158 || (_path5158 = /*#__PURE__*/React.createElement("path", {
    d: "M113 81v-1h1v1z",
    fill: "#90bd63",
    fillOpacity: 0.29
  })), _path5159 || (_path5159 = /*#__PURE__*/React.createElement("path", {
    d: "M115 80v1h-1v-1z",
    fill: "#8fbd5d",
    fillOpacity: 0.608
  })), _path5160 || (_path5160 = /*#__PURE__*/React.createElement("path", {
    d: "M115 81v-1h1v1z",
    fill: "#9cca68",
    fillOpacity: 0.153
  })), _path5161 || (_path5161 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81v1h-1v-1z",
    fill: "#9cc33b",
    fillOpacity: 0.384
  })), _path5162 || (_path5162 = /*#__PURE__*/React.createElement("path", {
    d: "M11 81h1v1h-1z",
    fill: "#99c63a",
    fillOpacity: 0.765
  })), _path5163 || (_path5163 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82v-1h1v1z",
    fill: "#9bcb46",
    fillOpacity: 0.565
  })), _path5164 || (_path5164 = /*#__PURE__*/React.createElement("path", {
    d: "M13 82v-1h1v1z",
    fill: "#aad971",
    fillOpacity: 0.106
  })), _path5165 || (_path5165 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81h1v1h-1z",
    fill: "#cce5e5",
    fillOpacity: 0.039
  })), _path5166 || (_path5166 = /*#__PURE__*/React.createElement("path", {
    d: "M16 81h1v1h-1z",
    fill: "#b1c8a2",
    fillOpacity: 0.129
  })), _path5167 || (_path5167 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82v-1h1v1z",
    fill: "#76a95d",
    fillOpacity: 0.49
  })), _path5168 || (_path5168 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h1v1h-1z",
    fill: "#529b38",
    fillOpacity: 0.784
  })), _path5169 || (_path5169 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81v1h-1v-1z",
    fill: "#71b53d",
    fillOpacity: 0.953
  })), _path5170 || (_path5170 = /*#__PURE__*/React.createElement("path", {
    d: "M22 81v1h-1v-1z",
    fill: "#66b339"
  })), _path5171 || (_path5171 = /*#__PURE__*/React.createElement("path", {
    d: "M22 82v-1h1v1z",
    fill: "#71ab3e"
  })), _path5172 || (_path5172 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#6fa835"
  })), _path5173 || (_path5173 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#479819"
  })), _path5174 || (_path5174 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82v-1h1v1z",
    fill: "#177d0c"
  })), _path5175 || (_path5175 = /*#__PURE__*/React.createElement("path", {
    d: "M26 82v-1h1v1z",
    fill: "#268223"
  })), _path5176 || (_path5176 = /*#__PURE__*/React.createElement("path", {
    d: "M28 82h-1v-1h1z",
    fill: "#469731"
  })), _path5177 || (_path5177 = /*#__PURE__*/React.createElement("path", {
    d: "M28 81h1v1h-1z",
    fill: "#469b24",
    fillOpacity: 0.988
  })), _path5178 || (_path5178 = /*#__PURE__*/React.createElement("path", {
    d: "M29 82v-1h1v1z",
    fill: "#6db043",
    fillOpacity: 0.996
  })), _path5179 || (_path5179 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h-1v-1h1z",
    fill: "#408c2d",
    fillOpacity: 0.635
  })), _path5180 || (_path5180 = /*#__PURE__*/React.createElement("path", {
    d: "M33 81v1h-1v-1z",
    fill: "#309228",
    fillOpacity: 0.592
  })), _path5181 || (_path5181 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81v1h-1v-1z",
    fill: "#48ae2b"
  })), _path5182 || (_path5182 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#4eb12a"
  })), _path5183 || (_path5183 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v1h-1v-1z",
    fill: "#55ab25"
  })), _path5184 || (_path5184 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#46a420"
  })), _path5185 || (_path5185 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82h-1v-1h1z",
    fill: "#3d9f1a"
  })), _path5186 || (_path5186 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#29a81d"
  })), _path5187 || (_path5187 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#2fae2d"
  })), _path5188 || (_path5188 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1z",
    fill: "#24961b"
  })), _path5189 || (_path5189 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#2a871c"
  })), _path5190 || (_path5190 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#5bb133"
  })), _path5191 || (_path5191 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#349f20"
  })), _path5192 || (_path5192 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#026a04"
  })), _path5193 || (_path5193 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#075e05"
  })), _path5194 || (_path5194 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#279215"
  })), _path5195 || (_path5195 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#44a825"
  })), _path5196 || (_path5196 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82h-1v-1h1z",
    fill: "#2f931d"
  })), _path5197 || (_path5197 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1z",
    fill: "#3d9422"
  })), _path5198 || (_path5198 = /*#__PURE__*/React.createElement("path", {
    d: "M51 82v-1h1v1z",
    fill: "#45a721"
  })), _path5199 || (_path5199 = /*#__PURE__*/React.createElement("path", {
    d: "M53 82h-1v-1h1z",
    fill: "#4aa61d"
  })), _path5200 || (_path5200 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1z",
    fill: "#4a9a19"
  })), _path5201 || (_path5201 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82v-1h1v1z",
    fill: "#377414"
  })), _path5202 || (_path5202 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-1v-1z",
    fill: "#245b12"
  })), _path5203 || (_path5203 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#59a52d"
  })), _path5204 || (_path5204 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#54af22"
  })), _path5205 || (_path5205 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#529628"
  })), _path5206 || (_path5206 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#104a07"
  })), _path5207 || (_path5207 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#043201"
  })), _path5208 || (_path5208 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#164d13"
  })), _path5209 || (_path5209 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#479b2b"
  })), _path5210 || (_path5210 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#67b93c"
  })), _path5211 || (_path5211 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#63af35"
  })), _path5212 || (_path5212 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#408b1b"
  })), _path5213 || (_path5213 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#48901f"
  })), _path5214 || (_path5214 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#6ac03c"
  })), _path5215 || (_path5215 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#217810"
  })), _path5216 || (_path5216 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#44981b"
  })), _path5217 || (_path5217 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#61bd29"
  })), _path5218 || (_path5218 = /*#__PURE__*/React.createElement("path", {
    d: "M73 81v1h-1v-1z",
    fill: "#5bb132"
  })), _path5219 || (_path5219 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1z",
    fill: "#307d22"
  })), _path5220 || (_path5220 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#186c15"
  })), _path5221 || (_path5221 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#1d8718"
  })), _path5222 || (_path5222 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v1h-1v-1z",
    fill: "#20a024"
  })), _path5223 || (_path5223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1z",
    fill: "#09440d"
  })), _path5224 || (_path5224 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#002a00"
  })), _path5225 || (_path5225 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#3b921d"
  })), _path5226 || (_path5226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#7dd248"
  })), _path5227 || (_path5227 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#5db549"
  })), _path5228 || (_path5228 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1z",
    fill: "#106710"
  })), _path5229 || (_path5229 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#37941e"
  })), _path5230 || (_path5230 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#3e8828"
  })), _path5231 || (_path5231 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#1a8910"
  })), _path5232 || (_path5232 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1z",
    fill: "#27a315"
  })), _path5233 || (_path5233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1z",
    fill: "#41ae27"
  })), _path5234 || (_path5234 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h-1v-1h1z",
    fill: "#78c74a"
  })), _path5235 || (_path5235 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82v-1h1v1z",
    fill: "#77be49"
  })), _path5236 || (_path5236 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v-1h1v1z",
    fill: "#225c1f"
  })), _path5237 || (_path5237 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1z",
    fill: "#509d3a"
  })), _path5238 || (_path5238 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1z",
    fill: "#5e9d38"
  })), _path5239 || (_path5239 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h1v1h-1z",
    fill: "#0b4e07"
  })), _path5240 || (_path5240 = /*#__PURE__*/React.createElement("path", {
    d: "M96 82h-1v-1h1z",
    fill: "#076007"
  })), _path5241 || (_path5241 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h-1v-1h1z",
    fill: "#38a024"
  })), _path5242 || (_path5242 = /*#__PURE__*/React.createElement("path", {
    d: "M97 81h1v1h-1z",
    fill: "#84c235"
  })), _path5243 || (_path5243 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82v-1h1v1z",
    fill: "#79b939",
    fillOpacity: 0.996
  })), _path5244 || (_path5244 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82v-1h1v1z",
    fill: "#83b55b",
    fillOpacity: 0.478
  })), _path5245 || (_path5245 = /*#__PURE__*/React.createElement("path", {
    d: "M100 81h1v1h-1z",
    fill: "#52954d",
    fillOpacity: 0.463
  })), _path5246 || (_path5246 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82v-1h1v1z",
    fill: "#389227",
    fillOpacity: 0.941
  })), _path5247 || (_path5247 = /*#__PURE__*/React.createElement("path", {
    d: "M102 81h1v1h-1z",
    fill: "#69b63b"
  })), _path5248 || (_path5248 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h-1v-1h1z",
    fill: "#8bcb53"
  })), _path5249 || (_path5249 = /*#__PURE__*/React.createElement("path", {
    d: "M105 82h-1v-1h1z",
    fill: "#4ea820"
  })), _path5250 || (_path5250 = /*#__PURE__*/React.createElement("path", {
    d: "M106 81v1h-1v-1z",
    fill: "#78c142",
    fillOpacity: 0.439
  })), _path5251 || (_path5251 = /*#__PURE__*/React.createElement("path", {
    d: "M107 82h-1v-1h1z",
    fill: "#abbf7f",
    fillOpacity: 0.204
  })), _path5252 || (_path5252 = /*#__PURE__*/React.createElement("path", {
    d: "M107 81h1v1h-1z",
    fill: "#aac279",
    fillOpacity: 0.082
  })), _path5253 || (_path5253 = /*#__PURE__*/React.createElement("path", {
    d: "M114 82v-1h1v1z",
    fill: "#8dbe65",
    fillOpacity: 0.247
  })), _path5254 || (_path5254 = /*#__PURE__*/React.createElement("path", {
    d: "M116 81v1h-1v-1z",
    fill: "#8ebc5a",
    fillOpacity: 0.616
  })), _path5255 || (_path5255 = /*#__PURE__*/React.createElement("path", {
    d: "M116 82v-1h1v1z",
    fill: "#aecc74",
    fillOpacity: 0.137
  })), _path5256 || (_path5256 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82v1H8v-1z",
    fill: "#a3c84d",
    fillOpacity: 0.22
  })), _path5257 || (_path5257 = /*#__PURE__*/React.createElement("path", {
    d: "M9 82h1v1H9z",
    fill: "#9ac338",
    fillOpacity: 0.655
  })), _path5258 || (_path5258 = /*#__PURE__*/React.createElement("path", {
    d: "M11 83h-1v-1h1z",
    fill: "#97c532",
    fillOpacity: 0.553
  })), _path5259 || (_path5259 = /*#__PURE__*/React.createElement("path", {
    d: "M12 82v1h-1v-1z",
    fill: "#a5d243",
    fillOpacity: 0.133
  })), _path5260 || (_path5260 = /*#__PURE__*/React.createElement("path", {
    d: "M15 82h1v1h-1z",
    fill: "#baccad",
    fillOpacity: 0.22
  })), _path5261 || (_path5261 = /*#__PURE__*/React.createElement("path", {
    d: "M16 83v-1h1v1z",
    fill: "#a1c090",
    fillOpacity: 0.29
  })), _path5262 || (_path5262 = /*#__PURE__*/React.createElement("path", {
    d: "M17 82h1v1h-1z",
    fill: "#81aa69",
    fillOpacity: 0.247
  })), _path5263 || (_path5263 = /*#__PURE__*/React.createElement("path", {
    d: "M19 82v1h-1v-1z",
    fill: "#85bc64",
    fillOpacity: 0.329
  })), _path5264 || (_path5264 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83h-1v-1h1z",
    fill: "#58ac25",
    fillOpacity: 0.969
  })), _path5265 || (_path5265 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83h-1v-1h1z",
    fill: "#65b233"
  })), _path5266 || (_path5266 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83v-1h1v1z",
    fill: "#72b148"
  })), _path5267 || (_path5267 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83h-1v-1h1z",
    fill: "#439325"
  })), _path5268 || (_path5268 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82v1h-1v-1z",
    fill: "#2e8a17",
    fillOpacity: 0.992
  })), _path5269 || (_path5269 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1z",
    fill: "#2b821a",
    fillOpacity: 0.953
  })), _path5270 || (_path5270 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1z",
    fill: "#4e9b2f"
  })), _path5271 || (_path5271 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83v-1h1v1z",
    fill: "#62a836"
  })), _path5272 || (_path5272 = /*#__PURE__*/React.createElement("path", {
    d: "M27 82h1v1h-1z",
    fill: "#64a63d",
    fillOpacity: 0.776
  })), _path5273 || (_path5273 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v-1h1v1z",
    fill: "#7dbb58",
    fillOpacity: 0.294
  })), _path5274 || (_path5274 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#51983e",
    fillOpacity: 0.812
  })), _path5275 || (_path5275 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#3f8539",
    fillOpacity: 0.329
  })), _path5276 || (_path5276 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82h1v1h-1z",
    fill: "#84c06c",
    fillOpacity: 0.286
  })), _path5277 || (_path5277 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82v1h-1v-1z",
    fill: "#6bbf3e",
    fillOpacity: 0.847
  })), _path5278 || (_path5278 = /*#__PURE__*/React.createElement("path", {
    d: "M33 83v-1h1v1z",
    fill: "#50b528"
  })), _path5279 || (_path5279 = /*#__PURE__*/React.createElement("path", {
    d: "M35 83h-1v-1h1z",
    fill: "#168a12"
  })), _path5280 || (_path5280 = /*#__PURE__*/React.createElement("path", {
    d: "M36 82v1h-1v-1z",
    fill: "#368922"
  })), _path5281 || (_path5281 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#74b735"
  })), _path5282 || (_path5282 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#5fb42a"
  })), _path5283 || (_path5283 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#3a9e1f"
  })), _path5284 || (_path5284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#1d7f1a"
  })), _path5285 || (_path5285 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#27ad29"
  })), _path5286 || (_path5286 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#1d9015"
  })), _path5287 || (_path5287 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82h1v1h-1z",
    fill: "#5aa92a"
  })), _path5288 || (_path5288 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#539728"
  })), _path5289 || (_path5289 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82v1h-1v-1z",
    fill: "#62ad3c"
  })), _path5290 || (_path5290 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#3d981f"
  })), _path5291 || (_path5291 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#54b624"
  })), _path5292 || (_path5292 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#4fa722"
  })), _path5293 || (_path5293 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#2b7811"
  })), _path5294 || (_path5294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 82v1h-1v-1z",
    fill: "#3d8a18"
  })), _path5295 || (_path5295 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83v-1h1v1z",
    fill: "#56a51c"
  })), _path5296 || (_path5296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 83v-1h1v1z",
    fill: "#50a016"
  })), _path5297 || (_path5297 = /*#__PURE__*/React.createElement("path", {
    d: "M54 82h1v1h-1z",
    fill: "#539e19"
  })), _path5298 || (_path5298 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82h1v1h-1z",
    fill: "#5b961f"
  })), _path5299 || (_path5299 = /*#__PURE__*/React.createElement("path", {
    d: "M56 82h1v1h-1z",
    fill: "#67a42a"
  })), _path5300 || (_path5300 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83h-1v-1h1z",
    fill: "#50ac21"
  })), _path5301 || (_path5301 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#2a8b12"
  })), _path5302 || (_path5302 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v1h-1v-1z",
    fill: "#014503"
  })), _path5303 || (_path5303 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#063507"
  })), _path5304 || (_path5304 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#023002"
  })), _path5305 || (_path5305 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#0f470c"
  })), _path5306 || (_path5306 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#41a127"
  })), _path5307 || (_path5307 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1z",
    fill: "#5cac37"
  })), _path5308 || (_path5308 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#4fa12c"
  })), _path5309 || (_path5309 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1z",
    fill: "#4a9923"
  })), _path5310 || (_path5310 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#4fa11d"
  })), _path5311 || (_path5311 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#68c438"
  })), _path5312 || (_path5312 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#65b837"
  })), _path5313 || (_path5313 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#78c443"
  })), _path5314 || (_path5314 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#58b71f"
  })), _path5315 || (_path5315 = /*#__PURE__*/React.createElement("path", {
    d: "M72 82h1v1h-1z",
    fill: "#39891b"
  })), _path5316 || (_path5316 = /*#__PURE__*/React.createElement("path", {
    d: "M73 82h1v1h-1z",
    fill: "#39832a"
  })), _path5317 || (_path5317 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1z",
    fill: "#207d18"
  })), _path5318 || (_path5318 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1z",
    fill: "#208d16"
  })), _path5319 || (_path5319 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82h1v1h-1z",
    fill: "#178419"
  })), _path5320 || (_path5320 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#0c6b0c"
  })), _path5321 || (_path5321 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#24661d"
  })), _path5322 || (_path5322 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#40a11e"
  })), _path5323 || (_path5323 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#77cb41"
  })), _path5324 || (_path5324 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#5eb549"
  })), _path5325 || (_path5325 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82v1h-1v-1z",
    fill: "#2e821d"
  })), _path5326 || (_path5326 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h1v1h-1z",
    fill: "#4c9333"
  })), _path5327 || (_path5327 = /*#__PURE__*/React.createElement("path", {
    d: "M86 82v1h-1v-1z",
    fill: "#43a41c"
  })), _path5328 || (_path5328 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#3da820"
  })), _path5329 || (_path5329 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#219a12"
  })), _path5330 || (_path5330 = /*#__PURE__*/React.createElement("path", {
    d: "M89 83h-1v-1h1z",
    fill: "#34a614"
  })), _path5331 || (_path5331 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h1v1h-1z",
    fill: "#79c244"
  })), _path5332 || (_path5332 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v1h-1v-1z",
    fill: "#598d3c"
  })), _path5333 || (_path5333 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-1z",
    fill: "#012801"
  })), _path5334 || (_path5334 = /*#__PURE__*/React.createElement("path", {
    d: "M92 83v-1h1v1z",
    fill: "#27721e"
  })), _path5335 || (_path5335 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#52a236"
  })), _path5336 || (_path5336 = /*#__PURE__*/React.createElement("path", {
    d: "M94 82h1v1h-1z",
    fill: "#196210"
  })), _path5337 || (_path5337 = /*#__PURE__*/React.createElement("path", {
    d: "M96 83h-1v-1h1z",
    fill: "#146314"
  })), _path5338 || (_path5338 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83h-1v-1h1z",
    fill: "#2a9126"
  })), _path5339 || (_path5339 = /*#__PURE__*/React.createElement("path", {
    d: "M97 82h1v1h-1z",
    fill: "#7fc55b"
  })), _path5340 || (_path5340 = /*#__PURE__*/React.createElement("path", {
    d: "M98 82h1v1h-1z",
    fill: "#2e8e27",
    fillOpacity: 0.996
  })), _path5341 || (_path5341 = /*#__PURE__*/React.createElement("path", {
    d: "M99 82h1v1h-1z",
    fill: "#40974a",
    fillOpacity: 0.792
  })), _path5342 || (_path5342 = /*#__PURE__*/React.createElement("path", {
    d: "M101 82v1h-1v-1z",
    fill: "#5e9c50",
    fillOpacity: 0.659
  })), _path5343 || (_path5343 = /*#__PURE__*/React.createElement("path", {
    d: "M101 83v-1h1v1z",
    fill: "#6eaa39",
    fillOpacity: 0.824
  })), _path5344 || (_path5344 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83h-1v-1h1z",
    fill: "#7db543",
    fillOpacity: 0.655
  })), _path5345 || (_path5345 = /*#__PURE__*/React.createElement("path", {
    d: "M103 83v-1h1v1z",
    fill: "#46a334",
    fillOpacity: 0.984
  })), _path5346 || (_path5346 = /*#__PURE__*/React.createElement("path", {
    d: "M104 82h1v1h-1z",
    fill: "#69c13f"
  })), _path5347 || (_path5347 = /*#__PURE__*/React.createElement("path", {
    d: "M106 83h-1v-1h1z",
    fill: "#73bd3b",
    fillOpacity: 0.918
  })), _path5348 || (_path5348 = /*#__PURE__*/React.createElement("path", {
    d: "M106 82h1v1h-1z",
    fill: "#8fb756",
    fillOpacity: 0.404
  })), _path5349 || (_path5349 = /*#__PURE__*/React.createElement("path", {
    d: "M117 83h-1v-1h1z",
    fill: "#aac68d",
    fillOpacity: 0.035
  })), _path5350 || (_path5350 = /*#__PURE__*/React.createElement("path", {
    d: "M6 83h1v1H6z",
    fill: "#b8d471",
    fillOpacity: 0.071
  })), _path5351 || (_path5351 = /*#__PURE__*/React.createElement("path", {
    d: "M8 84H7v-1h1z",
    fill: "#a1c242",
    fillOpacity: 0.494
  })), _path5352 || (_path5352 = /*#__PURE__*/React.createElement("path", {
    d: "M9 83v1H8v-1z",
    fill: "#9bc138",
    fillOpacity: 0.671
  })), _path5353 || (_path5353 = /*#__PURE__*/React.createElement("path", {
    d: "M9 84v-1h1v1z",
    fill: "#9ec737",
    fillOpacity: 0.271
  })), _path5354 || (_path5354 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83v1h-1v-1z",
    fill: "#b9d0b9",
    fillOpacity: 0.043
  })), _path5355 || (_path5355 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h1v1h-1z",
    fill: "#adc1a3",
    fillOpacity: 0.098
  })), _path5356 || (_path5356 = /*#__PURE__*/React.createElement("path", {
    d: "M18 84v-1h1v1z",
    fill: "#8aba4d",
    fillOpacity: 0.671
  })), _path5357 || (_path5357 = /*#__PURE__*/React.createElement("path", {
    d: "M20 83v1h-1v-1z",
    fill: "#72be2e"
  })), _path5358 || (_path5358 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84v-1h1v1z",
    fill: "#64b439"
  })), _path5359 || (_path5359 = /*#__PURE__*/React.createElement("path", {
    d: "M22 83v1h-1v-1z",
    fill: "#2b901e"
  })), _path5360 || (_path5360 = /*#__PURE__*/React.createElement("path", {
    d: "M23 83v1h-1v-1z",
    fill: "#1b8415",
    fillOpacity: 0.761
  })), _path5361 || (_path5361 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v-1h1v1z",
    fill: "#3a952b",
    fillOpacity: 0.275
  })), _path5362 || (_path5362 = /*#__PURE__*/React.createElement("path", {
    d: "M24 83h1v1h-1z",
    fill: "#8db481",
    fillOpacity: 0.333
  })), _path5363 || (_path5363 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84h-1v-1h1z",
    fill: "#8fbd61",
    fillOpacity: 0.902
  })), _path5364 || (_path5364 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v1h-1v-1z",
    fill: "#89c24b",
    fillOpacity: 0.973
  })), _path5365 || (_path5365 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1z",
    fill: "#68a244",
    fillOpacity: 0.886
  })), _path5366 || (_path5366 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84h-1v-1h1z",
    fill: "#4d9238",
    fillOpacity: 0.796
  })), _path5367 || (_path5367 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#419324",
    fillOpacity: 0.961
  })), _path5368 || (_path5368 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83h1v1h-1z",
    fill: "#64b140",
    fillOpacity: 0.875
  })), _path5369 || (_path5369 = /*#__PURE__*/React.createElement("path", {
    d: "M32 83v1h-1v-1z",
    fill: "#6aba38",
    fillOpacity: 0.988
  })), _path5370 || (_path5370 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84v-1h1v1z",
    fill: "#4aad29"
  })), _path5371 || (_path5371 = /*#__PURE__*/React.createElement("path", {
    d: "M33 84v-1h1v1z",
    fill: "#13890e"
  })), _path5372 || (_path5372 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#057e0e"
  })), _path5373 || (_path5373 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84v-1h1v1z",
    fill: "#1c8319"
  })), _path5374 || (_path5374 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#63ad33"
  })), _path5375 || (_path5375 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h1v1z",
    fill: "#6bb331"
  })), _path5376 || (_path5376 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#7aba3a"
  })), _path5377 || (_path5377 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1z",
    fill: "#4da425"
  })), _path5378 || (_path5378 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h-1v-1h1z",
    fill: "#2a9a21"
  })), _path5379 || (_path5379 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#27a124"
  })), _path5380 || (_path5380 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#47a527"
  })), _path5381 || (_path5381 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#57a421"
  })), _path5382 || (_path5382 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#38861f"
  })), _path5383 || (_path5383 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#7eb940"
  })), _path5384 || (_path5384 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v1z",
    fill: "#6dae38"
  })), _path5385 || (_path5385 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#46992e"
  })), _path5386 || (_path5386 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v-1h1v1z",
    fill: "#23891d"
  })), _path5387 || (_path5387 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#228316"
  })), _path5388 || (_path5388 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#2e8713"
  })), _path5389 || (_path5389 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#3c9c15"
  })), _path5390 || (_path5390 = /*#__PURE__*/React.createElement("path", {
    d: "M52 83h1v1h-1z",
    fill: "#469e12"
  })), _path5391 || (_path5391 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84v-1h1v1z",
    fill: "#4ea314"
  })), _path5392 || (_path5392 = /*#__PURE__*/React.createElement("path", {
    d: "M55 83v1h-1v-1z",
    fill: "#52a813"
  })), _path5393 || (_path5393 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#60a917"
  })), _path5394 || (_path5394 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84v-1h1v1z",
    fill: "#62a518"
  })), _path5395 || (_path5395 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1z",
    fill: "#5fa31f"
  })), _path5396 || (_path5396 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83v1h-1v-1z",
    fill: "#4eaf1d"
  })), _path5397 || (_path5397 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#1d6d0e"
  })), _path5398 || (_path5398 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1z",
    fill: "#022a04"
  })), _path5399 || (_path5399 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#003401"
  })), _path5400 || (_path5400 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83h1v1h-1z",
    fill: "#43a626"
  })), _path5401 || (_path5401 = /*#__PURE__*/React.createElement("path", {
    d: "M65 84h-1v-1h1z",
    fill: "#3e9126"
  })), _path5402 || (_path5402 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#086e09"
  })), _path5403 || (_path5403 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#004700"
  })), _path5404 || (_path5404 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#0a6204"
  })), _path5405 || (_path5405 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#54b72d"
  })), _path5406 || (_path5406 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#65b938"
  })), _path5407 || (_path5407 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#75bb4c"
  })), _path5408 || (_path5408 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#459022"
  })), _path5409 || (_path5409 = /*#__PURE__*/React.createElement("path", {
    d: "M72 84v-1h1v1z",
    fill: "#64a330"
  })), _path5410 || (_path5410 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84v-1h1v1z",
    fill: "#1a550d"
  })), _path5411 || (_path5411 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#17760f"
  })), _path5412 || (_path5412 = /*#__PURE__*/React.createElement("path", {
    d: "M76 83v1h-1v-1z",
    fill: "#319421"
  })), _path5413 || (_path5413 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#0e430c"
  })), _path5414 || (_path5414 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#207f1a"
  })), _path5415 || (_path5415 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#25951f"
  })), _path5416 || (_path5416 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#268813"
  })), _path5417 || (_path5417 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#5cb334"
  })), _path5418 || (_path5418 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#67c048"
  })), _path5419 || (_path5419 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#208120"
  })), _path5420 || (_path5420 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#2d8d1e"
  })), _path5421 || (_path5421 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h-1v-1h1z",
    fill: "#2d891c"
  })), _path5422 || (_path5422 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1z",
    fill: "#3ca01e"
  })), _path5423 || (_path5423 = /*#__PURE__*/React.createElement("path", {
    d: "M87 83v1h-1v-1z",
    fill: "#50af2c"
  })), _path5424 || (_path5424 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h1v1z",
    fill: "#5ab23b"
  })), _path5425 || (_path5425 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h1v1h-1z",
    fill: "#29a018"
  })), _path5426 || (_path5426 = /*#__PURE__*/React.createElement("path", {
    d: "M90 83v1h-1v-1z",
    fill: "#42b420"
  })), _path5427 || (_path5427 = /*#__PURE__*/React.createElement("path", {
    d: "M90 84v-1h1v1z",
    fill: "#78c645"
  })), _path5428 || (_path5428 = /*#__PURE__*/React.createElement("path", {
    d: "M91 83h1v1h-1z",
    fill: "#437827"
  })), _path5429 || (_path5429 = /*#__PURE__*/React.createElement("path", {
    d: "M92 84v-1h1v1z",
    fill: "#0e540c"
  })), _path5430 || (_path5430 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83h1v1h-1z",
    fill: "#388727"
  })), _path5431 || (_path5431 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84v-1h1v1z",
    fill: "#2c791f"
  })), _path5432 || (_path5432 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h-1v-1h1z",
    fill: "#156d15"
  })), _path5433 || (_path5433 = /*#__PURE__*/React.createElement("path", {
    d: "M97 83v1h-1v-1z",
    fill: "#097908"
  })), _path5434 || (_path5434 = /*#__PURE__*/React.createElement("path", {
    d: "M98 84h-1v-1h1z",
    fill: "#54b345"
  })), _path5435 || (_path5435 = /*#__PURE__*/React.createElement("path", {
    d: "M98 83h1v1h-1z",
    fill: "#2a8f22"
  })), _path5436 || (_path5436 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83v1h-1v-1z",
    fill: "#429924"
  })), _path5437 || (_path5437 = /*#__PURE__*/React.createElement("path", {
    d: "M100 83h1v1h-1z",
    fill: "#68b238"
  })), _path5438 || (_path5438 = /*#__PURE__*/React.createElement("path", {
    d: "M102 83v1h-1v-1z",
    fill: "#7ebb47",
    fillOpacity: 0.745
  })), _path5439 || (_path5439 = /*#__PURE__*/React.createElement("path", {
    d: "M102 84v-1h1v1z",
    fill: "#41a046",
    fillOpacity: 0.38
  })), _path5440 || (_path5440 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84h-1v-1h1z",
    fill: "#288f20",
    fillOpacity: 0.855
  })), _path5441 || (_path5441 = /*#__PURE__*/React.createElement("path", {
    d: "M104 84v-1h1v1z",
    fill: "#6ab946",
    fillOpacity: 0.8
  })), _path5442 || (_path5442 = /*#__PURE__*/React.createElement("path", {
    d: "M105 83h1v1h-1z",
    fill: "#86c555",
    fillOpacity: 0.976
  })), _path5443 || (_path5443 = /*#__PURE__*/React.createElement("path", {
    d: "M107 83v1h-1v-1z",
    fill: "#aace7f",
    fillOpacity: 0.165
  })), _path5444 || (_path5444 = /*#__PURE__*/React.createElement("path", {
    d: "M5 84h1v1H5z",
    fill: "#b4cd6a",
    fillOpacity: 0.122
  })), _path5445 || (_path5445 = /*#__PURE__*/React.createElement("path", {
    d: "M6 84h1v1H6z",
    fill: "#a3c343",
    fillOpacity: 0.624
  })), _path5446 || (_path5446 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85v-1h1v1z",
    fill: "#9fc140",
    fillOpacity: 0.388
  })), _path5447 || (_path5447 = /*#__PURE__*/React.createElement("path", {
    d: "M8 85v-1h1v1z",
    fill: "#b6da6d",
    fillOpacity: 0.027
  })), _path5448 || (_path5448 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85h-1v-1h1z",
    fill: "#7bbc35",
    fillOpacity: 0.898
  })), _path5449 || (_path5449 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v-1h1v1z",
    fill: "#4db11f"
  })), _path5450 || (_path5450 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84h1v1h-1z",
    fill: "#218b14",
    fillOpacity: 0.937
  })), _path5451 || (_path5451 = /*#__PURE__*/React.createElement("path", {
    d: "M21 84h1v1h-1z",
    fill: "#349028",
    fillOpacity: 0.498
  })), _path5452 || (_path5452 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84v1h-1v-1z",
    fill: "#c3e1c3",
    fillOpacity: 0.067
  })), _path5453 || (_path5453 = /*#__PURE__*/React.createElement("path", {
    d: "M23 84h1v1h-1z",
    fill: "#e6eee6",
    fillOpacity: 0.122
  })), _path5454 || (_path5454 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1z",
    fill: "#bdd5b3",
    fillOpacity: 0.29
  })), _path5455 || (_path5455 = /*#__PURE__*/React.createElement("path", {
    d: "M26 84v1h-1v-1z",
    fill: "#9cc58b",
    fillOpacity: 0.365
  })), _path5456 || (_path5456 = /*#__PURE__*/React.createElement("path", {
    d: "M26 85v-1h1v1z",
    fill: "#8bc05f",
    fillOpacity: 0.82
  })), _path5457 || (_path5457 = /*#__PURE__*/React.createElement("path", {
    d: "M28 84v1h-1v-1z",
    fill: "#7abb45"
  })), _path5458 || (_path5458 = /*#__PURE__*/React.createElement("path", {
    d: "M29 84v1h-1v-1z",
    fill: "#418e23"
  })), _path5459 || (_path5459 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84v1h-1v-1z",
    fill: "#69b33d"
  })), _path5460 || (_path5460 = /*#__PURE__*/React.createElement("path", {
    d: "M30 84h1v1h-1z",
    fill: "#6dc62e"
  })), _path5461 || (_path5461 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85h-1v-1h1z",
    fill: "#53b12a"
  })), _path5462 || (_path5462 = /*#__PURE__*/React.createElement("path", {
    d: "M32 84h1v1h-1z",
    fill: "#268b1c"
  })), _path5463 || (_path5463 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84v1h-1v-1z",
    fill: "#158d17"
  })), _path5464 || (_path5464 = /*#__PURE__*/React.createElement("path", {
    d: "M34 84h1v1h-1z",
    fill: "#067e0b"
  })), _path5465 || (_path5465 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h1v1h-1z",
    fill: "#0b7d0e"
  })), _path5466 || (_path5466 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#308e20"
  })), _path5467 || (_path5467 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v1h-1v-1z",
    fill: "#30931a"
  })), _path5468 || (_path5468 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84h1v1h-1z",
    fill: "#85b93f"
  })), _path5469 || (_path5469 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#7ebc3b"
  })), _path5470 || (_path5470 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#459a26"
  })), _path5471 || (_path5471 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#23871d"
  })), _path5472 || (_path5472 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#45ab22"
  })), _path5473 || (_path5473 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#73ba30"
  })), _path5474 || (_path5474 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#327414"
  })), _path5475 || (_path5475 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#4b832a"
  })), _path5476 || (_path5476 = /*#__PURE__*/React.createElement("path", {
    d: "M47 85h-1v-1h1z",
    fill: "#94c84e"
  })), _path5477 || (_path5477 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#6da641"
  })), _path5478 || (_path5478 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#266d19"
  })), _path5479 || (_path5479 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85h-1v-1h1z",
    fill: "#3d932f"
  })), _path5480 || (_path5480 = /*#__PURE__*/React.createElement("path", {
    d: "M50 84h1v1h-1z",
    fill: "#228b29"
  })), _path5481 || (_path5481 = /*#__PURE__*/React.createElement("path", {
    d: "M51 84h1v1h-1z",
    fill: "#21971d"
  })), _path5482 || (_path5482 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#218718"
  })), _path5483 || (_path5483 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#227910"
  })), _path5484 || (_path5484 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#3e9319"
  })), _path5485 || (_path5485 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84h1v1h-1z",
    fill: "#55a01c"
  })), _path5486 || (_path5486 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-1z",
    fill: "#55a81d"
  })), _path5487 || (_path5487 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#63a81d"
  })), _path5488 || (_path5488 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#58b41a"
  })), _path5489 || (_path5489 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1z",
    fill: "#4eae1a"
  })), _path5490 || (_path5490 = /*#__PURE__*/React.createElement("path", {
    d: "M61 85h-1v-1h1z",
    fill: "#4a901f"
  })), _path5491 || (_path5491 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#478b29"
  })), _path5492 || (_path5492 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85v-1h1v1z",
    fill: "#51a13c"
  })), _path5493 || (_path5493 = /*#__PURE__*/React.createElement("path", {
    d: "M63 85v-1h1v1z",
    fill: "#6abb4b"
  })), _path5494 || (_path5494 = /*#__PURE__*/React.createElement("path", {
    d: "M66 85h-1v-1h1z",
    fill: "#359021"
  })), _path5495 || (_path5495 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1z",
    fill: "#187113"
  })), _path5496 || (_path5496 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#3ea324"
  })), _path5497 || (_path5497 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#69be32"
  })), _path5498 || (_path5498 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#6ca448"
  })), _path5499 || (_path5499 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#326d1d"
  })), _path5500 || (_path5500 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#3d8824"
  })), _path5501 || (_path5501 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#52922c"
  })), _path5502 || (_path5502 = /*#__PURE__*/React.createElement("path", {
    d: "M75 84v1h-1v-1z",
    fill: "#096307"
  })), _path5503 || (_path5503 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#369428"
  })), _path5504 || (_path5504 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v1h-1v-1z",
    fill: "#0e3e0b"
  })), _path5505 || (_path5505 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#075c08"
  })), _path5506 || (_path5506 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#0b8814"
  })), _path5507 || (_path5507 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#125e0d"
  })), _path5508 || (_path5508 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#399020"
  })), _path5509 || (_path5509 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#61bd3f"
  })), _path5510 || (_path5510 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#3aa133"
  })), _path5511 || (_path5511 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84v1h-1v-1z",
    fill: "#28931b"
  })), _path5512 || (_path5512 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85v-1h1v1z",
    fill: "#138a10"
  })), _path5513 || (_path5513 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1z",
    fill: "#259b17"
  })), _path5514 || (_path5514 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85v-1h1v1z",
    fill: "#5cb837"
  })), _path5515 || (_path5515 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85h-1v-1h1z",
    fill: "#74bf4e"
  })), _path5516 || (_path5516 = /*#__PURE__*/React.createElement("path", {
    d: "M89 84v1h-1v-1z",
    fill: "#1b861d"
  })), _path5517 || (_path5517 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#23a01f"
  })), _path5518 || (_path5518 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84v1h-1v-1z",
    fill: "#4db223"
  })), _path5519 || (_path5519 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h1v1h-1z",
    fill: "#79bd40"
  })), _path5520 || (_path5520 = /*#__PURE__*/React.createElement("path", {
    d: "M92 85v-1h1v1z",
    fill: "#357920"
  })), _path5521 || (_path5521 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-1h1v1z",
    fill: "#2b6e1f"
  })), _path5522 || (_path5522 = /*#__PURE__*/React.createElement("path", {
    d: "M94 84h1v1h-1z",
    fill: "#318422"
  })), _path5523 || (_path5523 = /*#__PURE__*/React.createElement("path", {
    d: "M95 84h1v1h-1z",
    fill: "#208313"
  })), _path5524 || (_path5524 = /*#__PURE__*/React.createElement("path", {
    d: "M96 84h1v1h-1z",
    fill: "#3e9c28"
  })), _path5525 || (_path5525 = /*#__PURE__*/React.createElement("path", {
    d: "M98 85h-1v-1h1z",
    fill: "#2e9827"
  })), _path5526 || (_path5526 = /*#__PURE__*/React.createElement("path", {
    d: "M98 85v-1h1v1z",
    fill: "#5fb448"
  })), _path5527 || (_path5527 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85h-1v-1h1z",
    fill: "#4b9d21"
  })), _path5528 || (_path5528 = /*#__PURE__*/React.createElement("path", {
    d: "M101 84v1h-1v-1z",
    fill: "#55a638",
    fillOpacity: 0.78
  })), _path5529 || (_path5529 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85h-1v-1h1z",
    fill: "#55b23e",
    fillOpacity: 0.788
  })), _path5530 || (_path5530 = /*#__PURE__*/React.createElement("path", {
    d: "M103 84v1h-1v-1z",
    fill: "#289724",
    fillOpacity: 0.867
  })), _path5531 || (_path5531 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85v-1h1v1z",
    fill: "#409e39",
    fillOpacity: 0.278
  })), _path5532 || (_path5532 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85v-1h1v1z",
    fill: "#67b357",
    fillOpacity: 0.58
  })), _path5533 || (_path5533 = /*#__PURE__*/React.createElement("path", {
    d: "M105 84h1v1h-1z",
    fill: "#8bc56f",
    fillOpacity: 0.718
  })), _path5534 || (_path5534 = /*#__PURE__*/React.createElement("path", {
    d: "M107 85h-1v-1h1z",
    fill: "#b6cf91",
    fillOpacity: 0.51
  })), _path5535 || (_path5535 = /*#__PURE__*/React.createElement("path", {
    d: "M6 85v1H5v-1z",
    fill: "#b9d07f",
    fillOpacity: 0.086
  })), _path5536 || (_path5536 = /*#__PURE__*/React.createElement("path", {
    d: "M7 85v1H6v-1z",
    fill: "#bccf5e",
    fillOpacity: 0.106
  })), _path5537 || (_path5537 = /*#__PURE__*/React.createElement("path", {
    d: "M18 86h-1v-1h1z",
    fill: "#67af42",
    fillOpacity: 0.388
  })), _path5538 || (_path5538 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v1h-1v-1z",
    fill: "#40a11b",
    fillOpacity: 0.91
  })), _path5539 || (_path5539 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#29901c",
    fillOpacity: 0.604
  })), _path5540 || (_path5540 = /*#__PURE__*/React.createElement("path", {
    d: "M20 85h1v1h-1z",
    fill: "#4e9d4e",
    fillOpacity: 0.165
  })), _path5541 || (_path5541 = /*#__PURE__*/React.createElement("path", {
    d: "M21 86v-1h1v1z",
    fill: "#fffff2",
    fillOpacity: 0.082
  })), _path5542 || (_path5542 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86h-1v-1h1z",
    fill: "#afc999",
    fillOpacity: 0.392
  })), _path5543 || (_path5543 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#91b676",
    fillOpacity: 0.329
  })), _path5544 || (_path5544 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#69a248",
    fillOpacity: 0.333
  })), _path5545 || (_path5545 = /*#__PURE__*/React.createElement("path", {
    d: "M25 85h1v1h-1z",
    fill: "#48992a",
    fillOpacity: 0.69
  })), _path5546 || (_path5546 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h-1v-1h1z",
    fill: "#3f921b",
    fillOpacity: 0.882
  })), _path5547 || (_path5547 = /*#__PURE__*/React.createElement("path", {
    d: "M27 85h1v1h-1z",
    fill: "#7fb646",
    fillOpacity: 0.902
  })), _path5548 || (_path5548 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86v-1h1v1z",
    fill: "#88bb4c"
  })), _path5549 || (_path5549 = /*#__PURE__*/React.createElement("path", {
    d: "M30 85v1h-1v-1z",
    fill: "#69a93b",
    fillOpacity: 0.992
  })), _path5550 || (_path5550 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1z",
    fill: "#4fa425",
    fillOpacity: 0.961
  })), _path5551 || (_path5551 = /*#__PURE__*/React.createElement("path", {
    d: "M32 85v1h-1v-1z",
    fill: "#47a524",
    fillOpacity: 0.996
  })), _path5552 || (_path5552 = /*#__PURE__*/React.createElement("path", {
    d: "M33 85v1h-1v-1z",
    fill: "#28971a"
  })), _path5553 || (_path5553 = /*#__PURE__*/React.createElement("path", {
    d: "M34 86h-1v-1h1z",
    fill: "#0f8811"
  })), _path5554 || (_path5554 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#07800c"
  })), _path5555 || (_path5555 = /*#__PURE__*/React.createElement("path", {
    d: "M35 85h1v1h-1z",
    fill: "#096d07"
  })), _path5556 || (_path5556 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#0c6408"
  })), _path5557 || (_path5557 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#36931c"
  })), _path5558 || (_path5558 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#51a425"
  })), _path5559 || (_path5559 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#529c30"
  })), _path5560 || (_path5560 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1z",
    fill: "#5caa36"
  })), _path5561 || (_path5561 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#479d28"
  })), _path5562 || (_path5562 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#6cbd39"
  })), _path5563 || (_path5563 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#68b633"
  })), _path5564 || (_path5564 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#71af34"
  })), _path5565 || (_path5565 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#276717"
  })), _path5566 || (_path5566 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h1z",
    fill: "#91bd4d"
  })), _path5567 || (_path5567 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85h1v1h-1z",
    fill: "#83b341"
  })), _path5568 || (_path5568 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#37711d"
  })), _path5569 || (_path5569 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#0a4109"
  })), _path5570 || (_path5570 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h1v1z",
    fill: "#126919"
  })), _path5571 || (_path5571 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#249a27"
  })), _path5572 || (_path5572 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#259f25"
  })), _path5573 || (_path5573 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#117911"
  })), _path5574 || (_path5574 = /*#__PURE__*/React.createElement("path", {
    d: "M55 85h1v1h-1z",
    fill: "#257818"
  })), _path5575 || (_path5575 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#1e7714"
  })), _path5576 || (_path5576 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#3e8620"
  })), _path5577 || (_path5577 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#458a21"
  })), _path5578 || (_path5578 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#55a921"
  })), _path5579 || (_path5579 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#63bb20"
  })), _path5580 || (_path5580 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#61ab1e"
  })), _path5581 || (_path5581 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#6bae2a"
  })), _path5582 || (_path5582 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#72bc36"
  })), _path5583 || (_path5583 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86h-1v-1h1z",
    fill: "#68b329"
  })), _path5584 || (_path5584 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1z",
    fill: "#7dbe3f"
  })), _path5585 || (_path5585 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#4a9533"
  })), _path5586 || (_path5586 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#286e19"
  })), _path5587 || (_path5587 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#62bf27"
  })), _path5588 || (_path5588 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#61b135"
  })), _path5589 || (_path5589 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#166b14"
  })), _path5590 || (_path5590 = /*#__PURE__*/React.createElement("path", {
    d: "M73 85v1h-1v-1z",
    fill: "#0b600e"
  })), _path5591 || (_path5591 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#195914"
  })), _path5592 || (_path5592 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#076106"
  })), _path5593 || (_path5593 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#228f17"
  })), _path5594 || (_path5594 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#1b5f15"
  })), _path5595 || (_path5595 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#076608"
  })), _path5596 || (_path5596 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#188613"
  })), _path5597 || (_path5597 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#127c1d"
  })), _path5598 || (_path5598 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#2ba225"
  })), _path5599 || (_path5599 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#52b336"
  })), _path5600 || (_path5600 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#299928"
  })), _path5601 || (_path5601 = /*#__PURE__*/React.createElement("path", {
    d: "M83 85h1v1h-1z",
    fill: "#0b7409"
  })), _path5602 || (_path5602 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#09780b"
  })), _path5603 || (_path5603 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1z",
    fill: "#2c9b1e"
  })), _path5604 || (_path5604 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85h1v1h-1z",
    fill: "#47af2f"
  })), _path5605 || (_path5605 = /*#__PURE__*/React.createElement("path", {
    d: "M87 85h1v1h-1z",
    fill: "#40a239"
  })), _path5606 || (_path5606 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86v-1h1v1z",
    fill: "#2a9624"
  })), _path5607 || (_path5607 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85v1h-1v-1z",
    fill: "#2fa12d"
  })), _path5608 || (_path5608 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86v-1h1v1z",
    fill: "#4aac35"
  })), _path5609 || (_path5609 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85h1v1h-1z",
    fill: "#6cb841"
  })), _path5610 || (_path5610 = /*#__PURE__*/React.createElement("path", {
    d: "M93 86h-1v-1h1z",
    fill: "#61b241"
  })), _path5611 || (_path5611 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85v1h-1v-1z",
    fill: "#4ea133"
  })), _path5612 || (_path5612 = /*#__PURE__*/React.createElement("path", {
    d: "M94 85h1v1h-1z",
    fill: "#59ab38"
  })), _path5613 || (_path5613 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86h-1v-1h1z",
    fill: "#60b337"
  })), _path5614 || (_path5614 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h-1v-1h1z",
    fill: "#6cb43d"
  })), _path5615 || (_path5615 = /*#__PURE__*/React.createElement("path", {
    d: "M98 86h-1v-1h1z",
    fill: "#2b911a"
  })), _path5616 || (_path5616 = /*#__PURE__*/React.createElement("path", {
    d: "M99 85v1h-1v-1z",
    fill: "#5bb544"
  })), _path5617 || (_path5617 = /*#__PURE__*/React.createElement("path", {
    d: "M100 85v1h-1v-1z",
    fill: "#489d37"
  })), _path5618 || (_path5618 = /*#__PURE__*/React.createElement("path", {
    d: "M100 86v-1h1v1z",
    fill: "#24821d",
    fillOpacity: 0.886
  })), _path5619 || (_path5619 = /*#__PURE__*/React.createElement("path", {
    d: "M102 85v1h-1v-1z",
    fill: "#30a526",
    fillOpacity: 0.941
  })), _path5620 || (_path5620 = /*#__PURE__*/React.createElement("path", {
    d: "M103 86h-1v-1h1z",
    fill: "#1b9713",
    fillOpacity: 0.925
  })), _path5621 || (_path5621 = /*#__PURE__*/React.createElement("path", {
    d: "M103 85h1v1h-1z",
    fill: "#41a13d",
    fillOpacity: 0.459
  })), _path5622 || (_path5622 = /*#__PURE__*/React.createElement("path", {
    d: "M104 85h1v1h-1z",
    fill: "#4ea63c",
    fillOpacity: 0.976
  })), _path5623 || (_path5623 = /*#__PURE__*/React.createElement("path", {
    d: "M105 86v-1h1v1z",
    fill: "#5eaf45",
    fillOpacity: 0.851
  })), _path5624 || (_path5624 = /*#__PURE__*/React.createElement("path", {
    d: "M107 85v1h-1v-1z",
    fill: "#60aa45",
    fillOpacity: 0.843
  })), _path5625 || (_path5625 = /*#__PURE__*/React.createElement("path", {
    d: "M107 85h1v1h-1z",
    fill: "#45a62f",
    fillOpacity: 0.529
  })), _path5626 || (_path5626 = /*#__PURE__*/React.createElement("path", {
    d: "M109 86h-1v-1h1z",
    fill: "#2f9a29",
    fillOpacity: 0.529
  })), _path5627 || (_path5627 = /*#__PURE__*/React.createElement("path", {
    d: "M110 86h-1v-1h1z",
    fill: "#2a9b27",
    fillOpacity: 0.561
  })), _path5628 || (_path5628 = /*#__PURE__*/React.createElement("path", {
    d: "M110 85h1v1h-1z",
    fill: "#22991f",
    fillOpacity: 0.608
  })), _path5629 || (_path5629 = /*#__PURE__*/React.createElement("path", {
    d: "M112 85v1h-1v-1z",
    fill: "#22941d",
    fillOpacity: 0.608
  })), _path5630 || (_path5630 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86h-1v-1h1z",
    fill: "#43a223",
    fillOpacity: 0.565
  })), _path5631 || (_path5631 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86v-1h1v1z",
    fill: "#66aa31",
    fillOpacity: 0.51
  })), _path5632 || (_path5632 = /*#__PURE__*/React.createElement("path", {
    d: "M114 86v-1h1v1z",
    fill: "#7faf3e",
    fillOpacity: 0.4
  })), _path5633 || (_path5633 = /*#__PURE__*/React.createElement("path", {
    d: "M115 85h1v1h-1z",
    fill: "#95b75f",
    fillOpacity: 0.294
  })), _path5634 || (_path5634 = /*#__PURE__*/React.createElement("path", {
    d: "M117 85v1h-1v-1z",
    fill: "#aec98c",
    fillOpacity: 0.149
  })), _path5635 || (_path5635 = /*#__PURE__*/React.createElement("path", {
    d: "M118 86h-1v-1h1z",
    fill: "#ffffd4",
    fillOpacity: 0.024
  })), _path5636 || (_path5636 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86v1h-1v-1z",
    fill: "#7dbc59",
    fillOpacity: 0.302
  })), _path5637 || (_path5637 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86h1v1h-1z",
    fill: "#5ca837",
    fillOpacity: 0.706
  })), _path5638 || (_path5638 = /*#__PURE__*/React.createElement("path", {
    d: "M17 87v-1h1v1z",
    fill: "#4a9928",
    fillOpacity: 0.588
  })), _path5639 || (_path5639 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h-1v-1h1z",
    fill: "#33911d",
    fillOpacity: 0.137
  })), _path5640 || (_path5640 = /*#__PURE__*/React.createElement("path", {
    d: "M22 86h1v1h-1z",
    fill: "#93ab6b",
    fillOpacity: 0.204
  })), _path5641 || (_path5641 = /*#__PURE__*/React.createElement("path", {
    d: "M24 87h-1v-1h1z",
    fill: "#81a45a",
    fillOpacity: 0.255
  })), _path5642 || (_path5642 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#6a9f4a",
    fillOpacity: 0.188
  })), _path5643 || (_path5643 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#4b9d2d",
    fillOpacity: 0.133
  })), _path5644 || (_path5644 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#3f8c26",
    fillOpacity: 0.078
  })), _path5645 || (_path5645 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v1h-1z",
    fill: "#79a559",
    fillOpacity: 0.247
  })), _path5646 || (_path5646 = /*#__PURE__*/React.createElement("path", {
    d: "M29 87h-1v-1h1z",
    fill: "#97c760",
    fillOpacity: 0.969
  })), _path5647 || (_path5647 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86h1v1h-1z",
    fill: "#95c661",
    fillOpacity: 0.914
  })), _path5648 || (_path5648 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87h-1v-1h1z",
    fill: "#64a54b",
    fillOpacity: 0.467
  })), _path5649 || (_path5649 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87v-1h1v1z",
    fill: "#3fa628",
    fillOpacity: 0.941
  })), _path5650 || (_path5650 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86v1h-1v-1z",
    fill: "#15850e"
  })), _path5651 || (_path5651 = /*#__PURE__*/React.createElement("path", {
    d: "M33 86h1v1h-1z",
    fill: "#037207"
  })), _path5652 || (_path5652 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#07890c"
  })), _path5653 || (_path5653 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h1v1h-1z",
    fill: "#0d7305"
  })), _path5654 || (_path5654 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#3a8a1a"
  })), _path5655 || (_path5655 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#4b9c26"
  })), _path5656 || (_path5656 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#5cab2c"
  })), _path5657 || (_path5657 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#217e16"
  })), _path5658 || (_path5658 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#62a935"
  })), _path5659 || (_path5659 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#7cbc39"
  })), _path5660 || (_path5660 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#76bc3d"
  })), _path5661 || (_path5661 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#439f21"
  })), _path5662 || (_path5662 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#8ccb4a"
  })), _path5663 || (_path5663 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#458625"
  })), _path5664 || (_path5664 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#165e11"
  })), _path5665 || (_path5665 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#2d731a"
  })), _path5666 || (_path5666 = /*#__PURE__*/React.createElement("path", {
    d: "M49 86v1h-1v-1z",
    fill: "#72a73c"
  })), _path5667 || (_path5667 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#77ac42"
  })), _path5668 || (_path5668 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#2d6715"
  })), _path5669 || (_path5669 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#045309"
  })), _path5670 || (_path5670 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#0f7a0c"
  })), _path5671 || (_path5671 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#137814"
  })), _path5672 || (_path5672 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1z",
    fill: "#147e1f"
  })), _path5673 || (_path5673 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#1d9323"
  })), _path5674 || (_path5674 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#228620"
  })), _path5675 || (_path5675 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#246a1d"
  })), _path5676 || (_path5676 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#043902"
  })), _path5677 || (_path5677 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#67ad29"
  })), _path5678 || (_path5678 = /*#__PURE__*/React.createElement("path", {
    d: "M63 86v1h-1v-1z",
    fill: "#76b727"
  })), _path5679 || (_path5679 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#7dc72b"
  })), _path5680 || (_path5680 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#69af1d"
  })), _path5681 || (_path5681 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#599f22"
  })), _path5682 || (_path5682 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#5b8d37"
  })), _path5683 || (_path5683 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-1z",
    fill: "#143210"
  })), _path5684 || (_path5684 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#16530e"
  })), _path5685 || (_path5685 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#45af17"
  })), _path5686 || (_path5686 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#5abc2b"
  })), _path5687 || (_path5687 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#0f6a0a"
  })), _path5688 || (_path5688 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#0f580c"
  })), _path5689 || (_path5689 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#045106"
  })), _path5690 || (_path5690 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#0c710b"
  })), _path5691 || (_path5691 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#108012"
  })), _path5692 || (_path5692 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#0e660a"
  })), _path5693 || (_path5693 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#177816"
  })), _path5694 || (_path5694 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#36a42f"
  })), _path5695 || (_path5695 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#37b13a"
  })), _path5696 || (_path5696 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#178e13"
  })), _path5697 || (_path5697 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#51b636"
  })), _path5698 || (_path5698 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#19991d"
  })), _path5699 || (_path5699 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h-1v-1h1z",
    fill: "#25a02b"
  })), _path5700 || (_path5700 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#4daf3c"
  })), _path5701 || (_path5701 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#42af2d"
  })), _path5702 || (_path5702 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1z",
    fill: "#45b034"
  })), _path5703 || (_path5703 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-1h1v1z",
    fill: "#41aa39"
  })), _path5704 || (_path5704 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86h1v1h-1z",
    fill: "#4cb142"
  })), _path5705 || (_path5705 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v-1h1v1z",
    fill: "#4faf41"
  })), _path5706 || (_path5706 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86h1v1h-1z",
    fill: "#50a340"
  })), _path5707 || (_path5707 = /*#__PURE__*/React.createElement("path", {
    d: "M91 86h1v1h-1z",
    fill: "#37852d"
  })), _path5708 || (_path5708 = /*#__PURE__*/React.createElement("path", {
    d: "M92 87v-1h1v1z",
    fill: "#4b962f"
  })), _path5709 || (_path5709 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-1h1z",
    fill: "#75c645"
  })), _path5710 || (_path5710 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87v-1h1v1z",
    fill: "#83ca4a"
  })), _path5711 || (_path5711 = /*#__PURE__*/React.createElement("path", {
    d: "M96 86v1h-1v-1z",
    fill: "#82c44b"
  })), _path5712 || (_path5712 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v-1h1v1z",
    fill: "#74b53e"
  })), _path5713 || (_path5713 = /*#__PURE__*/React.createElement("path", {
    d: "M97 86h1v1h-1z",
    fill: "#66b738"
  })), _path5714 || (_path5714 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87v-1h1v1z",
    fill: "#4fa336"
  })), _path5715 || (_path5715 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87v-1h1v1z",
    fill: "#44932f"
  })), _path5716 || (_path5716 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87h-1v-1h1z",
    fill: "#459c32"
  })), _path5717 || (_path5717 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86v1h-1v-1z",
    fill: "#20921b",
    fillOpacity: 0.973
  })), _path5718 || (_path5718 = /*#__PURE__*/React.createElement("path", {
    d: "M102 86h1v1h-1z",
    fill: "#2d9d1e",
    fillOpacity: 0.749
  })), _path5719 || (_path5719 = /*#__PURE__*/React.createElement("path", {
    d: "M104 87h-1v-1h1z",
    fill: "#3da42f",
    fillOpacity: 0.718
  })), _path5720 || (_path5720 = /*#__PURE__*/React.createElement("path", {
    d: "M105 87h-1v-1h1z",
    fill: "#3b8f2d",
    fillOpacity: 0.486
  })), _path5721 || (_path5721 = /*#__PURE__*/React.createElement("path", {
    d: "M106 86v1h-1v-1z",
    fill: "#5cab40",
    fillOpacity: 0.78
  })), _path5722 || (_path5722 = /*#__PURE__*/React.createElement("path", {
    d: "M106 87v-1h1v1z",
    fill: "#52a33b",
    fillOpacity: 0.643
  })), _path5723 || (_path5723 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87h-1v-1h1z",
    fill: "#52ac34",
    fillOpacity: 0.498
  })), _path5724 || (_path5724 = /*#__PURE__*/React.createElement("path", {
    d: "M108 87v-1h1v1z",
    fill: "#259620",
    fillOpacity: 0.4
  })), _path5725 || (_path5725 = /*#__PURE__*/React.createElement("path", {
    d: "M109 87v-1h1v1z",
    fill: "#1f951d",
    fillOpacity: 0.408
  })), _path5726 || (_path5726 = /*#__PURE__*/React.createElement("path", {
    d: "M110 86h1v1h-1z",
    fill: "#1c9314",
    fillOpacity: 0.392
  })), _path5727 || (_path5727 = /*#__PURE__*/React.createElement("path", {
    d: "M112 87h-1v-1h1z",
    fill: "#2e9a29",
    fillOpacity: 0.388
  })), _path5728 || (_path5728 = /*#__PURE__*/React.createElement("path", {
    d: "M113 86v1h-1v-1z",
    fill: "#68af44",
    fillOpacity: 0.392
  })), _path5729 || (_path5729 = /*#__PURE__*/React.createElement("path", {
    d: "M114 87h-1v-1h1z",
    fill: "#6eb33e",
    fillOpacity: 0.145
  })), _path5730 || (_path5730 = /*#__PURE__*/React.createElement("path", {
    d: "M114 87v-1h1v1z",
    fill: "#8ab43f",
    fillOpacity: 0.094
  })), _path5731 || (_path5731 = /*#__PURE__*/React.createElement("path", {
    d: "M115 86h1v1h-1z",
    fill: "#9fbf5f",
    fillOpacity: 0.063
  })), _path5732 || (_path5732 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v1h-1v-1z",
    fill: "#7fbb5a",
    fillOpacity: 0.133
  })), _path5733 || (_path5733 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h1v1h-1z",
    fill: "#67ae3f",
    fillOpacity: 0.58
  })), _path5734 || (_path5734 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88h-1v-1h1z",
    fill: "#559e2e",
    fillOpacity: 0.643
  })), _path5735 || (_path5735 = /*#__PURE__*/React.createElement("path", {
    d: "M16 87h1v1h-1z",
    fill: "#479a29",
    fillOpacity: 0.239
  })), _path5736 || (_path5736 = /*#__PURE__*/React.createElement("path", {
    d: "M27 87h1v1h-1z",
    fill: "#667f66",
    fillOpacity: 0.039
  })), _path5737 || (_path5737 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v-1h1v1z",
    fill: "#88ab69",
    fillOpacity: 0.227
  })), _path5738 || (_path5738 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88h-1v-1h1z",
    fill: "#a6d677",
    fillOpacity: 0.773
  })), _path5739 || (_path5739 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1z",
    fill: "#78b948",
    fillOpacity: 0.949
  })), _path5740 || (_path5740 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h1z",
    fill: "#1d9916",
    fillOpacity: 0.992
  })), _path5741 || (_path5741 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88h-1v-1h1z",
    fill: "#198c18"
  })), _path5742 || (_path5742 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#1a7d11"
  })), _path5743 || (_path5743 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#289c17"
  })), _path5744 || (_path5744 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#3d8c2e",
    fillOpacity: 0.965
  })), _path5745 || (_path5745 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#5d9641",
    fillOpacity: 0.89
  })), _path5746 || (_path5746 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#7cb94c"
  })), _path5747 || (_path5747 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#4a9720"
  })), _path5748 || (_path5748 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#7ec439"
  })), _path5749 || (_path5749 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#7fbd3d"
  })), _path5750 || (_path5750 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#3f972a"
  })), _path5751 || (_path5751 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#74bb3c"
  })), _path5752 || (_path5752 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#84be3b"
  })), _path5753 || (_path5753 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#0d5604"
  })), _path5754 || (_path5754 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#005b01"
  })), _path5755 || (_path5755 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#085306"
  })), _path5756 || (_path5756 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#478527"
  })), _path5757 || (_path5757 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#7db240"
  })), _path5758 || (_path5758 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#408d1d"
  })), _path5759 || (_path5759 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#075f04"
  })), _path5760 || (_path5760 = /*#__PURE__*/React.createElement("path", {
    d: "M53 88v-1h1v1z",
    fill: "#025205"
  })), _path5761 || (_path5761 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#074f05"
  })), _path5762 || (_path5762 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#22851f"
  })), _path5763 || (_path5763 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#248d1e"
  })), _path5764 || (_path5764 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#2d8428"
  })), _path5765 || (_path5765 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#116f19"
  })), _path5766 || (_path5766 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#1a7615"
  })), _path5767 || (_path5767 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#15680f"
  })), _path5768 || (_path5768 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#2d7821"
  })), _path5769 || (_path5769 = /*#__PURE__*/React.createElement("path", {
    d: "M62 88v-1h1v1z",
    fill: "#60a434"
  })), _path5770 || (_path5770 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87v1h-1v-1z",
    fill: "#7fc939"
  })), _path5771 || (_path5771 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#57aa15"
  })), _path5772 || (_path5772 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#3f9522"
  })), _path5773 || (_path5773 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#032f04"
  })), _path5774 || (_path5774 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#032504"
  })), _path5775 || (_path5775 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#084d0b"
  })), _path5776 || (_path5776 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#3ea212"
  })), _path5777 || (_path5777 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#7cc433"
  })), _path5778 || (_path5778 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#70b53a"
  })), _path5779 || (_path5779 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87v1h-1v-1z",
    fill: "#0f680e"
  })), _path5780 || (_path5780 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#328e26"
  })), _path5781 || (_path5781 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#51b73e"
  })), _path5782 || (_path5782 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#1e8d19"
  })), _path5783 || (_path5783 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#44b141"
  })), _path5784 || (_path5784 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#5db74f"
  })), _path5785 || (_path5785 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#64b450"
  })), _path5786 || (_path5786 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#339c28"
  })), _path5787 || (_path5787 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#4ab02f"
  })), _path5788 || (_path5788 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#4ab335"
  })), _path5789 || (_path5789 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#279f2b"
  })), _path5790 || (_path5790 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1z",
    fill: "#2f9b22"
  })), _path5791 || (_path5791 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#40a725"
  })), _path5792 || (_path5792 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h1v1z",
    fill: "#217714"
  })), _path5793 || (_path5793 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h1v1h-1z",
    fill: "#54b138"
  })), _path5794 || (_path5794 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v1h-1v-1z",
    fill: "#43a23a"
  })), _path5795 || (_path5795 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87h1v1h-1z",
    fill: "#1a6e18"
  })), _path5796 || (_path5796 = /*#__PURE__*/React.createElement("path", {
    d: "M91 87v1h-1v-1z",
    fill: "#4c943e"
  })), _path5797 || (_path5797 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88v-1h1v1z",
    fill: "#3a8125"
  })), _path5798 || (_path5798 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v1h-1v-1z",
    fill: "#54a334"
  })), _path5799 || (_path5799 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87h1v1h-1z",
    fill: "#278215"
  })), _path5800 || (_path5800 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h1v1h-1z",
    fill: "#509d2b"
  })), _path5801 || (_path5801 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87v1h-1v-1z",
    fill: "#a7dd67"
  })), _path5802 || (_path5802 = /*#__PURE__*/React.createElement("path", {
    d: "M96 87h1v1h-1z",
    fill: "#a2d267"
  })), _path5803 || (_path5803 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87v1h-1v-1z",
    fill: "#7fbd42"
  })), _path5804 || (_path5804 = /*#__PURE__*/React.createElement("path", {
    d: "M98 87h1v1h-1z",
    fill: "#71b83c"
  })), _path5805 || (_path5805 = /*#__PURE__*/React.createElement("path", {
    d: "M99 87h1v1h-1z",
    fill: "#61a240",
    fillOpacity: 0.839
  })), _path5806 || (_path5806 = /*#__PURE__*/React.createElement("path", {
    d: "M101 87v1h-1v-1z",
    fill: "#6fb65a",
    fillOpacity: 0.706
  })), _path5807 || (_path5807 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88h-1v-1h1z",
    fill: "#41a42c",
    fillOpacity: 0.784
  })), _path5808 || (_path5808 = /*#__PURE__*/React.createElement("path", {
    d: "M102 87h1v1h-1z",
    fill: "#7fb56b",
    fillOpacity: 0.298
  })), _path5809 || (_path5809 = /*#__PURE__*/React.createElement("path", {
    d: "M103 87h1v1h-1z",
    fill: "#6aa550",
    fillOpacity: 0.235
  })), _path5810 || (_path5810 = /*#__PURE__*/React.createElement("path", {
    d: "M105 88v-1h1v1z",
    fill: "#99c87f",
    fillOpacity: 0.455
  })), _path5811 || (_path5811 = /*#__PURE__*/React.createElement("path", {
    d: "M106 88v-1h1v1z",
    fill: "#cfe7bc",
    fillOpacity: 0.212
  })), _path5812 || (_path5812 = /*#__PURE__*/React.createElement("path", {
    d: "M107 88v-1h1v1z",
    fill: "#d1debd",
    fillOpacity: 0.153
  })), _path5813 || (_path5813 = /*#__PURE__*/React.createElement("path", {
    d: "M111 87h1v1h-1z",
    fill: "#76ba58",
    fillOpacity: 0.439
  })), _path5814 || (_path5814 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88v-1h1v1z",
    fill: "#69a84e",
    fillOpacity: 0.6
  })), _path5815 || (_path5815 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89h-1v-1h1z",
    fill: "#9b7",
    fillOpacity: 0.059
  })), _path5816 || (_path5816 = /*#__PURE__*/React.createElement("path", {
    d: "M13 88v1h-1v-1z",
    fill: "#7dae4e",
    fillOpacity: 0.408
  })), _path5817 || (_path5817 = /*#__PURE__*/React.createElement("path", {
    d: "M13 89v-1h1v1z",
    fill: "#69a641",
    fillOpacity: 0.6
  })), _path5818 || (_path5818 = /*#__PURE__*/React.createElement("path", {
    d: "M14 88h1v1h-1z",
    fill: "#56a130",
    fillOpacity: 0.267
  })), _path5819 || (_path5819 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88v1h-1v-1z",
    fill: "#68b05b",
    fillOpacity: 0.153
  })), _path5820 || (_path5820 = /*#__PURE__*/React.createElement("path", {
    d: "M28 88h1v1h-1z",
    fill: "#2f9d2d",
    fillOpacity: 0.573
  })), _path5821 || (_path5821 = /*#__PURE__*/React.createElement("path", {
    d: "M30 88v1h-1v-1z",
    fill: "#369d26",
    fillOpacity: 0.929
  })), _path5822 || (_path5822 = /*#__PURE__*/React.createElement("path", {
    d: "M30 89v-1h1v1z",
    fill: "#9ace5e",
    fillOpacity: 0.961
  })), _path5823 || (_path5823 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v-1h1v1z",
    fill: "#56b028"
  })), _path5824 || (_path5824 = /*#__PURE__*/React.createElement("path", {
    d: "M32 89v-1h1v1z",
    fill: "#3b9f28"
  })), _path5825 || (_path5825 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1z",
    fill: "#7cb54a",
    fillOpacity: 0.922
  })), _path5826 || (_path5826 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v1h-1v-1z",
    fill: "#55a430",
    fillOpacity: 0.804
  })), _path5827 || (_path5827 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#429a33",
    fillOpacity: 0.902
  })), _path5828 || (_path5828 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1z",
    fill: "#3d9132",
    fillOpacity: 0.988
  })), _path5829 || (_path5829 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#4b933b",
    fillOpacity: 0.949
  })), _path5830 || (_path5830 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#84bc4b"
  })), _path5831 || (_path5831 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#5db028"
  })), _path5832 || (_path5832 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#54a21f"
  })), _path5833 || (_path5833 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#8bc73a"
  })), _path5834 || (_path5834 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#6eb331"
  })), _path5835 || (_path5835 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#509d35"
  })), _path5836 || (_path5836 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#5da733"
  })), _path5837 || (_path5837 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#8fcb49"
  })), _path5838 || (_path5838 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#49891c"
  })), _path5839 || (_path5839 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#015707"
  })), _path5840 || (_path5840 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#015202"
  })), _path5841 || (_path5841 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#1d6d17"
  })), _path5842 || (_path5842 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#64a436"
  })), _path5843 || (_path5843 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1z",
    fill: "#41881f"
  })), _path5844 || (_path5844 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#095605"
  })), _path5845 || (_path5845 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#187e16"
  })), _path5846 || (_path5846 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#1e6811"
  })), _path5847 || (_path5847 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#116a16"
  })), _path5848 || (_path5848 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#137418"
  })), _path5849 || (_path5849 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#268b21"
  })), _path5850 || (_path5850 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#1b711c"
  })), _path5851 || (_path5851 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#5e9f37"
  })), _path5852 || (_path5852 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h1v1h-1z",
    fill: "#7dcb43"
  })), _path5853 || (_path5853 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v1h-1v-1z",
    fill: "#5aa731"
  })), _path5854 || (_path5854 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#0e6b05"
  })), _path5855 || (_path5855 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#023d04"
  })), _path5856 || (_path5856 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#054e06"
  })), _path5857 || (_path5857 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#1b6f0a"
  })), _path5858 || (_path5858 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#70bd26"
  })), _path5859 || (_path5859 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#93d148"
  })), _path5860 || (_path5860 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#5cad3c"
  })), _path5861 || (_path5861 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#186e0d"
  })), _path5862 || (_path5862 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#045408"
  })), _path5863 || (_path5863 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1z",
    fill: "#2b851d"
  })), _path5864 || (_path5864 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#57b639"
  })), _path5865 || (_path5865 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#1c921b"
  })), _path5866 || (_path5866 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#178a17"
  })), _path5867 || (_path5867 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#12570f"
  })), _path5868 || (_path5868 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#0f3f0d"
  })), _path5869 || (_path5869 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#1f751f"
  })), _path5870 || (_path5870 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1z",
    fill: "#359d1f"
  })), _path5871 || (_path5871 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1z",
    fill: "#61b240"
  })), _path5872 || (_path5872 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#369724"
  })), _path5873 || (_path5873 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#2a9d20"
  })), _path5874 || (_path5874 = /*#__PURE__*/React.createElement("path", {
    d: "M86 89h-1v-1h1z",
    fill: "#338a26"
  })), _path5875 || (_path5875 = /*#__PURE__*/React.createElement("path", {
    d: "M87 88v1h-1v-1z",
    fill: "#0a5606"
  })), _path5876 || (_path5876 = /*#__PURE__*/React.createElement("path", {
    d: "M88 88v1h-1v-1z",
    fill: "#65b941"
  })), _path5877 || (_path5877 = /*#__PURE__*/React.createElement("path", {
    d: "M89 89h-1v-1h1z",
    fill: "#5cb342"
  })), _path5878 || (_path5878 = /*#__PURE__*/React.createElement("path", {
    d: "M89 88h1v1h-1z",
    fill: "#40942c"
  })), _path5879 || (_path5879 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89h-1v-1h1z",
    fill: "#65b748"
  })), _path5880 || (_path5880 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88h1v1h-1z",
    fill: "#3d862e"
  })), _path5881 || (_path5881 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v-1h1v1z",
    fill: "#065806"
  })), _path5882 || (_path5882 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89v-1h1v1z",
    fill: "#61aa3c"
  })), _path5883 || (_path5883 = /*#__PURE__*/React.createElement("path", {
    d: "M95 88h1v1h-1z",
    fill: "#47992b"
  })), _path5884 || (_path5884 = /*#__PURE__*/React.createElement("path", {
    d: "M97 88v1h-1v-1z",
    fill: "#69af40"
  })), _path5885 || (_path5885 = /*#__PURE__*/React.createElement("path", {
    d: "M98 89h-1v-1h1z",
    fill: "#a1db62"
  })), _path5886 || (_path5886 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89h-1v-1h1z",
    fill: "#81c349"
  })), _path5887 || (_path5887 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89v-1h1v1z",
    fill: "#77be47",
    fillOpacity: 0.871
  })), _path5888 || (_path5888 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89h-1v-1h1z",
    fill: "#5db43e",
    fillOpacity: 0.8
  })), _path5889 || (_path5889 = /*#__PURE__*/React.createElement("path", {
    d: "M102 88v1h-1v-1z",
    fill: "#369f25",
    fillOpacity: 0.902
  })), _path5890 || (_path5890 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89h-1v-1h1z",
    fill: "#7ab25b",
    fillOpacity: 0.459
  })), _path5891 || (_path5891 = /*#__PURE__*/React.createElement("path", {
    d: "M104 88v1h-1v-1z",
    fill: "#996",
    fillOpacity: 0.02
  })), _path5892 || (_path5892 = /*#__PURE__*/React.createElement("path", {
    d: "M105 88h1v1h-1z",
    fill: "#91bd74",
    fillOpacity: 0.412
  })), _path5893 || (_path5893 = /*#__PURE__*/React.createElement("path", {
    d: "M107 88v1h-1v-1z",
    fill: "#b6d4a1",
    fillOpacity: 0.235
  })), _path5894 || (_path5894 = /*#__PURE__*/React.createElement("path", {
    d: "M108 88v1h-1v-1z",
    fill: "#b7d0a1",
    fillOpacity: 0.278
  })), _path5895 || (_path5895 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88v1h-1v-1z",
    fill: "#87c378",
    fillOpacity: 0.133
  })), _path5896 || (_path5896 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88h1v1h-1z",
    fill: "#52a538",
    fillOpacity: 0.812
  })), _path5897 || (_path5897 = /*#__PURE__*/React.createElement("path", {
    d: "M112 88h1v1h-1z",
    fill: "#64ad47",
    fillOpacity: 0.42
  })), _path5898 || (_path5898 = /*#__PURE__*/React.createElement("path", {
    d: "M113 88h1v1h-1z",
    fill: "#a0c67a",
    fillOpacity: 0.106
  })), _path5899 || (_path5899 = /*#__PURE__*/React.createElement("path", {
    d: "M11 90h-1v-1h1z",
    fill: "#89b856",
    fillOpacity: 0.255
  })), _path5900 || (_path5900 = /*#__PURE__*/React.createElement("path", {
    d: "M12 89v1h-1v-1z",
    fill: "#80ab4d",
    fillOpacity: 0.529
  })), _path5901 || (_path5901 = /*#__PURE__*/React.createElement("path", {
    d: "M12 90v-1h1v1z",
    fill: "#78aa4a",
    fillOpacity: 0.365
  })), _path5902 || (_path5902 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1z",
    fill: "#72a757",
    fillOpacity: 0.114
  })), _path5903 || (_path5903 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90v-1h1v1z",
    fill: "#7aae55",
    fillOpacity: 0.424
  })), _path5904 || (_path5904 = /*#__PURE__*/React.createElement("path", {
    d: "M28 90h-1v-1h1z",
    fill: "#5ea33f",
    fillOpacity: 0.698
  })), _path5905 || (_path5905 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89v1h-1v-1z",
    fill: "#3ea12e",
    fillOpacity: 0.557
  })), _path5906 || (_path5906 = /*#__PURE__*/React.createElement("path", {
    d: "M29 89h1v1h-1z",
    fill: "#3d9527",
    fillOpacity: 0.227
  })), _path5907 || (_path5907 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89v1h-1v-1z",
    fill: "#b0d284",
    fillOpacity: 0.204
  })), _path5908 || (_path5908 = /*#__PURE__*/React.createElement("path", {
    d: "M31 89h1v1h-1z",
    fill: "#9ac75b",
    fillOpacity: 0.816
  })), _path5909 || (_path5909 = /*#__PURE__*/React.createElement("path", {
    d: "M33 90h-1v-1h1z",
    fill: "#5dab29",
    fillOpacity: 0.988
  })), _path5910 || (_path5910 = /*#__PURE__*/React.createElement("path", {
    d: "M34 90h-1v-1h1z",
    fill: "#7fb143",
    fillOpacity: 0.635
  })), _path5911 || (_path5911 = /*#__PURE__*/React.createElement("path", {
    d: "M34 89h1v1h-1z",
    fill: "#7fb04c",
    fillOpacity: 0.447
  })), _path5912 || (_path5912 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#4e9d33",
    fillOpacity: 0.608
  })), _path5913 || (_path5913 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#47a429"
  })), _path5914 || (_path5914 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1z",
    fill: "#278c16"
  })), _path5915 || (_path5915 = /*#__PURE__*/React.createElement("path", {
    d: "M38 89h1v1h-1z",
    fill: "#8bc44b"
  })), _path5916 || (_path5916 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#499727"
  })), _path5917 || (_path5917 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#23790e"
  })), _path5918 || (_path5918 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#57ac27"
  })), _path5919 || (_path5919 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#27900d"
  })), _path5920 || (_path5920 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#4b9a2c"
  })), _path5921 || (_path5921 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#7eb84b"
  })), _path5922 || (_path5922 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#88bd3c"
  })), _path5923 || (_path5923 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#145f0b"
  })), _path5924 || (_path5924 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#187514"
  })), _path5925 || (_path5925 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#21861a"
  })), _path5926 || (_path5926 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#116805"
  })), _path5927 || (_path5927 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#2d7e16"
  })), _path5928 || (_path5928 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#195a12"
  })), _path5929 || (_path5929 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#0f5e0d"
  })), _path5930 || (_path5930 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#248716"
  })), _path5931 || (_path5931 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#268f1a"
  })), _path5932 || (_path5932 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#177713"
  })), _path5933 || (_path5933 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#094808"
  })), _path5934 || (_path5934 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#104d0b"
  })), _path5935 || (_path5935 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#368c29"
  })), _path5936 || (_path5936 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#71b246"
  })), _path5937 || (_path5937 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v-1h1v1z",
    fill: "#72c339"
  })), _path5938 || (_path5938 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#359421"
  })), _path5939 || (_path5939 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#03730a"
  })), _path5940 || (_path5940 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#0e6706"
  })), _path5941 || (_path5941 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#389316"
  })), _path5942 || (_path5942 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#67bb2d"
  })), _path5943 || (_path5943 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#75c93f"
  })), _path5944 || (_path5944 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#39a421"
  })), _path5945 || (_path5945 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#0f7712"
  })), _path5946 || (_path5946 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#053f0a"
  })), _path5947 || (_path5947 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#034905"
  })), _path5948 || (_path5948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#289516"
  })), _path5949 || (_path5949 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#4aae2c"
  })), _path5950 || (_path5950 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#0b7a06"
  })), _path5951 || (_path5951 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#198d13"
  })), _path5952 || (_path5952 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#074e09"
  })), _path5953 || (_path5953 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#034004"
  })), _path5954 || (_path5954 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1z",
    fill: "#024e00"
  })), _path5955 || (_path5955 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#177c10"
  })), _path5956 || (_path5956 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#318d20"
  })), _path5957 || (_path5957 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#127f09"
  })), _path5958 || (_path5958 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#41ae2d"
  })), _path5959 || (_path5959 = /*#__PURE__*/React.createElement("path", {
    d: "M85 89h1v1h-1z",
    fill: "#28921c"
  })), _path5960 || (_path5960 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90v-1h1v1z",
    fill: "#34a020"
  })), _path5961 || (_path5961 = /*#__PURE__*/React.createElement("path", {
    d: "M88 89h1v1h-1z",
    fill: "#53b837"
  })), _path5962 || (_path5962 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90v-1h1v1z",
    fill: "#3aa924"
  })), _path5963 || (_path5963 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89v1h-1v-1z",
    fill: "#47a72b"
  })), _path5964 || (_path5964 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#43902b"
  })), _path5965 || (_path5965 = /*#__PURE__*/React.createElement("path", {
    d: "M93 89v1h-1v-1z",
    fill: "#297e12"
  })), _path5966 || (_path5966 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#3e9819"
  })), _path5967 || (_path5967 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h1v1h-1z",
    fill: "#71bc3a"
  })), _path5968 || (_path5968 = /*#__PURE__*/React.createElement("path", {
    d: "M96 89v1h-1v-1z",
    fill: "#49991c"
  })), _path5969 || (_path5969 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90v-1h1v1z",
    fill: "#469719"
  })), _path5970 || (_path5970 = /*#__PURE__*/React.createElement("path", {
    d: "M98 89v1h-1v-1z",
    fill: "#71bb31"
  })), _path5971 || (_path5971 = /*#__PURE__*/React.createElement("path", {
    d: "M98 90v-1h1v1z",
    fill: "#7abc38"
  })), _path5972 || (_path5972 = /*#__PURE__*/React.createElement("path", {
    d: "M99 89h1v1h-1z",
    fill: "#66b62d"
  })), _path5973 || (_path5973 = /*#__PURE__*/React.createElement("path", {
    d: "M101 89v1h-1v-1z",
    fill: "#6ec637"
  })), _path5974 || (_path5974 = /*#__PURE__*/React.createElement("path", {
    d: "M101 90v-1h1v1z",
    fill: "#63b639",
    fillOpacity: 0.953
  })), _path5975 || (_path5975 = /*#__PURE__*/React.createElement("path", {
    d: "M103 89v1h-1v-1z",
    fill: "#9ccd78",
    fillOpacity: 0.224
  })), _path5976 || (_path5976 = /*#__PURE__*/React.createElement("path", {
    d: "M105 89h1v1h-1z",
    fill: "#85b469",
    fillOpacity: 0.322
  })), _path5977 || (_path5977 = /*#__PURE__*/React.createElement("path", {
    d: "M107 90h-1v-1h1z",
    fill: "#a2c390",
    fillOpacity: 0.333
  })), _path5978 || (_path5978 = /*#__PURE__*/React.createElement("path", {
    d: "M108 89v1h-1v-1z",
    fill: "#a3c98a",
    fillOpacity: 0.447
  })), _path5979 || (_path5979 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90v-1h1v1z",
    fill: "#b6dab6",
    fillOpacity: 0.027
  })), _path5980 || (_path5980 = /*#__PURE__*/React.createElement("path", {
    d: "M111 90h-1v-1h1z",
    fill: "#5dac49",
    fillOpacity: 0.655
  })), _path5981 || (_path5981 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90h-1v-1h1z",
    fill: "#55ab42",
    fillOpacity: 0.718
  })), _path5982 || (_path5982 = /*#__PURE__*/React.createElement("path", {
    d: "M113 90h-1v-1h1z",
    fill: "#74af51",
    fillOpacity: 0.541
  })), _path5983 || (_path5983 = /*#__PURE__*/React.createElement("path", {
    d: "M114 90h-1v-1h1z",
    fill: "#a5d287",
    fillOpacity: 0.067
  })), _path5984 || (_path5984 = /*#__PURE__*/React.createElement("path", {
    d: "M8 90v1H7v-1z",
    fill: "#f0f",
    fillOpacity: 0.004
  })), _path5985 || (_path5985 = /*#__PURE__*/React.createElement("path", {
    d: "M8 91v-1h1v1z",
    fill: "#a7c07c",
    fillOpacity: 0.161
  })), _path5986 || (_path5986 = /*#__PURE__*/React.createElement("path", {
    d: "M9 91v-1h1v1z",
    fill: "#92b959",
    fillOpacity: 0.404
  })), _path5987 || (_path5987 = /*#__PURE__*/React.createElement("path", {
    d: "M10 90h1v1h-1z",
    fill: "#83b347",
    fillOpacity: 0.251
  })), _path5988 || (_path5988 = /*#__PURE__*/React.createElement("path", {
    d: "M11 90h1v1h-1z",
    fill: "#73a245",
    fillOpacity: 0.043
  })), _path5989 || (_path5989 = /*#__PURE__*/React.createElement("path", {
    d: "M18 91v-1h1v1z",
    fill: "#bbd6ae",
    fillOpacity: 0.075
  })), _path5990 || (_path5990 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1z",
    fill: "#b3cba0",
    fillOpacity: 0.212
  })), _path5991 || (_path5991 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v-1h1v1z",
    fill: "#77b255",
    fillOpacity: 0.118
  })), _path5992 || (_path5992 = /*#__PURE__*/React.createElement("path", {
    d: "M24 90h1v1h-1z",
    fill: "#5fa53a",
    fillOpacity: 0.459
  })), _path5993 || (_path5993 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#5e9e3d",
    fillOpacity: 0.518
  })), _path5994 || (_path5994 = /*#__PURE__*/React.createElement("path", {
    d: "M26 90h1v1h-1z",
    fill: "#6ba347",
    fillOpacity: 0.196
  })), _path5995 || (_path5995 = /*#__PURE__*/React.createElement("path", {
    d: "M27 91v-1h1v1z",
    fill: "#91b66d",
    fillOpacity: 0.027
  })), _path5996 || (_path5996 = /*#__PURE__*/React.createElement("path", {
    d: "M31 90h1v1h-1z",
    fill: "#b6ce8b",
    fillOpacity: 0.165
  })), _path5997 || (_path5997 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91v-1h1v1z",
    fill: "#98c855",
    fillOpacity: 0.91
  })), _path5998 || (_path5998 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91v-1h1v1z",
    fill: "#7fb840",
    fillOpacity: 0.847
  })), _path5999 || (_path5999 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#6aad28",
    fillOpacity: 0.984
  })), _path6000 || (_path6000 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v1h-1v-1z",
    fill: "#4c9817",
    fillOpacity: 0.722
  })), _path6001 || (_path6001 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1z",
    fill: "#64b235",
    fillOpacity: 0.816
  })), _path6002 || (_path6002 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#1b860c"
  })), _path6003 || (_path6003 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1z",
    fill: "#73b03e"
  })), _path6004 || (_path6004 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#37851f"
  })), _path6005 || (_path6005 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#1b680f"
  })), _path6006 || (_path6006 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#8fca41"
  })), _path6007 || (_path6007 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#43931c"
  })), _path6008 || (_path6008 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#319912"
  })), _path6009 || (_path6009 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#359b0d"
  })), _path6010 || (_path6010 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#529b33"
  })), _path6011 || (_path6011 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#a5ce4f"
  })), _path6012 || (_path6012 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#72ae2d"
  })), _path6013 || (_path6013 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#2e8f1d"
  })), _path6014 || (_path6014 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#107f0b"
  })), _path6015 || (_path6015 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#297e1e"
  })), _path6016 || (_path6016 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v1z",
    fill: "#348324"
  })), _path6017 || (_path6017 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#337e21"
  })), _path6018 || (_path6018 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#519332"
  })), _path6019 || (_path6019 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#3c9728"
  })), _path6020 || (_path6020 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#399920"
  })), _path6021 || (_path6021 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#2a8f18"
  })), _path6022 || (_path6022 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#15680d"
  })), _path6023 || (_path6023 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#317022"
  })), _path6024 || (_path6024 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#368021"
  })), _path6025 || (_path6025 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#419e31"
  })), _path6026 || (_path6026 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#28781b"
  })), _path6027 || (_path6027 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1z",
    fill: "#71b742"
  })), _path6028 || (_path6028 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#88c642"
  })), _path6029 || (_path6029 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#4c9f23"
  })), _path6030 || (_path6030 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#209511"
  })), _path6031 || (_path6031 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#48aa22"
  })), _path6032 || (_path6032 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#73c63a"
  })), _path6033 || (_path6033 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#60bc35"
  })), _path6034 || (_path6034 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#2b961d"
  })), _path6035 || (_path6035 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90v1h-1v-1z",
    fill: "#159112"
  })), _path6036 || (_path6036 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#176014"
  })), _path6037 || (_path6037 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#024103"
  })), _path6038 || (_path6038 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91v-1h1v1z",
    fill: "#0d740f"
  })), _path6039 || (_path6039 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#35a023"
  })), _path6040 || (_path6040 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#4da130"
  })), _path6041 || (_path6041 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#43a12d"
  })), _path6042 || (_path6042 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#277d1b"
  })), _path6043 || (_path6043 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#053705"
  })), _path6044 || (_path6044 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#084e05"
  })), _path6045 || (_path6045 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#065c0a"
  })), _path6046 || (_path6046 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#147415"
  })), _path6047 || (_path6047 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#25981a"
  })), _path6048 || (_path6048 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#2ba11d"
  })), _path6049 || (_path6049 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#4bb331"
  })), _path6050 || (_path6050 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#30ad25"
  })), _path6051 || (_path6051 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91h-1v-1h1z",
    fill: "#25a423"
  })), _path6052 || (_path6052 = /*#__PURE__*/React.createElement("path", {
    d: "M87 90h1v1h-1z",
    fill: "#4aae35"
  })), _path6053 || (_path6053 = /*#__PURE__*/React.createElement("path", {
    d: "M88 91v-1h1v1z",
    fill: "#4eae36"
  })), _path6054 || (_path6054 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90h1v1h-1z",
    fill: "#4eaf32"
  })), _path6055 || (_path6055 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91v-1h1v1z",
    fill: "#2f8e16"
  })), _path6056 || (_path6056 = /*#__PURE__*/React.createElement("path", {
    d: "M92 91h-1v-1h1z",
    fill: "#539e30"
  })), _path6057 || (_path6057 = /*#__PURE__*/React.createElement("path", {
    d: "M92 90h1v1h-1z",
    fill: "#368c19"
  })), _path6058 || (_path6058 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1z",
    fill: "#6dbb3c"
  })), _path6059 || (_path6059 = /*#__PURE__*/React.createElement("path", {
    d: "M95 90v1h-1v-1z",
    fill: "#3f931c"
  })), _path6060 || (_path6060 = /*#__PURE__*/React.createElement("path", {
    d: "M96 91h-1v-1h1z",
    fill: "#60aa2d"
  })), _path6061 || (_path6061 = /*#__PURE__*/React.createElement("path", {
    d: "M96 90h1v1h-1z",
    fill: "#64b42a"
  })), _path6062 || (_path6062 = /*#__PURE__*/React.createElement("path", {
    d: "M98 91h-1v-1h1z",
    fill: "#53a929"
  })), _path6063 || (_path6063 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90v1h-1v-1z",
    fill: "#76b448",
    fillOpacity: 0.984
  })), _path6064 || (_path6064 = /*#__PURE__*/React.createElement("path", {
    d: "M99 90h1v1h-1z",
    fill: "#46a429"
  })), _path6065 || (_path6065 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v-1h1v1z",
    fill: "#2b9213"
  })), _path6066 || (_path6066 = /*#__PURE__*/React.createElement("path", {
    d: "M102 90v1h-1v-1z",
    fill: "#62b538"
  })), _path6067 || (_path6067 = /*#__PURE__*/React.createElement("path", {
    d: "M103 91h-1v-1h1z",
    fill: "#9ace6b",
    fillOpacity: 0.706
  })), _path6068 || (_path6068 = /*#__PURE__*/React.createElement("path", {
    d: "M105 91v-1h1v1z",
    fill: "#83b06f",
    fillOpacity: 0.243
  })), _path6069 || (_path6069 = /*#__PURE__*/React.createElement("path", {
    d: "M107 90v1h-1v-1z",
    fill: "#8db37a",
    fillOpacity: 0.424
  })), _path6070 || (_path6070 = /*#__PURE__*/React.createElement("path", {
    d: "M107 90h1v1h-1z",
    fill: "#81af63",
    fillOpacity: 0.918
  })), _path6071 || (_path6071 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91h-1v-1h1z",
    fill: "#87a570",
    fillOpacity: 0.133
  })), _path6072 || (_path6072 = /*#__PURE__*/React.createElement("path", {
    d: "M109 90h1v1h-1z",
    fill: "#78b863",
    fillOpacity: 0.424
  })), _path6073 || (_path6073 = /*#__PURE__*/React.createElement("path", {
    d: "M110 90h1v1h-1z",
    fill: "#64ae4d",
    fillOpacity: 0.675
  })), _path6074 || (_path6074 = /*#__PURE__*/React.createElement("path", {
    d: "M112 90v1h-1v-1z",
    fill: "#68b050",
    fillOpacity: 0.545
  })), _path6075 || (_path6075 = /*#__PURE__*/React.createElement("path", {
    d: "M112 91v-1h1v1z",
    fill: "#94bf6a",
    fillOpacity: 0.047
  })), _path6076 || (_path6076 = /*#__PURE__*/React.createElement("path", {
    d: "M8 91h1v1H8z",
    fill: "#aab973",
    fillOpacity: 0.2
  })), _path6077 || (_path6077 = /*#__PURE__*/React.createElement("path", {
    d: "M10 91v1H9v-1z",
    fill: "#93ae5d",
    fillOpacity: 0.075
  })), _path6078 || (_path6078 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91v1h-1v-1z",
    fill: "#a3c385",
    fillOpacity: 0.435
  })), _path6079 || (_path6079 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h1v1h-1z",
    fill: "#b4c99f",
    fillOpacity: 0.188
  })), _path6080 || (_path6080 = /*#__PURE__*/React.createElement("path", {
    d: "M21 91h1v1h-1z",
    fill: "#7fbf5f",
    fillOpacity: 0.031
  })), _path6081 || (_path6081 = /*#__PURE__*/React.createElement("path", {
    d: "M23 91v1h-1v-1z",
    fill: "#57a539",
    fillOpacity: 0.435
  })), _path6082 || (_path6082 = /*#__PURE__*/React.createElement("path", {
    d: "M24 91v1h-1v-1z",
    fill: "#549f30",
    fillOpacity: 0.639
  })), _path6083 || (_path6083 = /*#__PURE__*/React.createElement("path", {
    d: "M25 91v1h-1v-1z",
    fill: "#60a231",
    fillOpacity: 0.302
  })), _path6084 || (_path6084 = /*#__PURE__*/React.createElement("path", {
    d: "M25 92v-1h1v1z",
    fill: "#7fbf3f",
    fillOpacity: 0.016
  })), _path6085 || (_path6085 = /*#__PURE__*/React.createElement("path", {
    d: "M30 91h1v1h-1z",
    fill: "#66a731",
    fillOpacity: 0.341
  })), _path6086 || (_path6086 = /*#__PURE__*/React.createElement("path", {
    d: "M31 92v-1h1v1z",
    fill: "#65a82f",
    fillOpacity: 0.718
  })), _path6087 || (_path6087 = /*#__PURE__*/React.createElement("path", {
    d: "M32 91h1v1h-1z",
    fill: "#7abd3a",
    fillOpacity: 0.925
  })), _path6088 || (_path6088 = /*#__PURE__*/React.createElement("path", {
    d: "M33 91h1v1h-1z",
    fill: "#8ec942"
  })), _path6089 || (_path6089 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#7fb52d",
    fillOpacity: 0.965
  })), _path6090 || (_path6090 = /*#__PURE__*/React.createElement("path", {
    d: "M36 92h-1v-1h1z",
    fill: "#4c9c31",
    fillOpacity: 0.525
  })), _path6091 || (_path6091 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#429d24",
    fillOpacity: 0.824
  })), _path6092 || (_path6092 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#419c11"
  })), _path6093 || (_path6093 = /*#__PURE__*/React.createElement("path", {
    d: "M39 92h-1v-1h1z",
    fill: "#81bc37"
  })), _path6094 || (_path6094 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#429127"
  })), _path6095 || (_path6095 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#388d1d"
  })), _path6096 || (_path6096 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#82c038"
  })), _path6097 || (_path6097 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#2c7718"
  })), _path6098 || (_path6098 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#0f6209"
  })), _path6099 || (_path6099 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#4ea71f"
  })), _path6100 || (_path6100 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#2c840c"
  })), _path6101 || (_path6101 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#63a334"
  })), _path6102 || (_path6102 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#8bc441"
  })), _path6103 || (_path6103 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#44962c"
  })), _path6104 || (_path6104 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#1b7714"
  })), _path6105 || (_path6105 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1z",
    fill: "#267916"
  })), _path6106 || (_path6106 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91h1v1h-1z",
    fill: "#448b2a"
  })), _path6107 || (_path6107 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#61a93b"
  })), _path6108 || (_path6108 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#6ab641"
  })), _path6109 || (_path6109 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#41a128"
  })), _path6110 || (_path6110 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#45a426"
  })), _path6111 || (_path6111 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#62b43c"
  })), _path6112 || (_path6112 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#5da33a"
  })), _path6113 || (_path6113 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#4e8732"
  })), _path6114 || (_path6114 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#337720"
  })), _path6115 || (_path6115 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#379926"
  })), _path6116 || (_path6116 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v-1h1v1z",
    fill: "#27801c"
  })), _path6117 || (_path6117 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#237715"
  })), _path6118 || (_path6118 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#9bcd57"
  })), _path6119 || (_path6119 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#8fc344"
  })), _path6120 || (_path6120 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#6cbb36"
  })), _path6121 || (_path6121 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#6dc43a"
  })), _path6122 || (_path6122 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#36a21f"
  })), _path6123 || (_path6123 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h-1v-1h1z",
    fill: "#1f9114"
  })), _path6124 || (_path6124 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#278d21"
  })), _path6125 || (_path6125 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1z",
    fill: "#08410a"
  })), _path6126 || (_path6126 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#0f7b10"
  })), _path6127 || (_path6127 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#0a700d"
  })), _path6128 || (_path6128 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#2d8a26"
  })), _path6129 || (_path6129 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#499929"
  })), _path6130 || (_path6130 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#5eb536"
  })), _path6131 || (_path6131 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#297b1e"
  })), _path6132 || (_path6132 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#064008"
  })), _path6133 || (_path6133 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#0b5511"
  })), _path6134 || (_path6134 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#106c0f"
  })), _path6135 || (_path6135 = /*#__PURE__*/React.createElement("path", {
    d: "M82 92v-1h1v1z",
    fill: "#1e9113"
  })), _path6136 || (_path6136 = /*#__PURE__*/React.createElement("path", {
    d: "M85 92h-1v-1h1z",
    fill: "#4fb934"
  })), _path6137 || (_path6137 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#3d9932"
  })), _path6138 || (_path6138 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1z",
    fill: "#24751d"
  })), _path6139 || (_path6139 = /*#__PURE__*/React.createElement("path", {
    d: "M88 92h-1v-1h1z",
    fill: "#338e24"
  })), _path6140 || (_path6140 = /*#__PURE__*/React.createElement("path", {
    d: "M89 91v1h-1v-1z",
    fill: "#369427"
  })), _path6141 || (_path6141 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92v-1h1v1z",
    fill: "#68ba4f"
  })), _path6142 || (_path6142 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91h1v1h-1z",
    fill: "#24811d"
  })), _path6143 || (_path6143 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h-1v-1h1z",
    fill: "#27742d"
  })), _path6144 || (_path6144 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92v-1h1v1z",
    fill: "#2c7321"
  })), _path6145 || (_path6145 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#62aa4d"
  })), _path6146 || (_path6146 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92v-1h1v1z",
    fill: "#156012"
  })), _path6147 || (_path6147 = /*#__PURE__*/React.createElement("path", {
    d: "M95 91h1v1h-1z",
    fill: "#7ec04a"
  })), _path6148 || (_path6148 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v-1h1v1z",
    fill: "#64b831"
  })), _path6149 || (_path6149 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h-1v-1h1z",
    fill: "#298d1b"
  })), _path6150 || (_path6150 = /*#__PURE__*/React.createElement("path", {
    d: "M99 91v1h-1v-1z",
    fill: "#5da448",
    fillOpacity: 0.996
  })), _path6151 || (_path6151 = /*#__PURE__*/React.createElement("path", {
    d: "M100 91v1h-1v-1z",
    fill: "#3ea732"
  })), _path6152 || (_path6152 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92h-1v-1h1z",
    fill: "#11810e",
    fillOpacity: 0.82
  })), _path6153 || (_path6153 = /*#__PURE__*/React.createElement("path", {
    d: "M101 92v-1h1v1z",
    fill: "#29881f",
    fillOpacity: 0.741
  })), _path6154 || (_path6154 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h-1v-1h1z",
    fill: "#95c671",
    fillOpacity: 0.529
  })), _path6155 || (_path6155 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v-1h1v1z",
    fill: "#a6c982",
    fillOpacity: 0.451
  })), _path6156 || (_path6156 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92v-1h1v1z",
    fill: "#a3c199",
    fillOpacity: 0.098
  })), _path6157 || (_path6157 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h-1v-1h1z",
    fill: "#84b57c",
    fillOpacity: 0.392
  })), _path6158 || (_path6158 = /*#__PURE__*/React.createElement("path", {
    d: "M107 92h-1v-1h1z",
    fill: "#75a869",
    fillOpacity: 0.714
  })), _path6159 || (_path6159 = /*#__PURE__*/React.createElement("path", {
    d: "M107 92v-1h1v1z",
    fill: "#6d9d53",
    fillOpacity: 0.914
  })), _path6160 || (_path6160 = /*#__PURE__*/React.createElement("path", {
    d: "M109 91v1h-1v-1z",
    fill: "#76b759",
    fillOpacity: 0.447
  })), _path6161 || (_path6161 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91v1h-1v-1z",
    fill: "#72b560",
    fillOpacity: 0.718
  })), _path6162 || (_path6162 = /*#__PURE__*/React.createElement("path", {
    d: "M110 91h1v1h-1z",
    fill: "#6daf4d",
    fillOpacity: 0.604
  })), _path6163 || (_path6163 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h-1v-1h1z",
    fill: "#72af57",
    fillOpacity: 0.114
  })), _path6164 || (_path6164 = /*#__PURE__*/React.createElement("path", {
    d: "M113 91v1h-1v-1z",
    fill: "#69a452",
    fillOpacity: 0.255
  })), _path6165 || (_path6165 = /*#__PURE__*/React.createElement("path", {
    d: "M114 92h-1v-1h1z",
    fill: "#80ab60",
    fillOpacity: 0.373
  })), _path6166 || (_path6166 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#b6c891",
    fillOpacity: 0.055
  })), _path6167 || (_path6167 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v-1h1v1z",
    fill: "#6cad48",
    fillOpacity: 0.565
  })), _path6168 || (_path6168 = /*#__PURE__*/React.createElement("path", {
    d: "M22 93h-1v-1h1z",
    fill: "#499d29",
    fillOpacity: 0.655
  })), _path6169 || (_path6169 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1z",
    fill: "#50a02b",
    fillOpacity: 0.412
  })), _path6170 || (_path6170 = /*#__PURE__*/React.createElement("path", {
    d: "M24 93h-1v-1h1z",
    fill: "#62b03a",
    fillOpacity: 0.051
  })), _path6171 || (_path6171 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#87b469",
    fillOpacity: 0.133
  })), _path6172 || (_path6172 = /*#__PURE__*/React.createElement("path", {
    d: "M28 93v-1h1v1z",
    fill: "#7eaa4f",
    fillOpacity: 0.388
  })), _path6173 || (_path6173 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93h-1v-1h1z",
    fill: "#6ea930",
    fillOpacity: 0.725
  })), _path6174 || (_path6174 = /*#__PURE__*/React.createElement("path", {
    d: "M30 92h1v1h-1z",
    fill: "#6aae24",
    fillOpacity: 0.98
  })), _path6175 || (_path6175 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h-1v-1h1z",
    fill: "#77b63a",
    fillOpacity: 0.882
  })), _path6176 || (_path6176 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h-1v-1h1z",
    fill: "#65b328",
    fillOpacity: 0.831
  })), _path6177 || (_path6177 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v1z",
    fill: "#5cb41f"
  })), _path6178 || (_path6178 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93v-1h1v1z",
    fill: "#42a218"
  })), _path6179 || (_path6179 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#24930a"
  })), _path6180 || (_path6180 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#53ad0e"
  })), _path6181 || (_path6181 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#7ab929"
  })), _path6182 || (_path6182 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#458928"
  })), _path6183 || (_path6183 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#428f22"
  })), _path6184 || (_path6184 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#579e27"
  })), _path6185 || (_path6185 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#085f0e"
  })), _path6186 || (_path6186 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#066606"
  })), _path6187 || (_path6187 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#2b8817"
  })), _path6188 || (_path6188 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#5db327"
  })), _path6189 || (_path6189 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#43a414"
  })), _path6190 || (_path6190 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#448b29"
  })), _path6191 || (_path6191 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#69a53f"
  })), _path6192 || (_path6192 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#6eaf3c"
  })), _path6193 || (_path6193 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#579239"
  })), _path6194 || (_path6194 = /*#__PURE__*/React.createElement("path", {
    d: "M52 92h1v1h-1z",
    fill: "#408c2b"
  })), _path6195 || (_path6195 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#409830"
  })), _path6196 || (_path6196 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#3c9f31"
  })), _path6197 || (_path6197 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#44a82d"
  })), _path6198 || (_path6198 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#5eb439"
  })), _path6199 || (_path6199 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#6dbc41"
  })), _path6200 || (_path6200 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#7bc542"
  })), _path6201 || (_path6201 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#83c343"
  })), _path6202 || (_path6202 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#82c34b"
  })), _path6203 || (_path6203 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#5fa73d"
  })), _path6204 || (_path6204 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#409329"
  })), _path6205 || (_path6205 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#6eab3c"
  })), _path6206 || (_path6206 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#c1e771"
  })), _path6207 || (_path6207 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#6ab536"
  })), _path6208 || (_path6208 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#43a92b"
  })), _path6209 || (_path6209 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#22951c"
  })), _path6210 || (_path6210 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#1e721a"
  })), _path6211 || (_path6211 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#0a7310"
  })), _path6212 || (_path6212 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#086b0b"
  })), _path6213 || (_path6213 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#004a02"
  })), _path6214 || (_path6214 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#3f9627"
  })), _path6215 || (_path6215 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#198311"
  })), _path6216 || (_path6216 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#4ca635"
  })), _path6217 || (_path6217 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#0f660c"
  })), _path6218 || (_path6218 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#0c5b12"
  })), _path6219 || (_path6219 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#0d5b0f"
  })), _path6220 || (_path6220 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#11831c"
  })), _path6221 || (_path6221 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#36a51f"
  })), _path6222 || (_path6222 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#4eb72f"
  })), _path6223 || (_path6223 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h1v1h-1z",
    fill: "#4aba35"
  })), _path6224 || (_path6224 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92v1h-1v-1z",
    fill: "#1f6e19"
  })), _path6225 || (_path6225 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#065a08"
  })), _path6226 || (_path6226 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h1v1h-1z",
    fill: "#218a1f"
  })), _path6227 || (_path6227 = /*#__PURE__*/React.createElement("path", {
    d: "M89 93h-1v-1h1z",
    fill: "#13750d"
  })), _path6228 || (_path6228 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#5aab47"
  })), _path6229 || (_path6229 = /*#__PURE__*/React.createElement("path", {
    d: "M90 92h1v1h-1z",
    fill: "#61b74a"
  })), _path6230 || (_path6230 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#267720"
  })), _path6231 || (_path6231 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1z",
    fill: "#61a545"
  })), _path6232 || (_path6232 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v1h-1z",
    fill: "#3e9031"
  })), _path6233 || (_path6233 = /*#__PURE__*/React.createElement("path", {
    d: "M94 92h1v1h-1z",
    fill: "#196418"
  })), _path6234 || (_path6234 = /*#__PURE__*/React.createElement("path", {
    d: "M96 92v1h-1v-1z",
    fill: "#84c756"
  })), _path6235 || (_path6235 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h-1v-1h1z",
    fill: "#5cb53f"
  })), _path6236 || (_path6236 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v-1h1v1z",
    fill: "#238d14"
  })), _path6237 || (_path6237 = /*#__PURE__*/React.createElement("path", {
    d: "M98 92h1v1h-1z",
    fill: "#4fa328"
  })), _path6238 || (_path6238 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h-1v-1h1z",
    fill: "#67ba39"
  })), _path6239 || (_path6239 = /*#__PURE__*/React.createElement("path", {
    d: "M100 92h1v1h-1z",
    fill: "#7eb54b",
    fillOpacity: 0.529
  })), _path6240 || (_path6240 = /*#__PURE__*/React.createElement("path", {
    d: "M102 93h-1v-1h1z",
    fill: "#70b65f",
    fillOpacity: 0.427
  })), _path6241 || (_path6241 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92v1h-1v-1z",
    fill: "#73b25a",
    fillOpacity: 0.522
  })), _path6242 || (_path6242 = /*#__PURE__*/React.createElement("path", {
    d: "M103 92h1v1h-1z",
    fill: "#aacd8a",
    fillOpacity: 0.282
  })), _path6243 || (_path6243 = /*#__PURE__*/React.createElement("path", {
    d: "M104 92h1v1h-1z",
    fill: "#91bc7c",
    fillOpacity: 0.569
  })), _path6244 || (_path6244 = /*#__PURE__*/React.createElement("path", {
    d: "M106 93h-1v-1h1z",
    fill: "#649f52",
    fillOpacity: 0.827
  })), _path6245 || (_path6245 = /*#__PURE__*/React.createElement("path", {
    d: "M106 92h1v1h-1z",
    fill: "#569a3d"
  })), _path6246 || (_path6246 = /*#__PURE__*/React.createElement("path", {
    d: "M107 93v-1h1v1z",
    fill: "#5fa646",
    fillOpacity: 0.847
  })), _path6247 || (_path6247 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v-1h1v1z",
    fill: "#63b34b",
    fillOpacity: 0.878
  })), _path6248 || (_path6248 = /*#__PURE__*/React.createElement("path", {
    d: "M109 92h1v1h-1z",
    fill: "#71b156",
    fillOpacity: 0.616
  })), _path6249 || (_path6249 = /*#__PURE__*/React.createElement("path", {
    d: "M110 92h1v1h-1z",
    fill: "#82b164",
    fillOpacity: 0.169
  })), _path6250 || (_path6250 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92v1h-1v-1z",
    fill: "#71af46",
    fillOpacity: 0.353
  })), _path6251 || (_path6251 = /*#__PURE__*/React.createElement("path", {
    d: "M112 92h1v1h-1z",
    fill: "#70af43",
    fillOpacity: 0.639
  })), _path6252 || (_path6252 = /*#__PURE__*/React.createElement("path", {
    d: "M113 93v-1h1v1z",
    fill: "#8cb860",
    fillOpacity: 0.114
  })), _path6253 || (_path6253 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#85b661",
    fillOpacity: 0.082
  })), _path6254 || (_path6254 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#5da532",
    fillOpacity: 0.514
  })), _path6255 || (_path6255 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#78b45b",
    fillOpacity: 0.349
  })), _path6256 || (_path6256 = /*#__PURE__*/React.createElement("path", {
    d: "M25 93h1v1h-1z",
    fill: "#9b7",
    fillOpacity: 0.118
  })), _path6257 || (_path6257 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93v1h-1v-1z",
    fill: "#90b872",
    fillOpacity: 0.298
  })), _path6258 || (_path6258 = /*#__PURE__*/React.createElement("path", {
    d: "M27 93h1v1h-1z",
    fill: "#86b45d",
    fillOpacity: 0.365
  })), _path6259 || (_path6259 = /*#__PURE__*/React.createElement("path", {
    d: "M28 94v-1h1v1z",
    fill: "#86ad56",
    fillOpacity: 0.208
  })), _path6260 || (_path6260 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#8bbd4a",
    fillOpacity: 0.122
  })), _path6261 || (_path6261 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94h-1v-1h1z",
    fill: "#8fc050",
    fillOpacity: 0.161
  })), _path6262 || (_path6262 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93v1h-1v-1z",
    fill: "#90bc63",
    fillOpacity: 0.18
  })), _path6263 || (_path6263 = /*#__PURE__*/React.createElement("path", {
    d: "M32 93h1v1h-1z",
    fill: "#66b03e",
    fillOpacity: 0.624
  })), _path6264 || (_path6264 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93h1v1h-1z",
    fill: "#38a417"
  })), _path6265 || (_path6265 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#5bb226"
  })), _path6266 || (_path6266 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#52a218"
  })), _path6267 || (_path6267 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#187d0e",
    fillOpacity: 0.925
  })), _path6268 || (_path6268 = /*#__PURE__*/React.createElement("path", {
    d: "M38 94h-1v-1h1z",
    fill: "#379f15",
    fillOpacity: 0.988
  })), _path6269 || (_path6269 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93v1h-1v-1z",
    fill: "#519f23"
  })), _path6270 || (_path6270 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#569930"
  })), _path6271 || (_path6271 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#53a128"
  })), _path6272 || (_path6272 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#399b1f"
  })), _path6273 || (_path6273 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#087a0f"
  })), _path6274 || (_path6274 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#0c7d09"
  })), _path6275 || (_path6275 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#34961c"
  })), _path6276 || (_path6276 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#5caa34"
  })), _path6277 || (_path6277 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#6cb429"
  })), _path6278 || (_path6278 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#64ad34"
  })), _path6279 || (_path6279 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#78b849"
  })), _path6280 || (_path6280 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#7eb54f"
  })), _path6281 || (_path6281 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#518231"
  })), _path6282 || (_path6282 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#2c6c20"
  })), _path6283 || (_path6283 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1z",
    fill: "#084c0b"
  })), _path6284 || (_path6284 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#034d05"
  })), _path6285 || (_path6285 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#0e600e"
  })), _path6286 || (_path6286 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#1d8017"
  })), _path6287 || (_path6287 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#2b971e"
  })), _path6288 || (_path6288 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#2a7b1d"
  })), _path6289 || (_path6289 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#4d9a2c"
  })), _path6290 || (_path6290 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#62b030"
  })), _path6291 || (_path6291 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#75ba40"
  })), _path6292 || (_path6292 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#80be47"
  })), _path6293 || (_path6293 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#89c355"
  })), _path6294 || (_path6294 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#94ca5a"
  })), _path6295 || (_path6295 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#bce56b"
  })), _path6296 || (_path6296 = /*#__PURE__*/React.createElement("path", {
    d: "M65 94v-1h1v1z",
    fill: "#90c54d"
  })), _path6297 || (_path6297 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#34901e"
  })), _path6298 || (_path6298 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#157412"
  })), _path6299 || (_path6299 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#4faf31"
  })), _path6300 || (_path6300 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#2ca521"
  })), _path6301 || (_path6301 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#117b14"
  })), _path6302 || (_path6302 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#0b5e0f"
  })), _path6303 || (_path6303 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1z",
    fill: "#065206"
  })), _path6304 || (_path6304 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#0a5105"
  })), _path6305 || (_path6305 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#6eb443"
  })), _path6306 || (_path6306 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93h1v1h-1z",
    fill: "#2b891e"
  })), _path6307 || (_path6307 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1z",
    fill: "#046b0c"
  })), _path6308 || (_path6308 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#408f2b"
  })), _path6309 || (_path6309 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#308f1e"
  })), _path6310 || (_path6310 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#046a08"
  })), _path6311 || (_path6311 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1z",
    fill: "#0d7f18"
  })), _path6312 || (_path6312 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94v-1h1v1z",
    fill: "#067514"
  })), _path6313 || (_path6313 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#57c132"
  })), _path6314 || (_path6314 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#34a426"
  })), _path6315 || (_path6315 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#127509"
  })), _path6316 || (_path6316 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1z",
    fill: "#2d9018"
  })), _path6317 || (_path6317 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#48a329"
  })), _path6318 || (_path6318 = /*#__PURE__*/React.createElement("path", {
    d: "M90 93v1h-1v-1z",
    fill: "#52a130"
  })), _path6319 || (_path6319 = /*#__PURE__*/React.createElement("path", {
    d: "M91 94h-1v-1h1z",
    fill: "#59ab33"
  })), _path6320 || (_path6320 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93h1v1h-1z",
    fill: "#519c26"
  })), _path6321 || (_path6321 = /*#__PURE__*/React.createElement("path", {
    d: "M94 94h-1v-1h1z",
    fill: "#26791c"
  })), _path6322 || (_path6322 = /*#__PURE__*/React.createElement("path", {
    d: "M95 93v1h-1v-1z",
    fill: "#2f8027"
  })), _path6323 || (_path6323 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94h-1v-1h1z",
    fill: "#6cbe4b"
  })), _path6324 || (_path6324 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93v1h-1v-1z",
    fill: "#3c9d25"
  })), _path6325 || (_path6325 = /*#__PURE__*/React.createElement("path", {
    d: "M97 93h1v1h-1z",
    fill: "#42a026"
  })), _path6326 || (_path6326 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h-1v-1h1z",
    fill: "#7fc14a"
  })), _path6327 || (_path6327 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94v-1h1v1z",
    fill: "#88bb57",
    fillOpacity: 0.706
  })), _path6328 || (_path6328 = /*#__PURE__*/React.createElement("path", {
    d: "M100 93h1v1h-1z",
    fill: "#a5bd63",
    fillOpacity: 0.667
  })), _path6329 || (_path6329 = /*#__PURE__*/React.createElement("path", {
    d: "M102 94h-1v-1h1z",
    fill: "#80b34e",
    fillOpacity: 0.753
  })), _path6330 || (_path6330 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h-1v-1h1z",
    fill: "#79ba61",
    fillOpacity: 0.616
  })), _path6331 || (_path6331 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h-1v-1h1z",
    fill: "#64a551",
    fillOpacity: 0.369
  })), _path6332 || (_path6332 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94v-1h1v1z",
    fill: "#99bf8c",
    fillOpacity: 0.157
  })), _path6333 || (_path6333 = /*#__PURE__*/React.createElement("path", {
    d: "M105 93h1v1h-1z",
    fill: "#539548",
    fillOpacity: 0.812
  })), _path6334 || (_path6334 = /*#__PURE__*/React.createElement("path", {
    d: "M106 94v-1h1v1z",
    fill: "#459533",
    fillOpacity: 0.925
  })), _path6335 || (_path6335 = /*#__PURE__*/React.createElement("path", {
    d: "M108 93v1h-1v-1z",
    fill: "#4dab38",
    fillOpacity: 0.98
  })), _path6336 || (_path6336 = /*#__PURE__*/React.createElement("path", {
    d: "M109 94h-1v-1h1z",
    fill: "#5cb14b",
    fillOpacity: 0.804
  })), _path6337 || (_path6337 = /*#__PURE__*/React.createElement("path", {
    d: "M109 93h1v1h-1z",
    fill: "#8cc272",
    fillOpacity: 0.298
  })), _path6338 || (_path6338 = /*#__PURE__*/React.createElement("path", {
    d: "M111 94h-1v-1h1z",
    fill: "#76b041",
    fillOpacity: 0.396
  })), _path6339 || (_path6339 = /*#__PURE__*/React.createElement("path", {
    d: "M112 93v1h-1v-1z",
    fill: "#75af40",
    fillOpacity: 0.604
  })), _path6340 || (_path6340 = /*#__PURE__*/React.createElement("path", {
    d: "M112 93h1v1h-1z",
    fill: "#96d269",
    fillOpacity: 0.067
  })), _path6341 || (_path6341 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1z",
    fill: "#bace97",
    fillOpacity: 0.145
  })), _path6342 || (_path6342 = /*#__PURE__*/React.createElement("path", {
    d: "M22 94h1v1h-1z",
    fill: "#9ac077",
    fillOpacity: 0.478
  })), _path6343 || (_path6343 = /*#__PURE__*/React.createElement("path", {
    d: "M24 94v1h-1v-1z",
    fill: "#a3c48e",
    fillOpacity: 0.275
  })), _path6344 || (_path6344 = /*#__PURE__*/React.createElement("path", {
    d: "M24 95v-1h1v1z",
    fill: "#a8ca90",
    fillOpacity: 0.173
  })), _path6345 || (_path6345 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#9bc67f",
    fillOpacity: 0.071
  })), _path6346 || (_path6346 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#91b691",
    fillOpacity: 0.027
  })), _path6347 || (_path6347 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#84b75b",
    fillOpacity: 0.196
  })), _path6348 || (_path6348 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1z",
    fill: "#6dac4c",
    fillOpacity: 0.365
  })), _path6349 || (_path6349 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94v1h-1v-1z",
    fill: "#62a048",
    fillOpacity: 0.467
  })), _path6350 || (_path6350 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h1v1z",
    fill: "#4da138",
    fillOpacity: 0.62
  })), _path6351 || (_path6351 = /*#__PURE__*/React.createElement("path", {
    d: "M33 94v1h-1v-1z",
    fill: "#2e9d16",
    fillOpacity: 0.945
  })), _path6352 || (_path6352 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#2ca315"
  })), _path6353 || (_path6353 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#37a00d"
  })), _path6354 || (_path6354 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#489e0f",
    fillOpacity: 0.949
  })), _path6355 || (_path6355 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#3f9238",
    fillOpacity: 0.267
  })), _path6356 || (_path6356 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#4da124",
    fillOpacity: 0.843
  })), _path6357 || (_path6357 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1z",
    fill: "#589a21"
  })), _path6358 || (_path6358 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1z",
    fill: "#509a26"
  })), _path6359 || (_path6359 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#5fba30"
  })), _path6360 || (_path6360 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#239b16"
  })), _path6361 || (_path6361 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#349a1f"
  })), _path6362 || (_path6362 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#4d9b2b"
  })), _path6363 || (_path6363 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#88cb50"
  })), _path6364 || (_path6364 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#76c23a"
  })), _path6365 || (_path6365 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#257412"
  })), _path6366 || (_path6366 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#247019"
  })), _path6367 || (_path6367 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#5f8c40"
  })), _path6368 || (_path6368 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#346d29"
  })), _path6369 || (_path6369 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#0c520d"
  })), _path6370 || (_path6370 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#0f650e"
  })), _path6371 || (_path6371 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#023f03"
  })), _path6372 || (_path6372 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#207017"
  })), _path6373 || (_path6373 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#1e9012"
  })), _path6374 || (_path6374 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#0a6b09"
  })), _path6375 || (_path6375 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#31851d"
  })), _path6376 || (_path6376 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#44941e"
  })), _path6377 || (_path6377 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#3a8b21"
  })), _path6378 || (_path6378 = /*#__PURE__*/React.createElement("path", {
    d: "M61 94h1v1h-1z",
    fill: "#63a331"
  })), _path6379 || (_path6379 = /*#__PURE__*/React.createElement("path", {
    d: "M63 94v1h-1v-1z",
    fill: "#528d27"
  })), _path6380 || (_path6380 = /*#__PURE__*/React.createElement("path", {
    d: "M63 95v-1h1v1z",
    fill: "#448c1f"
  })), _path6381 || (_path6381 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#6cb72f"
  })), _path6382 || (_path6382 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#bce66b"
  })), _path6383 || (_path6383 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#65a43e"
  })), _path6384 || (_path6384 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#105710"
  })), _path6385 || (_path6385 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#48b333"
  })), _path6386 || (_path6386 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#1b8815"
  })), _path6387 || (_path6387 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#074d0d"
  })), _path6388 || (_path6388 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#0f670c"
  })), _path6389 || (_path6389 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#065f04"
  })), _path6390 || (_path6390 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#2b781c"
  })), _path6391 || (_path6391 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#57a937"
  })), _path6392 || (_path6392 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#148410"
  })), _path6393 || (_path6393 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#055b07"
  })), _path6394 || (_path6394 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#10620e"
  })), _path6395 || (_path6395 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#3fa627"
  })), _path6396 || (_path6396 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1z",
    fill: "#1f7416"
  })), _path6397 || (_path6397 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h1v1h-1z",
    fill: "#034a07"
  })), _path6398 || (_path6398 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#004e00"
  })), _path6399 || (_path6399 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95h-1v-1h1z",
    fill: "#389523"
  })), _path6400 || (_path6400 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-1v-1z",
    fill: "#59ba3a"
  })), _path6401 || (_path6401 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#31961b"
  })), _path6402 || (_path6402 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#48a529"
  })), _path6403 || (_path6403 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#4da02a"
  })), _path6404 || (_path6404 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#5ba430"
  })), _path6405 || (_path6405 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94v1h-1v-1z",
    fill: "#449225"
  })), _path6406 || (_path6406 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#539d2f"
  })), _path6407 || (_path6407 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94h1v1h-1z",
    fill: "#5eac30"
  })), _path6408 || (_path6408 = /*#__PURE__*/React.createElement("path", {
    d: "M92 94v1h-1v-1z",
    fill: "#8ac559"
  })), _path6409 || (_path6409 = /*#__PURE__*/React.createElement("path", {
    d: "M92 95v-1h1v1z",
    fill: "#509131"
  })), _path6410 || (_path6410 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-1h1v1z",
    fill: "#227018"
  })), _path6411 || (_path6411 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95v-1h1v1z",
    fill: "#459737"
  })), _path6412 || (_path6412 = /*#__PURE__*/React.createElement("path", {
    d: "M96 94v1h-1v-1z",
    fill: "#59ae41"
  })), _path6413 || (_path6413 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95v-1h1v1z",
    fill: "#44a730"
  })), _path6414 || (_path6414 = /*#__PURE__*/React.createElement("path", {
    d: "M98 94v1h-1v-1z",
    fill: "#5ab339"
  })), _path6415 || (_path6415 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h-1v-1h1z",
    fill: "#82c854"
  })), _path6416 || (_path6416 = /*#__PURE__*/React.createElement("path", {
    d: "M99 94h1v1h-1z",
    fill: "#96c875",
    fillOpacity: 0.478
  })), _path6417 || (_path6417 = /*#__PURE__*/React.createElement("path", {
    d: "M101 95v-1h1v1z",
    fill: "#86b15d",
    fillOpacity: 0.298
  })), _path6418 || (_path6418 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94v1h-1v-1z",
    fill: "#9ec682",
    fillOpacity: 0.176
  })), _path6419 || (_path6419 = /*#__PURE__*/React.createElement("path", {
    d: "M103 94h1v1h-1z",
    fill: "#5da544",
    fillOpacity: 0.494
  })), _path6420 || (_path6420 = /*#__PURE__*/React.createElement("path", {
    d: "M104 94h1v1h-1z",
    fill: "#549e49",
    fillOpacity: 0.737
  })), _path6421 || (_path6421 = /*#__PURE__*/React.createElement("path", {
    d: "M106 95h-1v-1h1z",
    fill: "#7aa781",
    fillOpacity: 0.286
  })), _path6422 || (_path6422 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95h-1v-1h1z",
    fill: "#3d9a33",
    fillOpacity: 0.827
  })), _path6423 || (_path6423 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95h-1v-1h1z",
    fill: "#42a827",
    fillOpacity: 0.996
  })), _path6424 || (_path6424 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95v-1h1v1z",
    fill: "#6bb954",
    fillOpacity: 0.345
  })), _path6425 || (_path6425 = /*#__PURE__*/React.createElement("path", {
    d: "M110 94v1h-1v-1z",
    fill: "#6bae38",
    fillOpacity: 0.475
  })), _path6426 || (_path6426 = /*#__PURE__*/React.createElement("path", {
    d: "M110 95v-1h1v1z",
    fill: "#6ead37",
    fillOpacity: 0.506
  })), _path6427 || (_path6427 = /*#__PURE__*/React.createElement("path", {
    d: "M112 94v1h-1v-1z",
    fill: "#cf6",
    fillOpacity: 0.02
  })), _path6428 || (_path6428 = /*#__PURE__*/React.createElement("path", {
    d: "M19 95h1v1h-1z",
    fill: "#adcc99",
    fillOpacity: 0.098
  })), _path6429 || (_path6429 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#a3c290",
    fillOpacity: 0.263
  })), _path6430 || (_path6430 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95v1h-1v-1z",
    fill: "#9fbe90",
    fillOpacity: 0.263
  })), _path6431 || (_path6431 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#97bd6f",
    fillOpacity: 0.369
  })), _path6432 || (_path6432 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#a1bd7f",
    fillOpacity: 0.29
  })), _path6433 || (_path6433 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#9a7",
    fillOpacity: 0.059
  })), _path6434 || (_path6434 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#75a64a",
    fillOpacity: 0.349
  })), _path6435 || (_path6435 = /*#__PURE__*/React.createElement("path", {
    d: "M30 95v1h-1v-1z",
    fill: "#66a542",
    fillOpacity: 0.302
  })), _path6436 || (_path6436 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96h-1v-1h1z",
    fill: "#76a859",
    fillOpacity: 0.345
  })), _path6437 || (_path6437 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95h1v1h-1z",
    fill: "#62ad3b",
    fillOpacity: 0.651
  })), _path6438 || (_path6438 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1z",
    fill: "#309e0c"
  })), _path6439 || (_path6439 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96h-1v-1h1z",
    fill: "#38a41a"
  })), _path6440 || (_path6440 = /*#__PURE__*/React.createElement("path", {
    d: "M35 95v1h-1v-1z",
    fill: "#2d9d0f"
  })), _path6441 || (_path6441 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h-1v-1h1z",
    fill: "#499f0f",
    fillOpacity: 0.957
  })), _path6442 || (_path6442 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#6da947",
    fillOpacity: 0.584
  })), _path6443 || (_path6443 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#48a12e",
    fillOpacity: 0.941
  })), _path6444 || (_path6444 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#31a01a"
  })), _path6445 || (_path6445 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h1v1h-1z",
    fill: "#2da418"
  })), _path6446 || (_path6446 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#65c32f"
  })), _path6447 || (_path6447 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#1a8007"
  })), _path6448 || (_path6448 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#41a31f"
  })), _path6449 || (_path6449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#56a334"
  })), _path6450 || (_path6450 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#73b24a"
  })), _path6451 || (_path6451 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#439f2a"
  })), _path6452 || (_path6452 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#2b931f"
  })), _path6453 || (_path6453 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#4cab2e"
  })), _path6454 || (_path6454 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1z",
    fill: "#4aa01f"
  })), _path6455 || (_path6455 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v1h-1v-1z",
    fill: "#1d6912"
  })), _path6456 || (_path6456 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#347828"
  })), _path6457 || (_path6457 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#0f600f"
  })), _path6458 || (_path6458 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#106d11"
  })), _path6459 || (_path6459 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#155b0d"
  })), _path6460 || (_path6460 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#33901e"
  })), _path6461 || (_path6461 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#1f9110"
  })), _path6462 || (_path6462 = /*#__PURE__*/React.createElement("path", {
    d: "M57 95h1v1h-1z",
    fill: "#056103"
  })), _path6463 || (_path6463 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#125b0e"
  })), _path6464 || (_path6464 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1z",
    fill: "#5ba332"
  })), _path6465 || (_path6465 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1z",
    fill: "#268415"
  })), _path6466 || (_path6466 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#4ea228"
  })), _path6467 || (_path6467 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#64a735"
  })), _path6468 || (_path6468 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#7cb33d"
  })), _path6469 || (_path6469 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#70a32e"
  })), _path6470 || (_path6470 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h-1v-1h1z",
    fill: "#7cb039"
  })), _path6471 || (_path6471 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#89ba59"
  })), _path6472 || (_path6472 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#33a32d"
  })), _path6473 || (_path6473 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1z",
    fill: "#0a620c"
  })), _path6474 || (_path6474 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#2ea01d"
  })), _path6475 || (_path6475 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#0b6c0a"
  })), _path6476 || (_path6476 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#10740d"
  })), _path6477 || (_path6477 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95h1v1h-1z",
    fill: "#349729"
  })), _path6478 || (_path6478 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95h1v1h-1z",
    fill: "#16871b"
  })), _path6479 || (_path6479 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#0d6913"
  })), _path6480 || (_path6480 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#034b03"
  })), _path6481 || (_path6481 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#217915"
  })), _path6482 || (_path6482 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#3e8623"
  })), _path6483 || (_path6483 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#2c5a22"
  })), _path6484 || (_path6484 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#095b08"
  })), _path6485 || (_path6485 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95v1h-1v-1z",
    fill: "#4bae2e"
  })), _path6486 || (_path6486 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-1v-1h1z",
    fill: "#6abe39"
  })), _path6487 || (_path6487 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#56b12a"
  })), _path6488 || (_path6488 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#47a821"
  })), _path6489 || (_path6489 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95h1v1h-1z",
    fill: "#4e9e39"
  })), _path6490 || (_path6490 = /*#__PURE__*/React.createElement("path", {
    d: "M89 96h-1v-1h1z",
    fill: "#07730d"
  })), _path6491 || (_path6491 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#2c871c"
  })), _path6492 || (_path6492 = /*#__PURE__*/React.createElement("path", {
    d: "M91 96h-1v-1h1z",
    fill: "#55b133"
  })), _path6493 || (_path6493 = /*#__PURE__*/React.createElement("path", {
    d: "M91 95h1v1h-1z",
    fill: "#60b348"
  })), _path6494 || (_path6494 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v1h-1v-1z",
    fill: "#116510"
  })), _path6495 || (_path6495 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1z",
    fill: "#22801d"
  })), _path6496 || (_path6496 = /*#__PURE__*/React.createElement("path", {
    d: "M94 95h1v1h-1z",
    fill: "#49a22f"
  })), _path6497 || (_path6497 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96v-1h1v1z",
    fill: "#48a937"
  })), _path6498 || (_path6498 = /*#__PURE__*/React.createElement("path", {
    d: "M96 95h1v1h-1z",
    fill: "#1c8912"
  })), _path6499 || (_path6499 = /*#__PURE__*/React.createElement("path", {
    d: "M98 96h-1v-1h1z",
    fill: "#57b137"
  })), _path6500 || (_path6500 = /*#__PURE__*/React.createElement("path", {
    d: "M98 95h1v1h-1z",
    fill: "#8ece61"
  })), _path6501 || (_path6501 = /*#__PURE__*/React.createElement("path", {
    d: "M99 95h1v1h-1z",
    fill: "#97c466",
    fillOpacity: 0.51
  })), _path6502 || (_path6502 = /*#__PURE__*/React.createElement("path", {
    d: "M102 95v1h-1v-1z",
    fill: "#7fb279",
    fillOpacity: 0.157
  })), _path6503 || (_path6503 = /*#__PURE__*/React.createElement("path", {
    d: "M103 96h-1v-1h1z",
    fill: "#93c489",
    fillOpacity: 0.102
  })), _path6504 || (_path6504 = /*#__PURE__*/React.createElement("path", {
    d: "M103 95h1v1h-1z",
    fill: "#5f9f5f",
    fillOpacity: 0.031
  })), _path6505 || (_path6505 = /*#__PURE__*/React.createElement("path", {
    d: "M105 95v1h-1v-1z",
    fill: "#2c812a",
    fillOpacity: 0.678
  })), _path6506 || (_path6506 = /*#__PURE__*/React.createElement("path", {
    d: "M105 96v-1h1v1z",
    fill: "#38973a",
    fillOpacity: 0.635
  })), _path6507 || (_path6507 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95v1h-1v-1z",
    fill: "#3c9829",
    fillOpacity: 0.859
  })), _path6508 || (_path6508 = /*#__PURE__*/React.createElement("path", {
    d: "M107 95h1v1h-1z",
    fill: "#69bb49",
    fillOpacity: 0.651
  })), _path6509 || (_path6509 = /*#__PURE__*/React.createElement("path", {
    d: "M108 95h1v1h-1z",
    fill: "#64ad35",
    fillOpacity: 0.753
  })), _path6510 || (_path6510 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96v-1h1v1z",
    fill: "#73ae33",
    fillOpacity: 0.58
  })), _path6511 || (_path6511 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v-1h1v1z",
    fill: "#a5bb87",
    fillOpacity: 0.133
  })), _path6512 || (_path6512 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h1v1h-1z",
    fill: "#a3bb88",
    fillOpacity: 0.294
  })), _path6513 || (_path6513 = /*#__PURE__*/React.createElement("path", {
    d: "M19 96h1v1h-1z",
    fill: "#9fbb8b",
    fillOpacity: 0.294
  })), _path6514 || (_path6514 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97v-1h1v1z",
    fill: "#9fbf87",
    fillOpacity: 0.125
  })), _path6515 || (_path6515 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#afc693",
    fillOpacity: 0.176
  })), _path6516 || (_path6516 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#afbf94",
    fillOpacity: 0.188
  })), _path6517 || (_path6517 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1z",
    fill: "#dab6da",
    fillOpacity: 0.027
  })), _path6518 || (_path6518 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1z",
    fill: "#82a867",
    fillOpacity: 0.29
  })), _path6519 || (_path6519 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97v-1h1v1z",
    fill: "#72ae34",
    fillOpacity: 0.498
  })), _path6520 || (_path6520 = /*#__PURE__*/React.createElement("path", {
    d: "M32 97v-1h1v1z",
    fill: "#6fb128"
  })), _path6521 || (_path6521 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-1z",
    fill: "#69b734"
  })), _path6522 || (_path6522 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-1h1v1z",
    fill: "#26960d"
  })), _path6523 || (_path6523 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96v1h-1v-1z",
    fill: "#50a719"
  })), _path6524 || (_path6524 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97h-1v-1h1z",
    fill: "#24a619"
  })), _path6525 || (_path6525 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#0c9708"
  })), _path6526 || (_path6526 = /*#__PURE__*/React.createElement("path", {
    d: "M39 96h1v1h-1z",
    fill: "#1d960c"
  })), _path6527 || (_path6527 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-1v-1z",
    fill: "#72bc33"
  })), _path6528 || (_path6528 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#58a023"
  })), _path6529 || (_path6529 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#75bd36"
  })), _path6530 || (_path6530 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#67b637"
  })), _path6531 || (_path6531 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#279320"
  })), _path6532 || (_path6532 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#1d7f16"
  })), _path6533 || (_path6533 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1z",
    fill: "#257919"
  })), _path6534 || (_path6534 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#45ac21"
  })), _path6535 || (_path6535 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97v-1h1v1z",
    fill: "#489f15"
  })), _path6536 || (_path6536 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#0e5d09"
  })), _path6537 || (_path6537 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#0b6c0e"
  })), _path6538 || (_path6538 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#125f0f"
  })), _path6539 || (_path6539 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#319f16"
  })), _path6540 || (_path6540 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#178f10"
  })), _path6541 || (_path6541 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#045c05"
  })), _path6542 || (_path6542 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#024405"
  })), _path6543 || (_path6543 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#478822"
  })), _path6544 || (_path6544 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#62b42b"
  })), _path6545 || (_path6545 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#3aa216"
  })), _path6546 || (_path6546 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#419c1c"
  })), _path6547 || (_path6547 = /*#__PURE__*/React.createElement("path", {
    d: "M63 97v-1h1v1z",
    fill: "#5a9e2f"
  })), _path6548 || (_path6548 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96v1h-1v-1z",
    fill: "#80a34a"
  })), _path6549 || (_path6549 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#8eaf4b"
  })), _path6550 || (_path6550 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#90ba47"
  })), _path6551 || (_path6551 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#68ae44"
  })), _path6552 || (_path6552 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1z",
    fill: "#066e07"
  })), _path6553 || (_path6553 = /*#__PURE__*/React.createElement("path", {
    d: "M70 96v1h-1v-1z",
    fill: "#025900"
  })), _path6554 || (_path6554 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#2d9c1e"
  })), _path6555 || (_path6555 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#108110"
  })), _path6556 || (_path6556 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v-1h1v1z",
    fill: "#1a9519"
  })), _path6557 || (_path6557 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#1f8227"
  })), _path6558 || (_path6558 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#115a1f"
  })), _path6559 || (_path6559 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#033801"
  })), _path6560 || (_path6560 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#044a05"
  })), _path6561 || (_path6561 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#126e11"
  })), _path6562 || (_path6562 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#227d12"
  })), _path6563 || (_path6563 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#359512"
  })), _path6564 || (_path6564 = /*#__PURE__*/React.createElement("path", {
    d: "M83 97h-1v-1h1z",
    fill: "#5cb82b"
  })), _path6565 || (_path6565 = /*#__PURE__*/React.createElement("path", {
    d: "M83 96h1v1h-1z",
    fill: "#67bb2a"
  })), _path6566 || (_path6566 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1z",
    fill: "#4cae16"
  })), _path6567 || (_path6567 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1z",
    fill: "#3d9619"
  })), _path6568 || (_path6568 = /*#__PURE__*/React.createElement("path", {
    d: "M87 97v-1h1v1z",
    fill: "#57a042"
  })), _path6569 || (_path6569 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#077b0e"
  })), _path6570 || (_path6570 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v1h-1z",
    fill: "#4fa833"
  })), _path6571 || (_path6571 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97h-1v-1h1z",
    fill: "#318f26"
  })), _path6572 || (_path6572 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97v-1h1v1z",
    fill: "#27891a"
  })), _path6573 || (_path6573 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h-1v-1h1z",
    fill: "#3ea32b"
  })), _path6574 || (_path6574 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97v-1h1v1z",
    fill: "#57a73e"
  })), _path6575 || (_path6575 = /*#__PURE__*/React.createElement("path", {
    d: "M95 96h1v1h-1z",
    fill: "#157712"
  })), _path6576 || (_path6576 = /*#__PURE__*/React.createElement("path", {
    d: "M96 97v-1h1v1z",
    fill: "#12860d"
  })), _path6577 || (_path6577 = /*#__PURE__*/React.createElement("path", {
    d: "M97 96h1v1h-1z",
    fill: "#5bbb37"
  })), _path6578 || (_path6578 = /*#__PURE__*/React.createElement("path", {
    d: "M99 96v1h-1v-1z",
    fill: "#8ac45a",
    fillOpacity: 0.914
  })), _path6579 || (_path6579 = /*#__PURE__*/React.createElement("path", {
    d: "M99 97v-1h1v1z",
    fill: "#aed37b",
    fillOpacity: 0.137
  })), _path6580 || (_path6580 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97v-1h1v1z",
    fill: "#90bb7f",
    fillOpacity: 0.118
  })), _path6581 || (_path6581 = /*#__PURE__*/React.createElement("path", {
    d: "M102 96h1v1h-1z",
    fill: "#97c684",
    fillOpacity: 0.106
  })), _path6582 || (_path6582 = /*#__PURE__*/React.createElement("path", {
    d: "M104 96h1v1h-1z",
    fill: "#3b8f3b",
    fillOpacity: 0.251
  })), _path6583 || (_path6583 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97h-1v-1h1z",
    fill: "#2b9c1f"
  })), _path6584 || (_path6584 = /*#__PURE__*/React.createElement("path", {
    d: "M106 97v-1h1v1z",
    fill: "#4dab37",
    fillOpacity: 0.792
  })), _path6585 || (_path6585 = /*#__PURE__*/React.createElement("path", {
    d: "M107 97v-1h1v1z",
    fill: "#55ab2a",
    fillOpacity: 0.722
  })), _path6586 || (_path6586 = /*#__PURE__*/React.createElement("path", {
    d: "M109 96v1h-1v-1z",
    fill: "#63b231",
    fillOpacity: 0.624
  })), _path6587 || (_path6587 = /*#__PURE__*/React.createElement("path", {
    d: "M16 97v1h-1v-1z",
    fill: "#b9b9b9",
    fillOpacity: 0.043
  })), _path6588 || (_path6588 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v1h-1v-1z",
    fill: "#a7c096",
    fillOpacity: 0.239
  })), _path6589 || (_path6589 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98h-1v-1h1z",
    fill: "#a5bb8f",
    fillOpacity: 0.224
  })), _path6590 || (_path6590 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98v-1h1v1z",
    fill: "#a5c387",
    fillOpacity: 0.067
  })), _path6591 || (_path6591 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#afbf8f",
    fillOpacity: 0.188
  })), _path6592 || (_path6592 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#b1c297",
    fillOpacity: 0.231
  })), _path6593 || (_path6593 = /*#__PURE__*/React.createElement("path", {
    d: "M31 97h1v1h-1z",
    fill: "#a3c95d",
    fillOpacity: 0.447
  })), _path6594 || (_path6594 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#8fcc42"
  })), _path6595 || (_path6595 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#3b9b18"
  })), _path6596 || (_path6596 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#36aa18"
  })), _path6597 || (_path6597 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#3ba516"
  })), _path6598 || (_path6598 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#2e9e0a"
  })), _path6599 || (_path6599 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#29a10c"
  })), _path6600 || (_path6600 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#1d8c12"
  })), _path6601 || (_path6601 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#2b8912"
  })), _path6602 || (_path6602 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#85c63c",
    fillOpacity: 0.988
  })), _path6603 || (_path6603 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#569b29",
    fillOpacity: 0.969
  })), _path6604 || (_path6604 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h1v1h-1z",
    fill: "#489c29"
  })), _path6605 || (_path6605 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#238117"
  })), _path6606 || (_path6606 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#389b22"
  })), _path6607 || (_path6607 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#147919"
  })), _path6608 || (_path6608 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#136c0c"
  })), _path6609 || (_path6609 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97h1v1h-1z",
    fill: "#5d9f33"
  })), _path6610 || (_path6610 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#47a715"
  })), _path6611 || (_path6611 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#388e17"
  })), _path6612 || (_path6612 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#0d540a"
  })), _path6613 || (_path6613 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97v1h-1v-1z",
    fill: "#146e13"
  })), _path6614 || (_path6614 = /*#__PURE__*/React.createElement("path", {
    d: "M53 97h1v1h-1z",
    fill: "#075206"
  })), _path6615 || (_path6615 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#3e8822"
  })), _path6616 || (_path6616 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#35a01f"
  })), _path6617 || (_path6617 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#13820f"
  })), _path6618 || (_path6618 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#055805"
  })), _path6619 || (_path6619 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#003e01"
  })), _path6620 || (_path6620 = /*#__PURE__*/React.createElement("path", {
    d: "M60 98h-1v-1h1z",
    fill: "#3e7d1e"
  })), _path6621 || (_path6621 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#81c237"
  })), _path6622 || (_path6622 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#5faf23"
  })), _path6623 || (_path6623 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#52af26"
  })), _path6624 || (_path6624 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#1a7910"
  })), _path6625 || (_path6625 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98h-1v-1h1z",
    fill: "#1d7215"
  })), _path6626 || (_path6626 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#5c9b37"
  })), _path6627 || (_path6627 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#9abf55"
  })), _path6628 || (_path6628 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#87b44a"
  })), _path6629 || (_path6629 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#2b7a17"
  })), _path6630 || (_path6630 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#026b03"
  })), _path6631 || (_path6631 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#25a316"
  })), _path6632 || (_path6632 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#177b0f"
  })), _path6633 || (_path6633 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#014903"
  })), _path6634 || (_path6634 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#137a12"
  })), _path6635 || (_path6635 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#0f9719"
  })), _path6636 || (_path6636 = /*#__PURE__*/React.createElement("path", {
    d: "M76 97v1h-1v-1z",
    fill: "#08610f"
  })), _path6637 || (_path6637 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#034507"
  })), _path6638 || (_path6638 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#0c4f06"
  })), _path6639 || (_path6639 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v1h-1v-1z",
    fill: "#10530a"
  })), _path6640 || (_path6640 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#23a005"
  })), _path6641 || (_path6641 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#38ad07"
  })), _path6642 || (_path6642 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1z",
    fill: "#66c52b"
  })), _path6643 || (_path6643 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#6bc129"
  })), _path6644 || (_path6644 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#4fa925"
  })), _path6645 || (_path6645 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1z",
    fill: "#13560e"
  })), _path6646 || (_path6646 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#31861e"
  })), _path6647 || (_path6647 = /*#__PURE__*/React.createElement("path", {
    d: "M88 97v1h-1v-1z",
    fill: "#61a647"
  })), _path6648 || (_path6648 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v1h-1v-1z",
    fill: "#0f6b0e"
  })), _path6649 || (_path6649 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#22811c"
  })), _path6650 || (_path6650 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-1h1v1z",
    fill: "#389e25"
  })), _path6651 || (_path6651 = /*#__PURE__*/React.createElement("path", {
    d: "M91 97h1v1h-1z",
    fill: "#2b9b1c"
  })), _path6652 || (_path6652 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-1h1z",
    fill: "#339b23"
  })), _path6653 || (_path6653 = /*#__PURE__*/React.createElement("path", {
    d: "M93 97h1v1h-1z",
    fill: "#147e15"
  })), _path6654 || (_path6654 = /*#__PURE__*/React.createElement("path", {
    d: "M94 97h1v1h-1z",
    fill: "#439234"
  })), _path6655 || (_path6655 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v-1h1v1z",
    fill: "#0b6b09"
  })), _path6656 || (_path6656 = /*#__PURE__*/React.createElement("path", {
    d: "M97 97v1h-1v-1z",
    fill: "#279217"
  })), _path6657 || (_path6657 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98v-1h1v1z",
    fill: "#61b738"
  })), _path6658 || (_path6658 = /*#__PURE__*/React.createElement("path", {
    d: "M99 98h-1v-1h1z",
    fill: "#85bd5f",
    fillOpacity: 0.553
  })), _path6659 || (_path6659 = /*#__PURE__*/React.createElement("path", {
    d: "M101 97h1v1h-1z",
    fill: "#8dc68d",
    fillOpacity: 0.035
  })), _path6660 || (_path6660 = /*#__PURE__*/React.createElement("path", {
    d: "M102 98v-1h1v1z",
    fill: "#b6b691",
    fillOpacity: 0.027
  })), _path6661 || (_path6661 = /*#__PURE__*/React.createElement("path", {
    d: "M103 97h1v1h-1z",
    fill: "#5ba366",
    fillOpacity: 0.098
  })), _path6662 || (_path6662 = /*#__PURE__*/React.createElement("path", {
    d: "M105 97v1h-1v-1z",
    fill: "#46a035",
    fillOpacity: 0.706
  })), _path6663 || (_path6663 = /*#__PURE__*/React.createElement("path", {
    d: "M105 98v-1h1v1z",
    fill: "#5eb947",
    fillOpacity: 0.867
  })), _path6664 || (_path6664 = /*#__PURE__*/React.createElement("path", {
    d: "M107 98h-1v-1h1z",
    fill: "#24a016"
  })), _path6665 || (_path6665 = /*#__PURE__*/React.createElement("path", {
    d: "M108 97v1h-1v-1z",
    fill: "#59b029",
    fillOpacity: 0.624
  })), _path6666 || (_path6666 = /*#__PURE__*/React.createElement("path", {
    d: "M16 98h1v1h-1z",
    fill: "#ffffbf",
    fillOpacity: 0.016
  })), _path6667 || (_path6667 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#adbc8e",
    fillOpacity: 0.196
  })), _path6668 || (_path6668 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#afbf93",
    fillOpacity: 0.251
  })), _path6669 || (_path6669 = /*#__PURE__*/React.createElement("path", {
    d: "M31 99h-1v-1h1z",
    fill: "#e2ffff",
    fillOpacity: 0.035
  })), _path6670 || (_path6670 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#8bca59",
    fillOpacity: 0.69
  })), _path6671 || (_path6671 = /*#__PURE__*/React.createElement("path", {
    d: "M32 98h1v1h-1z",
    fill: "#66bd2d"
  })), _path6672 || (_path6672 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#2d9c1c"
  })), _path6673 || (_path6673 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#45a323",
    fillOpacity: 0.969
  })), _path6674 || (_path6674 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#49a420",
    fillOpacity: 0.922
  })), _path6675 || (_path6675 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#6bac2f",
    fillOpacity: 0.839
  })), _path6676 || (_path6676 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#58a31f",
    fillOpacity: 0.702
  })), _path6677 || (_path6677 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#5dab37"
  })), _path6678 || (_path6678 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#75bd3b"
  })), _path6679 || (_path6679 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98h1v1h-1z",
    fill: "#8bc63f",
    fillOpacity: 0.761
  })), _path6680 || (_path6680 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#549d31",
    fillOpacity: 0.686
  })), _path6681 || (_path6681 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#55a137",
    fillOpacity: 0.988
  })), _path6682 || (_path6682 = /*#__PURE__*/React.createElement("path", {
    d: "M43 99v-1h1v1z",
    fill: "#388c1e"
  })), _path6683 || (_path6683 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1z",
    fill: "#48a927"
  })), _path6684 || (_path6684 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#187610"
  })), _path6685 || (_path6685 = /*#__PURE__*/React.createElement("path", {
    d: "M46 99v-1h1v1z",
    fill: "#057010"
  })), _path6686 || (_path6686 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-1v-1z",
    fill: "#398425"
  })), _path6687 || (_path6687 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1z",
    fill: "#4b7e26"
  })), _path6688 || (_path6688 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99h-1v-1h1z",
    fill: "#46a720"
  })), _path6689 || (_path6689 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v1h-1v-1z",
    fill: "#3ea60e"
  })), _path6690 || (_path6690 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#50952c"
  })), _path6691 || (_path6691 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#438932"
  })), _path6692 || (_path6692 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#015504"
  })), _path6693 || (_path6693 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#1d7713"
  })), _path6694 || (_path6694 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v-1h1v1z",
    fill: "#2d9d1b"
  })), _path6695 || (_path6695 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#0c6b07"
  })), _path6696 || (_path6696 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#066408"
  })), _path6697 || (_path6697 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#055003"
  })), _path6698 || (_path6698 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#2c761c"
  })), _path6699 || (_path6699 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v-1h1v1z",
    fill: "#66aa2f"
  })), _path6700 || (_path6700 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1z",
    fill: "#8ac636"
  })), _path6701 || (_path6701 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#5aaf25"
  })), _path6702 || (_path6702 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#066c05"
  })), _path6703 || (_path6703 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#218f12"
  })), _path6704 || (_path6704 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-1v-1z",
    fill: "#41a525"
  })), _path6705 || (_path6705 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1z",
    fill: "#449a29"
  })), _path6706 || (_path6706 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98h1v1h-1z",
    fill: "#7ab740"
  })), _path6707 || (_path6707 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#7fb849"
  })), _path6708 || (_path6708 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#29961d"
  })), _path6709 || (_path6709 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#1f8116"
  })), _path6710 || (_path6710 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#084d05"
  })), _path6711 || (_path6711 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#015004"
  })), _path6712 || (_path6712 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#08720d"
  })), _path6713 || (_path6713 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#16971a"
  })), _path6714 || (_path6714 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#3b6d1f"
  })), _path6715 || (_path6715 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1z",
    fill: "#36861d"
  })), _path6716 || (_path6716 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1z",
    fill: "#1e930d"
  })), _path6717 || (_path6717 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1z",
    fill: "#27a509"
  })), _path6718 || (_path6718 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#31ad0c"
  })), _path6719 || (_path6719 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98h1v1h-1z",
    fill: "#179807"
  })), _path6720 || (_path6720 = /*#__PURE__*/React.createElement("path", {
    d: "M82 98h1v1h-1z",
    fill: "#69be3a"
  })), _path6721 || (_path6721 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98h1v1h-1z",
    fill: "#96cc51"
  })), _path6722 || (_path6722 = /*#__PURE__*/React.createElement("path", {
    d: "M85 98v1h-1v-1z",
    fill: "#51962c"
  })), _path6723 || (_path6723 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h-1v-1h1z",
    fill: "#004c01"
  })), _path6724 || (_path6724 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#3a8e27"
  })), _path6725 || (_path6725 = /*#__PURE__*/React.createElement("path", {
    d: "M88 98v1h-1v-1z",
    fill: "#549c39"
  })), _path6726 || (_path6726 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#13650f"
  })), _path6727 || (_path6727 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#2d921a"
  })), _path6728 || (_path6728 = /*#__PURE__*/React.createElement("path", {
    d: "M91 98h1v1h-1z",
    fill: "#31971d"
  })), _path6729 || (_path6729 = /*#__PURE__*/React.createElement("path", {
    d: "M93 99h-1v-1h1z",
    fill: "#0e6f0c"
  })), _path6730 || (_path6730 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1z",
    fill: "#07750a"
  })), _path6731 || (_path6731 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98v1h-1v-1z",
    fill: "#439933"
  })), _path6732 || (_path6732 = /*#__PURE__*/React.createElement("path", {
    d: "M95 98h1v1h-1z",
    fill: "#097a09"
  })), _path6733 || (_path6733 = /*#__PURE__*/React.createElement("path", {
    d: "M97 99h-1v-1h1z",
    fill: "#3ea220"
  })), _path6734 || (_path6734 = /*#__PURE__*/React.createElement("path", {
    d: "M97 98h1v1h-1z",
    fill: "#87cb57"
  })), _path6735 || (_path6735 = /*#__PURE__*/React.createElement("path", {
    d: "M98 98h1v1h-1z",
    fill: "#86ba69",
    fillOpacity: 0.482
  })), _path6736 || (_path6736 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h-1v-1h1z",
    fill: "#bbe4c9",
    fillOpacity: 0.075
  })), _path6737 || (_path6737 = /*#__PURE__*/React.createElement("path", {
    d: "M104 98v1h-1v-1z",
    fill: "#6eb862",
    fillOpacity: 0.698
  })), _path6738 || (_path6738 = /*#__PURE__*/React.createElement("path", {
    d: "M104 99v-1h1v1z",
    fill: "#73bb56",
    fillOpacity: 0.604
  })), _path6739 || (_path6739 = /*#__PURE__*/React.createElement("path", {
    d: "M106 98v1h-1v-1z",
    fill: "#42aa24",
    fillOpacity: 0.824
  })), _path6740 || (_path6740 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99v-1h1v1z",
    fill: "#51b132",
    fillOpacity: 0.878
  })), _path6741 || (_path6741 = /*#__PURE__*/React.createElement("path", {
    d: "M108 98v1h-1v-1z",
    fill: "#a6d185",
    fillOpacity: 0.396
  })), _path6742 || (_path6742 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100h-1v-1h1z",
    fill: "#abbe8f",
    fillOpacity: 0.216
  })), _path6743 || (_path6743 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v-1h1v1z",
    fill: "#acc58f",
    fillOpacity: 0.243
  })), _path6744 || (_path6744 = /*#__PURE__*/React.createElement("path", {
    d: "M28 100v-1h1v1z",
    fill: "#96c387",
    fillOpacity: 0.067
  })), _path6745 || (_path6745 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100h-1v-1h1z",
    fill: "#86b269",
    fillOpacity: 0.275
  })), _path6746 || (_path6746 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v-1h1v1z",
    fill: "#80bb54",
    fillOpacity: 0.725
  })), _path6747 || (_path6747 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#72b925",
    fillOpacity: 0.98
  })), _path6748 || (_path6748 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#41a617"
  })), _path6749 || (_path6749 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99v1h-1v-1z",
    fill: "#2b921a",
    fillOpacity: 0.965
  })), _path6750 || (_path6750 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#6eac44",
    fillOpacity: 0.353
  })), _path6751 || (_path6751 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#9fc25f",
    fillOpacity: 0.231
  })), _path6752 || (_path6752 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#a5c15e",
    fillOpacity: 0.667
  })), _path6753 || (_path6753 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#7bab46",
    fillOpacity: 0.227
  })), _path6754 || (_path6754 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#7dbc37",
    fillOpacity: 0.89
  })), _path6755 || (_path6755 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#8bc844",
    fillOpacity: 0.937
  })), _path6756 || (_path6756 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#87bc40",
    fillOpacity: 0.937
  })), _path6757 || (_path6757 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100v-1h1v1z",
    fill: "#71a53b",
    fillOpacity: 0.671
  })), _path6758 || (_path6758 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#75ab55",
    fillOpacity: 0.518
  })), _path6759 || (_path6759 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#6bb638",
    fillOpacity: 0.953
  })), _path6760 || (_path6760 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#38951b"
  })), _path6761 || (_path6761 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h1z",
    fill: "#067206"
  })), _path6762 || (_path6762 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#188d22"
  })), _path6763 || (_path6763 = /*#__PURE__*/React.createElement("path", {
    d: "M48 99v1h-1v-1z",
    fill: "#428128"
  })), _path6764 || (_path6764 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#3d7c2a"
  })), _path6765 || (_path6765 = /*#__PURE__*/React.createElement("path", {
    d: "M50 99v1h-1v-1z",
    fill: "#4c9f34"
  })), _path6766 || (_path6766 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#49a51b"
  })), _path6767 || (_path6767 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99v1h-1v-1z",
    fill: "#61a236"
  })), _path6768 || (_path6768 = /*#__PURE__*/React.createElement("path", {
    d: "M53 100v-1h1v1z",
    fill: "#095e05"
  })), _path6769 || (_path6769 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#0a710f"
  })), _path6770 || (_path6770 = /*#__PURE__*/React.createElement("path", {
    d: "M55 100v-1h1v1z",
    fill: "#1b9817"
  })), _path6771 || (_path6771 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#086005"
  })), _path6772 || (_path6772 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1z",
    fill: "#026606"
  })), _path6773 || (_path6773 = /*#__PURE__*/React.createElement("path", {
    d: "M58 100v-1h1v1z",
    fill: "#076b09"
  })), _path6774 || (_path6774 = /*#__PURE__*/React.createElement("path", {
    d: "M60 99v1h-1v-1z",
    fill: "#076704"
  })), _path6775 || (_path6775 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#4ea022"
  })), _path6776 || (_path6776 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#8cc836"
  })), _path6777 || (_path6777 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#7ac037"
  })), _path6778 || (_path6778 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#1f8c16"
  })), _path6779 || (_path6779 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#2c9e1b"
  })), _path6780 || (_path6780 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#369c1a"
  })), _path6781 || (_path6781 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#0d7905"
  })), _path6782 || (_path6782 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#52a52f"
  })), _path6783 || (_path6783 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#5bb42e"
  })), _path6784 || (_path6784 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#3c9b2c"
  })), _path6785 || (_path6785 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#034605"
  })), _path6786 || (_path6786 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#054503"
  })), _path6787 || (_path6787 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#0d5e08"
  })), _path6788 || (_path6788 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#036c06"
  })), _path6789 || (_path6789 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#107f12"
  })), _path6790 || (_path6790 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#1d8c19"
  })), _path6791 || (_path6791 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#2f961d"
  })), _path6792 || (_path6792 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#1c9907"
  })), _path6793 || (_path6793 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1z",
    fill: "#36ae0f"
  })), _path6794 || (_path6794 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h1v1h-1z",
    fill: "#4fb622"
  })), _path6795 || (_path6795 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1z",
    fill: "#52b12c"
  })), _path6796 || (_path6796 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100h-1v-1h1z",
    fill: "#228a17"
  })), _path6797 || (_path6797 = /*#__PURE__*/React.createElement("path", {
    d: "M82 100v-1h1v1z",
    fill: "#66ba3b"
  })), _path6798 || (_path6798 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-1v-1z",
    fill: "#5da626"
  })), _path6799 || (_path6799 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h1v1h-1z",
    fill: "#609e37"
  })), _path6800 || (_path6800 = /*#__PURE__*/React.createElement("path", {
    d: "M85 99h1v1h-1z",
    fill: "#2c7023"
  })), _path6801 || (_path6801 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v1h-1z",
    fill: "#3d952b"
  })), _path6802 || (_path6802 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1z",
    fill: "#19810f"
  })), _path6803 || (_path6803 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#2b931b"
  })), _path6804 || (_path6804 = /*#__PURE__*/React.createElement("path", {
    d: "M90 100h-1v-1h1z",
    fill: "#25851a"
  })), _path6805 || (_path6805 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99v1h-1v-1z",
    fill: "#217d11"
  })), _path6806 || (_path6806 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h1v1h-1z",
    fill: "#47a926"
  })), _path6807 || (_path6807 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100v-1h1v1z",
    fill: "#0a7307"
  })), _path6808 || (_path6808 = /*#__PURE__*/React.createElement("path", {
    d: "M93 100v-1h1v1z",
    fill: "#0e7408"
  })), _path6809 || (_path6809 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100h-1v-1h1z",
    fill: "#439d34"
  })), _path6810 || (_path6810 = /*#__PURE__*/React.createElement("path", {
    d: "M95 99h1v1h-1z",
    fill: "#27981e"
  })), _path6811 || (_path6811 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100h-1v-1h1z",
    fill: "#49ae1e"
  })), _path6812 || (_path6812 = /*#__PURE__*/React.createElement("path", {
    d: "M98 99v1h-1v-1z",
    fill: "#91c961",
    fillOpacity: 0.965
  })), _path6813 || (_path6813 = /*#__PURE__*/React.createElement("path", {
    d: "M99 100h-1v-1h1z",
    fill: "#89b96c",
    fillOpacity: 0.486
  })), _path6814 || (_path6814 = /*#__PURE__*/React.createElement("path", {
    d: "M101 100v-1h1v1z",
    fill: "#daecda",
    fillOpacity: 0.055
  })), _path6815 || (_path6815 = /*#__PURE__*/React.createElement("path", {
    d: "M102 100v-1h1v1z",
    fill: "#9dc88a",
    fillOpacity: 0.439
  })), _path6816 || (_path6816 = /*#__PURE__*/React.createElement("path", {
    d: "M103 99h1v1h-1z",
    fill: "#84c56e",
    fillOpacity: 0.596
  })), _path6817 || (_path6817 = /*#__PURE__*/React.createElement("path", {
    d: "M104 99h1v1h-1z",
    fill: "#59af2b",
    fillOpacity: 0.851
  })), _path6818 || (_path6818 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99v1h-1v-1z",
    fill: "#51ad25",
    fillOpacity: 0.647
  })), _path6819 || (_path6819 = /*#__PURE__*/React.createElement("path", {
    d: "M106 99h1v1h-1z",
    fill: "#aed596",
    fillOpacity: 0.286
  })), _path6820 || (_path6820 = /*#__PURE__*/React.createElement("path", {
    d: "M108 100h-1v-1h1z",
    fill: "#abcc98",
    fillOpacity: 0.42
  })), _path6821 || (_path6821 = /*#__PURE__*/React.createElement("path", {
    d: "M109 100h-1v-1h1z",
    fill: "#cccce5",
    fillOpacity: 0.039
  })), _path6822 || (_path6822 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v1h-1v-1z",
    fill: "#9fbf8f",
    fillOpacity: 0.063
  })), _path6823 || (_path6823 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v-1h1v1z",
    fill: "#92bc6e",
    fillOpacity: 0.463
  })), _path6824 || (_path6824 = /*#__PURE__*/React.createElement("path", {
    d: "M29 101h-1v-1h1z",
    fill: "#7fb459",
    fillOpacity: 0.627
  })), _path6825 || (_path6825 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v1h-1v-1z",
    fill: "#91bb69",
    fillOpacity: 0.427
  })), _path6826 || (_path6826 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-1h1z",
    fill: "#9ad060",
    fillOpacity: 0.498
  })), _path6827 || (_path6827 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#8fc136",
    fillOpacity: 0.753
  })), _path6828 || (_path6828 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#3da416"
  })), _path6829 || (_path6829 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#40a028",
    fillOpacity: 0.812
  })), _path6830 || (_path6830 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#dfbf7f",
    fillOpacity: 0.031
  })), _path6831 || (_path6831 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#accc6a",
    fillOpacity: 0.639
  })), _path6832 || (_path6832 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#93c659",
    fillOpacity: 0.616
  })), _path6833 || (_path6833 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#93c159",
    fillOpacity: 0.392
  })), _path6834 || (_path6834 = /*#__PURE__*/React.createElement("path", {
    d: "M40 100v1h-1v-1z",
    fill: "#8dcc4c",
    fillOpacity: 0.416
  })), _path6835 || (_path6835 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#77b632",
    fillOpacity: 0.996
  })), _path6836 || (_path6836 = /*#__PURE__*/React.createElement("path", {
    d: "M42 101h-1v-1h1z",
    fill: "#71a64d",
    fillOpacity: 0.361
  })), _path6837 || (_path6837 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#74b159",
    fillOpacity: 0.412
  })), _path6838 || (_path6838 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#61ad2d",
    fillOpacity: 0.937
  })), _path6839 || (_path6839 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#378618"
  })), _path6840 || (_path6840 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-1h1v1z",
    fill: "#217f17"
  })), _path6841 || (_path6841 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#2f9526"
  })), _path6842 || (_path6842 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101v-1h1v1z",
    fill: "#347a20"
  })), _path6843 || (_path6843 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100h1v1h-1z",
    fill: "#115e0e"
  })), _path6844 || (_path6844 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#348328"
  })), _path6845 || (_path6845 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#2e8b1a"
  })), _path6846 || (_path6846 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#3eaa13"
  })), _path6847 || (_path6847 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#4fa621"
  })), _path6848 || (_path6848 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#257010"
  })), _path6849 || (_path6849 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#036409"
  })), _path6850 || (_path6850 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#108c13"
  })), _path6851 || (_path6851 = /*#__PURE__*/React.createElement("path", {
    d: "M56 101v-1h1v1z",
    fill: "#055804"
  })), _path6852 || (_path6852 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#045c01"
  })), _path6853 || (_path6853 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#1b7411"
  })), _path6854 || (_path6854 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#288a1c"
  })), _path6855 || (_path6855 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#4ea523"
  })), _path6856 || (_path6856 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#86c031"
  })), _path6857 || (_path6857 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#8ace42"
  })), _path6858 || (_path6858 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#258c13"
  })), _path6859 || (_path6859 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#1a8c14"
  })), _path6860 || (_path6860 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#2d9e15"
  })), _path6861 || (_path6861 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#1e8d15"
  })), _path6862 || (_path6862 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#17760e"
  })), _path6863 || (_path6863 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#41b020"
  })), _path6864 || (_path6864 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#1f8e14"
  })), _path6865 || (_path6865 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#006503"
  })), _path6866 || (_path6866 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#066609"
  })), _path6867 || (_path6867 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100v1h-1v-1z",
    fill: "#096205"
  })), _path6868 || (_path6868 = /*#__PURE__*/React.createElement("path", {
    d: "M73 101v-1h1v1z",
    fill: "#11780d"
  })), _path6869 || (_path6869 = /*#__PURE__*/React.createElement("path", {
    d: "M74 101v-1h1v1z",
    fill: "#2a9821"
  })), _path6870 || (_path6870 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#15970d"
  })), _path6871 || (_path6871 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100v1h-1v-1z",
    fill: "#1ea204"
  })), _path6872 || (_path6872 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100h1v1h-1z",
    fill: "#48b51f"
  })), _path6873 || (_path6873 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101h-1v-1h1z",
    fill: "#59ba34"
  })), _path6874 || (_path6874 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101v-1h1v1z",
    fill: "#449c35"
  })), _path6875 || (_path6875 = /*#__PURE__*/React.createElement("path", {
    d: "M81 100h1v1h-1z",
    fill: "#4d9d34"
  })), _path6876 || (_path6876 = /*#__PURE__*/React.createElement("path", {
    d: "M83 100v1h-1v-1z",
    fill: "#5fb334"
  })), _path6877 || (_path6877 = /*#__PURE__*/React.createElement("path", {
    d: "M84 101h-1v-1h1z",
    fill: "#238a13"
  })), _path6878 || (_path6878 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101h-1v-1h1z",
    fill: "#66b342"
  })), _path6879 || (_path6879 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#459c2d"
  })), _path6880 || (_path6880 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#339c25"
  })), _path6881 || (_path6881 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#22871c"
  })), _path6882 || (_path6882 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#0b630a"
  })), _path6883 || (_path6883 = /*#__PURE__*/React.createElement("path", {
    d: "M89 100h1v1h-1z",
    fill: "#167512"
  })), _path6884 || (_path6884 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v-1h1v1z",
    fill: "#2a8f1c"
  })), _path6885 || (_path6885 = /*#__PURE__*/React.createElement("path", {
    d: "M91 101v-1h1v1z",
    fill: "#3aa51a"
  })), _path6886 || (_path6886 = /*#__PURE__*/React.createElement("path", {
    d: "M92 100h1v1h-1z",
    fill: "#188411"
  })), _path6887 || (_path6887 = /*#__PURE__*/React.createElement("path", {
    d: "M94 101h-1v-1h1z",
    fill: "#137d0d"
  })), _path6888 || (_path6888 = /*#__PURE__*/React.createElement("path", {
    d: "M95 100v1h-1v-1z",
    fill: "#41a230"
  })), _path6889 || (_path6889 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101v-1h1v1z",
    fill: "#39a219"
  })), _path6890 || (_path6890 = /*#__PURE__*/React.createElement("path", {
    d: "M97 100v1h-1v-1z",
    fill: "#5ab72e"
  })), _path6891 || (_path6891 = /*#__PURE__*/React.createElement("path", {
    d: "M98 100v1h-1v-1z",
    fill: "#8dc460",
    fillOpacity: 0.733
  })), _path6892 || (_path6892 = /*#__PURE__*/React.createElement("path", {
    d: "M98 100h1v1h-1z",
    fill: "#71a56e",
    fillOpacity: 0.424
  })), _path6893 || (_path6893 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100v1h-1v-1z",
    fill: "#6a947f",
    fillOpacity: 0.047
  })), _path6894 || (_path6894 = /*#__PURE__*/React.createElement("path", {
    d: "M100 101v-1h1v1z",
    fill: "#66a172",
    fillOpacity: 0.235
  })), _path6895 || (_path6895 = /*#__PURE__*/React.createElement("path", {
    d: "M101 100h1v1h-1z",
    fill: "#99c291",
    fillOpacity: 0.412
  })), _path6896 || (_path6896 = /*#__PURE__*/React.createElement("path", {
    d: "M102 101v-1h1v1z",
    fill: "#8ec96b",
    fillOpacity: 0.616
  })), _path6897 || (_path6897 = /*#__PURE__*/React.createElement("path", {
    d: "M103 100h1v1h-1z",
    fill: "#66b32a",
    fillOpacity: 0.902
  })), _path6898 || (_path6898 = /*#__PURE__*/React.createElement("path", {
    d: "M104 100h1v1h-1z",
    fill: "#60b12a",
    fillOpacity: 0.631
  })), _path6899 || (_path6899 = /*#__PURE__*/React.createElement("path", {
    d: "M106 101h-1v-1h1z",
    fill: "#dfdfbf",
    fillOpacity: 0.031
  })), _path6900 || (_path6900 = /*#__PURE__*/React.createElement("path", {
    d: "M107 100v1h-1v-1z",
    fill: "#c8d7be",
    fillOpacity: 0.2
  })), _path6901 || (_path6901 = /*#__PURE__*/React.createElement("path", {
    d: "M108 101h-1v-1h1z",
    fill: "#c5d6b3",
    fillOpacity: 0.173
  })), _path6902 || (_path6902 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101v1h-1v-1z",
    fill: "#b8c6aa",
    fillOpacity: 0.071
  })), _path6903 || (_path6903 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102v-1h1v1z",
    fill: "#9cbf85",
    fillOpacity: 0.173
  })), _path6904 || (_path6904 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v1h-1v-1z",
    fill: "#99ba82",
    fillOpacity: 0.306
  })), _path6905 || (_path6905 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102h-1v-1h1z",
    fill: "#92b87f",
    fillOpacity: 0.157
  })), _path6906 || (_path6906 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101h1v1h-1z",
    fill: "#9cc475",
    fillOpacity: 0.102
  })), _path6907 || (_path6907 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#9cbf6b",
    fillOpacity: 0.427
  })), _path6908 || (_path6908 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101v1h-1v-1z",
    fill: "#b1cb81",
    fillOpacity: 0.231
  })), _path6909 || (_path6909 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#88bc32",
    fillOpacity: 0.827
  })), _path6910 || (_path6910 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#4daa1e",
    fillOpacity: 0.988
  })), _path6911 || (_path6911 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1z",
    fill: "#2d9717",
    fillOpacity: 0.886
  })), _path6912 || (_path6912 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#24881b",
    fillOpacity: 0.11
  })), _path6913 || (_path6913 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#9cc761",
    fillOpacity: 0.722
  })), _path6914 || (_path6914 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#a0cc67",
    fillOpacity: 0.569
  })), _path6915 || (_path6915 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#87b353",
    fillOpacity: 0.553
  })), _path6916 || (_path6916 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#90c554",
    fillOpacity: 0.69
  })), _path6917 || (_path6917 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#8ab949",
    fillOpacity: 0.616
  })), _path6918 || (_path6918 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#6ba338",
    fillOpacity: 0.8
  })), _path6919 || (_path6919 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#64a83f",
    fillOpacity: 0.518
  })), _path6920 || (_path6920 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#50a024",
    fillOpacity: 0.816
  })), _path6921 || (_path6921 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102h-1v-1h1z",
    fill: "#2c8210"
  })), _path6922 || (_path6922 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102h-1v-1h1z",
    fill: "#378626"
  })), _path6923 || (_path6923 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#369d27"
  })), _path6924 || (_path6924 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#438f2e"
  })), _path6925 || (_path6925 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#2e7e28"
  })), _path6926 || (_path6926 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#31881e"
  })), _path6927 || (_path6927 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#389724"
  })), _path6928 || (_path6928 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#45a028"
  })), _path6929 || (_path6929 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#44a519"
  })), _path6930 || (_path6930 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#3e841c"
  })), _path6931 || (_path6931 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#035704"
  })), _path6932 || (_path6932 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#0a840d"
  })), _path6933 || (_path6933 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#056007"
  })), _path6934 || (_path6934 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#0f760c"
  })), _path6935 || (_path6935 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#248f17"
  })), _path6936 || (_path6936 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#4dac2e"
  })), _path6937 || (_path6937 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#7bbe2a"
  })), _path6938 || (_path6938 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#94cc40"
  })), _path6939 || (_path6939 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#40a11f"
  })), _path6940 || (_path6940 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#21921c"
  })), _path6941 || (_path6941 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#34a317"
  })), _path6942 || (_path6942 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#1b8312"
  })), _path6943 || (_path6943 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#176a17"
  })), _path6944 || (_path6944 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v1h-1z",
    fill: "#3f9831",
    fillOpacity: 0.988
  })), _path6945 || (_path6945 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#249412"
  })), _path6946 || (_path6946 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#128a08"
  })), _path6947 || (_path6947 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#199511"
  })), _path6948 || (_path6948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#2aa80e"
  })), _path6949 || (_path6949 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1z",
    fill: "#39a717"
  })), _path6950 || (_path6950 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#3eaf13"
  })), _path6951 || (_path6951 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#4fb417"
  })), _path6952 || (_path6952 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102v-1h1v1z",
    fill: "#5cad3f"
  })), _path6953 || (_path6953 = /*#__PURE__*/React.createElement("path", {
    d: "M79 101v1h-1v-1z",
    fill: "#3d9128"
  })), _path6954 || (_path6954 = /*#__PURE__*/React.createElement("path", {
    d: "M80 102h-1v-1h1z",
    fill: "#5cb036",
    fillOpacity: 0.776
  })), _path6955 || (_path6955 = /*#__PURE__*/React.createElement("path", {
    d: "M80 101h1v1h-1z",
    fill: "#156512",
    fillOpacity: 0.8
  })), _path6956 || (_path6956 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#59a638",
    fillOpacity: 0.992
  })), _path6957 || (_path6957 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102v-1h1v1z",
    fill: "#50a72e"
  })), _path6958 || (_path6958 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v-1h1v1z",
    fill: "#43a82a"
  })), _path6959 || (_path6959 = /*#__PURE__*/React.createElement("path", {
    d: "M86 101v1h-1v-1z",
    fill: "#2a991b"
  })), _path6960 || (_path6960 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#19851e",
    fillOpacity: 0.863
  })), _path6961 || (_path6961 = /*#__PURE__*/React.createElement("path", {
    d: "M88 102h-1v-1h1z",
    fill: "#1f6829",
    fillOpacity: 0.478
  })), _path6962 || (_path6962 = /*#__PURE__*/React.createElement("path", {
    d: "M89 101v1h-1v-1z",
    fill: "#125e19",
    fillOpacity: 0.553
  })), _path6963 || (_path6963 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v1h-1v-1z",
    fill: "#2e8c21",
    fillOpacity: 0.996
  })), _path6964 || (_path6964 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h-1v-1h1z",
    fill: "#41a024"
  })), _path6965 || (_path6965 = /*#__PURE__*/React.createElement("path", {
    d: "M92 101v1h-1v-1z",
    fill: "#359b1f"
  })), _path6966 || (_path6966 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v-1h1v1z",
    fill: "#178911"
  })), _path6967 || (_path6967 = /*#__PURE__*/React.createElement("path", {
    d: "M94 102v-1h1v1z",
    fill: "#439e2b"
  })), _path6968 || (_path6968 = /*#__PURE__*/React.createElement("path", {
    d: "M95 101h1v1h-1z",
    fill: "#5bb024"
  })), _path6969 || (_path6969 = /*#__PURE__*/React.createElement("path", {
    d: "M97 102h-1v-1h1z",
    fill: "#67bc3b"
  })), _path6970 || (_path6970 = /*#__PURE__*/React.createElement("path", {
    d: "M97 101h1v1h-1z",
    fill: "#50a23b",
    fillOpacity: 0.761
  })), _path6971 || (_path6971 = /*#__PURE__*/React.createElement("path", {
    d: "M98 101h1v1h-1z",
    fill: "#4f9a5c",
    fillOpacity: 0.388
  })), _path6972 || (_path6972 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102v-1h1v1z",
    fill: "#419843",
    fillOpacity: 0.655
  })), _path6973 || (_path6973 = /*#__PURE__*/React.createElement("path", {
    d: "M101 101v1h-1v-1z",
    fill: "#7ebc70",
    fillOpacity: 0.553
  })), _path6974 || (_path6974 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102h-1v-1h1z",
    fill: "#94cf72",
    fillOpacity: 0.506
  })), _path6975 || (_path6975 = /*#__PURE__*/React.createElement("path", {
    d: "M103 102h-1v-1h1z",
    fill: "#64b42c",
    fillOpacity: 0.925
  })), _path6976 || (_path6976 = /*#__PURE__*/React.createElement("path", {
    d: "M103 101h1v1h-1z",
    fill: "#67af2d",
    fillOpacity: 0.569
  })), _path6977 || (_path6977 = /*#__PURE__*/React.createElement("path", {
    d: "M106 102v-1h1v1z",
    fill: "#d5dcc7",
    fillOpacity: 0.145
  })), _path6978 || (_path6978 = /*#__PURE__*/React.createElement("path", {
    d: "M107 101h1v1h-1z",
    fill: "#d3e0c1",
    fillOpacity: 0.227
  })), _path6979 || (_path6979 = /*#__PURE__*/React.createElement("path", {
    d: "M23 103h-1v-1h1z",
    fill: "#bdcda4",
    fillOpacity: 0.122
  })), _path6980 || (_path6980 = /*#__PURE__*/React.createElement("path", {
    d: "M24 102v1h-1v-1z",
    fill: "#b1c89a",
    fillOpacity: 0.259
  })), _path6981 || (_path6981 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#a6c294",
    fillOpacity: 0.216
  })), _path6982 || (_path6982 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#a1bb86",
    fillOpacity: 0.075
  })), _path6983 || (_path6983 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#9fbf7f",
    fillOpacity: 0.031
  })), _path6984 || (_path6984 = /*#__PURE__*/React.createElement("path", {
    d: "M31 103h-1v-1h1z",
    fill: "#93bb6b",
    fillOpacity: 0.373
  })), _path6985 || (_path6985 = /*#__PURE__*/React.createElement("path", {
    d: "M32 102v1h-1v-1z",
    fill: "#66b61d",
    fillOpacity: 0.98
  })), _path6986 || (_path6986 = /*#__PURE__*/React.createElement("path", {
    d: "M33 102v1h-1v-1z",
    fill: "#60ab22",
    fillOpacity: 0.588
  })), _path6987 || (_path6987 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v1z",
    fill: "#3e9529",
    fillOpacity: 0.529
  })), _path6988 || (_path6988 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1z",
    fill: "#419426",
    fillOpacity: 0.6
  })), _path6989 || (_path6989 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103v-1h1v1z",
    fill: "#a4cd7b",
    fillOpacity: 0.463
  })), _path6990 || (_path6990 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#aed175",
    fillOpacity: 0.62
  })), _path6991 || (_path6991 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#c3de8f",
    fillOpacity: 0.369
  })), _path6992 || (_path6992 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#8ab944",
    fillOpacity: 0.749
  })), _path6993 || (_path6993 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#97c860",
    fillOpacity: 0.62
  })), _path6994 || (_path6994 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#b1bf77",
    fillOpacity: 0.427
  })), _path6995 || (_path6995 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#99b668",
    fillOpacity: 0.373
  })), _path6996 || (_path6996 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#5fa834",
    fillOpacity: 0.8
  })), _path6997 || (_path6997 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#56a924",
    fillOpacity: 0.961
  })), _path6998 || (_path6998 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#2e840e"
  })), _path6999 || (_path6999 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#29811a"
  })), _path7000 || (_path7000 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#237e18",
    fillOpacity: 0.996
  })), _path7001 || (_path7001 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#4c913a",
    fillOpacity: 0.988
  })), _path7002 || (_path7002 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#54a62f"
  })), _path7003 || (_path7003 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#409629",
    fillOpacity: 0.992
  })), _path7004 || (_path7004 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#246119",
    fillOpacity: 0.898
  })), _path7005 || (_path7005 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#499824",
    fillOpacity: 0.992
  })), _path7006 || (_path7006 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#398d19"
  })), _path7007 || (_path7007 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#0b6109"
  })), _path7008 || (_path7008 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#108811"
  })), _path7009 || (_path7009 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#128611"
  })), _path7010 || (_path7010 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#269818"
  })), _path7011 || (_path7011 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#2f971f"
  })), _path7012 || (_path7012 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#4ca426"
  })), _path7013 || (_path7013 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#64aa1f"
  })), _path7014 || (_path7014 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#60a91e"
  })), _path7015 || (_path7015 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#8cc83a"
  })), _path7016 || (_path7016 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#75be35"
  })), _path7017 || (_path7017 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#1a8c0a"
  })), _path7018 || (_path7018 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#40ac1f"
  })), _path7019 || (_path7019 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#278320",
    fillOpacity: 0.996
  })), _path7020 || (_path7020 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#32802e"
  })), _path7021 || (_path7021 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#56994f",
    fillOpacity: 0.569
  })), _path7022 || (_path7022 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#449b1e",
    fillOpacity: 0.843
  })), _path7023 || (_path7023 = /*#__PURE__*/React.createElement("path", {
    d: "M70 102h1v1h-1z",
    fill: "#4ca917"
  })), _path7024 || (_path7024 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v-1h1v1z",
    fill: "#4ea816"
  })), _path7025 || (_path7025 = /*#__PURE__*/React.createElement("path", {
    d: "M73 102v1h-1v-1z",
    fill: "#49af16"
  })), _path7026 || (_path7026 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#4bb616"
  })), _path7027 || (_path7027 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h1v1h-1z",
    fill: "#4db61f"
  })), _path7028 || (_path7028 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#63b73b"
  })), _path7029 || (_path7029 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#75bf3a"
  })), _path7030 || (_path7030 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-1v-1h1z",
    fill: "#37931a"
  })), _path7031 || (_path7031 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#3d912e",
    fillOpacity: 0.816
  })), _path7032 || (_path7032 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h1v1h-1z",
    fill: "#a5c797",
    fillOpacity: 0.145
  })), _path7033 || (_path7033 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v-1h1v1z",
    fill: "#6ea55f",
    fillOpacity: 0.2
  })), _path7034 || (_path7034 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#69ba44",
    fillOpacity: 0.961
  })), _path7035 || (_path7035 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1z",
    fill: "#3c9f25"
  })), _path7036 || (_path7036 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1z",
    fill: "#1e9016"
  })), _path7037 || (_path7037 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#43af30"
  })), _path7038 || (_path7038 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103v-1h1v1z",
    fill: "#46a737"
  })), _path7039 || (_path7039 = /*#__PURE__*/React.createElement("path", {
    d: "M87 103h-1v-1h1z",
    fill: "#197c18",
    fillOpacity: 0.749
  })), _path7040 || (_path7040 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h1v1h-1z",
    fill: "#508643",
    fillOpacity: 0.075
  })), _path7041 || (_path7041 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103h-1v-1h1z",
    fill: "#75b452",
    fillOpacity: 0.682
  })), _path7042 || (_path7042 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#68ae42",
    fillOpacity: 0.875
  })), _path7043 || (_path7043 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h1v1h-1z",
    fill: "#389328",
    fillOpacity: 0.961
  })), _path7044 || (_path7044 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v1h-1v-1z",
    fill: "#3d9b31",
    fillOpacity: 0.682
  })), _path7045 || (_path7045 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102h1v1h-1z",
    fill: "#289614",
    fillOpacity: 0.973
  })), _path7046 || (_path7046 = /*#__PURE__*/React.createElement("path", {
    d: "M95 102v1h-1v-1z",
    fill: "#5bac30"
  })), _path7047 || (_path7047 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v-1h1v1z",
    fill: "#60ab2b"
  })), _path7048 || (_path7048 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103h-1v-1h1z",
    fill: "#58ad33"
  })), _path7049 || (_path7049 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v-1h1v1z",
    fill: "#087a08",
    fillOpacity: 0.98
  })), _path7050 || (_path7050 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h-1v-1h1z",
    fill: "#239025",
    fillOpacity: 0.796
  })), _path7051 || (_path7051 = /*#__PURE__*/React.createElement("path", {
    d: "M99 102h1v1h-1z",
    fill: "#74b65c",
    fillOpacity: 0.678
  })), _path7052 || (_path7052 = /*#__PURE__*/React.createElement("path", {
    d: "M100 103v-1h1v1z",
    fill: "#92cb70",
    fillOpacity: 0.463
  })), _path7053 || (_path7053 = /*#__PURE__*/React.createElement("path", {
    d: "M102 102v1h-1v-1z",
    fill: "#61b326",
    fillOpacity: 0.89
  })), _path7054 || (_path7054 = /*#__PURE__*/React.createElement("path", {
    d: "M103 103h-1v-1h1z",
    fill: "#5daa1f",
    fillOpacity: 0.439
  })), _path7055 || (_path7055 = /*#__PURE__*/React.createElement("path", {
    d: "M107 103h-1v-1h1z",
    fill: "#ded",
    fillOpacity: 0.059
  })), _path7056 || (_path7056 = /*#__PURE__*/React.createElement("path", {
    d: "M108 102v1h-1v-1z",
    fill: "#dae8cc",
    fillOpacity: 0.22
  })), _path7057 || (_path7057 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103h1v1h-1z",
    fill: "#bfd7a7",
    fillOpacity: 0.125
  })), _path7058 || (_path7058 = /*#__PURE__*/React.createElement("path", {
    d: "M22 103v1h-1v-1z",
    fill: "#b6c99f",
    fillOpacity: 0.263
  })), _path7059 || (_path7059 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v-1h1v1z",
    fill: "#b6ca99",
    fillOpacity: 0.208
  })), _path7060 || (_path7060 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103h1v1h-1z",
    fill: "#a5d87f",
    fillOpacity: 0.078
  })), _path7061 || (_path7061 = /*#__PURE__*/React.createElement("path", {
    d: "M32 103v1h-1v-1z",
    fill: "#69ad26",
    fillOpacity: 0.894
  })), _path7062 || (_path7062 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v1h-1v-1z",
    fill: "#79ae4b",
    fillOpacity: 0.396
  })), _path7063 || (_path7063 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h-1v-1h1z",
    fill: "#8ec184",
    fillOpacity: 0.196
  })), _path7064 || (_path7064 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#71b438",
    fillOpacity: 0.996
  })), _path7065 || (_path7065 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#97c75f",
    fillOpacity: 0.482
  })), _path7066 || (_path7066 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#d6e0b7",
    fillOpacity: 0.098
  })), _path7067 || (_path7067 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#a5c667",
    fillOpacity: 0.741
  })), _path7068 || (_path7068 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#85b442",
    fillOpacity: 0.8
  })), _path7069 || (_path7069 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#94c565",
    fillOpacity: 0.678
  })), _path7070 || (_path7070 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1z",
    fill: "#b9c192",
    fillOpacity: 0.129
  })), _path7071 || (_path7071 = /*#__PURE__*/React.createElement("path", {
    d: "M42 103v1h-1v-1z",
    fill: "#aebba1",
    fillOpacity: 0.075
  })), _path7072 || (_path7072 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#69aa46",
    fillOpacity: 0.714
  })), _path7073 || (_path7073 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103v1h-1v-1z",
    fill: "#6cb72e"
  })), _path7074 || (_path7074 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#499a13"
  })), _path7075 || (_path7075 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#339425"
  })), _path7076 || (_path7076 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#12680b"
  })), _path7077 || (_path7077 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#368c22"
  })), _path7078 || (_path7078 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#43a223"
  })), _path7079 || (_path7079 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#59a83f",
    fillOpacity: 0.729
  })), _path7080 || (_path7080 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#215518",
    fillOpacity: 0.659
  })), _path7081 || (_path7081 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#3b841e",
    fillOpacity: 0.996
  })), _path7082 || (_path7082 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#45a522"
  })), _path7083 || (_path7083 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#248e15"
  })), _path7084 || (_path7084 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#25931b"
  })), _path7085 || (_path7085 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1z",
    fill: "#26931a"
  })), _path7086 || (_path7086 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#107a0d"
  })), _path7087 || (_path7087 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#1e830c"
  })), _path7088 || (_path7088 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#4eb221"
  })), _path7089 || (_path7089 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#3a9817"
  })), _path7090 || (_path7090 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#228509"
  })), _path7091 || (_path7091 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#72b826"
  })), _path7092 || (_path7092 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#8fc938"
  })), _path7093 || (_path7093 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#58ae23"
  })), _path7094 || (_path7094 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#58a831",
    fillOpacity: 0.914
  })), _path7095 || (_path7095 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#5fa24b",
    fillOpacity: 0.82
  })), _path7096 || (_path7096 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#4e913e",
    fillOpacity: 0.859
  })), _path7097 || (_path7097 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1z",
    fill: "#318124",
    fillOpacity: 0.667
  })), _path7098 || (_path7098 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104h-1v-1h1z",
    fill: "#65a429",
    fillOpacity: 0.631
  })), _path7099 || (_path7099 = /*#__PURE__*/React.createElement("path", {
    d: "M71 103v1h-1v-1z",
    fill: "#6bba1c"
  })), _path7100 || (_path7100 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103v1h-1v-1z",
    fill: "#53b512"
  })), _path7101 || (_path7101 = /*#__PURE__*/React.createElement("path", {
    d: "M72 103h1v1h-1z",
    fill: "#4bb226"
  })), _path7102 || (_path7102 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#58b52e"
  })), _path7103 || (_path7103 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#479b30"
  })), _path7104 || (_path7104 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#55a728"
  })), _path7105 || (_path7105 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104v-1h1v1z",
    fill: "#6bb533",
    fillOpacity: 0.878
  })), _path7106 || (_path7106 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#387c3e",
    fillOpacity: 0.176
  })), _path7107 || (_path7107 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#2f8133",
    fillOpacity: 0.502
  })), _path7108 || (_path7108 = /*#__PURE__*/React.createElement("path", {
    d: "M80 104v-1h1v1z",
    fill: "#3a9a1d",
    fillOpacity: 0.875
  })), _path7109 || (_path7109 = /*#__PURE__*/React.createElement("path", {
    d: "M81 103h1v1h-1z",
    fill: "#45ab24"
  })), _path7110 || (_path7110 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#46b333"
  })), _path7111 || (_path7111 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h1z",
    fill: "#27a229"
  })), _path7112 || (_path7112 = /*#__PURE__*/React.createElement("path", {
    d: "M85 104h-1v-1h1z",
    fill: "#2d8f22",
    fillOpacity: 0.851
  })), _path7113 || (_path7113 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#69b654",
    fillOpacity: 0.51
  })), _path7114 || (_path7114 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104h-1v-1h1z",
    fill: "#2d9426",
    fillOpacity: 0.863
  })), _path7115 || (_path7115 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v-1h1v1z",
    fill: "#248721",
    fillOpacity: 0.859
  })), _path7116 || (_path7116 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#41933c",
    fillOpacity: 0.4
  })), _path7117 || (_path7117 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#92c278",
    fillOpacity: 0.349
  })), _path7118 || (_path7118 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#bbc9a1",
    fillOpacity: 0.075
  })), _path7119 || (_path7119 = /*#__PURE__*/React.createElement("path", {
    d: "M91 103h1v1h-1z",
    fill: "#3e892f",
    fillOpacity: 0.627
  })), _path7120 || (_path7120 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h-1v-1h1z",
    fill: "#3e9742",
    fillOpacity: 0.271
  })), _path7121 || (_path7121 = /*#__PURE__*/React.createElement("path", {
    d: "M94 103v1h-1v-1z",
    fill: "#3ba023",
    fillOpacity: 0.953
  })), _path7122 || (_path7122 = /*#__PURE__*/React.createElement("path", {
    d: "M95 103v1h-1v-1z",
    fill: "#59ad2e"
  })), _path7123 || (_path7123 = /*#__PURE__*/React.createElement("path", {
    d: "M96 103v1h-1v-1z",
    fill: "#3d9e21"
  })), _path7124 || (_path7124 = /*#__PURE__*/React.createElement("path", {
    d: "M97 103v1h-1v-1z",
    fill: "#42a027"
  })), _path7125 || (_path7125 = /*#__PURE__*/React.createElement("path", {
    d: "M97 104v-1h1v1z",
    fill: "#158b08"
  })), _path7126 || (_path7126 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h-1v-1h1z",
    fill: "#55af33",
    fillOpacity: 0.855
  })), _path7127 || (_path7127 = /*#__PURE__*/React.createElement("path", {
    d: "M99 103h1v1h-1z",
    fill: "#8ec75d",
    fillOpacity: 0.612
  })), _path7128 || (_path7128 = /*#__PURE__*/React.createElement("path", {
    d: "M101 104h-1v-1h1z",
    fill: "#67b42f",
    fillOpacity: 0.914
  })), _path7129 || (_path7129 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h-1v-1h1z",
    fill: "#68b62e",
    fillOpacity: 0.706
  })), _path7130 || (_path7130 = /*#__PURE__*/React.createElement("path", {
    d: "M102 103h1v1h-1z",
    fill: "#d4dbd4",
    fillOpacity: 0.141
  })), _path7131 || (_path7131 = /*#__PURE__*/React.createElement("path", {
    d: "M104 103v1h-1v-1z",
    fill: "#d0decc",
    fillOpacity: 0.216
  })), _path7132 || (_path7132 = /*#__PURE__*/React.createElement("path", {
    d: "M104 104v-1h1v1z",
    fill: "#d4dfcf",
    fillOpacity: 0.188
  })), _path7133 || (_path7133 = /*#__PURE__*/React.createElement("path", {
    d: "M106 104h-1v-1h1z",
    fill: "#cad7ca",
    fillOpacity: 0.153
  })), _path7134 || (_path7134 = /*#__PURE__*/React.createElement("path", {
    d: "M107 104v-1h1v1z",
    fill: "#dce7d6",
    fillOpacity: 0.173
  })), _path7135 || (_path7135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104v1h-1v-1z",
    fill: "#d6d6b7",
    fillOpacity: 0.098
  })), _path7136 || (_path7136 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105v-1h1v1z",
    fill: "#c6d2b2",
    fillOpacity: 0.247
  })), _path7137 || (_path7137 = /*#__PURE__*/React.createElement("path", {
    d: "M21 105h-1v-1h1z",
    fill: "#bfd1a8",
    fillOpacity: 0.22
  })), _path7138 || (_path7138 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104v1h-1v-1z",
    fill: "#bda",
    fillOpacity: 0.059
  })), _path7139 || (_path7139 = /*#__PURE__*/React.createElement("path", {
    d: "M31 104v1h-1v-1z",
    fill: "#a1c452",
    fillOpacity: 0.341
  })), _path7140 || (_path7140 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105v-1h1v1z",
    fill: "#92bc3e",
    fillOpacity: 0.627
  })), _path7141 || (_path7141 = /*#__PURE__*/React.createElement("path", {
    d: "M32 105v-1h1v1z",
    fill: "#9dc29d",
    fillOpacity: 0.082
  })), _path7142 || (_path7142 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#a6c586",
    fillOpacity: 0.506
  })), _path7143 || (_path7143 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#8cc854",
    fillOpacity: 0.973
  })), _path7144 || (_path7144 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#76b23e",
    fillOpacity: 0.498
  })), _path7145 || (_path7145 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#a6c768",
    fillOpacity: 0.506
  })), _path7146 || (_path7146 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#b1cd72",
    fillOpacity: 0.427
  })), _path7147 || (_path7147 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#82b545",
    fillOpacity: 0.651
  })), _path7148 || (_path7148 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#8dc34c",
    fillOpacity: 0.702
  })), _path7149 || (_path7149 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#76a655",
    fillOpacity: 0.431
  })), _path7150 || (_path7150 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#7eb54b",
    fillOpacity: 0.847
  })), _path7151 || (_path7151 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#5fa320"
  })), _path7152 || (_path7152 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#3ba016"
  })), _path7153 || (_path7153 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#2b9514"
  })), _path7154 || (_path7154 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#269215"
  })), _path7155 || (_path7155 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#65ae41",
    fillOpacity: 0.58
  })), _path7156 || (_path7156 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#2e8329",
    fillOpacity: 0.694
  })), _path7157 || (_path7157 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104v1h-1v-1z",
    fill: "#24901b"
  })), _path7158 || (_path7158 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h1v1h-1z",
    fill: "#2d9314"
  })), _path7159 || (_path7159 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#46ac17"
  })), _path7160 || (_path7160 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#248f13"
  })), _path7161 || (_path7161 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#1e890d"
  })), _path7162 || (_path7162 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#399410"
  })), _path7163 || (_path7163 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1z",
    fill: "#6eba22"
  })), _path7164 || (_path7164 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#43ab1e"
  })), _path7165 || (_path7165 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#2b900c"
  })), _path7166 || (_path7166 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#4ea718"
  })), _path7167 || (_path7167 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#59a810"
  })), _path7168 || (_path7168 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h-1v-1h1z",
    fill: "#93cd35"
  })), _path7169 || (_path7169 = /*#__PURE__*/React.createElement("path", {
    d: "M65 105h-1v-1h1z",
    fill: "#82c13a"
  })), _path7170 || (_path7170 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104h1v1h-1z",
    fill: "#6a9d44",
    fillOpacity: 0.349
  })), _path7171 || (_path7171 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104h1v1h-1z",
    fill: "#6d9e47",
    fillOpacity: 0.31
  })), _path7172 || (_path7172 = /*#__PURE__*/React.createElement("path", {
    d: "M68 105h-1v-1h1z",
    fill: "#69a139",
    fillOpacity: 0.8
  })), _path7173 || (_path7173 = /*#__PURE__*/React.createElement("path", {
    d: "M68 104h1v1h-1z",
    fill: "#5ea322"
  })), _path7174 || (_path7174 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#55a818"
  })), _path7175 || (_path7175 = /*#__PURE__*/React.createElement("path", {
    d: "M71 105h-1v-1h1z",
    fill: "#42a512"
  })), _path7176 || (_path7176 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#55b730"
  })), _path7177 || (_path7177 = /*#__PURE__*/React.createElement("path", {
    d: "M73 104v1h-1v-1z",
    fill: "#64ba39"
  })), _path7178 || (_path7178 = /*#__PURE__*/React.createElement("path", {
    d: "M74 104v1h-1v-1z",
    fill: "#73c345",
    fillOpacity: 0.973
  })), _path7179 || (_path7179 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#78b356",
    fillOpacity: 0.839
  })), _path7180 || (_path7180 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#388b32",
    fillOpacity: 0.996
  })), _path7181 || (_path7181 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#29891d"
  })), _path7182 || (_path7182 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#87c348",
    fillOpacity: 0.933
  })), _path7183 || (_path7183 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104v1h-1v-1z",
    fill: "#2e941d",
    fillOpacity: 0.82
  })), _path7184 || (_path7184 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105h-1v-1h1z",
    fill: "#299719",
    fillOpacity: 0.996
  })), _path7185 || (_path7185 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#5aba34"
  })), _path7186 || (_path7186 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#73c844"
  })), _path7187 || (_path7187 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#37a028"
  })), _path7188 || (_path7188 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#138818",
    fillOpacity: 0.925
  })), _path7189 || (_path7189 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105h-1v-1h1z",
    fill: "#168718",
    fillOpacity: 0.953
  })), _path7190 || (_path7190 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#56ad3a",
    fillOpacity: 0.565
  })), _path7191 || (_path7191 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#57a446",
    fillOpacity: 0.353
  })), _path7192 || (_path7192 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105h-1v-1h1z",
    fill: "#45a239",
    fillOpacity: 0.78
  })), _path7193 || (_path7193 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#41ab2e"
  })), _path7194 || (_path7194 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105h-1v-1h1z",
    fill: "#4ca630",
    fillOpacity: 0.89
  })), _path7195 || (_path7195 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v-1h1v1z",
    fill: "#62af3a",
    fillOpacity: 0.478
  })), _path7196 || (_path7196 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105v-1h1v1z",
    fill: "#51a534",
    fillOpacity: 0.761
  })), _path7197 || (_path7197 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104v1h-1v-1z",
    fill: "#52ac3a",
    fillOpacity: 0.678
  })), _path7198 || (_path7198 = /*#__PURE__*/React.createElement("path", {
    d: "M93 104h1v1h-1z",
    fill: "#3aa718",
    fillOpacity: 0.98
  })), _path7199 || (_path7199 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105h-1v-1h1z",
    fill: "#41a922"
  })), _path7200 || (_path7200 = /*#__PURE__*/React.createElement("path", {
    d: "M96 104v1h-1v-1z",
    fill: "#34a71c"
  })), _path7201 || (_path7201 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105h-1v-1h1z",
    fill: "#4aa927",
    fillOpacity: 0.808
  })), _path7202 || (_path7202 = /*#__PURE__*/React.createElement("path", {
    d: "M98 104v1h-1v-1z",
    fill: "#5bb02c",
    fillOpacity: 0.906
  })), _path7203 || (_path7203 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105v-1h1v1z",
    fill: "#64c330"
  })), _path7204 || (_path7204 = /*#__PURE__*/React.createElement("path", {
    d: "M99 104h1v1h-1z",
    fill: "#62bb26",
    fillOpacity: 0.961
  })), _path7205 || (_path7205 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105v-1h1v1z",
    fill: "#75bc42",
    fillOpacity: 0.408
  })), _path7206 || (_path7206 = /*#__PURE__*/React.createElement("path", {
    d: "M102 105h-1v-1h1z",
    fill: "#aad4aa",
    fillOpacity: 0.047
  })), _path7207 || (_path7207 = /*#__PURE__*/React.createElement("path", {
    d: "M102 104h1v1h-1z",
    fill: "#c6c6c6",
    fillOpacity: 0.035
  })), _path7208 || (_path7208 = /*#__PURE__*/React.createElement("path", {
    d: "M107 104h1v1h-1z",
    fill: "#dee4d7",
    fillOpacity: 0.153
  })), _path7209 || (_path7209 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105h1v1h-1z",
    fill: "#cce5b2",
    fillOpacity: 0.039
  })), _path7210 || (_path7210 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106h-1v-1h1z",
    fill: "#9ac14a",
    fillOpacity: 0.694
  })), _path7211 || (_path7211 = /*#__PURE__*/React.createElement("path", {
    d: "M31 105h1v1h-1z",
    fill: "#99bb43",
    fillOpacity: 0.208
  })), _path7212 || (_path7212 = /*#__PURE__*/React.createElement("path", {
    d: "M32 106v-1h1v1z",
    fill: "#c5d29f",
    fillOpacity: 0.157
  })), _path7213 || (_path7213 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#c2d194",
    fillOpacity: 0.329
  })), _path7214 || (_path7214 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#abd184",
    fillOpacity: 0.286
  })), _path7215 || (_path7215 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#91c14b",
    fillOpacity: 0.933
  })), _path7216 || (_path7216 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#add267",
    fillOpacity: 0.404
  })), _path7217 || (_path7217 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105v1h-1v-1z",
    fill: "#93ba5b",
    fillOpacity: 0.718
  })), _path7218 || (_path7218 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-1h1v1z",
    fill: "#93c458",
    fillOpacity: 0.584
  })), _path7219 || (_path7219 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#7bab62",
    fillOpacity: 0.275
  })), _path7220 || (_path7220 = /*#__PURE__*/React.createElement("path", {
    d: "M44 105v1h-1v-1z",
    fill: "#8bb760",
    fillOpacity: 0.518
  })), _path7221 || (_path7221 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1z",
    fill: "#7daf35",
    fillOpacity: 0.961
  })), _path7222 || (_path7222 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#41a316"
  })), _path7223 || (_path7223 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#3ea116"
  })), _path7224 || (_path7224 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#26960e"
  })), _path7225 || (_path7225 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1z",
    fill: "#229612"
  })), _path7226 || (_path7226 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#34a11f"
  })), _path7227 || (_path7227 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#2e941a",
    fillOpacity: 0.976
  })), _path7228 || (_path7228 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#208414",
    fillOpacity: 0.988
  })), _path7229 || (_path7229 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h-1v-1h1z",
    fill: "#309115"
  })), _path7230 || (_path7230 = /*#__PURE__*/React.createElement("path", {
    d: "M54 105v1h-1v-1z",
    fill: "#39931f"
  })), _path7231 || (_path7231 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#55a720"
  })), _path7232 || (_path7232 = /*#__PURE__*/React.createElement("path", {
    d: "M56 106h-1v-1h1z",
    fill: "#57af16"
  })), _path7233 || (_path7233 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#61b11c"
  })), _path7234 || (_path7234 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#71ba19"
  })), _path7235 || (_path7235 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#6ec020"
  })), _path7236 || (_path7236 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#48a618"
  })), _path7237 || (_path7237 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#6db136",
    fillOpacity: 0.737
  })), _path7238 || (_path7238 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1z",
    fill: "#67a734",
    fillOpacity: 0.569
  })), _path7239 || (_path7239 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105v1h-1v-1z",
    fill: "#5dab1c",
    fillOpacity: 0.976
  })), _path7240 || (_path7240 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h1v1h-1z",
    fill: "#94cc3a"
  })), _path7241 || (_path7241 = /*#__PURE__*/React.createElement("path", {
    d: "M64 105h1v1h-1z",
    fill: "#99c94d",
    fillOpacity: 0.835
  })), _path7242 || (_path7242 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v-1h1v1z",
    fill: "#84ad64",
    fillOpacity: 0.22
  })), _path7243 || (_path7243 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#afc7a7",
    fillOpacity: 0.125
  })), _path7244 || (_path7244 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#9ac176",
    fillOpacity: 0.278
  })), _path7245 || (_path7245 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#79b03e",
    fillOpacity: 0.435
  })), _path7246 || (_path7246 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#4ba621",
    fillOpacity: 0.957
  })), _path7247 || (_path7247 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#55b22d",
    fillOpacity: 0.996
  })), _path7248 || (_path7248 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#58b421"
  })), _path7249 || (_path7249 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#74c53c"
  })), _path7250 || (_path7250 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v-1h1v1z",
    fill: "#8bc868",
    fillOpacity: 0.518
  })), _path7251 || (_path7251 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#73a157",
    fillOpacity: 0.459
  })), _path7252 || (_path7252 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#378829"
  })), _path7253 || (_path7253 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1z",
    fill: "#1e7f18"
  })), _path7254 || (_path7254 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#4fb429"
  })), _path7255 || (_path7255 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105v1h-1v-1z",
    fill: "#3fad22"
  })), _path7256 || (_path7256 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#6ebd35"
  })), _path7257 || (_path7257 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#70bf3e",
    fillOpacity: 0.996
  })), _path7258 || (_path7258 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#61b250",
    fillOpacity: 0.71
  })), _path7259 || (_path7259 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#52a148",
    fillOpacity: 0.471
  })), _path7260 || (_path7260 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#289621",
    fillOpacity: 0.749
  })), _path7261 || (_path7261 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#4fad2f",
    fillOpacity: 0.918
  })), _path7262 || (_path7262 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v1h-1z",
    fill: "#64b045",
    fillOpacity: 0.545
  })), _path7263 || (_path7263 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#5ea741",
    fillOpacity: 0.455
  })), _path7264 || (_path7264 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#4ea433",
    fillOpacity: 0.584
  })), _path7265 || (_path7265 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v1h-1v-1z",
    fill: "#4a9e28",
    fillOpacity: 0.686
  })), _path7266 || (_path7266 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106h-1v-1h1z",
    fill: "#47a022",
    fillOpacity: 0.824
  })), _path7267 || (_path7267 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105h1v1h-1z",
    fill: "#3b9f16",
    fillOpacity: 0.965
  })), _path7268 || (_path7268 = /*#__PURE__*/React.createElement("path", {
    d: "M92 105h1v1h-1z",
    fill: "#49b021"
  })), _path7269 || (_path7269 = /*#__PURE__*/React.createElement("path", {
    d: "M94 106h-1v-1h1z",
    fill: "#5bba30"
  })), _path7270 || (_path7270 = /*#__PURE__*/React.createElement("path", {
    d: "M95 105v1h-1v-1z",
    fill: "#309a20",
    fillOpacity: 0.965
  })), _path7271 || (_path7271 = /*#__PURE__*/React.createElement("path", {
    d: "M96 106h-1v-1h1z",
    fill: "#3c9a20",
    fillOpacity: 0.867
  })), _path7272 || (_path7272 = /*#__PURE__*/React.createElement("path", {
    d: "M97 105v1h-1v-1z",
    fill: "#5d974b",
    fillOpacity: 0.29
  })), _path7273 || (_path7273 = /*#__PURE__*/React.createElement("path", {
    d: "M98 106h-1v-1h1z",
    fill: "#7dc45f",
    fillOpacity: 0.62
  })), _path7274 || (_path7274 = /*#__PURE__*/React.createElement("path", {
    d: "M98 105h1v1h-1z",
    fill: "#5ccb26"
  })), _path7275 || (_path7275 = /*#__PURE__*/React.createElement("path", {
    d: "M100 105v1h-1v-1z",
    fill: "#6dbb2c",
    fillOpacity: 0.604
  })), _path7276 || (_path7276 = /*#__PURE__*/React.createElement("path", {
    d: "M107 106v-1h1v1z",
    fill: "#e4e4d6",
    fillOpacity: 0.075
  })), _path7277 || (_path7277 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v-1h1v1z",
    fill: "#9ac94b",
    fillOpacity: 0.278
  })), _path7278 || (_path7278 = /*#__PURE__*/React.createElement("path", {
    d: "M30 106h1v1h-1z",
    fill: "#8fbf35",
    fillOpacity: 0.58
  })), _path7279 || (_path7279 = /*#__PURE__*/React.createElement("path", {
    d: "M32 107h-1v-1h1z",
    fill: "#cdd7aa",
    fillOpacity: 0.2
  })), _path7280 || (_path7280 = /*#__PURE__*/React.createElement("path", {
    d: "M33 107h-1v-1h1z",
    fill: "#c1d096",
    fillOpacity: 0.278
  })), _path7281 || (_path7281 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#c7daa6",
    fillOpacity: 0.271
  })), _path7282 || (_path7282 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h1v1h-1z",
    fill: "#94c153",
    fillOpacity: 0.655
  })), _path7283 || (_path7283 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1z",
    fill: "#8ebd4f",
    fillOpacity: 0.365
  })), _path7284 || (_path7284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#96bd61",
    fillOpacity: 0.659
  })), _path7285 || (_path7285 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#94c25e",
    fillOpacity: 0.647
  })), _path7286 || (_path7286 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#85b663",
    fillOpacity: 0.18
  })), _path7287 || (_path7287 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-1v-1z",
    fill: "#89b55a",
    fillOpacity: 0.529
  })), _path7288 || (_path7288 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#88b637",
    fillOpacity: 0.894
  })), _path7289 || (_path7289 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-1v-1z",
    fill: "#59a825"
  })), _path7290 || (_path7290 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#6eb742"
  })), _path7291 || (_path7291 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#26980d"
  })), _path7292 || (_path7292 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#2da117"
  })), _path7293 || (_path7293 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#32941d"
  })), _path7294 || (_path7294 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#0a6907"
  })), _path7295 || (_path7295 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#036502"
  })), _path7296 || (_path7296 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#1c780b"
  })), _path7297 || (_path7297 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#68b229"
  })), _path7298 || (_path7298 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#54a91f"
  })), _path7299 || (_path7299 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#65b01b"
  })), _path7300 || (_path7300 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#6dbb1b"
  })), _path7301 || (_path7301 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#49a611"
  })), _path7302 || (_path7302 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#64c12b"
  })), _path7303 || (_path7303 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#42a21b"
  })), _path7304 || (_path7304 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#4d9d28",
    fillOpacity: 0.545
  })), _path7305 || (_path7305 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#96c46f",
    fillOpacity: 0.153
  })), _path7306 || (_path7306 = /*#__PURE__*/React.createElement("path", {
    d: "M62 106h1v1h-1z",
    fill: "#7cb833",
    fillOpacity: 0.827
  })), _path7307 || (_path7307 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1z",
    fill: "#96c552",
    fillOpacity: 0.365
  })), _path7308 || (_path7308 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106v1h-1v-1z",
    fill: "#dadab6",
    fillOpacity: 0.027
  })), _path7309 || (_path7309 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#94c37c",
    fillOpacity: 0.169
  })), _path7310 || (_path7310 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#7fbb58",
    fillOpacity: 0.596
  })), _path7311 || (_path7311 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#81bc4e",
    fillOpacity: 0.882
  })), _path7312 || (_path7312 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#76b63f",
    fillOpacity: 0.996
  })), _path7313 || (_path7313 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#68b231",
    fillOpacity: 0.682
  })), _path7314 || (_path7314 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#74b540",
    fillOpacity: 0.792
  })), _path7315 || (_path7315 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#73ad38",
    fillOpacity: 0.875
  })), _path7316 || (_path7316 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#7fb345",
    fillOpacity: 0.925
  })), _path7317 || (_path7317 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#5ba625"
  })), _path7318 || (_path7318 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v1h-1v-1z",
    fill: "#2e9216"
  })), _path7319 || (_path7319 = /*#__PURE__*/React.createElement("path", {
    d: "M77 107v-1h1v1z",
    fill: "#65ac34"
  })), _path7320 || (_path7320 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#63b723"
  })), _path7321 || (_path7321 = /*#__PURE__*/React.createElement("path", {
    d: "M79 106h1v1h-1z",
    fill: "#61be2a"
  })), _path7322 || (_path7322 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106h1v1h-1z",
    fill: "#80c63a"
  })), _path7323 || (_path7323 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106v1h-1v-1z",
    fill: "#71c139"
  })), _path7324 || (_path7324 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107v-1h1v1z",
    fill: "#71b64c",
    fillOpacity: 0.827
  })), _path7325 || (_path7325 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#4aa230",
    fillOpacity: 0.604
  })), _path7326 || (_path7326 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#419f37",
    fillOpacity: 0.502
  })), _path7327 || (_path7327 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#3da337",
    fillOpacity: 0.776
  })), _path7328 || (_path7328 = /*#__PURE__*/React.createElement("path", {
    d: "M87 106v1h-1v-1z",
    fill: "#dceaba",
    fillOpacity: 0.145
  })), _path7329 || (_path7329 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106v1h-1v-1z",
    fill: "#7f7f7f",
    fillOpacity: 0.016
  })), _path7330 || (_path7330 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h-1v-1h1z",
    fill: "#492",
    fillOpacity: 0.176
  })), _path7331 || (_path7331 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1z",
    fill: "#469d1f",
    fillOpacity: 0.565
  })), _path7332 || (_path7332 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107v-1h1v1z",
    fill: "#5dbe36",
    fillOpacity: 0.973
  })), _path7333 || (_path7333 = /*#__PURE__*/React.createElement("path", {
    d: "M95 107h-1v-1h1z",
    fill: "#319f1b",
    fillOpacity: 0.91
  })), _path7334 || (_path7334 = /*#__PURE__*/React.createElement("path", {
    d: "M95 106h1v1h-1z",
    fill: "#97cb61",
    fillOpacity: 0.443
  })), _path7335 || (_path7335 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106v1h-1v-1z",
    fill: "#8dcd76",
    fillOpacity: 0.345
  })), _path7336 || (_path7336 = /*#__PURE__*/React.createElement("path", {
    d: "M97 106h1v1h-1z",
    fill: "#5caf3d",
    fillOpacity: 0.792
  })), _path7337 || (_path7337 = /*#__PURE__*/React.createElement("path", {
    d: "M99 106v1h-1v-1z",
    fill: "#60b720",
    fillOpacity: 0.612
  })), _path7338 || (_path7338 = /*#__PURE__*/React.createElement("path", {
    d: "M99 107v-1h1v1z",
    fill: "#7fc332",
    fillOpacity: 0.855
  })), _path7339 || (_path7339 = /*#__PURE__*/React.createElement("path", {
    d: "M100 106h1v1h-1z",
    fill: "#bfe391",
    fillOpacity: 0.11
  })), _path7340 || (_path7340 = /*#__PURE__*/React.createElement("path", {
    d: "M30 107v1h-1v-1z",
    fill: "#90c138",
    fillOpacity: 0.635
  })), _path7341 || (_path7341 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107v1h-1v-1z",
    fill: "#aacd61",
    fillOpacity: 0.482
  })), _path7342 || (_path7342 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107h1v1h-1z",
    fill: "#c3d098",
    fillOpacity: 0.302
  })), _path7343 || (_path7343 = /*#__PURE__*/React.createElement("path", {
    d: "M34 108h-1v-1h1z",
    fill: "#ccdaae",
    fillOpacity: 0.137
  })), _path7344 || (_path7344 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107v1h-1v-1z",
    fill: "#c4d2a1",
    fillOpacity: 0.204
  })), _path7345 || (_path7345 = /*#__PURE__*/React.createElement("path", {
    d: "M35 108v-1h1v1z",
    fill: "#99bf59",
    fillOpacity: 0.078
  })), _path7346 || (_path7346 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108h-1v-1h1z",
    fill: "#8ab64f",
    fillOpacity: 0.576
  })), _path7347 || (_path7347 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#99c670",
    fillOpacity: 0.196
  })), _path7348 || (_path7348 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#8cb655",
    fillOpacity: 0.733
  })), _path7349 || (_path7349 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#a2b973",
    fillOpacity: 0.043
  })), _path7350 || (_path7350 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#8cbf66",
    fillOpacity: 0.078
  })), _path7351 || (_path7351 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#8bb55b",
    fillOpacity: 0.502
  })), _path7352 || (_path7352 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#85bc44",
    fillOpacity: 0.831
  })), _path7353 || (_path7353 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1z",
    fill: "#62b328"
  })), _path7354 || (_path7354 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#7ab73d",
    fillOpacity: 0.925
  })), _path7355 || (_path7355 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#52a534",
    fillOpacity: 0.533
  })), _path7356 || (_path7356 = /*#__PURE__*/React.createElement("path", {
    d: "M49 107v1h-1v-1z",
    fill: "#33a61c",
    fillOpacity: 0.98
  })), _path7357 || (_path7357 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1z",
    fill: "#299110"
  })), _path7358 || (_path7358 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#207410"
  })), _path7359 || (_path7359 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#056804"
  })), _path7360 || (_path7360 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108h-1v-1h1z",
    fill: "#339415"
  })), _path7361 || (_path7361 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#62b220"
  })), _path7362 || (_path7362 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#2b9613"
  })), _path7363 || (_path7363 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#45a41d"
  })), _path7364 || (_path7364 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#62b313"
  })), _path7365 || (_path7365 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#62b91e"
  })), _path7366 || (_path7366 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#5eba27"
  })), _path7367 || (_path7367 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#4faa25"
  })), _path7368 || (_path7368 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#5da522"
  })), _path7369 || (_path7369 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#81b533",
    fillOpacity: 0.867
  })), _path7370 || (_path7370 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#85b131",
    fillOpacity: 0.722
  })), _path7371 || (_path7371 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#9ab864",
    fillOpacity: 0.427
  })), _path7372 || (_path7372 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1z",
    fill: "#a2c169",
    fillOpacity: 0.388
  })), _path7373 || (_path7373 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#9fc56b",
    fillOpacity: 0.345
  })), _path7374 || (_path7374 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#94c26a",
    fillOpacity: 0.412
  })), _path7375 || (_path7375 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#91be6d",
    fillOpacity: 0.447
  })), _path7376 || (_path7376 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#94c778",
    fillOpacity: 0.216
  })), _path7377 || (_path7377 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108v-1h1v1z",
    fill: "#7cb54d",
    fillOpacity: 0.757
  })), _path7378 || (_path7378 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#88be55",
    fillOpacity: 0.431
  })), _path7379 || (_path7379 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#a1c98c",
    fillOpacity: 0.278
  })), _path7380 || (_path7380 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#83b746"
  })), _path7381 || (_path7381 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#7dc032"
  })), _path7382 || (_path7382 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v1h-1z",
    fill: "#73c02e"
  })), _path7383 || (_path7383 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1z",
    fill: "#51ad1e"
  })), _path7384 || (_path7384 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#72b632"
  })), _path7385 || (_path7385 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#90c941",
    fillOpacity: 0.788
  })), _path7386 || (_path7386 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h1v1h-1z",
    fill: "#88c545",
    fillOpacity: 0.835
  })), _path7387 || (_path7387 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107v1h-1v-1z",
    fill: "#7cc336",
    fillOpacity: 0.996
  })), _path7388 || (_path7388 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#7ebe43",
    fillOpacity: 0.608
  })), _path7389 || (_path7389 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#73b63b",
    fillOpacity: 0.604
  })), _path7390 || (_path7390 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#53aa2d",
    fillOpacity: 0.576
  })), _path7391 || (_path7391 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107h1v1h-1z",
    fill: "#38912a",
    fillOpacity: 0.514
  })), _path7392 || (_path7392 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#31942e",
    fillOpacity: 0.706
  })), _path7393 || (_path7393 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#8cc07c",
    fillOpacity: 0.384
  })), _path7394 || (_path7394 = /*#__PURE__*/React.createElement("path", {
    d: "M93 108h-1v-1h1z",
    fill: "#96bb87",
    fillOpacity: 0.192
  })), _path7395 || (_path7395 = /*#__PURE__*/React.createElement("path", {
    d: "M93 107h1v1h-1z",
    fill: "#68b833",
    fillOpacity: 0.949
  })), _path7396 || (_path7396 = /*#__PURE__*/React.createElement("path", {
    d: "M94 107h1v1h-1z",
    fill: "#52ae1f",
    fillOpacity: 0.898
  })), _path7397 || (_path7397 = /*#__PURE__*/React.createElement("path", {
    d: "M95 108v-1h1v1z",
    fill: "#74c43a",
    fillOpacity: 0.941
  })), _path7398 || (_path7398 = /*#__PURE__*/React.createElement("path", {
    d: "M96 107h1v1h-1z",
    fill: "#67bc32"
  })), _path7399 || (_path7399 = /*#__PURE__*/React.createElement("path", {
    d: "M98 108h-1v-1h1z",
    fill: "#74b63e",
    fillOpacity: 0.706
  })), _path7400 || (_path7400 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108h-1v-1h1z",
    fill: "#9db877",
    fillOpacity: 0.184
  })), _path7401 || (_path7401 = /*#__PURE__*/React.createElement("path", {
    d: "M100 107v1h-1v-1z",
    fill: "#7abc33",
    fillOpacity: 0.859
  })), _path7402 || (_path7402 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108v-1h1v1z",
    fill: "#8fcb4c",
    fillOpacity: 0.522
  })), _path7403 || (_path7403 = /*#__PURE__*/React.createElement("path", {
    d: "M28 108h1v1h-1z",
    fill: "#96c145",
    fillOpacity: 0.259
  })), _path7404 || (_path7404 = /*#__PURE__*/React.createElement("path", {
    d: "M30 109h-1v-1h1z",
    fill: "#94c239",
    fillOpacity: 0.941
  })), _path7405 || (_path7405 = /*#__PURE__*/React.createElement("path", {
    d: "M31 108v1h-1v-1z",
    fill: "#b5d371",
    fillOpacity: 0.369
  })), _path7406 || (_path7406 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108h1v1h-1z",
    fill: "#dae1bd",
    fillOpacity: 0.137
  })), _path7407 || (_path7407 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#8aaf56",
    fillOpacity: 0.404
  })), _path7408 || (_path7408 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#90b661",
    fillOpacity: 0.235
  })), _path7409 || (_path7409 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#84ab4d",
    fillOpacity: 0.506
  })), _path7410 || (_path7410 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#85ab4d",
    fillOpacity: 0.18
  })), _path7411 || (_path7411 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#8fbd63",
    fillOpacity: 0.502
  })), _path7412 || (_path7412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#77b641",
    fillOpacity: 0.776
  })), _path7413 || (_path7413 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1z",
    fill: "#6db928"
  })), _path7414 || (_path7414 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#89bb43",
    fillOpacity: 0.443
  })), _path7415 || (_path7415 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#50a045",
    fillOpacity: 0.286
  })), _path7416 || (_path7416 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#46a427"
  })), _path7417 || (_path7417 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#4aa722",
    fillOpacity: 0.996
  })), _path7418 || (_path7418 = /*#__PURE__*/React.createElement("path", {
    d: "M51 109h-1v-1h1z",
    fill: "#409e11"
  })), _path7419 || (_path7419 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#2e9110"
  })), _path7420 || (_path7420 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#42a61f"
  })), _path7421 || (_path7421 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#69b828"
  })), _path7422 || (_path7422 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#61b21c"
  })), _path7423 || (_path7423 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#61aa24",
    fillOpacity: 0.741
  })), _path7424 || (_path7424 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#7bb736",
    fillOpacity: 0.365
  })), _path7425 || (_path7425 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#73b919",
    fillOpacity: 0.89
  })), _path7426 || (_path7426 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#67b61b"
  })), _path7427 || (_path7427 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#6ab426"
  })), _path7428 || (_path7428 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109v-1h1v1z",
    fill: "#98cb48"
  })), _path7429 || (_path7429 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1z",
    fill: "#a0c750",
    fillOpacity: 0.58
  })), _path7430 || (_path7430 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108v1h-1v-1z",
    fill: "#b0c475",
    fillOpacity: 0.051
  })), _path7431 || (_path7431 = /*#__PURE__*/React.createElement("path", {
    d: "M63 109v-1h1v1z",
    fill: "#a2c16c",
    fillOpacity: 0.129
  })), _path7432 || (_path7432 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#a4c572",
    fillOpacity: 0.298
  })), _path7433 || (_path7433 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#98c560",
    fillOpacity: 0.675
  })), _path7434 || (_path7434 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-1z",
    fill: "#93c45e",
    fillOpacity: 0.306
  })), _path7435 || (_path7435 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#9ec08e",
    fillOpacity: 0.239
  })), _path7436 || (_path7436 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#97c674",
    fillOpacity: 0.231
  })), _path7437 || (_path7437 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#b4d296",
    fillOpacity: 0.067
  })), _path7438 || (_path7438 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#92c264",
    fillOpacity: 0.349
  })), _path7439 || (_path7439 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v-1h1v1z",
    fill: "#8ec45e",
    fillOpacity: 0.722
  })), _path7440 || (_path7440 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#8fc457",
    fillOpacity: 0.671
  })), _path7441 || (_path7441 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#8ec44e",
    fillOpacity: 0.525
  })), _path7442 || (_path7442 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#71b22e"
  })), _path7443 || (_path7443 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108v1h-1v-1z",
    fill: "#59b01a"
  })), _path7444 || (_path7444 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109v-1h1v1z",
    fill: "#87c744",
    fillOpacity: 0.627
  })), _path7445 || (_path7445 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#a3cb5f",
    fillOpacity: 0.545
  })), _path7446 || (_path7446 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#9dc36c",
    fillOpacity: 0.184
  })), _path7447 || (_path7447 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#67af3c",
    fillOpacity: 0.733
  })), _path7448 || (_path7448 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#64b045",
    fillOpacity: 0.486
  })), _path7449 || (_path7449 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#358c35",
    fillOpacity: 0.263
  })), _path7450 || (_path7450 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#53a24f",
    fillOpacity: 0.467
  })), _path7451 || (_path7451 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#8bb66d",
    fillOpacity: 0.165
  })), _path7452 || (_path7452 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109v-1h1v1z",
    fill: "#81b961",
    fillOpacity: 0.502
  })), _path7453 || (_path7453 = /*#__PURE__*/React.createElement("path", {
    d: "M94 108v1h-1v-1z",
    fill: "#4eab1f",
    fillOpacity: 0.914
  })), _path7454 || (_path7454 = /*#__PURE__*/React.createElement("path", {
    d: "M94 109v-1h1v1z",
    fill: "#6bbe44",
    fillOpacity: 0.631
  })), _path7455 || (_path7455 = /*#__PURE__*/React.createElement("path", {
    d: "M95 109v-1h1v1z",
    fill: "#69b54a",
    fillOpacity: 0.749
  })), _path7456 || (_path7456 = /*#__PURE__*/React.createElement("path", {
    d: "M96 108h1v1h-1z",
    fill: "#6bb945",
    fillOpacity: 0.318
  })), _path7457 || (_path7457 = /*#__PURE__*/React.createElement("path", {
    d: "M97 108h1v1h-1z",
    fill: "#90bc55",
    fillOpacity: 0.424
  })), _path7458 || (_path7458 = /*#__PURE__*/React.createElement("path", {
    d: "M99 108v1h-1v-1z",
    fill: "#7aa743",
    fillOpacity: 0.651
  })), _path7459 || (_path7459 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108v1h-1v-1z",
    fill: "#85ba51",
    fillOpacity: 0.851
  })), _path7460 || (_path7460 = /*#__PURE__*/React.createElement("path", {
    d: "M100 108h1v1h-1z",
    fill: "#87c541",
    fillOpacity: 0.922
  })), _path7461 || (_path7461 = /*#__PURE__*/React.createElement("path", {
    d: "M102 108v1h-1v-1z",
    fill: "#b8db83",
    fillOpacity: 0.114
  })), _path7462 || (_path7462 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109v1h-1v-1z",
    fill: "#a2c551",
    fillOpacity: 0.69
  })), _path7463 || (_path7463 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109h1v1h-1z",
    fill: "#adce5d",
    fillOpacity: 0.514
  })), _path7464 || (_path7464 = /*#__PURE__*/React.createElement("path", {
    d: "M36 109h1v1h-1z",
    fill: "#94b46a",
    fillOpacity: 0.094
  })), _path7465 || (_path7465 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#88ad61",
    fillOpacity: 0.431
  })), _path7466 || (_path7466 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#79a549",
    fillOpacity: 0.314
  })), _path7467 || (_path7467 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#7ca546",
    fillOpacity: 0.314
  })), _path7468 || (_path7468 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#8eba5f",
    fillOpacity: 0.408
  })), _path7469 || (_path7469 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#73b434",
    fillOpacity: 0.682
  })), _path7470 || (_path7470 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#75b52b",
    fillOpacity: 0.859
  })), _path7471 || (_path7471 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#d6e4ae",
    fillOpacity: 0.075
  })), _path7472 || (_path7472 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#44a32d",
    fillOpacity: 0.675
  })), _path7473 || (_path7473 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#5ea93d",
    fillOpacity: 0.678
  })), _path7474 || (_path7474 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#49a22e",
    fillOpacity: 0.745
  })), _path7475 || (_path7475 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#3fa413"
  })), _path7476 || (_path7476 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110h-1v-1h1z",
    fill: "#52ae0e"
  })), _path7477 || (_path7477 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1z",
    fill: "#48a613"
  })), _path7478 || (_path7478 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#8dca45",
    fillOpacity: 0.961
  })), _path7479 || (_path7479 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#99c03e",
    fillOpacity: 0.416
  })), _path7480 || (_path7480 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#ffdfbf",
    fillOpacity: 0.031
  })), _path7481 || (_path7481 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#7eb535",
    fillOpacity: 0.396
  })), _path7482 || (_path7482 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#7bbd20"
  })), _path7483 || (_path7483 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#89c733"
  })), _path7484 || (_path7484 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#abd059",
    fillOpacity: 0.729
  })), _path7485 || (_path7485 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#dada91",
    fillOpacity: 0.055
  })), _path7486 || (_path7486 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#a8c482",
    fillOpacity: 0.29
  })), _path7487 || (_path7487 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#b7d797",
    fillOpacity: 0.125
  })), _path7488 || (_path7488 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#89b075",
    fillOpacity: 0.051
  })), _path7489 || (_path7489 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#8ebc67",
    fillOpacity: 0.463
  })), _path7490 || (_path7490 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#8dc165",
    fillOpacity: 0.424
  })), _path7491 || (_path7491 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#9bc87a",
    fillOpacity: 0.4
  })), _path7492 || (_path7492 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#a1cd70",
    fillOpacity: 0.204
  })), _path7493 || (_path7493 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#76b330",
    fillOpacity: 0.702
  })), _path7494 || (_path7494 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#68a028",
    fillOpacity: 0.612
  })), _path7495 || (_path7495 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#80af4b",
    fillOpacity: 0.467
  })), _path7496 || (_path7496 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#99bd71",
    fillOpacity: 0.353
  })), _path7497 || (_path7497 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#9ecc69",
    fillOpacity: 0.635
  })), _path7498 || (_path7498 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#99b24c",
    fillOpacity: 0.039
  })), _path7499 || (_path7499 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#5f9f4f",
    fillOpacity: 0.063
  })), _path7500 || (_path7500 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#5aa935",
    fillOpacity: 0.62
  })), _path7501 || (_path7501 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#53ab3e",
    fillOpacity: 0.525
  })), _path7502 || (_path7502 = /*#__PURE__*/React.createElement("path", {
    d: "M84 109v1h-1v-1z",
    fill: "#44994c",
    fillOpacity: 0.235
  })), _path7503 || (_path7503 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1z",
    fill: "#579166",
    fillOpacity: 0.137
  })), _path7504 || (_path7504 = /*#__PURE__*/React.createElement("path", {
    d: "M85 109h1v1h-1z",
    fill: "#6cbd71",
    fillOpacity: 0.184
  })), _path7505 || (_path7505 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1z",
    fill: "#449941",
    fillOpacity: 0.6
  })), _path7506 || (_path7506 = /*#__PURE__*/React.createElement("path", {
    d: "M89 110v-1h1v1z",
    fill: "#69a54b",
    fillOpacity: 0.2
  })), _path7507 || (_path7507 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#70aa4c",
    fillOpacity: 0.471
  })), _path7508 || (_path7508 = /*#__PURE__*/React.createElement("path", {
    d: "M91 109h1v1h-1z",
    fill: "#7aaf4c",
    fillOpacity: 0.604
  })), _path7509 || (_path7509 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109v1h-1v-1z",
    fill: "#84be60",
    fillOpacity: 0.31
  })), _path7510 || (_path7510 = /*#__PURE__*/React.createElement("path", {
    d: "M93 109h1v1h-1z",
    fill: "#54b131",
    fillOpacity: 0.784
  })), _path7511 || (_path7511 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110h-1v-1h1z",
    fill: "#65b844",
    fillOpacity: 0.741
  })), _path7512 || (_path7512 = /*#__PURE__*/React.createElement("path", {
    d: "M95 110v-1h1v1z",
    fill: "#7fb15c",
    fillOpacity: 0.141
  })), _path7513 || (_path7513 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h-1v-1h1z",
    fill: "#b0cd9c",
    fillOpacity: 0.102
  })), _path7514 || (_path7514 = /*#__PURE__*/React.createElement("path", {
    d: "M100 109h1v1h-1z",
    fill: "#96c851",
    fillOpacity: 0.6
  })), _path7515 || (_path7515 = /*#__PURE__*/React.createElement("path", {
    d: "M102 110h-1v-1h1z",
    fill: "#a1ce55",
    fillOpacity: 0.514
  })), _path7516 || (_path7516 = /*#__PURE__*/React.createElement("path", {
    d: "M27 111v-1h1v1z",
    fill: "#b5cc79",
    fillOpacity: 0.353
  })), _path7517 || (_path7517 = /*#__PURE__*/React.createElement("path", {
    d: "M29 111h-1v-1h1z",
    fill: "#b3cf6a",
    fillOpacity: 0.545
  })), _path7518 || (_path7518 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#84ab61",
    fillOpacity: 0.286
  })), _path7519 || (_path7519 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1z",
    fill: "#89b075",
    fillOpacity: 0.102
  })), _path7520 || (_path7520 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#6da741",
    fillOpacity: 0.137
  })), _path7521 || (_path7521 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#74a143",
    fillOpacity: 0.447
  })), _path7522 || (_path7522 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1z",
    fill: "#8bba55",
    fillOpacity: 0.365
  })), _path7523 || (_path7523 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#7abb33",
    fillOpacity: 0.918
  })), _path7524 || (_path7524 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-1v-1h1z",
    fill: "#83b935",
    fillOpacity: 0.71
  })), _path7525 || (_path7525 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#7fbc70",
    fillOpacity: 0.196
  })), _path7526 || (_path7526 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#4aa528",
    fillOpacity: 0.969
  })), _path7527 || (_path7527 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#5da530",
    fillOpacity: 0.761
  })), _path7528 || (_path7528 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111v-1h1v1z",
    fill: "#359719",
    fillOpacity: 0.694
  })), _path7529 || (_path7529 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1z",
    fill: "#419d1f",
    fillOpacity: 0.902
  })), _path7530 || (_path7530 = /*#__PURE__*/React.createElement("path", {
    d: "M51 111v-1h1v1z",
    fill: "#59b01c"
  })), _path7531 || (_path7531 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111h-1v-1h1z",
    fill: "#64ac16"
  })), _path7532 || (_path7532 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#9ccd4b",
    fillOpacity: 0.953
  })), _path7533 || (_path7533 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#b0d762",
    fillOpacity: 0.204
  })), _path7534 || (_path7534 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v1h-1z",
    fill: "#90b856",
    fillOpacity: 0.325
  })), _path7535 || (_path7535 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#88c827"
  })), _path7536 || (_path7536 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v-1h1v1z",
    fill: "#8bc02c",
    fillOpacity: 0.882
  })), _path7537 || (_path7537 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110h1v1h-1z",
    fill: "#dde8a6",
    fillOpacity: 0.09
  })), _path7538 || (_path7538 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fillOpacity: 0.004
  })), _path7539 || (_path7539 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#96c763",
    fillOpacity: 0.573
  })), _path7540 || (_path7540 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#8bc242",
    fillOpacity: 0.765
  })), _path7541 || (_path7541 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#7fb42d",
    fillOpacity: 0.243
  })), _path7542 || (_path7542 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#93a67f",
    fillOpacity: 0.102
  })), _path7543 || (_path7543 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#94bf53",
    fillOpacity: 0.706
  })), _path7544 || (_path7544 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#98c95d",
    fillOpacity: 0.224
  })), _path7545 || (_path7545 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#50aa36",
    fillOpacity: 0.459
  })), _path7546 || (_path7546 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#5fad4b",
    fillOpacity: 0.757
  })), _path7547 || (_path7547 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#5c9c67",
    fillOpacity: 0.376
  })), _path7548 || (_path7548 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#4e9855",
    fillOpacity: 0.459
  })), _path7549 || (_path7549 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#3ca136",
    fillOpacity: 0.847
  })), _path7550 || (_path7550 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#3ba43d",
    fillOpacity: 0.639
  })), _path7551 || (_path7551 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110h1v1h-1z",
    fill: "#3aa535",
    fillOpacity: 0.835
  })), _path7552 || (_path7552 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v1h-1v-1z",
    fill: "#54a735",
    fillOpacity: 0.733
  })), _path7553 || (_path7553 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111v-1h1v1z",
    fill: "#71aa4f",
    fillOpacity: 0.176
  })), _path7554 || (_path7554 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111h-1v-1h1z",
    fill: "#7ec364",
    fillOpacity: 0.388
  })), _path7555 || (_path7555 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110h1v1h-1z",
    fill: "#64b749",
    fillOpacity: 0.753
  })), _path7556 || (_path7556 = /*#__PURE__*/React.createElement("path", {
    d: "M100 110h1v1h-1z",
    fill: "#bfdf5f",
    fillOpacity: 0.031
  })), _path7557 || (_path7557 = /*#__PURE__*/React.createElement("path", {
    d: "M102 111h-1v-1h1z",
    fill: "#aacf69",
    fillOpacity: 0.38
  })), _path7558 || (_path7558 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112v-1h1v1z",
    fill: "#c1d07f",
    fillOpacity: 0.259
  })), _path7559 || (_path7559 = /*#__PURE__*/React.createElement("path", {
    d: "M28 112h-1v-1h1z",
    fill: "#b4cc69",
    fillOpacity: 0.808
  })), _path7560 || (_path7560 = /*#__PURE__*/React.createElement("path", {
    d: "M28 111h1v1h-1z",
    fill: "#b7cf7f",
    fillOpacity: 0.125
  })), _path7561 || (_path7561 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#8cb87b",
    fillOpacity: 0.114
  })), _path7562 || (_path7562 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#83ac63",
    fillOpacity: 0.341
  })), _path7563 || (_path7563 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#5fbf3f",
    fillOpacity: 0.031
  })), _path7564 || (_path7564 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h1v1h-1z",
    fill: "#68a140",
    fillOpacity: 0.545
  })), _path7565 || (_path7565 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#8fbf50",
    fillOpacity: 0.522
  })), _path7566 || (_path7566 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#83c13d",
    fillOpacity: 0.969
  })), _path7567 || (_path7567 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-1h1v1z",
    fill: "#8bb640",
    fillOpacity: 0.647
  })), _path7568 || (_path7568 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1z",
    fill: "#63ae3f",
    fillOpacity: 0.361
  })), _path7569 || (_path7569 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111v1h-1v-1z",
    fill: "#4fa025",
    fillOpacity: 0.616
  })), _path7570 || (_path7570 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#75ac4b",
    fillOpacity: 0.145
  })), _path7571 || (_path7571 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1z",
    fill: "#92b45e",
    fillOpacity: 0.349
  })), _path7572 || (_path7572 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v1h-1z",
    fill: "#5f9f48",
    fillOpacity: 0.22
  })), _path7573 || (_path7573 = /*#__PURE__*/React.createElement("path", {
    d: "M52 112h-1v-1h1z",
    fill: "#55a121",
    fillOpacity: 0.875
  })), _path7574 || (_path7574 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h1v1h-1z",
    fill: "#77bd1c"
  })), _path7575 || (_path7575 = /*#__PURE__*/React.createElement("path", {
    d: "M53 112v-1h1v1z",
    fill: "#8ac826"
  })), _path7576 || (_path7576 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v1h-1v-1z",
    fill: "#9fcc4b",
    fillOpacity: 0.451
  })), _path7577 || (_path7577 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h1v1h-1z",
    fill: "#693",
    fillOpacity: 0.02
  })), _path7578 || (_path7578 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1z",
    fill: "#a6ca51",
    fillOpacity: 0.788
  })), _path7579 || (_path7579 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#a9d54c",
    fillOpacity: 0.827
  })), _path7580 || (_path7580 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v1h-1v-1z",
    fill: "#95be45",
    fillOpacity: 0.616
  })), _path7581 || (_path7581 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1z",
    fill: "#b8c67f",
    fillOpacity: 0.071
  })), _path7582 || (_path7582 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#b6da85",
    fillOpacity: 0.082
  })), _path7583 || (_path7583 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111h1v1h-1z",
    fill: "#a1cb68",
    fillOpacity: 0.525
  })), _path7584 || (_path7584 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1z",
    fill: "#8bbe50",
    fillOpacity: 0.71
  })), _path7585 || (_path7585 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#83b55a",
    fillOpacity: 0.518
  })), _path7586 || (_path7586 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#99c65a",
    fillOpacity: 0.267
  })), _path7587 || (_path7587 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h1v1h-1z",
    fill: "#89bc51",
    fillOpacity: 0.776
  })), _path7588 || (_path7588 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111h1v1h-1z",
    fill: "#87bc67",
    fillOpacity: 0.318
  })), _path7589 || (_path7589 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#69a84f",
    fillOpacity: 0.314
  })), _path7590 || (_path7590 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#50a244",
    fillOpacity: 0.584
  })), _path7591 || (_path7591 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#46a33f",
    fillOpacity: 0.427
  })), _path7592 || (_path7592 = /*#__PURE__*/React.createElement("path", {
    d: "M86 112v-1h1v1z",
    fill: "#219922",
    fillOpacity: 0.925
  })), _path7593 || (_path7593 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112v-1h1v1z",
    fill: "#219f1e",
    fillOpacity: 0.847
  })), _path7594 || (_path7594 = /*#__PURE__*/React.createElement("path", {
    d: "M89 111v1h-1v-1z",
    fill: "#3ea62b",
    fillOpacity: 0.643
  })), _path7595 || (_path7595 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112h-1v-1h1z",
    fill: "#6eaf43",
    fillOpacity: 0.714
  })), _path7596 || (_path7596 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111h1v1h-1z",
    fill: "#83b757",
    fillOpacity: 0.549
  })), _path7597 || (_path7597 = /*#__PURE__*/React.createElement("path", {
    d: "M91 112v-1h1v1z",
    fill: "#75c75f",
    fillOpacity: 0.627
  })), _path7598 || (_path7598 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111v1h-1v-1z",
    fill: "#6cb74c",
    fillOpacity: 0.839
  })), _path7599 || (_path7599 = /*#__PURE__*/React.createElement("path", {
    d: "M94 111v1h-1v-1z",
    fill: "#7cb94d",
    fillOpacity: 0.506
  })), _path7600 || (_path7600 = /*#__PURE__*/React.createElement("path", {
    d: "M26 112h1v1h-1z",
    fill: "#c6d290",
    fillOpacity: 0.318
  })), _path7601 || (_path7601 = /*#__PURE__*/React.createElement("path", {
    d: "M27 113v-1h1v1z",
    fill: "#bcd073",
    fillOpacity: 0.302
  })), _path7602 || (_path7602 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112v1h-1v-1z",
    fill: "#89b062",
    fillOpacity: 0.435
  })), _path7603 || (_path7603 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#97b76f",
    fillOpacity: 0.125
  })), _path7604 || (_path7604 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#5aa03e",
    fillOpacity: 0.51
  })), _path7605 || (_path7605 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#5faa4a",
    fillOpacity: 0.094
  })), _path7606 || (_path7606 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#c4d49a",
    fillOpacity: 0.188
  })), _path7607 || (_path7607 = /*#__PURE__*/React.createElement("path", {
    d: "M43 112h1v1h-1z",
    fill: "#a4c670",
    fillOpacity: 0.463
  })), _path7608 || (_path7608 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#93bf5a",
    fillOpacity: 0.455
  })), _path7609 || (_path7609 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#9bbc58",
    fillOpacity: 0.545
  })), _path7610 || (_path7610 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1z",
    fill: "#66ac3a",
    fillOpacity: 0.671
  })), _path7611 || (_path7611 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-1h1z",
    fill: "#66a82d",
    fillOpacity: 0.196
  })), _path7612 || (_path7612 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1z",
    fill: "#adc475",
    fillOpacity: 0.306
  })), _path7613 || (_path7613 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v1h-1v-1z",
    fill: "#a2be6f",
    fillOpacity: 0.216
  })), _path7614 || (_path7614 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113v-1h1v1z",
    fill: "#60a033",
    fillOpacity: 0.486
  })), _path7615 || (_path7615 = /*#__PURE__*/React.createElement("path", {
    d: "M53 113h-1v-1h1z",
    fill: "#77b828"
  })), _path7616 || (_path7616 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#9ed53a"
  })), _path7617 || (_path7617 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#9cc73b",
    fillOpacity: 0.722
  })), _path7618 || (_path7618 = /*#__PURE__*/React.createElement("path", {
    d: "M57 112v1h-1v-1z",
    fill: "#b8d36f",
    fillOpacity: 0.341
  })), _path7619 || (_path7619 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-1h1v1z",
    fill: "#bbd769",
    fillOpacity: 0.757
  })), _path7620 || (_path7620 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113h-1v-1h1z",
    fill: "#b9d06e",
    fillOpacity: 0.173
  })), _path7621 || (_path7621 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#a0bd5e",
    fillOpacity: 0.306
  })), _path7622 || (_path7622 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#a2bf5c",
    fillOpacity: 0.173
  })), _path7623 || (_path7623 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113v-1h1v1z",
    fill: "#cc9",
    fillOpacity: 0.039
  })), _path7624 || (_path7624 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h1v1h-1z",
    fill: "#b2d180",
    fillOpacity: 0.459
  })), _path7625 || (_path7625 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1z",
    fill: "#a8d070",
    fillOpacity: 0.302
  })), _path7626 || (_path7626 = /*#__PURE__*/React.createElement("path", {
    d: "M73 112v1h-1v-1z",
    fill: "#c8dac8",
    fillOpacity: 0.055
  })), _path7627 || (_path7627 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#82b170",
    fillOpacity: 0.169
  })), _path7628 || (_path7628 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#88b176",
    fillOpacity: 0.388
  })), _path7629 || (_path7629 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#84ab75",
    fillOpacity: 0.204
  })), _path7630 || (_path7630 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#a7bf7f",
    fillOpacity: 0.125
  })), _path7631 || (_path7631 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#98c06b",
    fillOpacity: 0.4
  })), _path7632 || (_path7632 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#70aa46",
    fillOpacity: 0.541
  })), _path7633 || (_path7633 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#65a53e",
    fillOpacity: 0.561
  })), _path7634 || (_path7634 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#68b053",
    fillOpacity: 0.192
  })), _path7635 || (_path7635 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#66b044",
    fillOpacity: 0.498
  })), _path7636 || (_path7636 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#4aad31",
    fillOpacity: 0.957
  })), _path7637 || (_path7637 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#3ca331",
    fillOpacity: 0.906
  })), _path7638 || (_path7638 = /*#__PURE__*/React.createElement("path", {
    d: "M86 113v-1h1v1z",
    fill: "#3f9f39",
    fillOpacity: 0.365
  })), _path7639 || (_path7639 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112h1v1h-1z",
    fill: "#6aa955",
    fillOpacity: 0.478
  })), _path7640 || (_path7640 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v1h-1v-1z",
    fill: "#8eb75b",
    fillOpacity: 0.098
  })), _path7641 || (_path7641 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113v-1h1v1z",
    fill: "#87bb50",
    fillOpacity: 0.384
  })), _path7642 || (_path7642 = /*#__PURE__*/React.createElement("path", {
    d: "M91 113v-1h1v1z",
    fill: "#6ebc40",
    fillOpacity: 0.757
  })), _path7643 || (_path7643 = /*#__PURE__*/React.createElement("path", {
    d: "M93 113h-1v-1h1z",
    fill: "#63b52d",
    fillOpacity: 0.871
  })), _path7644 || (_path7644 = /*#__PURE__*/React.createElement("path", {
    d: "M93 112h1v1h-1z",
    fill: "#65b02d",
    fillOpacity: 0.776
  })), _path7645 || (_path7645 = /*#__PURE__*/React.createElement("path", {
    d: "M95 113h-1v-1h1z",
    fill: "#76b93f",
    fillOpacity: 0.329
  })), _path7646 || (_path7646 = /*#__PURE__*/React.createElement("path", {
    d: "M96 113h-1v-1h1z",
    fill: "#84b751",
    fillOpacity: 0.098
  })), _path7647 || (_path7647 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1z",
    fill: "#9b7",
    fillOpacity: 0.176
  })), _path7648 || (_path7648 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1z",
    fill: "#8eb46b",
    fillOpacity: 0.4
  })), _path7649 || (_path7649 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#559b3e",
    fillOpacity: 0.4
  })), _path7650 || (_path7650 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#77ae55",
    fillOpacity: 0.435
  })), _path7651 || (_path7651 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#b7cc88",
    fillOpacity: 0.337
  })), _path7652 || (_path7652 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114h-1v-1h1z",
    fill: "#a3c37a",
    fillOpacity: 0.22
  })), _path7653 || (_path7653 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#a5c276",
    fillOpacity: 0.345
  })), _path7654 || (_path7654 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#99ca69",
    fillOpacity: 0.227
  })), _path7655 || (_path7655 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#6cac33",
    fillOpacity: 0.655
  })), _path7656 || (_path7656 = /*#__PURE__*/React.createElement("path", {
    d: "M47 113h1v1h-1z",
    fill: "#aab88d",
    fillOpacity: 0.071
  })), _path7657 || (_path7657 = /*#__PURE__*/React.createElement("path", {
    d: "M49 113v1h-1v-1z",
    fill: "#aec782",
    fillOpacity: 0.161
  })), _path7658 || (_path7658 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113v1h-1v-1z",
    fill: "#83b95c",
    fillOpacity: 0.129
  })), _path7659 || (_path7659 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113h1v1h-1z",
    fill: "#6fab2b",
    fillOpacity: 0.945
  })), _path7660 || (_path7660 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v1h-1v-1z",
    fill: "#90bd49",
    fillOpacity: 0.69
  })), _path7661 || (_path7661 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v1h-1z",
    fill: "#aad053",
    fillOpacity: 0.835
  })), _path7662 || (_path7662 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114v-1h1v1z",
    fill: "#a8ce52",
    fillOpacity: 0.451
  })), _path7663 || (_path7663 = /*#__PURE__*/React.createElement("path", {
    d: "M56 114v-1h1v1z",
    fill: "#c5de7d",
    fillOpacity: 0.678
  })), _path7664 || (_path7664 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114h-1v-1h1z",
    fill: "#d7ebaa",
    fillOpacity: 0.153
  })), _path7665 || (_path7665 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v-1h1v1z",
    fill: "#a3c160",
    fillOpacity: 0.196
  })), _path7666 || (_path7666 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h1v1z",
    fill: "#a7c55f",
    fillOpacity: 0.263
  })), _path7667 || (_path7667 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v1h-1v-1z",
    fill: "#d0d0a2",
    fillOpacity: 0.043
  })), _path7668 || (_path7668 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#87ac78",
    fillOpacity: 0.267
  })), _path7669 || (_path7669 = /*#__PURE__*/React.createElement("path", {
    d: "M76 113h1v1h-1z",
    fill: "#7baa69",
    fillOpacity: 0.388
  })), _path7670 || (_path7670 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114v-1h1v1z",
    fill: "#7cad6c",
    fillOpacity: 0.184
  })), _path7671 || (_path7671 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#ffe7ff",
    fillOpacity: 0.043
  })), _path7672 || (_path7672 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113v1h-1v-1z",
    fill: "#9cbf79",
    fillOpacity: 0.345
  })), _path7673 || (_path7673 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1z",
    fill: "#6eb648",
    fillOpacity: 0.208
  })), _path7674 || (_path7674 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#4cab27",
    fillOpacity: 0.914
  })), _path7675 || (_path7675 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#52b52c",
    fillOpacity: 0.992
  })), _path7676 || (_path7676 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114h-1v-1h1z",
    fill: "#60b633",
    fillOpacity: 0.871
  })), _path7677 || (_path7677 = /*#__PURE__*/React.createElement("path", {
    d: "M85 114h-1v-1h1z",
    fill: "#72be53",
    fillOpacity: 0.263
  })), _path7678 || (_path7678 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#68ab68",
    fillOpacity: 0.192
  })), _path7679 || (_path7679 = /*#__PURE__*/React.createElement("path", {
    d: "M87 113v1h-1v-1z",
    fill: "#589650",
    fillOpacity: 0.384
  })), _path7680 || (_path7680 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v1h-1v-1z",
    fill: "#80b46a",
    fillOpacity: 0.443
  })), _path7681 || (_path7681 = /*#__PURE__*/React.createElement("path", {
    d: "M89 114h-1v-1h1z",
    fill: "#88ba6f",
    fillOpacity: 0.161
  })), _path7682 || (_path7682 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-1h1v1z",
    fill: "#6cb747",
    fillOpacity: 0.404
  })), _path7683 || (_path7683 = /*#__PURE__*/React.createElement("path", {
    d: "M93 114v-1h1v1z",
    fill: "#70bb3a",
    fillOpacity: 0.561
  })), _path7684 || (_path7684 = /*#__PURE__*/React.createElement("path", {
    d: "M94 114v-1h1v1z",
    fill: "#77bb36",
    fillOpacity: 0.655
  })), _path7685 || (_path7685 = /*#__PURE__*/React.createElement("path", {
    d: "M96 114h-1v-1h1z",
    fill: "#7abc30",
    fillOpacity: 0.718
  })), _path7686 || (_path7686 = /*#__PURE__*/React.createElement("path", {
    d: "M97 114h-1v-1h1z",
    fill: "#80bc2f",
    fillOpacity: 0.678
  })), _path7687 || (_path7687 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114h-1v-1h1z",
    fill: "#7fbe3a",
    fillOpacity: 0.494
  })), _path7688 || (_path7688 = /*#__PURE__*/React.createElement("path", {
    d: "M99 113v1h-1v-1z",
    fill: "#88c13d",
    fillOpacity: 0.212
  })), _path7689 || (_path7689 = /*#__PURE__*/React.createElement("path", {
    d: "M100 113v1h-1v-1z",
    fill: "#b6da7f",
    fillOpacity: 0.055
  })), _path7690 || (_path7690 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#84b062",
    fillOpacity: 0.408
  })), _path7691 || (_path7691 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#76b150",
    fillOpacity: 0.557
  })), _path7692 || (_path7692 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#67a93e",
    fillOpacity: 0.784
  })), _path7693 || (_path7693 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#bfd88c",
    fillOpacity: 0.078
  })), _path7694 || (_path7694 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#bfd2a5",
    fillOpacity: 0.157
  })), _path7695 || (_path7695 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#c4d19c",
    fillOpacity: 0.153
  })), _path7696 || (_path7696 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#79b53a",
    fillOpacity: 0.396
  })), _path7697 || (_path7697 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#70a92f",
    fillOpacity: 0.337
  })), _path7698 || (_path7698 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h1v1h-1z",
    fill: "#b6daa3",
    fillOpacity: 0.055
  })), _path7699 || (_path7699 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115v-1h1v1z",
    fill: "#80b534",
    fillOpacity: 0.902
  })), _path7700 || (_path7700 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114h1v1h-1z",
    fill: "#89b741",
    fillOpacity: 0.459
  })), _path7701 || (_path7701 = /*#__PURE__*/React.createElement("path", {
    d: "M55 115h-1v-1h1z",
    fill: "#bdde82",
    fillOpacity: 0.153
  })), _path7702 || (_path7702 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114h1v1h-1z",
    fill: "#9fc83d",
    fillOpacity: 0.925
  })), _path7703 || (_path7703 = /*#__PURE__*/React.createElement("path", {
    d: "M57 114v1h-1v-1z",
    fill: "#aacd4d",
    fillOpacity: 0.733
  })), _path7704 || (_path7704 = /*#__PURE__*/React.createElement("path", {
    d: "M60 115h-1v-1h1z",
    fill: "#aac26d",
    fillOpacity: 0.082
  })), _path7705 || (_path7705 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1z",
    fill: "#b3c978",
    fillOpacity: 0.357
  })), _path7706 || (_path7706 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115v-1h1v1z",
    fill: "#7f946a",
    fillOpacity: 0.047
  })), _path7707 || (_path7707 = /*#__PURE__*/React.createElement("path", {
    d: "M77 114h1v1h-1z",
    fill: "#6ba45a",
    fillOpacity: 0.42
  })), _path7708 || (_path7708 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114v1h-1v-1z",
    fill: "#66b341",
    fillOpacity: 0.675
  })), _path7709 || (_path7709 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114h1v1h-1z",
    fill: "#5fb62f",
    fillOpacity: 0.851
  })), _path7710 || (_path7710 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#60b731",
    fillOpacity: 0.906
  })), _path7711 || (_path7711 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#5ab53a",
    fillOpacity: 0.529
  })), _path7712 || (_path7712 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#63b53a",
    fillOpacity: 0.392
  })), _path7713 || (_path7713 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114v1h-1v-1z",
    fill: "#79b23b",
    fillOpacity: 0.784
  })), _path7714 || (_path7714 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115h-1v-1h1z",
    fill: "#95bd59",
    fillOpacity: 0.38
  })), _path7715 || (_path7715 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114h1v1h-1z",
    fill: "#59a050",
    fillOpacity: 0.212
  })), _path7716 || (_path7716 = /*#__PURE__*/React.createElement("path", {
    d: "M88 114v1h-1v-1z",
    fill: "#56a543",
    fillOpacity: 0.761
  })), _path7717 || (_path7717 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#71b956",
    fillOpacity: 0.404
  })), _path7718 || (_path7718 = /*#__PURE__*/React.createElement("path", {
    d: "M92 115v-1h1v1z",
    fill: "#80b65c",
    fillOpacity: 0.357
  })), _path7719 || (_path7719 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115h-1v-1h1z",
    fill: "#a1c986",
    fillOpacity: 0.075
  })), _path7720 || (_path7720 = /*#__PURE__*/React.createElement("path", {
    d: "M95 115v-1h1v1z",
    fill: "#8fbf4f",
    fillOpacity: 0.063
  })), _path7721 || (_path7721 = /*#__PURE__*/React.createElement("path", {
    d: "M96 115v-1h1v1z",
    fill: "#81be33",
    fillOpacity: 0.231
  })), _path7722 || (_path7722 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114v1h-1v-1z",
    fill: "#7ebf30",
    fillOpacity: 0.49
  })), _path7723 || (_path7723 = /*#__PURE__*/React.createElement("path", {
    d: "M98 114h1v1h-1z",
    fill: "#80c029",
    fillOpacity: 0.702
  })), _path7724 || (_path7724 = /*#__PURE__*/React.createElement("path", {
    d: "M99 114h1v1h-1z",
    fill: "#8ac13a",
    fillOpacity: 0.749
  })), _path7725 || (_path7725 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v-1h1v1z",
    fill: "#9ac650",
    fillOpacity: 0.569
  })), _path7726 || (_path7726 = /*#__PURE__*/React.createElement("path", {
    d: "M102 115h-1v-1h1z",
    fill: "#a8cc76",
    fillOpacity: 0.22
  })), _path7727 || (_path7727 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#9bbc6e",
    fillOpacity: 0.09
  })), _path7728 || (_path7728 = /*#__PURE__*/React.createElement("path", {
    d: "M40 115h1v1h-1z",
    fill: "#74b034",
    fillOpacity: 0.878
  })), _path7729 || (_path7729 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1z",
    fill: "#65ad33",
    fillOpacity: 0.737
  })), _path7730 || (_path7730 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#bdcab0",
    fillOpacity: 0.153
  })), _path7731 || (_path7731 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#84b13e",
    fillOpacity: 0.635
  })), _path7732 || (_path7732 = /*#__PURE__*/React.createElement("path", {
    d: "M46 115h1v1h-1z",
    fill: "#90b142",
    fillOpacity: 0.09
  })), _path7733 || (_path7733 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115h1v1h-1z",
    fill: "#8ebb39",
    fillOpacity: 0.82
  })), _path7734 || (_path7734 = /*#__PURE__*/React.createElement("path", {
    d: "M54 115v1h-1v-1z",
    fill: "#94be4c",
    fillOpacity: 0.573
  })), _path7735 || (_path7735 = /*#__PURE__*/React.createElement("path", {
    d: "M54 116v-1h1v1z",
    fill: "#ffffec",
    fillOpacity: 0.055
  })), _path7736 || (_path7736 = /*#__PURE__*/React.createElement("path", {
    d: "M56 115v1h-1v-1z",
    fill: "#c2de77",
    fillOpacity: 0.612
  })), _path7737 || (_path7737 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115v1h-1v-1z",
    fill: "#aacd59",
    fillOpacity: 0.345
  })), _path7738 || (_path7738 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115v1h-1v-1z",
    fill: "#c9d49a",
    fillOpacity: 0.376
  })), _path7739 || (_path7739 = /*#__PURE__*/React.createElement("path", {
    d: "M76 116h-1v-1h1z",
    fill: "#86bb6b",
    fillOpacity: 0.075
  })), _path7740 || (_path7740 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115v1h-1v-1z",
    fill: "#78b64d",
    fillOpacity: 0.373
  })), _path7741 || (_path7741 = /*#__PURE__*/React.createElement("path", {
    d: "M77 115h1v1h-1z",
    fill: "#6ab23f",
    fillOpacity: 0.682
  })), _path7742 || (_path7742 = /*#__PURE__*/React.createElement("path", {
    d: "M79 116h-1v-1h1z",
    fill: "#58b02d",
    fillOpacity: 0.71
  })), _path7743 || (_path7743 = /*#__PURE__*/React.createElement("path", {
    d: "M80 116h-1v-1h1z",
    fill: "#5cb633",
    fillOpacity: 0.635
  })), _path7744 || (_path7744 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116h-1v-1h1z",
    fill: "#70af4b",
    fillOpacity: 0.729
  })), _path7745 || (_path7745 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v-1h1v1z",
    fill: "#8db86d",
    fillOpacity: 0.255
  })), _path7746 || (_path7746 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116v-1h1v1z",
    fill: "#7ca744",
    fillOpacity: 0.161
  })), _path7747 || (_path7747 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115v1h-1v-1z",
    fill: "#78af33",
    fillOpacity: 0.753
  })), _path7748 || (_path7748 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116v-1h1v1z",
    fill: "#7db43b",
    fillOpacity: 0.588
  })), _path7749 || (_path7749 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115v1h-1v-1z",
    fill: "#59aa37",
    fillOpacity: 0.235
  })), _path7750 || (_path7750 = /*#__PURE__*/React.createElement("path", {
    d: "M88 115h1v1h-1z",
    fill: "#68af42",
    fillOpacity: 0.678
  })), _path7751 || (_path7751 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-1v-1z",
    fill: "#9cc47f",
    fillOpacity: 0.102
  })), _path7752 || (_path7752 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h-1v-1h1z",
    fill: "#87b65d",
    fillOpacity: 0.427
  })), _path7753 || (_path7753 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115v1h-1v-1z",
    fill: "#94c541",
    fillOpacity: 0.122
  })), _path7754 || (_path7754 = /*#__PURE__*/React.createElement("path", {
    d: "M100 115h1v1h-1z",
    fill: "#91c345",
    fillOpacity: 0.302
  })), _path7755 || (_path7755 = /*#__PURE__*/React.createElement("path", {
    d: "M102 115v1h-1v-1z",
    fill: "#9dc06c",
    fillOpacity: 0.286
  })), _path7756 || (_path7756 = /*#__PURE__*/React.createElement("path", {
    d: "M39 116h1v1h-1z",
    fill: "#afc684",
    fillOpacity: 0.302
  })), _path7757 || (_path7757 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v1h-1v-1z",
    fill: "#8fba54",
    fillOpacity: 0.51
  })), _path7758 || (_path7758 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117h-1v-1h1z",
    fill: "#7bab49",
    fillOpacity: 0.518
  })), _path7759 || (_path7759 = /*#__PURE__*/React.createElement("path", {
    d: "M42 117v-1h1v1z",
    fill: "#afc6a4",
    fillOpacity: 0.176
  })), _path7760 || (_path7760 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116v1h-1v-1z",
    fill: "#b4c3c3",
    fillOpacity: 0.067
  })), _path7761 || (_path7761 = /*#__PURE__*/React.createElement("path", {
    d: "M44 117v-1h1v1z",
    fill: "#91be48",
    fillOpacity: 0.247
  })), _path7762 || (_path7762 = /*#__PURE__*/React.createElement("path", {
    d: "M46 116v1h-1v-1z",
    fill: "#8fb845",
    fillOpacity: 0.608
  })), _path7763 || (_path7763 = /*#__PURE__*/React.createElement("path", {
    d: "M52 117v-1h1v1z",
    fill: "#98c350",
    fillOpacity: 0.71
  })), _path7764 || (_path7764 = /*#__PURE__*/React.createElement("path", {
    d: "M54 116v1h-1v-1z",
    fill: "#a1c45c",
    fillOpacity: 0.671
  })), _path7765 || (_path7765 = /*#__PURE__*/React.createElement("path", {
    d: "M55 117h-1v-1h1z",
    fill: "#e5efaf",
    fillOpacity: 0.439
  })), _path7766 || (_path7766 = /*#__PURE__*/React.createElement("path", {
    d: "M55 116h1v1h-1z",
    fill: "#e7f1ab",
    fillOpacity: 0.216
  })), _path7767 || (_path7767 = /*#__PURE__*/React.createElement("path", {
    d: "M60 116h1v1h-1z",
    fill: "#d6e4b2",
    fillOpacity: 0.224
  })), _path7768 || (_path7768 = /*#__PURE__*/React.createElement("path", {
    d: "M74 116v1h-1v-1z",
    fill: "#9bbc79",
    fillOpacity: 0.09
  })), _path7769 || (_path7769 = /*#__PURE__*/React.createElement("path", {
    d: "M75 117h-1v-1h1z",
    fill: "#8eba6a",
    fillOpacity: 0.337
  })), _path7770 || (_path7770 = /*#__PURE__*/React.createElement("path", {
    d: "M76 117h-1v-1h1z",
    fill: "#7fb556",
    fillOpacity: 0.533
  })), _path7771 || (_path7771 = /*#__PURE__*/React.createElement("path", {
    d: "M77 116v1h-1v-1z",
    fill: "#78b550",
    fillOpacity: 0.424
  })), _path7772 || (_path7772 = /*#__PURE__*/React.createElement("path", {
    d: "M78 116v1h-1v-1z",
    fill: "#7cba50",
    fillOpacity: 0.161
  })), _path7773 || (_path7773 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v1h-1v-1z",
    fill: "#78a157",
    fillOpacity: 0.149
  })), _path7774 || (_path7774 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v1h-1v-1z",
    fill: "#77af55",
    fillOpacity: 0.529
  })), _path7775 || (_path7775 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v-1h1v1z",
    fill: "#7cb056",
    fillOpacity: 0.651
  })), _path7776 || (_path7776 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116h1v1h-1z",
    fill: "#7cb455",
    fillOpacity: 0.361
  })), _path7777 || (_path7777 = /*#__PURE__*/React.createElement("path", {
    d: "M84 117v-1h1v1z",
    fill: "#7cb05b",
    fillOpacity: 0.153
  })), _path7778 || (_path7778 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116h1v1h-1z",
    fill: "#6ca92b",
    fillOpacity: 0.643
  })), _path7779 || (_path7779 = /*#__PURE__*/React.createElement("path", {
    d: "M86 117v-1h1v1z",
    fill: "#6bab28",
    fillOpacity: 0.635
  })), _path7780 || (_path7780 = /*#__PURE__*/React.createElement("path", {
    d: "M89 116v1h-1v-1z",
    fill: "#68b23f",
    fillOpacity: 0.365
  })), _path7781 || (_path7781 = /*#__PURE__*/React.createElement("path", {
    d: "M90 117h-1v-1h1z",
    fill: "#5cb02e",
    fillOpacity: 0.776
  })), _path7782 || (_path7782 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116h1v1h-1z",
    fill: "#4c9933",
    fillOpacity: 0.078
  })), _path7783 || (_path7783 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117v-1h1v1z",
    fill: "#add399",
    fillOpacity: 0.208
  })), _path7784 || (_path7784 = /*#__PURE__*/React.createElement("path", {
    d: "M92 117v-1h1v1z",
    fill: "#85bb5d",
    fillOpacity: 0.502
  })), _path7785 || (_path7785 = /*#__PURE__*/React.createElement("path", {
    d: "M39 117h1v1h-1z",
    fill: "#b6c491",
    fillOpacity: 0.137
  })), _path7786 || (_path7786 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1z",
    fill: "#96bc57",
    fillOpacity: 0.286
  })), _path7787 || (_path7787 = /*#__PURE__*/React.createElement("path", {
    d: "M45 118v-1h1v1z",
    fill: "#9cc059",
    fillOpacity: 0.224
  })), _path7788 || (_path7788 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117v1h-1v-1z",
    fill: "#a0c564",
    fillOpacity: 0.537
  })), _path7789 || (_path7789 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117h1v1h-1z",
    fill: "#a9c960",
    fillOpacity: 0.843
  })), _path7790 || (_path7790 = /*#__PURE__*/React.createElement("path", {
    d: "M55 118h-1v-1h1z",
    fill: "#daeca0",
    fillOpacity: 0.38
  })), _path7791 || (_path7791 = /*#__PURE__*/React.createElement("path", {
    d: "M72 117h1v1h-1z",
    fill: "#a6b994",
    fillOpacity: 0.216
  })), _path7792 || (_path7792 = /*#__PURE__*/React.createElement("path", {
    d: "M73 118v-1h1v1z",
    fill: "#a0c087",
    fillOpacity: 0.318
  })), _path7793 || (_path7793 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118h-1v-1h1z",
    fill: "#95c279",
    fillOpacity: 0.18
  })), _path7794 || (_path7794 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117h1v1h-1z",
    fill: "#8cbb68",
    fillOpacity: 0.192
  })), _path7795 || (_path7795 = /*#__PURE__*/React.createElement("path", {
    d: "M84 118h-1v-1h1z",
    fill: "#82b556",
    fillOpacity: 0.569
  })), _path7796 || (_path7796 = /*#__PURE__*/React.createElement("path", {
    d: "M85 117v1h-1v-1z",
    fill: "#7db74d",
    fillOpacity: 0.71
  })), _path7797 || (_path7797 = /*#__PURE__*/React.createElement("path", {
    d: "M85 118v-1h1v1z",
    fill: "#7db849",
    fillOpacity: 0.612
  })), _path7798 || (_path7798 = /*#__PURE__*/React.createElement("path", {
    d: "M87 117v1h-1v-1z",
    fill: "#6ab32c",
    fillOpacity: 0.925
  })), _path7799 || (_path7799 = /*#__PURE__*/React.createElement("path", {
    d: "M87 117h1v1h-1z",
    fill: "#89c45d",
    fillOpacity: 0.204
  })), _path7800 || (_path7800 = /*#__PURE__*/React.createElement("path", {
    d: "M88 117h1v1h-1z",
    fill: "#55a",
    fillOpacity: 0.012
  })), _path7801 || (_path7801 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h-1v-1h1z",
    fill: "#64b63e",
    fillOpacity: 0.757
  })), _path7802 || (_path7802 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118v-1h1v1z",
    fill: "#44a52e",
    fillOpacity: 0.69
  })), _path7803 || (_path7803 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117h1v1h-1z",
    fill: "#70b455",
    fillOpacity: 0.71
  })), _path7804 || (_path7804 = /*#__PURE__*/React.createElement("path", {
    d: "M93 118h-1v-1h1z",
    fill: "#87b755",
    fillOpacity: 0.376
  })), _path7805 || (_path7805 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h-1v-1h1z",
    fill: "#adc776",
    fillOpacity: 0.345
  })), _path7806 || (_path7806 = /*#__PURE__*/React.createElement("path", {
    d: "M54 118v1h-1v-1z",
    fill: "#c5da87",
    fillOpacity: 0.663
  })), _path7807 || (_path7807 = /*#__PURE__*/React.createElement("path", {
    d: "M54 119v-1h1v1z",
    fill: "#e7e78b",
    fillOpacity: 0.043
  })), _path7808 || (_path7808 = /*#__PURE__*/React.createElement("path", {
    d: "M84 119v-1h1v1z",
    fill: "#8cbf59",
    fillOpacity: 0.078
  })), _path7809 || (_path7809 = /*#__PURE__*/React.createElement("path", {
    d: "M86 119h-1v-1h1z",
    fill: "#84b749",
    fillOpacity: 0.392
  })), _path7810 || (_path7810 = /*#__PURE__*/React.createElement("path", {
    d: "M87 118v1h-1v-1z",
    fill: "#7eb83d",
    fillOpacity: 0.78
  })), _path7811 || (_path7811 = /*#__PURE__*/React.createElement("path", {
    d: "M87 118h1v1h-1z",
    fill: "#84b847",
    fillOpacity: 0.792
  })), _path7812 || (_path7812 = /*#__PURE__*/React.createElement("path", {
    d: "M88 118h1v1h-1z",
    fill: "#95c35c",
    fillOpacity: 0.475
  })), _path7813 || (_path7813 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118v1h-1v-1z",
    fill: "#75b25b",
    fillOpacity: 0.494
  })), _path7814 || (_path7814 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118h1v1h-1z",
    fill: "#5ab552",
    fillOpacity: 0.353
  })), _path7815 || (_path7815 = /*#__PURE__*/React.createElement("path", {
    d: "M91 119v-1h1v1z",
    fill: "#39a229",
    fillOpacity: 0.925
  })), _path7816 || (_path7816 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119h-1v-1h1z",
    fill: "#60ad49",
    fillOpacity: 0.271
  })), _path7817 || (_path7817 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#f0f0c3",
    fillOpacity: 0.067
  })), _path7818 || (_path7818 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h1v1h-1z",
    fill: "#e7f0c6",
    fillOpacity: 0.212
  })), _path7819 || (_path7819 = /*#__PURE__*/React.createElement("path", {
    d: "M88 120h-1v-1h1z",
    fill: "#8bb948",
    fillOpacity: 0.302
  })), _path7820 || (_path7820 = /*#__PURE__*/React.createElement("path", {
    d: "M89 119v1h-1v-1z",
    fill: "#8dbc4c",
    fillOpacity: 0.651
  })), _path7821 || (_path7821 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119v1h-1v-1z",
    fill: "#6eb73d",
    fillOpacity: 0.867
  })), _path7822 || (_path7822 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119h1v1h-1z",
    fill: "#74b84b",
    fillOpacity: 0.569
  })), _path7823 || (_path7823 = /*#__PURE__*/React.createElement("path", {
    d: "M92 119v1h-1v-1z",
    fill: "#69b74e",
    fillOpacity: 0.718
  })), _path7824 || (_path7824 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119v1h-1v-1z",
    fill: "#61ae3e",
    fillOpacity: 0.871
  })), _path7825 || (_path7825 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v1h-1v-1z",
    fill: "#88bd64",
    fillOpacity: 0.169
  })), _path7826 || (_path7826 = /*#__PURE__*/React.createElement("path", {
    d: "M89 121v-1h1v1z",
    fill: "#82b755",
    fillOpacity: 0.153
  })), _path7827 || (_path7827 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121h-1v-1h1z",
    fill: "#7dba4e",
    fillOpacity: 0.718
  })), _path7828 || (_path7828 = /*#__PURE__*/React.createElement("path", {
    d: "M92 121h-1v-1h1z",
    fill: "#7db143",
    fillOpacity: 0.686
  })), _path7829 || (_path7829 = /*#__PURE__*/React.createElement("path", {
    d: "M93 121h-1v-1h1z",
    fill: "#73b44a",
    fillOpacity: 0.51
  })), _path7830 || (_path7830 = /*#__PURE__*/React.createElement("path", {
    d: "M93 121v-1h1v1z",
    fill: "#8dbb61",
    fillOpacity: 0.369
  })), _path7831 || (_path7831 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121v1h-1v-1z",
    fill: "#ccf",
    fillOpacity: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrassAndYardClippings);
export default __webpack_public_path__ + "static/media/grass-and-yard-clippings.b53d7e9000cf91ed62b65d5d613e917a.svg";
export { ForwardRef as ReactComponent };